import * as React$1 from 'react';
import React__default, { forwardRef, useRef, useContext, useState, useEffect, useCallback, useImperativeHandle, Component } from 'react';
import ReactDOM from 'react-dom';
import { Equipment as Equipment$2, Point, Site, RuleEvent as RuleEvent$2, Floorplan as Floorplan$2, Preset, Schedule } from '@fsg/chariot.js/resources/models/index.js';
import { Lighting as Lighting$1, HVAC as HVAC$1, Gateway as Gateway$1, TemperatureSensor as TemperatureSensor$1, Unknown as Unknown$1, Settings as Settings$1, BooleanSensor as BooleanSensor$1, EquipmentPrimitiveTypes, EquipmentPrimitiveType } from '@fsg/chariot.js/resources/models/equipment/PrimitiveTypes/index.js';
import { useChariot, useChariotGet, useChariotList, useChariotFind } from '@fsg/chariot.js/adaptors/react/hooks/index.js';
import { Link, NavLink } from 'react-router-dom';
import { renderToString } from 'react-dom/server.browser.js';
import Chariot from '@fsg/chariot.js';
import { ChariotContext, ChariotProvider } from '@fsg/chariot.js/adaptors/react/index.js';

var THEMES = ["gordon", "chariot-light", "chariot-dark"];

var ThemeContext = /*#__PURE__*/React__default.createContext(THEMES[0]);

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$U() {
  _extends$U = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$U.apply(this, arguments);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$2(self);
}

function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$2(this, result);
  };
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}

function _toArray$1(arr) {
  return _arrayWithHoles$2(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableRest$2();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var DEFAULT_RESOLUTION = "15M";
var SUB_DAY_RESOLUTIONS = ["5M", "10M", "15M", "30M", "1H", "12H"];
var SUB_WEEK_RESOLUTIONS = ["1D"];
var SUB_MONTH_RESOLUTIONS = ["7D"];
var SUB_YEAR_RESOLUTIONS = ["30D"];
var RESOLUTIONS = [].concat(SUB_DAY_RESOLUTIONS, SUB_WEEK_RESOLUTIONS, SUB_MONTH_RESOLUTIONS, SUB_YEAR_RESOLUTIONS);
var RESOLUTION_MS_MAP = {
  "5M": 300000,
  "10M": 600000,
  "15M": 900000,
  "30M": 1800000,
  "1H": 3600000,
  "12H": 43200000,
  "1D": 86400000,
  "7D": 604800000,
  "30D": 2592000000
};

var context$6 = /*#__PURE__*/React__default.createContext({
  registerAction: function registerAction() {
    return null;
  },
  unregisterAction: function unregisterAction() {
    return null;
  },
  actions: []
});
var QuickActionsContext = context$6;

var VALID_KEYS = ["escape", "cmd", "ctrl", "opt", "alt", "shift", "backspace", "arrowup", "arrowdown", "arrowleft", "arrowright", "bracketleft", "bracketright", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "`", ",", ".", "/", ";", "'", "[", "]", "=", "-", "\\"];

var QuickActionsProvider = /*#__PURE__*/function (_React$Component) {
  _inherits$2(QuickActionsProvider, _React$Component);

  var _super = _createSuper$4(QuickActionsProvider);

  function QuickActionsProvider(props) {
    var _this;

    _classCallCheck$2(this, QuickActionsProvider);

    _this = _super.call(this, props);
    _this.shortcutRoot = window.document.body;
    _this.registerAction = _this.registerAction.bind(_assertThisInitialized$2(_this));
    _this.unregisterAction = _this.unregisterAction.bind(_assertThisInitialized$2(_this));
    _this.handleKeyboardEvent = _this.handleKeyboardEvent.bind(_assertThisInitialized$2(_this));
    _this._mounted = true; // state is ONLY used for shortcut legend

    _this.state = {};
    return _this;
  }

  _createClass$2(QuickActionsProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      this.shortcutRoot.addEventListener("keydown", this.handleKeyboardEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
      this.shortcutRoot.removeEventListener("keydown", this.handleKeyboardEvent);
    }
  }, {
    key: "handleKeyboardEvent",
    value: function handleKeyboardEvent(event) {
      var _event$code;

      if (!this._mounted) return true;
      var pressedKey = ((_event$code = event.code) === null || _event$code === void 0 ? void 0 : _event$code.toLowerCase()) || "";
      if (pressedKey.startsWith("key")) pressedKey = pressedKey.slice(3, pressedKey.length);
      var keySegments = [pressedKey];

      if (event.metaKey || event.ctrlKey) {
        keySegments.push("ctrl");
      }

      if (event.shiftKey) {
        keySegments.push("shift");
      }

      if (event.altKey) {
        keySegments.push("alt");
      }

      var normalizedShortcut;

      try {
        normalizedShortcut = this.normalizeShortcutString(keySegments.sort().join("+"));
      } catch (e) {
        return true;
      }

      var captured = false;

      var _iterator = _createForOfIteratorHelper(this.getActions()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
              shortcut = _step$value.shortcut,
              trigger = _step$value.trigger;

          if (shortcut == normalizedShortcut && trigger) {
            try {
              trigger.call(null, event);
              captured = true;
            } catch (e) {//pass
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (captured) {
        event.preventDefault();
        return false;
      }

      return true;
    }
  }, {
    key: "getEventName",
    value: function getEventName(shortcut) {
      return "quick-action:".concat(shortcut);
    }
  }, {
    key: "normalizeShortcutString",
    value: function normalizeShortcutString(shortcut) {
      var segments = shortcut.split("+"),
          sanitizedSegments = [];

      var _iterator2 = _createForOfIteratorHelper(segments),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var segment = _step2.value;
          var sanitizedSegment = segment.trim().toLowerCase();

          if (sanitizedSegment == "bracketleft") {
            sanitizedSegment = "[";
          } else if (sanitizedSegment == "bracketright") {
            sanitizedSegment = "]";
          }

          if (!VALID_KEYS.includes(sanitizedSegment)) {
            throw new Error("Invalid key in keyboard shortcut: ".concat(sanitizedSegment));
          }

          if (sanitizedSegment == "cmd") {
            sanitizedSegment = "ctrl";
          }

          if (sanitizedSegment == "opt") {
            sanitizedSegment = "alt";
          }

          if (sanitizedSegment.length == 1) {
            if (sanitizedSegment == "[") {
              sanitizedSegment = "bracketleft";
            } else if (sanitizedSegment == "]") {
              sanitizedSegment = "bracketright";
            } else {
              sanitizedSegment = "key".concat(sanitizedSegment);
            }
          }

          sanitizedSegments.push(sanitizedSegment);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return sanitizedSegments.sort().join("+");
    }
  }, {
    key: "registerAction",
    value: function registerAction(id, _ref) {
      var shortcut = _ref.shortcut,
          handler = _ref.handler,
          label = _ref.label,
          description = _ref.description,
          context = _ref.context;
      if (!this._mounted) return;
      if (!id) throw new Error("Must provide an action ID when registering quick actions.");
      if (!handler) throw new Error("Must provide an action handler when registering quick actions.");
      if (!label) throw new Error("Must provide a label when registering a quick action");

      if (shortcut && typeof shortcut == "string") {
        shortcut = this.normalizeShortcutString(shortcut);
      } else {
        shortcut = null;
      }

      this.setState(_defineProperty$3({}, id, {
        label: label,
        description: description,
        context: context,
        shortcut: shortcut,
        trigger: handler
      }));
    }
  }, {
    key: "unregisterAction",
    value: function unregisterAction(id) {
      if (!this._mounted) return;
      if (!this.state[id]) return;
      this.setState(_defineProperty$3({}, id, null));
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return Object.values(this.state).filter(function (v) {
        return v !== null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var context = {
        registerAction: this.registerAction,
        unregisterAction: this.unregisterAction,
        actions: this.getActions()
      };
      return /*#__PURE__*/React__default.createElement(QuickActionsContext.Provider, {
        value: context
      }, this.props.children);
    }
  }]);

  return QuickActionsProvider;
}(React__default.Component);

QuickActionsProvider.propTypes = {
  children: PropTypes.any
};
var QuickActionsProvider$1 = QuickActionsProvider;

var context$5 = /*#__PURE__*/React__default.createContext({
  registerNotification: function registerNotification() {
    return null;
  },
  dismissNotification: function dismissNotification() {
    return null;
  }
});
var AppNotificationsContext = context$5;

var withChariot = function withChariot(WrappedComponent) {
  var ChariotEnabledComponent = /*#__PURE__*/function (_React$Component) {
    _inherits$2(ChariotEnabledComponent, _React$Component);

    var _super = _createSuper$4(ChariotEnabledComponent);

    function ChariotEnabledComponent() {
      _classCallCheck$2(this, ChariotEnabledComponent);

      return _super.apply(this, arguments);
    }

    _createClass$2(ChariotEnabledComponent, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends$U({}, this.props, {
          chariot: this.context
        }));
      }
    }]);

    return ChariotEnabledComponent;
  }(React__default.Component);

  ChariotEnabledComponent.contextType = ChariotContext;
  ChariotEnabledComponent.propTypes = {
    forwardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      current: PropTypes.any
    })])
  };
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    return /*#__PURE__*/React__default.createElement(ChariotEnabledComponent, _extends$U({}, props, {
      forwardRef: ref
    }));
  });
};

var withChariot$1 = withChariot;

var withChariotProvider = function withChariotProvider(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits$2(_class, _React$Component);

    var _super = _createSuper$4(_class);

    function _class() {
      _classCallCheck$2(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass$2(_class, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default.createElement(ChariotProvider, {
          domain: "aeon.fsgchariot.app",
          cache: true,
          cors: true,
          noClientBoundaries: true
        }, /*#__PURE__*/React__default.createElement(WrappedComponent, this.props));
      }
    }]);

    return _class;
  }(React__default.Component);
};

var withChariotProvider$1 = withChariotProvider;

var withChariotLogin = function withChariotLogin(WrappedComponent) {
  var _class;

  return _class = /*#__PURE__*/function (_React$Component) {
    _inherits$2(_class, _React$Component);

    var _super = _createSuper$4(_class);

    function _class(props) {
      var _this;

      _classCallCheck$2(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        authenticated: false
      };
      return _this;
    }

    _createClass$2(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.subscription = this.context.onLoginStateChanged.subscribe(function (state) {
          if (state && state.user) _this2.setState({
            authenticated: true
          });
        });
        this.attemptLogin();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.subscription) this.subscription.cancel();
      }
    }, {
      key: "attemptLogin",
      value: function () {
        var _attemptLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var email, password;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  email = localStorage.getItem("chariot-email") || window.prompt("Please enter your Chariot login to retrieve data.\n\nEmail Address:"), password = localStorage.getItem("chariot-password") || window.prompt("Please enter your Chariot login to retrieve data.\n\nPassword:");
                  localStorage.setItem("chariot-email", email);
                  localStorage.setItem("chariot-password", password); // if (this.context.auth.authenticated) return;

                  _context.prev = 3;
                  _context.next = 6;
                  return this.context.login({
                    email: email,
                    password: password
                  });

                case 6:
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](3);
                  console.log(_context.t0); // localStorage.setItem(`chariot-email`, ``);
                  // localStorage.setItem(`chariot-password`, ``);
                  // this.attemptLogin();

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 8]]);
        }));

        function attemptLogin() {
          return _attemptLogin.apply(this, arguments);
        }

        return attemptLogin;
      }()
    }, {
      key: "render",
      value: function render() {
        if (!this.state.authenticated) return null;
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      }
    }]);

    return _class;
  }(React__default.Component), _defineProperty$3(_class, "contextType", ChariotContext), _class;
};

var withChariotLogin$1 = withChariotLogin;

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1(self);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toArray(arr) {
  return _arrayWithHoles$1(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableRest$1();
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass$1(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$1(_objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck$1(this, EventEmitter);

    this.observers = {};
  }

  _createClass$1(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape$1(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits$1(ResourceStore, _EventEmitter);

  var _super = _createSuper$1(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck$1(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass$1(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1$1(_objectSpread$1$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$1$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits$1(Translator, _EventEmitter);

  var _super = _createSuper$1$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized$1(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass$1(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof$2(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = '_zero';

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck$1(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass$1(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  _createClass$1(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass$1(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape$1;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val.trim();
        if (val.trim() === 'false') formatOptions[key.trim()] = false;
        if (val.trim() === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val.trim())) formatOptions[key.trim()] = parseInt(val.trim(), 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4({}, options)).format(val);
      }
    };
    this.init(options);
  }

  _createClass$1(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits$1(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck$1(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass$1(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$2(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof$2(args[2]) === 'object' || _typeof$2(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n$1 = function (_EventEmitter) {
  _inherits$1(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck$1(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized$1(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn$1(_this, _assertThisInitialized$1(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass$1(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof$2(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

_defineProperty$2(I18n$1, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n$1(options, callback);
});

var instance = I18n$1.createInstance();
instance.createInstance = I18n$1.createInstance;

instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

var i18n$1 = instance;

var global$1 = {
	loading: "Loading",
	cancel: "Cancel",
	errorFetchingBlank: "Error fetching {{blank}}",
	lastYear: "Last Year",
	lastMonth: "Last Month",
	lastWeek: "Last Week",
	today: "Today",
	clickToCopy: "Click to Copy",
	copied: "Copied!"
};
var site = {
	filterSites: "Filter Sites",
	wentOffline: "went offline",
	cameOnline: "came online"
};
var equipment$1 = {
	combinedPointsDesc: "Multiple points",
	lightStatus: "Light {{status}}",
	lightState: "Light State",
	lightOff: "Off",
	lightOn: "On",
	last24HTimeframeDesc: "Last 24 Hours",
	todayTimeframeDesc: "Today",
	hvac: "HVAC",
	lighting: "Lighting",
	booleanSensors: "Boolean Sensors",
	temperatureSensors: "Temperature Sensors",
	gateway: "Gateway",
	otherDevices: "Other Devices",
	unknown: "Unknown",
	heating: "Heating",
	cooling: "Cooling",
	loading: "Loading",
	errorLoading: "An error occurred while loading equipment.",
	noneFoundForSite: "No equipment found for site.",
	equipmentOffline: "Equipment Offline",
	equipmentOnline: "Equipment Online",
	offlineFromCriticalPoints: "One or more critical points are offline.",
	multipleDownPoints: "{{firstPointName}} and {{otherCount}} other points are unable to connect.",
	downPoint: "{{pointName}} is unable to connect.",
	spaceTemp: "Space Temp",
	supplyTemp: "Supply Temp",
	humidity: "Humidity",
	fanStatus: "Fan Status",
	temperatureN: "Temperature {{n}}",
	humidityN: "Humidity {{n}}",
	"24hrRuntime": "24 Hour Runtime",
	"24HrRangeSuffix": "{{prefix}} - 24 Hours",
	"72hrTrend": "72 Hour Trend",
	fanOn: "Fan On",
	blankTodayVs: "{{blank}}: Today vs",
	outsideTemp: "Outside Temp",
	notificationHistoryHeader: "Notification History"
};
var point$1 = {
	noValue: "No Value",
	errorLoading: "An error occurred while loading points.",
	noneFoundForEquipment: "No points found for equipment.",
	selectRecommended: "Select recommended points",
	selectAll: "Select all points"
};
var gateway$1 = {
	healthHeader: "Gateway Health",
	uptimeLabel: "Uptime",
	uptimeTimespanLabel: "Today",
	memoryLabel: "Memory",
	memoryPctLabel: "Usage",
	storageLabel: "Storage",
	storageUsageLabel: "Usage",
	networkDetailsHeader: "Network Details",
	lanLabel: "LAN IP",
	wanLabel: "WAN IP",
	publicIpLabel: "Public IP",
	virtualIpLabel: "Virtual IP",
	clientsHeader: "Clients",
	equipmentHeader: "Equipment",
	macHeader: "MAC",
	ipv4Header: "IPV4"
};
var table$1 = {
	noData: "No data to display.",
	perPage: "per page",
	pageNofTotal: "Page {{n}} of {{total}}",
	pageSpan: "{{start}}-{{end}} of {{total}}",
	searchPlaceholder: "Filter"
};
var actions$1 = {
	pageActionsHeader: "On This Page",
	globalActionsHeader: "Global",
	closeModal: "Close Modal",
	quickAccess: "Quick Access",
	quickAccessDesc: "Open a global search field for quick access to features and data",
	closeQuickAccess: "Close Quick Access",
	goToPrevTab: "Open tab to the left",
	goToPrevTabDesc: "",
	goToNextTab: "Open tab to the right",
	goToNextTabDesc: "",
	goToFirstTab: "Open the first tab",
	goToFirstTabDesc: "",
	goToLastTab: "Open the last tab",
	goToLastTabDesc: "",
	clearAllNotifications: "Clear all notifications",
	clearAllNotificationsDesc: ""
};
var floorplans = {
	addItemsHelp: "Click and drag items to add to the floorplan.",
	searchPlaceholder: "Search",
	searchItemsNoMatchesHelp: "No equipment match your search",
	searchItemsNoRemainingHelp: "There are no equipment remaining on the site",
	closeDetailsButtonLabel: "Close",
	closeDetailsActionLabel: "Close Equipment",
	closeDetailsActionDesc: "",
	removeButtonLabel: "Remove from Floorplan",
	removeActionLabel: "Remove Equipment from Floorplan",
	removeActionDesc: "",
	equipmentLoadFailedLabel: "Unable to load Equipment"
};
var inputs = {
	fileInputPlaceholder: "Click to select a file or drag and drop a file here",
	fileInputMulitplePlaceholder: "Click to select files or drag and drop files here",
	fileInputDropzoneText: "Drop files here"
};
var rules = {
	nMoreActors: "and {{n}} others",
	outOfRange: "is out of range",
	outOfRangeResolved: "was out of range",
	multipleOutOfRange: "are out of range",
	multipleOutOfRangeResolved: "were out of range",
	resolvedLabel: "Resolved: ",
	errorLoadingPoint: "Unknown point"
};
var charts = {
	editChart: "Click to edit config",
	barRangeDesc: "{{value}} of range",
	chartInvalidBecauseReason: "Chart config is invalid: {{reason}}",
	invalidRangeValue: "Range is invalid",
	startDateInvalidReason: "Start Date is invalid",
	endDateInvalidReason: "End Date is invalid",
	startDateTooLateReason: "Start Date must be before End Date",
	endDateTooLateReason: "End Date may not be more than 2 years after Start Date",
	selectSiteToShowData: "Select a site to show data.",
	selectPointToShowData: "Select a point to show data.",
	addDataToRenderChart: "Add data to render chart",
	timeRange: "Time Range",
	startDate: "Start Date",
	endDate: "End Date",
	controlledRange: "Select a different time range to change the start and end date.",
	startEndDesc: "Specify the desired time range for this chart. Custom ranges will stay the same when you return to your report.",
	lengthMustMatchChartTooltip: "Length of time must match chart.",
	resolution: "Point Data Resolution",
	stackBars: "Stack bars",
	barSize: "Bar Size",
	numberOfBars: "Number of Bars",
	useValueComparisonColorPicker: "Change value comparison colors below",
	tileSize: "Tile Size",
	numberOfTiles: "Number of Tiles",
	point: "Point",
	weather: "Weather",
	colorLabel: "Color",
	tempDataLabel: "Temperature Data",
	humidityDataLabel: "Humidity Data",
	temp: "Temperature",
	humidity: "Humidity",
	lineChartTypeLabel: "Line",
	gradientPolygonChartTypeLabel: "Filled Polygon",
	barChartTypeLabel: "Bar",
	heatmapChartTypeLabel: "Heatmap",
	xAxisLabel: "X Axis",
	yAxisLabel: "Y Axis",
	useDifferentRangeLabel: "Use Different Range",
	tooltipsLabel: "Tooltips",
	dashedLabel: "Dashed",
	removeLabel: "Remove",
	compareValueLabel: "Compare Value",
	upperValueLimitLabel: "Upper Limit",
	lowerValueLimitLabel: "Lower Limit",
	equalToCondition: "=",
	moreThanCondition: ">",
	lessThanCondition: "<",
	siteNameLabel: "Name",
	siteAddressLabel: "Address",
	equipmentNameLabel: "Name",
	equipmentTypeLabel: "Type",
	pointNameLabel: "Name",
	pointTrendLabel: "Suggested",
	pointTrendTrue: "Yes",
	pointTrendFalse: "",
	selectResourceHeader: "Select {{resource}}",
	pointSelectorEmpty: "Click to select point",
	siteSelectorEmpty: "Click to select site",
	rangeToday: "Today",
	rangePastDay: "Past 24 Hours",
	rangeWeekAgoToday: "A Week Ago Today",
	rangeMonthAgoToday: "A Month Ago Today",
	rangeYearAgoToday: "A Year Ago Today",
	rangePastWeek: "Past Week",
	rangeLastWeek: "Last Week",
	rangeWeekToDate: "Week To Date",
	rangeLastWeekToDate: "Last Week To Date",
	rangePastMonth: "Past Month",
	rangeLastMonth: "Last Month",
	rangeMonthToDate: "Month To Date",
	rangeLastMonthToDate: "Last Month To Date",
	rangePastYear: "Past Year",
	rangeLastYear: "Last Year",
	rangeYearToDate: "Year To Date",
	rangeLastYearToDate: "Last Year To Date",
	rangeCustom: "Custom Range",
	addDataSource: "Add equipment data points or weather data to this chart. You can add multiple points to the same chart. "
};
var schedules = {
	removePoint: "Remove",
	addPoints: "Add Points",
	selectPoints: "Select Settable Points",
	selectEquipment: "Select Equipment",
	pointNameLabel: "Point",
	equipmentNameLabel: "Equipment",
	equipmentTypeLabel: "Type",
	linkDayTo: "Link day to {{day}}",
	copyDay: "Copy {{day}} to",
	removeDay: "Remove {{day}}",
	unlinkDay: "Unlink {{day}} from {{linkedToDay}}",
	editPreset: "Edit Preset",
	removePreset: "Remove Zone",
	unknownPreset: "Unknown Preset",
	controlledEquipmentHeader: "Controlled Equipment",
	noControlledEquipment: "No equipment are controlled by this schedule"
};
var en = {
	global: global$1,
	site: site,
	equipment: equipment$1,
	point: point$1,
	gateway: gateway$1,
	table: table$1,
	actions: actions$1,
	floorplans: floorplans,
	inputs: inputs,
	rules: rules,
	charts: charts,
	schedules: schedules
};

var equipment = {
	combinedPointsDesc: "",
	lightStatus: "",
	lightOff: "",
	lightOn: "",
	last24HTimeframeDesc: "",
	todayTimeframeDesc: "",
	hvac: "",
	lighting: "",
	booleanSensors: "",
	temperatureSensors: "",
	gateway: "",
	otherDevices: "",
	unknown: "",
	heating: "",
	cooling: ""
};
var point = {
	noValue: ""
};
var gateway = {
	healthHeader: "",
	uptimeLabel: "",
	uptimeTimespanLabel: "",
	memoryLabel: "",
	memoryPctLabel: "",
	storageLabel: "",
	storageUsageLabel: "",
	networkDetailsHeader: "",
	lanLabel: "",
	wanLabel: "",
	publicIpLabel: "",
	virtualIpLabel: "",
	clientsHeader: "",
	equipmentHeader: "",
	macHeader: "",
	ipv4Header: ""
};
var table = {
	noData: "",
	perPage: "",
	pageNofTotal: "",
	pageSpan: "",
	searchPlaceholder: ""
};
var actions = {
	pageActionsHeader: "p",
	globalActionsHeader: "g",
	closeModal: "c",
	quickAccess: "a",
	quickAccessDesc: "",
	closeQuickAccess: "a",
	goToPrevTab: "a",
	goToPrevTabDesc: "",
	goToNextTab: "a",
	goToNextTabDesc: "",
	goToFirstTab: "a",
	goToFirstTabDesc: "",
	goToLastTab: "a",
	goToLastTabDesc: ""
};
var blank = {
	equipment: equipment,
	point: point,
	gateway: gateway,
	table: table,
	actions: actions
};

var I18n = i18n$1.createInstance({
  debug: process.env.NODE_ENV == "development",
  resources: {
    en: {
      spokes: en
    },
    blank: {
      spokes: blank
    }
  },
  defaultNS: "spokes",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
}, function (err) {
  if (err) console.error(err);
});
var i18n = I18n;

var _excluded$x = ["forwardRef"];

var withI18n = function withI18n(WrappedComponent) {
  var I18nEnabledComponent = /*#__PURE__*/function (_React$Component) {
    _inherits$2(I18nEnabledComponent, _React$Component);

    var _super = _createSuper$4(I18nEnabledComponent);

    function I18nEnabledComponent(props) {
      var _this;

      _classCallCheck$2(this, I18nEnabledComponent);

      _this = _super.call(this, props);
      _this.state = {
        lng: i18n.language
      };
      _this.handleLanguageChanged = _this.handleLanguageChanged.bind(_assertThisInitialized$2(_this));
      return _this;
    }

    _createClass$2(I18nEnabledComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        i18n.on("languageChanged", this.handleLanguageChanged);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        i18n.off("languageChanged", this.handleLanguageChanged);
      }
    }, {
      key: "handleLanguageChanged",
      value: function handleLanguageChanged(lng) {
        this.setState({
          lng: lng
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            props = _objectWithoutProperties(_this$props, _excluded$x);

        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends$U({}, props, {
          ref: forwardRef,
          i18n: i18n
        }));
      }
    }]);

    return I18nEnabledComponent;
  }(React__default.Component);

  I18nEnabledComponent.propTypes = {
    forwardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      current: PropTypes.any
    })])
  };
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    return /*#__PURE__*/React__default.createElement(I18nEnabledComponent, _extends$U({}, props, {
      forwardRef: ref
    }));
  });
};

var withI18n$1 = withI18n;

var generateRandomString = function generateRandomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var result = "",
      pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    result += pool.charAt(Math.floor(Math.random() * pool.length));
  }

  return result;
};

var QuickAction = /*#__PURE__*/function (_React$Component) {
  _inherits$2(QuickAction, _React$Component);

  var _super = _createSuper$4(QuickAction);

  function QuickAction(props) {
    var _this;

    _classCallCheck$2(this, QuickAction);

    _this = _super.call(this, props);
    _this.id = generateRandomString();
    _this.handlerFn = _this.props.handler;
    return _this;
  }

  _createClass$2(QuickAction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.register();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevShortcut = prevProps.shortcut,
          prevLabel = prevProps.label,
          prevDescription = prevProps.description,
          prevContext = prevProps.context,
          prevHandler = prevProps.handler;
      var _this$props = this.props,
          shortcut = _this$props.shortcut,
          label = _this$props.label,
          description = _this$props.description,
          context = _this$props.context,
          handler = _this$props.handler;

      if (prevShortcut !== shortcut || prevLabel !== label || prevDescription !== description || prevContext !== context) {
        this.unregister();
        this.register();
      }

      if (prevHandler !== handler) {
        this.handlerFn = handler;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregister();
    }
  }, {
    key: "register",
    value: function register() {
      var _this$props2 = this.props,
          shortcut = _this$props2.shortcut,
          label = _this$props2.label,
          description = _this$props2.description,
          context = _this$props2.context;
      this.context.registerAction(this.id, {
        shortcut: shortcut,
        label: label,
        description: description,
        context: context,
        handler: this.handler.bind(this)
      });
    }
  }, {
    key: "unregister",
    value: function unregister() {
      this.context.unregisterAction(this.id);
    }
  }, {
    key: "handler",
    value: function handler(event) {
      if (this.handlerFn) this.handlerFn.call(null, event);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return QuickAction;
}(React__default.Component);

QuickAction.defaultProps = {
  context: "page"
};
QuickAction.propTypes = {
  shortcut: PropTypes.string,
  handler: PropTypes.func.isRequired,
  context: PropTypes.oneOf(["global", "page"]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string
};
QuickAction.contextType = QuickActionsContext;
var QuickAction$1 = QuickAction;

var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loading-spinner"
  }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null));
};

var LoadingSpinner$1 = LoadingSpinner;

var _excluded$w = ["loading", "component", "className", "children", "quickActionLabel", "quickActionDescription", "quickActionShortcut"];
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var button = useRef();

  var loading = props.loading,
      component = props.component,
      className = props.className,
      children = props.children,
      quickActionLabel = props.quickActionLabel,
      quickActionDescription = props.quickActionDescription,
      quickActionShortcut = props.quickActionShortcut,
      buttonProps = _objectWithoutProperties(props, _excluded$w);

  if (loading) {
    buttonProps.disabled = true;
  }

  if (buttonProps.disabled) {
    delete buttonProps.onClick;
  }

  var Component = component || "button";
  return /*#__PURE__*/React__default.createElement(Component, _extends$U({
    ref: ref || button
  }, buttonProps, {
    className: "button ".concat(className ? className : "", " ").concat(loading ? "loading" : "")
  }), loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), children, quickActionLabel && !buttonProps.disabled && /*#__PURE__*/React__default.createElement(QuickAction$1, {
    handler: function handler() {
      if (button.current) {
        button.current.click();
      } else if (ref.current) {
        ref.current.click();
      }
    },
    label: quickActionLabel,
    description: quickActionDescription,
    shortcut: quickActionShortcut
  }));
});
Button.propTypes = {
  loading: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  quickActionLabel: PropTypes.string,
  quickActionDescription: PropTypes.string,
  quickActionShortcut: PropTypes.string,
  children: PropTypes.any
};
var Button$1 = Button;

var _excluded$v = ["children", "className"];

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$v);

  return /*#__PURE__*/React__default.createElement("div", _extends$U({
    className: "button-group ".concat(className ? className : "")
  }, props), children);
};

ButtonGroup.propTypes = {
  className: PropTypes.string,
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (child.type !== Button$1) error = new Error("".concat(componentName, " children should be of type Button"));
    });
    return error;
  }
};
var ButtonGroup$1 = ButtonGroup;

var useAppNotification = function useAppNotification() {
  var ctx = useContext(AppNotificationsContext);
  return ctx.registerNotification;
};

var useAppNotification$1 = useAppNotification;

var TrendResolutionContext = /*#__PURE__*/React__default.createContext(DEFAULT_RESOLUTION);

var useDefaultResolution = function useDefaultResolution() {
  var resolution = useContext(TrendResolutionContext);
  return resolution;
};

var useDefaultResolution$1 = useDefaultResolution;

var useEquipmentStatus = function useEquipmentStatus(equipment) {
  var _useState = useState(true),
      _useState2 = _slicedToArray$1(_useState, 2),
      online = _useState2[0],
      setOnline = _useState2[1];

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!equipment) {
                _context.next = 6;
                break;
              }

              _context.t0 = setOnline;
              _context.next = 4;
              return equipment.getOnlineStatus();

            case 4:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [equipment]);
  return online;
};

var useEquipmentStatus$1 = useEquipmentStatus;

var useI18n = function useI18n() {
  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      setLng = _useState2[1];

  useEffect(function () {
    setLng(i18n.language);

    var handleLanguageChanged = function handleLanguageChanged(lng) {
      return setLng(lng);
    };

    i18n.on("languageChanged", handleLanguageChanged);
    return function () {
      return i18n.off("languageChanged", handleLanguageChanged);
    };
  }, []);
  return i18n;
};

var useI18n$1 = useI18n;

var _excluded$u = ["onClick", "onClickReturns", "preventPropagation", "onError", "suppressError", "children"];
var PatientButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var notify = useAppNotification$1();

  var defaultOnError = function defaultOnError(error) {
    return notify({
      message: error.message,
      type: "error"
    });
  };

  var _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {
    return Promise.resolve();
  } : _props$onClick,
      _props$onClickReturns = props.onClickReturns,
      onClickReturns = _props$onClickReturns === void 0 ? false : _props$onClickReturns,
      _props$preventPropaga = props.preventPropagation,
      preventPropagation = _props$preventPropaga === void 0 ? true : _props$preventPropaga,
      onError = props.onError,
      suppressError = props.suppressError,
      children = props.children,
      buttonProps = _objectWithoutProperties(props, _excluded$u);

  var _useState = useState(function () {
    return function () {
      return onClickReturns;
    };
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      onClickProxy = _useState2[0],
      setOnClickProxy = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      promiseLoading = _useState4[0],
      setPromiseLoading = _useState4[1];

  useEffect(function () {
    var mounted = true;
    setOnClickProxy(function () {
      return function (event) {
        if (preventPropagation) event.stopPropagation();

        _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _continue;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setPromiseLoading(true);
                  _context.prev = 1;
                  _context.next = 4;
                  return onClick(event);

                case 4:
                  _context.next = 11;
                  break;

                case 6:
                  _context.prev = 6;
                  _context.t0 = _context["catch"](1);
                  _continue = false;

                  if (suppressError) {
                    if (typeof suppressError == "boolean" || suppressError(_context.t0)) {
                      _continue = true;
                    }
                  }

                  if (!_continue) {
                    if (onError) {
                      onError(_context.t0);
                    } else {
                      defaultOnError(_context.t0);
                    }
                  }

                case 11:
                  if (mounted) {
                    _context.next = 13;
                    break;
                  }

                  return _context.abrupt("return");

                case 13:
                  setPromiseLoading(false);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 6]]);
        }))();

        return onClickReturns;
      };
    });
    return function () {
      mounted = false;
    };
  }, [onClick, onClickReturns, preventPropagation, onError]);
  return /*#__PURE__*/React__default.createElement(Button$1, _extends$U({
    ref: ref
  }, buttonProps, {
    onClick: onClickProxy,
    loading: promiseLoading
  }), children);
});
PatientButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  onError: PropTypes.func,
  children: PropTypes.any,
  onClickReturns: PropTypes.any,
  preventPropagation: PropTypes.bool,
  suppressError: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
};
var PatientButton$1 = PatientButton;

var _path$P;

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var SvgAlertOctagon = function SvgAlertOctagon(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$T({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-octagon",
    ref: ref
  }, props), _path$P || (_path$P = /*#__PURE__*/React$1.createElement("path", {
    d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"
  })));
};

var ForwardRef$S = /*#__PURE__*/forwardRef(SvgAlertOctagon);

var _path$O;

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var SvgAlertTriangle = function SvgAlertTriangle(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-triangle",
    ref: ref
  }, props), _path$O || (_path$O = /*#__PURE__*/React$1.createElement("path", {
    d: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01"
  })));
};

var ForwardRef$R = /*#__PURE__*/forwardRef(SvgAlertTriangle);

var _circle$d, _path$N;

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-info",
    ref: ref
  }, props), _circle$d || (_circle$d = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path$N || (_path$N = /*#__PURE__*/React$1.createElement("path", {
    d: "M12 16v-4M12 8h.01"
  })));
};

var ForwardRef$Q = /*#__PURE__*/forwardRef(SvgInfo);

var AppMessage = function AppMessage(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "info" : _ref$type;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "app-message ".concat(type)
  }, type == "warning" ? /*#__PURE__*/React__default.createElement(ForwardRef$R, {
    width: "32",
    height: "32"
  }) : type == "error" ? /*#__PURE__*/React__default.createElement(ForwardRef$S, {
    width: "32",
    height: "32"
  }) : /*#__PURE__*/React__default.createElement(ForwardRef$Q, {
    width: "32",
    height: "32"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "contents"
  }, children));
};

AppMessage.propTypes = {
  children: PropTypes.any,
  type: PropTypes.oneOf(["info", "warning", "error"])
};
var AppMessage$1 = AppMessage;

var _excluded$t = ["children"];

var AppInfo = function AppInfo(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$t);

  return /*#__PURE__*/React__default.createElement(AppMessage$1, _extends$U({
    type: "info"
  }, props), children);
};

AppInfo.propTypes = {
  children: PropTypes.any
};
var AppInfo$1 = AppInfo;

var _excluded$s = ["children"];

var AppWarning = function AppWarning(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$s);

  return /*#__PURE__*/React__default.createElement(AppMessage$1, _extends$U({
    type: "warning"
  }, props), children);
};

AppWarning.propTypes = {
  children: PropTypes.any
};
var AppWarning$1 = AppWarning;

var _excluded$r = ["children"];

var AppError = function AppError(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$r);

  return /*#__PURE__*/React__default.createElement(AppMessage$1, _extends$U({
    type: "error"
  }, props), children);
};

AppError.propTypes = {
  children: PropTypes.any
};
var AppError$1 = AppError;

var _path$M;

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var SvgX = function SvgX(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x",
    ref: ref
  }, props), _path$M || (_path$M = /*#__PURE__*/React$1.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  })));
};

var ForwardRef$P = /*#__PURE__*/forwardRef(SvgX);

var AppNotification = function AppNotification(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "info" : _ref$type,
      message = _ref.message,
      close = _ref.close,
      dismissMs = _ref.dismissMs;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      closing = _useState2[0],
      setClosing = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      notificationClass = _useState4[0],
      setNotificationClass = _useState4[1];

  var animateClose = function animateClose() {
    if (closing) return;
    setNotificationClass("closing");
    setClosing(true);
    setTimeout(function () {
      return close();
    }, 500);
  };

  useEffect(function () {
    if (!dismissMs) return;
    var timeoutId = setTimeout(function () {
      animateClose();
    }, dismissMs);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [dismissMs]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "app-notification ".concat(type, " ").concat(notificationClass, " ").concat(dismissMs ? "auto-dismissing" : "")
  }, /*#__PURE__*/React__default.createElement(AppMessage$1, {
    type: type
  }, message), close && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: animateClose
  }, /*#__PURE__*/React__default.createElement(ForwardRef$P, null)));
};

AppNotification.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["info", "warning", "error"]),
  close: PropTypes.func.isRequired,
  dismissMs: PropTypes.number
};
var AppNotification$1 = AppNotification;

var AppNotificationManager = /*#__PURE__*/function (_React$Component) {
  _inherits$2(AppNotificationManager, _React$Component);

  var _super = _createSuper$4(AppNotificationManager);

  function AppNotificationManager(props) {
    var _this;

    _classCallCheck$2(this, AppNotificationManager);

    _this = _super.call(this, props);
    _this.registerNotification = _this.registerNotification.bind(_assertThisInitialized$2(_this));
    _this.dismissNotification = _this.dismissNotification.bind(_assertThisInitialized$2(_this));
    _this.notificationRoot = document.getElementById("notification-root");

    if (!_this.notificationRoot) {
      _this.notificationRoot = document.createElement("div");
      _this.notificationRoot.id = "notification-root";
      document.body.appendChild(_this.notificationRoot);
    }

    _this._mounted = false;
    _this.state = {
      notifications: []
    };
    return _this;
  }

  _createClass$2(AppNotificationManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "registerNotification",
    value: function registerNotification(_ref) {
      var _ref$type = _ref.type,
          type = _ref$type === void 0 ? "info" : _ref$type,
          message = _ref.message,
          _ref$dismissMs = _ref.dismissMs,
          dismissMs = _ref$dismissMs === void 0 ? 3000 : _ref$dismissMs;
      if (!this._mounted) return;
      if (typeof dismissMs == "string") dismissMs = parseInt(dismissMs);
      var id = generateRandomString();
      this.setState({
        notifications: this.state.notifications.concat({
          id: id,
          type: type,
          message: message,
          dismissMs: dismissMs
        })
      });
    }
  }, {
    key: "dismissNotification",
    value: function dismissNotification(id) {
      if (!this._mounted) return;

      var notifications = _toConsumableArray(this.state.notifications);

      this.setState({
        notifications: notifications.filter(function (_ref2) {
          var nId = _ref2.id;
          return nId != id;
        })
      });
    }
  }, {
    key: "renderNotification",
    value: function renderNotification(_ref3) {
      var _this2 = this;

      var id = _ref3.id,
          type = _ref3.type,
          message = _ref3.message,
          dismissMs = _ref3.dismissMs;
      return /*#__PURE__*/React__default.createElement(AppNotification$1, {
        key: id,
        type: type,
        message: message,
        close: function close() {
          return _this2.dismissNotification(id);
        },
        dismissMs: dismissMs
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var i18n = this.props.i18n;
      var notifications = this.state.notifications;
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
        theme: this.context,
        useQuickActionsProvider: false,
        useNotificationsProvider: false
      }, notifications.length > 0 && /*#__PURE__*/React__default.createElement(QuickAction$1, {
        handler: function handler() {
          return _this3.setState({
            notifications: []
          });
        },
        context: "global",
        label: i18n.t("actions.clearAllNotifications"),
        description: i18n.t("actions.clearAllNotificationsDesc")
      }), _toConsumableArray(notifications).reverse().map(this.renderNotification.bind(this))), this.notificationRoot);
    }
  }]);

  return AppNotificationManager;
}(React__default.Component);

_defineProperty$3(AppNotificationManager, "contextType", ThemeContext);

AppNotificationManager.propTypes = {
  children: PropTypes.any,
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  })
};
var AppNotificationManager$1 = withI18n$1(AppNotificationManager);

var AppNotificationsProvider = function AppNotificationsProvider(_ref) {
  var children = _ref.children;
  var manager = useRef();
  var context = {
    registerNotification: function registerNotification() {
      var _manager$current, _manager$current$regi;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return manager === null || manager === void 0 ? void 0 : (_manager$current = manager.current) === null || _manager$current === void 0 ? void 0 : (_manager$current$regi = _manager$current.registerNotification).call.apply(_manager$current$regi, [undefined].concat(args));
    },
    dismissNotification: function dismissNotification() {
      var _manager$current2, _manager$current2$dis;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return manager === null || manager === void 0 ? void 0 : (_manager$current2 = manager.current) === null || _manager$current2 === void 0 ? void 0 : (_manager$current2$dis = _manager$current2.dismissNotification) === null || _manager$current2$dis === void 0 ? void 0 : _manager$current2$dis.call.apply(_manager$current2$dis, [undefined].concat(args));
    }
  };
  return /*#__PURE__*/React__default.createElement(AppNotificationsContext.Provider, {
    value: context
  }, children, /*#__PURE__*/React__default.createElement(AppNotificationManager$1, {
    ref: manager
  }));
};

AppNotificationsProvider.propTypes = {
  children: PropTypes.any
};
var AppNotificationsProvider$1 = AppNotificationsProvider;

var ThemeLanguage = function ThemeLanguage(_ref) {
  var lng = _ref.lng;
  var i18n = useI18n$1();
  useEffect(function () {
    i18n.changeLanguage(lng);
  }, [lng]);
  return null;
};

var ThemeLanguage$1 = ThemeLanguage;

var _excluded$q = ["theme", "children", "className", "useQuickActionsProvider", "useNotificationsProvider", "lng", "defaultTrendResolution"];

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children,
      className = props.className,
      _props$useQuickAction = props.useQuickActionsProvider,
      useQuickActionsProvider = _props$useQuickAction === void 0 ? true : _props$useQuickAction,
      _props$useNotificatio = props.useNotificationsProvider,
      useNotificationsProvider = _props$useNotificatio === void 0 ? true : _props$useNotificatio,
      lng = props.lng,
      _props$defaultTrendRe = props.defaultTrendResolution,
      defaultTrendResolution = _props$defaultTrendRe === void 0 ? DEFAULT_RESOLUTION : _props$defaultTrendRe,
      divProps = _objectWithoutProperties(props, _excluded$q);

  var QuickActionsProviderComponent = React__default.Fragment,
      NotificationsProviderComponent = React__default.Fragment;
  if (useQuickActionsProvider) QuickActionsProviderComponent = QuickActionsProvider$1;
  if (useNotificationsProvider) NotificationsProviderComponent = AppNotificationsProvider$1;
  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: theme
  }, lng && /*#__PURE__*/React__default.createElement(ThemeLanguage$1, {
    lng: lng
  }), /*#__PURE__*/React__default.createElement(TrendResolutionContext.Provider, {
    value: defaultTrendResolution
  }, /*#__PURE__*/React__default.createElement(QuickActionsProviderComponent, null, /*#__PURE__*/React__default.createElement(NotificationsProviderComponent, null, /*#__PURE__*/React__default.createElement("div", _extends$U({}, divProps, {
    className: "theme-provider theme--".concat(theme, " ").concat(className ? className : "")
  }), children)))));
};

ThemeProvider.propTypes = {
  theme: PropTypes.oneOf(THEMES),
  children: PropTypes.any,
  className: PropTypes.string,
  lng: PropTypes.string,
  useQuickActionsProvider: PropTypes.bool,
  useNotificationsProvider: PropTypes.bool,
  defaultTrendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var ThemeProvider$1 = ThemeProvider;

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$1));

var moment = moment$1.exports;

var tabbable$1 = "a[href], area[href], input:not([disabled]):not([type=\"hidden\"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
var PX_PADDING_BETWEEN_EL_AND_TOOLTIP = 14;
var PX_WRAPPER_SIZE = 40 * 8;

var PopOver = /*#__PURE__*/function (_React$Component) {
  _inherits$2(PopOver, _React$Component);

  var _super = _createSuper$4(PopOver);

  function PopOver(props) {
    var _this;

    _classCallCheck$2(this, PopOver);

    _this = _super.call(this, props);
    _this.anchor = null;
    _this._mounted = true;
    _this.popOver = /*#__PURE__*/React__default.createRef();
    _this.state = {
      shown: false,
      hiding: false,
      hidingTimeout: -1,
      top: -1000,
      left: -1000,
      anchorWidth: 0,
      anchorHeight: 0,
      position: props.position
    };
    _this.handleAnchorClick = _this.handleAnchorClick.bind(_assertThisInitialized$2(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized$2(_this));
    _this.handleCaptureOutsideClick = _this.handleCaptureOutsideClick.bind(_assertThisInitialized$2(_this));
    _this.handleScrollWhileOpen = _this.handleScrollWhileOpen.bind(_assertThisInitialized$2(_this));
    _this.tabData = [];
    _this.appRoot = document.getElementById("app") || document.getElementById("root");
    _this.popOverRoot = document.getElementById("pop-over-root");

    if (!_this.popOverRoot) {
      _this.popOverRoot = document.createElement("div");
      _this.popOverRoot.id = "pop-over-root";
      document.body.appendChild(_this.popOverRoot);
    }

    return _this;
  }

  _createClass$2(PopOver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.rebindAnchor(this.props.anchor);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.anchor !== this.props.anchor) {
        this.rebindAnchor(this.props.anchor, this.anchor);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
      clearTimeout(this.state.hidingTimeout);
      document.removeEventListener("scroll", this.handleScrollWhileOpen, true);
      this.appRoot.removeEventListener("click", this.handleCaptureOutsideClick);
      this.rebindAnchor(null, this.anchor);
    }
  }, {
    key: "rebindAnchor",
    value: function rebindAnchor(anchor) {
      var prevAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.anchor;

      if (prevAnchor !== null && prevAnchor !== void 0 && prevAnchor.current) {
        prevAnchor.current.removeEventListener("click", this.handleAnchorClick);
      }

      if (anchor) {
        this.anchor = anchor;

        if (anchor.current) {
          anchor.current.addEventListener("click", this.handleAnchorClick);
        }
      }
    }
  }, {
    key: "handleAnchorClick",
    value: function handleAnchorClick() {
      clearTimeout(this.state.hidingTimeout);
      if (this.state.shown) return this.handleClose();
      this.setPosition();
      document.addEventListener("scroll", this.handleScrollWhileOpen, true);

      if (this.appRoot) {
        var tabbableNodes = this.appRoot.querySelectorAll(tabbable$1);
        this.tabData = Array.from(tabbableNodes).map(function (node) {
          var tabIndex = node.getAttribute("tabindex") || null;
          node.setAttribute("tabindex", -1);
          return {
            node: node,
            tabIndex: tabIndex
          };
        });
        this.appRoot.addEventListener("click", this.handleCaptureOutsideClick);
      }

      var body = this.popOverRoot.querySelector(".pop-over-inner");

      if (body) {
        var firstTabbableInBody = body.querySelector(tabbable$1);

        if (firstTabbableInBody) {
          firstTabbableInBody.focus();
          return;
        }
      }

      var firstTabbable = this.popOverRoot.querySelector(tabbable$1);

      if (firstTabbable) {
        firstTabbable.focus();
      }
    }
  }, {
    key: "handleScrollWhileOpen",
    value: function handleScrollWhileOpen() {
      this.setPosition();
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var _this$anchor;

      var anchor = (_this$anchor = this.anchor) === null || _this$anchor === void 0 ? void 0 : _this$anchor.current;
      if (!anchor) return;
      var rect = anchor.getBoundingClientRect();

      if (rect) {
        var coords = {
          top: rect.top + window.scrollY,
          left: rect.left + window.scrollX
        },
            position = this.props.position,
            viewHeight = window.document.documentElement.clientHeight,
            viewWidth = window.document.documentElement.clientWidth,
            height = anchor.offsetHeight || anchor.clientHeight,
            width = anchor.offsetWidth || anchor.clientWidth,
            coordsBottom = coords.top + height,
            coordsRight = coords.left + width;
        var WRAPPER_MARGIN = PX_WRAPPER_SIZE + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;

        if (position.includes("top") && coords.top < WRAPPER_MARGIN) {
          position = position.replace("top", "bottom");
        } else if (position.includes("bottom") && coordsBottom > viewHeight - WRAPPER_MARGIN) {
          position = position.replace("bottom", "top");
        }

        if (position.includes("left") && coords.left < WRAPPER_MARGIN) {
          position = position.replace("left", "right");
        } else if (position.includes("right") && coordsRight > viewWidth - WRAPPER_MARGIN) {
          position = position.replace("right", "left");
        }

        if (position == "top") {
          if (coords.left < WRAPPER_MARGIN / 2) {
            position = "top-right";
          } else if (coordsRight > viewWidth - WRAPPER_MARGIN / 2) {
            position = "top-left";
          }
        } else if (position == "right") {
          if (coords.top < WRAPPER_MARGIN / 2) {
            position = "right-bottom";
          } else if (coordsBottom > viewHeight - WRAPPER_MARGIN / 2) {
            position = "right-top";
          }
        } else if (position == "bottom") {
          if (coords.left < WRAPPER_MARGIN / 2) {
            position = "bottom-right";
          } else if (coordsRight > viewWidth - WRAPPER_MARGIN / 2) {
            position = "bottom-left";
          }
        } else if (position == "left") {
          if (coords.top < WRAPPER_MARGIN / 2) {
            position = "left-bottom";
          } else if (coordsBottom > viewHeight - WRAPPER_MARGIN / 2) {
            position = "left-top";
          }
        }

        if (position == "top") {
          coords.top -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.left += width / 2;
          coords.align = "bottom";
        } else if (position == "top-right") {
          coords.top -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.left += width;
          coords.align = "bottom-left";
        } else if (position == "top-left") {
          coords.top -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.align = "bottom-right";
        } else if (position == "bottom") {
          coords.top += height + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.left += width / 2;
          coords.align = "top";
        } else if (position == "bottom-right") {
          coords.top += height + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.left += width;
          coords.align = "top-left";
        } else if (position == "bottom-left") {
          coords.top += height + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.align = "top-right";
        } else if (position == "left") {
          coords.left -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.top += height / 2;
          coords.align = "right";
        } else if (position == "left-bottom") {
          coords.left -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.top += height;
          coords.align = "right-top";
        } else if (position == "left-top") {
          coords.left -= PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.align = "right-bottom";
        } else if (position == "right") {
          coords.left += width + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.top += height / 2;
          coords.align = "left";
        } else if (position == "right-bottom") {
          coords.left += width + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.top += height;
          coords.align = "left-top";
        } else if (position == "right-top") {
          coords.left += width + PX_PADDING_BETWEEN_EL_AND_TOOLTIP;
          coords.align = "left-bottom";
        }

        this.setState(_objectSpread2({
          shown: true,
          anchorWidth: width,
          anchorHeight: height,
          position: position
        }, coords));
      }
    }
  }, {
    key: "handleCaptureOutsideClick",
    value: function handleCaptureOutsideClick(e) {
      var _this$anchor2;

      if ((_this$anchor2 = this.anchor) !== null && _this$anchor2 !== void 0 && _this$anchor2.current && this.anchor.current.contains(e.target)) return;
      e.preventDefault();
      this.handleClose();
      return false;
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this$props$parent,
          _this$props$parent$cu,
          _this2 = this;

      document.removeEventListener("scroll", this.handleScrollWhileOpen, true);
      this.appRoot.removeEventListener("click", this.handleCaptureOutsideClick);
      this.tabData.forEach(function (_ref) {
        var node = _ref.node,
            tabIndex = _ref.tabIndex;

        if (tabIndex == null) {
          node.removeAttribute("tabindex");
        } else {
          node.setAttribute("tabindex", tabIndex);
        }
      });
      (_this$props$parent = this.props.parent) === null || _this$props$parent === void 0 ? void 0 : (_this$props$parent$cu = _this$props$parent.current) === null || _this$props$parent$cu === void 0 ? void 0 : _this$props$parent$cu.handleClose();
      if (!this._mounted) return;
      this.setState({
        hiding: true,
        hidingTimeout: setTimeout(function () {
          if (!_this2._mounted) return;

          _this2.setState({
            hiding: false,
            shown: false
          });
        }, 200)
      });
    }
  }, {
    key: "handleInsideClick",
    value: function handleInsideClick(e) {
      e.stopPropagation();
      if (this.props.closeOnInsideClick) this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shown) return null;
      var _this$state = this.state,
          top = _this$state.top,
          left = _this$state.left,
          right = _this$state.right,
          bottom = _this$state.bottom,
          align = _this$state.align,
          hiding = _this$state.hiding,
          anchorWidth = _this$state.anchorWidth,
          anchorHeight = _this$state.anchorHeight,
          position = _this$state.position,
          _this$props = this.props,
          children = _this$props.children,
          wrapperClassName = _this$props.wrapperClassName,
          className = _this$props.className;
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
        theme: this.context,
        useQuickActionsProvider: false,
        useNotificationsProvider: false
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "pop-over-wrapper align-".concat(align, " ").concat(wrapperClassName ? wrapperClassName : ""),
        style: {
          top: top,
          left: left,
          bottom: bottom,
          right: right,
          "--anchor-width": "".concat(anchorWidth, "px"),
          "--anchor-height": "".concat(anchorHeight, "px")
        },
        onClick: this.handleClose.bind(this)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "pop-over ".concat(hiding ? "hiding" : "", " position-").concat(position, " ").concat(className ? className : ""),
        onClick: this.handleInsideClick.bind(this),
        ref: this.popOver
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "pop-over-inner"
      }, children)))), this.popOverRoot);
    }
  }]);

  return PopOver;
}(React__default.Component);

_defineProperty$3(PopOver, "contextType", ThemeContext);

PopOver.propTypes = {
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
  anchor: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  children: PropTypes.any,
  position: PropTypes.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right", "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"]),
  closeOnInsideClick: PropTypes.bool,
  parent: PropTypes.shape({
    current: PropTypes.instanceOf(PopOver)
  })
};
PopOver.defaultProps = {
  position: "bottom"
};
var PopOver$1 = PopOver;

var _excluded$p = ["items", "className"],
    _excluded2 = ["label", "items", "parentPopOver", "onClick"];
var PopOverMenuItemPropType = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  loading: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape(PopOverMenuItemPropType))
};
var PopOverMenu = /*#__PURE__*/forwardRef(function (props, ref) {
  var items = props.items,
      className = props.className,
      popOverProps = _objectWithoutProperties(props, _excluded$p);

  var root = useRef();
  return /*#__PURE__*/React__default.createElement(PopOver$1, _extends$U({
    ref: ref || root,
    className: "".concat(className ? className : "", " pop-over-menu"),
    closeOnInsideClick: true
  }, popOverProps), items.map(function (itemProps, index) {
    return /*#__PURE__*/React__default.createElement(PopOverMenuItem, _extends$U({
      key: index,
      parentPopOver: ref || root
    }, itemProps));
  }));
});
PopOverMenu.propTypes = {
  className: PropTypes.string,
  anchor: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  children: PropTypes.any,
  position: PropTypes.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right", "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"]),
  items: PropTypes.arrayOf(PropTypes.shape(PopOverMenuItemPropType))
};

var PopOverMenuItem = function PopOverMenuItem(props) {
  var label = props.label,
      items = props.items,
      parentPopOver = props.parentPopOver,
      onClickFromProps = props.onClick,
      buttonProps = _objectWithoutProperties(props, _excluded2);

  var onClick = onClickFromProps;

  if (!onClickFromProps && items && items.length > 0) {
    onClick = function onClick(e) {
      return e.stopPropagation();
    };
  }

  var button = useRef();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, _extends$U({
    ref: button,
    onClick: onClick
  }, buttonProps), label), items && items.length > 0 && /*#__PURE__*/React__default.createElement(PopOverMenu, {
    parent: parentPopOver,
    anchor: button,
    position: "right-bottom",
    items: items
  }));
};

PopOverMenuItem.propTypes = _objectSpread2({
  parentPopOver: PropTypes.any
}, PopOverMenuItemPropType);
var PopOverMenu$1 = PopOverMenu;

var _circle$c, _circle2, _circle3;

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var SvgMoreHorizontal = function SvgMoreHorizontal(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-more-horizontal",
    ref: ref
  }, props), _circle$c || (_circle$c = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })));
};

var ForwardRef$O = /*#__PURE__*/forwardRef(SvgMoreHorizontal);

var CardHeader = function CardHeader(_ref) {
  var label = _ref.label,
      Icon = _ref.icon,
      children = _ref.children,
      className = _ref.className,
      actions = _ref.actions;
  var moreButton = useRef();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card-header ".concat(className ? className : "")
  }, Icon && /*#__PURE__*/React__default.createElement(Icon, {
    width: "2rem",
    height: "2rem"
  }), /*#__PURE__*/React__default.createElement("strong", {
    className: "card-label"
  }, label, "\xA0"), children, actions && actions.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
    ref: moreButton,
    className: "more"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$O, null)), /*#__PURE__*/React__default.createElement(PopOverMenu$1, {
    anchor: moreButton,
    items: actions
  })));
};

CardHeader.propTypes = {
  label: PropTypes.any.isRequired,
  icon: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.any,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  }))
};
var CardHeader$1 = CardHeader;

var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      loading = _ref.loading;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: "card ".concat(loading ? "loading" : "", " ").concat(className ? className : "")
  }, loading ? /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null) : children);
});
Card.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null,
        hasHeader = false;
    React__default.Children.forEach(prop, function (child) {
      if (!child) return;
      if (child.type == CardHeader$1) hasHeader = true;
    });
    if (!hasHeader && !props.loading) return new Error("".concat(componentName, " must have CardHeader child."));
    return error;
  }
};
var Card$1 = Card;

var CardBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: "card-body ".concat(className ? className : "")
  }, children);
});
CardBody.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
var CardBody$1 = CardBody;

var context$4 = /*#__PURE__*/React__default.createContext({
  chartWidth: 0,
  chartHeight: 0,
  chartPadTop: 0,
  chartPadLeft: 0,
  yAxesPositioning: {},
  registerYScale: function registerYScale() {
    return null;
  },
  unregisterYScale: function unregisterYScale() {
    return null;
  },
  registerYAxis: function registerYAxis() {
    return null;
  },
  unregisterYAxis: function unregisterYAxis() {
    return null;
  }
});
var ChartContext = context$4;

var context$3 = /*#__PURE__*/React__default.createContext({
  data: [],
  valueLabels: null,
  tooltipLabel: null,
  valueScale: null,
  timeScale: null,
  mapValue: function mapValue(v) {
    return v;
  }
});
var ChartDataSourceContext = context$3;

var translateColorToSafeString = function translateColorToSafeString(colorString) {
  var chartNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var value = colorString;

  if (colorString.startsWith("var(")) {
    var _colorString$match = colorString.match(/--[^)]+/),
        _colorString$match2 = _slicedToArray$1(_colorString$match, 1),
        cssVariable = _colorString$match2[0];

    value = getComputedStyle(chartNode).getPropertyValue(cssVariable);
  }

  if (value == "none" || !value) return "transparent";
  return value;
};

var ToolTip = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ToolTip, _React$Component);

  var _super = _createSuper$4(ToolTip);

  function ToolTip(props) {
    var _this;

    _classCallCheck$2(this, ToolTip);

    _this = _super.call(this, props);
    _this.anchor = null;
    _this._mounted = true;
    _this.state = {
      shown: false,
      showingTimeout: -1,
      hiding: false,
      hidingTimeout: -1,
      top: -1000,
      left: -1000
    };
    _this.handleAnchorMouseEnter = _this.handleAnchorMouseEnter.bind(_assertThisInitialized$2(_this));
    _this.handleAnchorMouseLeave = _this.handleAnchorMouseLeave.bind(_assertThisInitialized$2(_this));
    _this.handleScrollWhileOpen = _this.handleScrollWhileOpen.bind(_assertThisInitialized$2(_this));
    _this.toolTipRoot = document.getElementById("tool-tip-root");

    if (!_this.toolTipRoot) {
      _this.toolTipRoot = document.createElement("div");
      _this.toolTipRoot.id = "tool-tip-root";
      document.body.appendChild(_this.toolTipRoot);
    }

    return _this;
  }

  _createClass$2(ToolTip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.rebindAnchor(this.props.anchor, null, this.props.show != undefined);

      if (this.props.show) {
        this.setPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.anchor && this.anchor !== this.props.anchor) {
        this.rebindAnchor(this.props.anchor, this.anchor, this.props.show != undefined);
      }

      if (!prevProps.show && this.props.show) {
        this.setPosition();
      } else if (prevProps.show && !this.props.show) {
        this.setState({
          hiding: false,
          shown: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
      clearTimeout(this.state.hidingTimeout);
      clearTimeout(this.state.showingTimeout);
      this.rebindAnchor(null, this.anchor);
      document.removeEventListener("scroll", this.handleScrollWhileOpen, true);
    }
  }, {
    key: "rebindAnchor",
    value: function rebindAnchor(anchor) {
      var prevAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.anchor;
      var controlled = arguments.length > 2 ? arguments[2] : undefined;

      if (prevAnchor !== null && prevAnchor !== void 0 && prevAnchor.current) {
        prevAnchor.current.removeEventListener("mouseenter", this.handleAnchorMouseEnter);
        prevAnchor.current.removeEventListener("mouseleave", this.handleAnchorMouseLeave);
      }

      if (anchor) {
        this.anchor = anchor;

        if (anchor.current && !controlled) {
          anchor.current.addEventListener("mouseenter", this.handleAnchorMouseEnter);
          anchor.current.addEventListener("mouseleave", this.handleAnchorMouseLeave);
        }
      }
    }
  }, {
    key: "handleAnchorMouseEnter",
    value: function handleAnchorMouseEnter() {
      var _this2 = this;

      clearTimeout(this.state.hidingTimeout);
      this.setState({
        showingTimeout: setTimeout(function () {
          if (!_this2._mounted) return;

          _this2.setPosition();

          document.addEventListener("scroll", _this2.handleScrollWhileOpen, true);
        }, this.props.delay)
      });
    }
  }, {
    key: "handleScrollWhileOpen",
    value: function handleScrollWhileOpen() {
      this.setPosition();
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var _this$anchor;

      var anchor = (_this$anchor = this.anchor) === null || _this$anchor === void 0 ? void 0 : _this$anchor.current;
      if (!anchor) return;
      var rect = anchor.getBoundingClientRect();

      if (rect) {
        var coords = {
          top: rect.top + window.scrollY,
          left: rect.left + window.scrollX
        },
            position = this.props.position,
            viewHeight = window.document.documentElement.clientHeight,
            viewWidth = window.document.documentElement.clientWidth,
            height = anchor.offsetHeight || anchor.clientHeight,
            width = anchor.offsetWidth || anchor.clientWidth;

        if (anchor.matches("svg *")) {
          try {
            var _anchor$getBBox = anchor.getBBox(),
                svgNodeHeight = _anchor$getBBox.height,
                svgNodeWidth = _anchor$getBBox.width;

            height = svgNodeHeight;
            width = svgNodeWidth;
          } catch (e) {
            height = 0;
            width = 0;
          }
        }

        var coordsBottom = coords.top + height,
            coordsRight = coords.left + width;
        var WRAPPER_MARGIN = this.props.wrapperSize + this.props.paddingBetweenAnchorAndTooltip;

        if (position.includes("top") && coords.top < WRAPPER_MARGIN) {
          position = position.replace("top", "bottom");
        } else if (position.includes("bottom") && coordsBottom > viewHeight - WRAPPER_MARGIN) {
          position = position.replace("bottom", "top");
        }

        if (position.includes("left") && coords.left < WRAPPER_MARGIN) {
          if (coordsRight > viewWidth - WRAPPER_MARGIN) {
            position = "bottom";
          } else {
            position = position.replace("left", "right");
          }
        } else if (position.includes("right") && coordsRight > viewWidth - WRAPPER_MARGIN) {
          if (coords.left < WRAPPER_MARGIN) {
            position = "bottom";
          } else {
            position = position.replace("right", "left");
          }
        }

        if (position == "top") {
          if (coords.left < WRAPPER_MARGIN / 2) {
            position = "right";
          } else if (coordsRight > viewWidth - WRAPPER_MARGIN / 2) {
            position = "left";
          }
        } else if (position == "right") {
          if (coords.top < WRAPPER_MARGIN / 2) {
            position = "bottom";
          } else if (coordsBottom > viewHeight - WRAPPER_MARGIN / 2) {
            position = "top";
          }
        } else if (position == "bottom") {
          if (coords.left < WRAPPER_MARGIN / 2 && coordsRight < viewWidth - WRAPPER_MARGIN / 2) {
            position = "right";
          } else if (coordsRight > viewWidth - WRAPPER_MARGIN / 2 && coords.left > WRAPPER_MARGIN / 2) {
            position = "left";
          } else if (coordsBottom > viewHeight - WRAPPER_MARGIN / 2) {
            position = "bottom";
          }
        } else if (position == "left") {
          if (coords.top < WRAPPER_MARGIN / 2) {
            position = "bottom";
          } else if (coordsBottom > viewHeight - WRAPPER_MARGIN / 2) {
            position = "top";
          }
        }

        if (position == "top") {
          coords.top -= this.props.paddingBetweenAnchorAndTooltip;
          coords.left += width / 2;
          coords.align = "bottom";
        } else if (position == "bottom") {
          coords.top += height + this.props.paddingBetweenAnchorAndTooltip;
          coords.left += width / 2;
          coords.align = "top";
        } else if (position == "left") {
          coords.left -= this.props.paddingBetweenAnchorAndTooltip;
          coords.top += height / 2;
          coords.align = "right";
        } else if (position == "right") {
          coords.left += width + this.props.paddingBetweenAnchorAndTooltip;
          coords.top += height / 2;
          coords.align = "left";
        }

        this.setState(_objectSpread2({
          shown: true
        }, coords));
      }
    }
  }, {
    key: "handleAnchorMouseLeave",
    value: function handleAnchorMouseLeave() {
      var _this3 = this;

      clearTimeout(this.state.showingTimeout);
      this.setState({
        hiding: true,
        hidingTimeout: setTimeout(function () {
          if (!_this3._mounted) return;
          document.removeEventListener("scroll", _this3.handleScrollWhileOpen, true);

          _this3.setState({
            hiding: false,
            shown: false
          });
        }, 200)
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shown) return null;
      var _this$state = this.state,
          top = _this$state.top,
          left = _this$state.left,
          align = _this$state.align,
          hiding = _this$state.hiding,
          _this$props = this.props,
          children = _this$props.children,
          wrapperClassName = _this$props.wrapperClassName,
          style = _this$props.style;
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
        theme: this.context,
        className: "tool-tip-wrapper align-".concat(align, " ").concat(wrapperClassName ? wrapperClassName : ""),
        style: {
          top: top,
          left: left
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "tool-tip ".concat(hiding ? "hiding" : ""),
        style: style
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "tool-tip-inner"
      }, children))), this.toolTipRoot);
    }
  }]);

  return ToolTip;
}(React__default.Component);

_defineProperty$3(ToolTip, "contextType", ThemeContext);

ToolTip.propTypes = {
  show: PropTypes.bool,
  anchor: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  children: PropTypes.any,
  style: PropTypes.any,
  wrapperClassName: PropTypes.string,
  position: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  delay: PropTypes.number,
  paddingBetweenAnchorAndTooltip: PropTypes.number.isRequired,
  wrapperSize: PropTypes.number
};
ToolTip.defaultProps = {
  position: "top",
  delay: 500,
  paddingBetweenAnchorAndTooltip: 10,
  wrapperSize: 160
};
var ToolTip$1 = ToolTip;

var ChartPoint = function ChartPoint(_ref) {
  var left = _ref.left,
      top = _ref.top,
      label = _ref.label;
  var circle = useRef();

  var _useContext = useContext(ChartContext),
      chartWidth = _useContext.chartWidth,
      chartHeight = _useContext.chartHeight,
      chartPadTop = _useContext.chartPadTop,
      chartPadLeft = _useContext.chartPadLeft;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("circle", {
    className: "chart-point-segment",
    fill: "rgb(0,0,0,0)",
    ref: circle,
    cx: left * chartWidth + chartPadLeft,
    cy: top * chartHeight + chartPadTop,
    r: 10
  }), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: "bottom",
    anchor: circle,
    delay: 25,
    paddingBetweenAnchorAndTooltip: 5
  }, label));
};

ChartPoint.propTypes = {
  left: PropTypes.number,
  top: PropTypes.number,
  label: PropTypes.any
};
var ChartPoint$1 = ChartPoint;

var _excluded$o = ["tooltips", "tooltipValueFormat", "draw", "stroke", "baseline"];
var LineSegment = /*#__PURE__*/forwardRef(function (props, _ref3) {
  var _props$tooltips = props.tooltips,
      tooltips = _props$tooltips === void 0 ? false : _props$tooltips,
      _props$tooltipValueFo = props.tooltipValueFormat,
      tooltipValueFormat = _props$tooltipValueFo === void 0 ? function (n) {
    return n;
  } : _props$tooltipValueFo,
      _props$draw = props.draw,
      draw = _props$draw === void 0 ? false : _props$draw,
      _props$stroke = props.stroke,
      stroke = _props$stroke === void 0 ? "var(--chart-line-segment-stroke-color)" : _props$stroke,
      _props$baseline = props.baseline,
      baseline = _props$baseline === void 0 ? 0 : _props$baseline,
      polylineProps = _objectWithoutProperties(props, _excluded$o);

  var _useContext = useContext(ChartContext),
      chartWidth = _useContext.chartWidth,
      chartHeight = _useContext.chartHeight,
      chartPadTop = _useContext.chartPadTop,
      chartPadLeft = _useContext.chartPadLeft,
      isCanvas = _useContext.isCanvas,
      chartRef = _useContext.chartRef,
      canvasRefreshCounter = _useContext.canvasRefreshCounter;

  var _useContext2 = useContext(ChartDataSourceContext),
      data = _useContext2.data,
      tooltipLabel = _useContext2.tooltipLabel,
      tooltipValueLabel = _useContext2.tooltipValueLabel,
      valueScale = _useContext2.valueScale,
      timeScale = _useContext2.timeScale,
      mapValue = _useContext2.mapValue;

  var _useState = useState(!draw),
      _useState2 = _slicedToArray$1(_useState, 2),
      polylineLengthLoaded = _useState2[0],
      setPolyLineLengthLoaded = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray$1(_useState3, 2),
      polylineLength = _useState4[0],
      setPolylineLength = _useState4[1];

  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    if (data.length == 0 || !valueScale || !timeScale) return;
    var strokeDasharray = polylineProps.strokeDasharray;
    var minDate = timeScale.min,
        maxDate = timeScale.max;
    var minValue = valueScale.min,
        maxValue = valueScale.max;
    if (minValue == Infinity || maxValue == -Infinity) return;
    var positionedData = data.map(function (_ref) {
      var value = _ref.value,
          date = _ref.date;
      return {
        top: minValue == maxValue ? 1 : 1 - (value - minValue) / (maxValue - minValue),
        left: (date - minDate) / (maxDate - minDate),
        friendlyDate: moment(date).format("lll"),
        friendlyValue: tooltipValueFormat(mapValue ? mapValue(value) : value)
      };
    });

    if (baseline > 0) {
      positionedData = positionedData.map(function (datum) {
        var totalHeight = 1 - baseline;
        return _objectSpread2(_objectSpread2({}, datum), {}, {
          top: datum.top * totalHeight
        });
      });
    }

    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    ctx.strokeStyle = translateColorToSafeString(stroke, chartRef.current);
    ctx.lineWidth = 2 * dpr;
    ctx.beginPath();

    if (strokeDasharray) {
      ctx.setLineDash(strokeDasharray.split(" ").map(function (n) {
        return parseInt(n) * dpr;
      }));
    } else {
      ctx.setLineDash([]);
    }

    var moved = false;

    var _iterator = _createForOfIteratorHelper(positionedData),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var point = _step.value;
        var left = point.left * chartWidth + chartPadLeft;
        var top = point.top * chartHeight + chartPadTop;

        if (!moved) {
          ctx.moveTo(left * dpr, top * dpr);
          moved = true;
        } else {
          ctx.lineTo(left * dpr, top * dpr);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    ctx.stroke();
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, data, valueScale, timeScale]);
  if (isCanvas) return null;
  if (data.length == 0 || !valueScale || !timeScale) return null;
  var minDate = timeScale.min,
      maxDate = timeScale.max;
  var minValue = valueScale.min,
      maxValue = valueScale.max;
  if (minValue == Infinity || maxValue == -Infinity) return null;
  var positionedData = data.map(function (_ref2) {
    var value = _ref2.value,
        date = _ref2.date;
    return {
      top: minValue == maxValue ? 1 : 1 - (value - minValue) / (maxValue - minValue),
      left: (date - minDate) / (maxDate - minDate),
      friendlyDate: moment(date).format("lll"),
      friendlyValue: tooltipValueFormat(mapValue ? mapValue(value) : value)
    };
  });

  if (baseline > 0) {
    positionedData = positionedData.map(function (datum) {
      var totalHeight = 1 - baseline;
      return _objectSpread2(_objectSpread2({}, datum), {}, {
        top: datum.top * totalHeight
      });
    });
  }

  var polylinePoints = positionedData.map(function (point) {
    return "".concat(point.left * chartWidth + chartPadLeft, ",").concat(point.top * chartHeight + chartPadTop);
  }).join(" ");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("polyline", _extends$U({
    ref: function ref(node) {
      if (_ref3 && _ref3.current !== node) _ref3.current = node;

      if (node && node.getTotalLength) {
        if (!polylineLengthLoaded || node.getTotalLength() !== polylineLength) {
          setPolylineLength(node.getTotalLength());
          setPolyLineLengthLoaded(true);
        }
      }
    },
    fill: "none",
    stroke: stroke,
    strokeWidth: "2",
    strokeDasharray: draw ? polylineLength : null,
    strokeDashoffset: draw ? polylineLength : null,
    className: draw ? "draw" : null
  }, polylineProps, {
    points: polylinePoints
  })), tooltips && positionedData.map(function (_ref4, index) {
    var top = _ref4.top,
        left = _ref4.left,
        friendlyDate = _ref4.friendlyDate,
        friendlyValue = _ref4.friendlyValue;
    return /*#__PURE__*/React__default.createElement(ChartPoint$1, {
      key: index,
      top: top,
      left: left,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, tooltipLabel), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, tooltipValueLabel, friendlyValue), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, friendlyDate), /*#__PURE__*/React__default.createElement("br", null))
    });
  }));
});
LineSegment.propTypes = {
  stroke: PropTypes.string,
  tooltips: PropTypes.bool,
  tooltipValueFormat: PropTypes.func,
  draw: PropTypes.bool,
  baseline: PropTypes.number
};
var Line$1 = LineSegment;

var context$2 = /*#__PURE__*/React__default.createContext({
  registerBarSegment: function registerBarSegment() {
    return null;
  },
  unregisterBarSegment: function unregisterBarSegment() {
    return null;
  },
  getBarXOffset: function getBarXOffset() {
    return null;
  },
  getBarYOffset: function getBarYOffset() {
    return null;
  },
  numberOfBars: 0,
  barDisplayWidth: 0,
  barClusterWidth: 0
});
var BarContext = context$2;

var BarSegment = function BarSegment(props) {
  var _props$tooltips = props.tooltips,
      tooltips = _props$tooltips === void 0 ? false : _props$tooltips,
      _props$includeDatumIn = props.includeDatumInBar,
      includeDatumInBar = _props$includeDatumIn === void 0 ? function (value) {
    return value > 0;
  } : _props$includeDatumIn,
      noUnfilled = props.noUnfilled,
      _props$filledColor = props.filledColor,
      filledColor = _props$filledColor === void 0 ? "var(--chart-bar-segment-filled-color)" : _props$filledColor,
      _props$unfilledColor = props.unfilledColor,
      unfilledColor = _props$unfilledColor === void 0 ? "var(--chart-bar-segment-unfilled-color)" : _props$unfilledColor;

  var _useContext = useContext(BarContext),
      registerBarSegment = _useContext.registerBarSegment,
      unregisterBarSegment = _useContext.unregisterBarSegment,
      getBarXOffset = _useContext.getBarXOffset,
      getBarYOffset = _useContext.getBarYOffset,
      numberOfBars = _useContext.numberOfBars,
      barDisplayWidth = _useContext.barDisplayWidth,
      barClusterWidth = _useContext.barClusterWidth;

  var _useContext2 = useContext(ChartDataSourceContext),
      data = _useContext2.data,
      valueScale = _useContext2.valueScale,
      timeScale = _useContext2.timeScale,
      mapValue = _useContext2.mapValue;

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  useEffect(function () {
    registerBarSegment(id);
    return function () {
      return unregisterBarSegment(id);
    };
  }, [id]);
  if (data.length == 0 || !valueScale || !timeScale) return null;
  var minDate = timeScale.min,
      maxDate = timeScale.max;
  var msBarSize = (maxDate - minDate) / numberOfBars;
  var bars = [];

  var _loop = function _loop(barIndex) {
    var barStart = minDate + barIndex * msBarSize,
        barEnd = barStart + msBarSize,
        barRange = barEnd - barStart;
    var barValue = 0;
    var dataBeforeRange = data.filter(function (_ref2) {
      var date = _ref2.date;
      return barStart > date;
    });
    var valueBeforeRange = 0;

    if (dataBeforeRange.length > 0) {
      var lastDatum = dataBeforeRange[dataBeforeRange.length - 1];
      valueBeforeRange = lastDatum.value;
    }

    var dataInRange = data.filter(function (_ref3) {
      var date = _ref3.date;
      return barStart <= date && barEnd > date;
    });

    if (dataInRange.length > 0 && includeDatumInBar(mapValue(valueBeforeRange))) {
      var firstDatum = dataInRange[0];
      barValue += (firstDatum.date - barStart) / barRange;
    }

    barValue += dataInRange.reduce(function (percent, datum, index) {
      if (!includeDatumInBar(mapValue(datum.value))) return percent;
      var nextDate = barEnd;
      var nextDatum = dataInRange[index + 1];
      if (nextDatum) nextDate = nextDatum.date;
      return percent + (nextDate - datum.date) / barRange;
    }, 0);

    if (dataInRange.length == 0 && includeDatumInBar(mapValue(valueBeforeRange))) {
      barValue = 1;
    }

    bars.push({
      start: barStart,
      end: barEnd,
      value: barValue
    });
  };

  for (var barIndex = 0; barIndex < numberOfBars; barIndex += 1) {
    _loop(barIndex);
  }

  return bars.map(function (_ref, index) {
    var start = _ref.start,
        end = _ref.end,
        value = _ref.value;
    return /*#__PURE__*/React__default.createElement(Bar, {
      key: index,
      id: "".concat(id, "-").concat(index),
      displayWidth: barDisplayWidth,
      clusterWidth: barClusterWidth,
      start: start,
      end: end,
      value: value,
      filledColor: filledColor,
      unfilledColor: unfilledColor,
      noUnfilled: noUnfilled,
      tooltip: tooltips,
      xOffset: getBarXOffset(id),
      yOffset: getBarYOffset(id, index, value)
    });
  });
};

BarSegment.propTypes = {
  tooltips: PropTypes.bool,
  includeDatumInBar: PropTypes.func,
  filledColor: PropTypes.string,
  unfilledColor: PropTypes.string,
  noUnfilled: PropTypes.bool
};

var Bar = function Bar(props) {
  var id = props.id,
      displayWidth = props.displayWidth,
      clusterWidth = props.clusterWidth,
      start = props.start,
      end = props.end,
      value = props.value,
      filledColor = props.filledColor,
      unfilledColor = props.unfilledColor,
      noUnfilled = props.noUnfilled,
      tooltip = props.tooltip,
      xOffset = props.xOffset,
      yOffset = props.yOffset;
  var filledRef = useRef();
  var i18n = useI18n$1();

  var _useContext3 = useContext(ChartContext),
      chartWidth = _useContext3.chartWidth,
      chartHeight = _useContext3.chartHeight,
      chartPadTop = _useContext3.chartPadTop,
      chartPadLeft = _useContext3.chartPadLeft,
      isCanvas = _useContext3.isCanvas,
      chartRef = _useContext3.chartRef,
      canvasRefreshCounter = _useContext3.canvasRefreshCounter;

  var _useContext4 = useContext(ChartDataSourceContext),
      tooltipLabel = _useContext4.tooltipLabel,
      timeScale = _useContext4.timeScale;

  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    if (!timeScale) return;
    var minDate = timeScale.min,
        maxDate = timeScale.max;
    var msCenter = start + (end - start) / 2;
    var centerX = chartWidth * ((msCenter - minDate) / (maxDate - minDate));
    var leftX = centerX - clusterWidth / 2;
    var filledY = chartPadTop + (1 - value) * chartHeight;
    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;

    if (yOffset) {
      filledY -= yOffset * chartHeight * dpr;
    } else if (!yOffset && !noUnfilled) {
      ctx.beginPath();
      ctx.fillStyle = translateColorToSafeString(unfilledColor, chartRef.current);
      ctx.fillRect((chartPadLeft + leftX + xOffset) * dpr, chartPadTop * dpr, displayWidth * dpr, chartHeight * dpr);
      ctx.stroke();
    }

    ctx.beginPath();
    ctx.fillStyle = translateColorToSafeString(filledColor, chartRef.current);
    ctx.fillRect((chartPadLeft + leftX + xOffset) * dpr, filledY * dpr, displayWidth * dpr, value * chartHeight * dpr);
    ctx.stroke();
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, timeScale, start, end, clusterWidth]);
  if (isCanvas) return null;
  if (!timeScale) return null;
  var minDate = timeScale.min,
      maxDate = timeScale.max;
  var msCenter = start + (end - start) / 2;
  var centerX = chartWidth * ((msCenter - minDate) / (maxDate - minDate));
  var leftX = centerX - clusterWidth / 2;
  var filledY = chartPadTop + (1 - value) * chartHeight;

  if (yOffset) {
    filledY -= yOffset * chartHeight;
  }

  var filledInstructions = "M".concat(chartPadLeft + leftX + xOffset + displayWidth / 2, ",").concat(filledY, "\n                              h").concat(displayWidth / 2, "\n                              v").concat(value * chartHeight, "\n                              h").concat(-1 * displayWidth, "\n                              v").concat(-1 * (value * chartHeight), "\n                              h").concat(displayWidth / 2, " z").replace(/\n\s+/g, " ");
  var unfilledInstructions = "M".concat(chartPadLeft + leftX + xOffset + displayWidth / 2, ",").concat(chartPadTop, "\n                                h").concat(displayWidth / 2, "\n                                v").concat(chartHeight, "\n                                h").concat(-1 * displayWidth, "\n                                v").concat(-1 * chartHeight, "\n                                h").concat(displayWidth / 2, " z").replace(/\n\s+/g, " ");
  var showDate = moment(start).format("L") !== moment(end).format("L");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: id
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: chartPadLeft + leftX + xOffset,
    y: chartPadTop,
    width: displayWidth,
    height: chartHeight,
    rx: 2
  }))), !yOffset && !noUnfilled && /*#__PURE__*/React__default.createElement("path", {
    d: unfilledInstructions,
    clipPath: "url(#".concat(id, ")"),
    fill: unfilledColor
  }), !!value && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: filledInstructions,
    clipPath: "url(#".concat(id, ")"),
    ref: filledRef,
    fill: filledColor,
    strokeWidth: 2,
    stroke: "transparent"
  }), tooltip && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: "bottom",
    anchor: filledRef,
    delay: 25
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, tooltipLabel), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.barRangeDesc", {
    value: "".concat(Math.round(value * 100), "%")
  })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, moment(start).format("lll"), " - ", showDate ? moment(end).format("lll") : moment(end).format("LT"))))));
};

Bar.propTypes = {
  id: PropTypes.string,
  displayWidth: PropTypes.number,
  clusterWidth: PropTypes.number,
  start: PropTypes.number,
  end: PropTypes.number,
  value: PropTypes.number,
  filledColor: PropTypes.string,
  unfilledColor: PropTypes.string,
  noUnfilled: PropTypes.bool,
  tooltip: PropTypes.bool,
  xOffset: PropTypes.number,
  yOffset: PropTypes.number
};
var Bar$1 = BarSegment;

var context$1 = /*#__PURE__*/React__default.createContext({
  tileWidth: 0,
  tileHeight: 0,
  tilePadding: 0,
  numberOfTiles: 0,
  numberOfTilesPerRow: 0,
  registerTileLabel: function registerTileLabel() {
    return null;
  },
  unregisterTileLabel: function unregisterTileLabel() {
    return null;
  },
  getFormattedTileLabel: function getFormattedTileLabel() {
    return null;
  }
});
var HeatMapContext = context$1;

var rgbRegExp = /^rgba?\((\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3})/;
var hexRegExp = /^#?[\w\d]{6}$/;

var getRGBFromColorString = function getRGBFromColorString(color) {
  if (hexRegExp.test(color)) {
    return {
      r: parseInt(color.replace("#", "").substring(0, 2), 16),
      g: parseInt(color.replace("#", "").substring(2, 4), 16),
      b: parseInt(color.replace("#", "").substring(4, 6), 16)
    };
  } else if (rgbRegExp.test(color)) {
    var _color$match = color.match(rgbRegExp),
        _color$match2 = _slicedToArray$1(_color$match, 4),
        r = _color$match2[1],
        g = _color$match2[2],
        b = _color$match2[3];

    return {
      r: parseInt(r),
      g: parseInt(g),
      b: parseInt(b)
    };
  } else {
    return {
      r: 0,
      g: 0,
      b: 0
    };
  }
};

var calculateColorFromPercent = function calculateColorFromPercent(color1, color2, percent) {
  var pad = function pad(n) {
    return n.length < 2 ? "0".concat(n) : n;
  };

  var hex = function hex(n) {
    return pad(n.toString(16));
  };

  var _getRGBFromColorStrin = getRGBFromColorString(color1),
      r1 = _getRGBFromColorStrin.r,
      g1 = _getRGBFromColorStrin.g,
      b1 = _getRGBFromColorStrin.b;

  var _getRGBFromColorStrin2 = getRGBFromColorString(color2),
      r2 = _getRGBFromColorStrin2.r,
      g2 = _getRGBFromColorStrin2.g,
      b2 = _getRGBFromColorStrin2.b;

  percent = Math.min(percent, 1);
  percent = Math.max(percent, 0);
  var r = Math.round((r1 + r2) / 2);
  var g = Math.round((g1 + g2) / 2);
  var b = Math.round((b1 + b2) / 2);
  var colorsToMix,
      amountToMix = 0;

  if (percent < 0.5) {
    colorsToMix = {
      r: r1,
      g: g1,
      b: b1
    };
    amountToMix = (0.5 - percent) * 2;
  } else if (percent > 0.5) {
    colorsToMix = {
      r: r2,
      g: g2,
      b: b2
    };
    amountToMix = (percent - 0.5) * 2;
  }

  if (colorsToMix && amountToMix > 0) {
    var _colorsToMix = colorsToMix,
        rm = _colorsToMix.r,
        gm = _colorsToMix.g,
        bm = _colorsToMix.b;
    r = Math.round(rm * amountToMix + r * (1 - amountToMix));
    g = Math.round(gm * amountToMix + g * (1 - amountToMix));
    b = Math.round(bm * amountToMix + b * (1 - amountToMix));
  }

  return "#".concat(hex(r)).concat(hex(g)).concat(hex(b));
};

var HeatMapSegment = function HeatMapSegment(props) {
  var tooltips = props.tooltips,
      lowerBound = props.lowerBound,
      lowerFill = props.lowerFill,
      upperBound = props.upperBound,
      upperFill = props.upperFill;

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useContext = useContext(HeatMapContext),
      tileWidth = _useContext.tileWidth,
      tileHeight = _useContext.tileHeight,
      tilePadding = _useContext.tilePadding,
      numberOfTiles = _useContext.numberOfTiles,
      numberOfTilesPerRow = _useContext.numberOfTilesPerRow;

  var _useContext2 = useContext(ChartDataSourceContext),
      data = _useContext2.data,
      valueScale = _useContext2.valueScale,
      timeScale = _useContext2.timeScale,
      tooltipLabel = _useContext2.tooltipLabel;

  if (data.length == 0 || !valueScale || !timeScale) return null;
  var minDate = timeScale.min,
      maxDate = timeScale.max;
  var msTileSize = (maxDate - minDate) / numberOfTiles;
  var tiles = [];

  var _loop = function _loop(tileIndex) {
    var rowIndex = Math.floor(tileIndex / numberOfTilesPerRow),
        tileIndexInRow = tileIndex % numberOfTilesPerRow;
    var tileStart = minDate + tileIndex * msTileSize,
        tileEnd = tileStart + msTileSize,
        tileRange = tileEnd - tileStart;
    var dataBeforeRange = data.filter(function (_ref2) {
      var date = _ref2.date;
      return tileStart > date;
    });
    var valueBeforeRange = 0;

    if (dataBeforeRange.length > 0) {
      var lastDatum = dataBeforeRange[dataBeforeRange.length - 1];
      valueBeforeRange = lastDatum.value;
    }

    var dataInRange = data.filter(function (_ref3) {
      var date = _ref3.date;
      return tileStart <= date && tileEnd > date;
    });
    var weightedValuesInRange = [];

    if (dataInRange.length > 0) {
      weightedValuesInRange.push({
        value: valueBeforeRange,
        rangePercentage: (dataInRange[0].date - tileStart) / tileRange
      });

      for (var datumIndex = 0; datumIndex < dataInRange.length; datumIndex += 1) {
        var datum = dataInRange[datumIndex];
        var nextDate = tileEnd;
        var nextDatum = dataInRange[datumIndex + 1];
        if (nextDatum) nextDate = nextDatum.date;
        weightedValuesInRange.push({
          value: datum.value,
          rangePercentage: (nextDate - datum.date) / tileRange
        });
      }
    } else {
      weightedValuesInRange.push({
        value: valueBeforeRange,
        rangePercentage: 1
      });
    }

    var tileAverageValue = weightedValuesInRange.reduce(function (averageValue, _ref4) {
      var value = _ref4.value,
          rangePercentage = _ref4.rangePercentage;
      return averageValue + value * rangePercentage;
    }, 0);
    var percent = (tileAverageValue - lowerBound) / (upperBound - lowerBound);
    var tileColor = calculateColorFromPercent(lowerFill, upperFill, percent);
    tiles.push({
      start: tileStart,
      end: tileEnd,
      fill: tileColor,
      width: tileWidth,
      height: tileHeight,
      averageValue: tileAverageValue.toFixed(2),
      x: tileIndexInRow * (tileWidth + tilePadding),
      y: rowIndex * (tileHeight + tilePadding)
    });
  };

  for (var tileIndex = 0; tileIndex < numberOfTiles; tileIndex += 1) {
    _loop(tileIndex);
  }

  return tiles.map(function (_ref, index) {
    var start = _ref.start,
        end = _ref.end,
        fill = _ref.fill,
        width = _ref.width,
        height = _ref.height,
        averageValue = _ref.averageValue,
        x = _ref.x,
        y = _ref.y;
    return /*#__PURE__*/React__default.createElement(HeatMapTile, {
      key: index,
      segmentId: id,
      tileIndex: index,
      start: start,
      end: end,
      width: width,
      height: height,
      x: x,
      y: y,
      fill: fill,
      tooltip: tooltips,
      tooltipLabel: "".concat(tooltipLabel, ": ").concat(averageValue)
    });
  });
};

HeatMapSegment.propTypes = {
  tooltips: PropTypes.bool,
  tileSize: PropTypes.number,
  tilePadding: PropTypes.number,
  lowerBound: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lowerFill: PropTypes.string,
  upperBound: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  upperFill: PropTypes.string
};

var HeatMapTile = function HeatMapTile(props) {
  var segmentId = props.segmentId,
      tileIndex = props.tileIndex,
      start = props.start,
      end = props.end,
      tooltipLabel = props.tooltipLabel,
      tooltip = props.tooltip,
      width = props.width,
      height = props.height,
      x = props.x,
      y = props.y,
      fill = props.fill;

  var _useContext3 = useContext(ChartContext),
      chartWidth = _useContext3.chartWidth,
      chartHeight = _useContext3.chartHeight,
      chartPadTop = _useContext3.chartPadTop,
      chartPadLeft = _useContext3.chartPadLeft,
      isCanvas = _useContext3.isCanvas,
      chartRef = _useContext3.chartRef,
      canvasRefreshCounter = _useContext3.canvasRefreshCounter;

  var _useContext4 = useContext(HeatMapContext),
      registerTileLabel = _useContext4.registerTileLabel,
      unregisterTileLabel = _useContext4.unregisterTileLabel,
      getFormattedTileLabel = _useContext4.getFormattedTileLabel;

  useEffect(function () {
    if (tooltip) registerTileLabel(segmentId, tileIndex, start, end, tooltipLabel);
    return function () {
      return unregisterTileLabel(segmentId, tileIndex);
    };
  }, [start, end, tooltipLabel, tooltip]);
  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    ctx.beginPath();
    ctx.fillStyle = translateColorToSafeString(fill, chartRef.current);
    ctx.fillRect((chartPadLeft + x) * dpr, (chartPadTop + y) * dpr, width * dpr, height * dpr);
    ctx.stroke();
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, fill, x, y]);
  if (isCanvas) return null;
  var tile = useRef();
  var tooltipContents = getFormattedTileLabel(tileIndex);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("rect", {
    ref: tile,
    width: width,
    height: height,
    x: chartPadLeft + x,
    y: chartPadTop + y,
    fill: fill
  }), tooltipContents && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    wrapperSize: 300,
    position: "bottom",
    anchor: tile,
    delay: 25
  }, tooltipContents));
};

HeatMapTile.propTypes = {
  start: PropTypes.number,
  end: PropTypes.number,
  tooltip: PropTypes.bool,
  tooltipLabel: PropTypes.string,
  segmentId: PropTypes.string,
  tileIndex: PropTypes.number,
  value: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  fill: PropTypes.string
};
var HeatMap = HeatMapSegment;

var _excluded$n = ["data"];
var GappedLineSegment = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(ChartDataSourceContext),
      combinedData = _useContext.data,
      contextValue = _objectWithoutProperties(_useContext, _excluded$n);

  var dataSegments = combinedData.reduce(function (segmentsArray, datum) {
    if (datum.value) {
      segmentsArray[segmentsArray.length - 1].push(datum);
    } else if (segmentsArray[segmentsArray.length - 1].length > 0) {
      var lastValue = segmentsArray[segmentsArray.length - 1][0].value;
      segmentsArray[segmentsArray.length - 1].push({
        date: datum.date - 1,
        value: lastValue
      });
      segmentsArray.push([]);
    }

    return segmentsArray;
  }, [[]]);
  return dataSegments.map(function (data, index) {
    return /*#__PURE__*/React__default.createElement(ChartDataSourceContext.Provider, {
      key: index,
      value: _objectSpread2(_objectSpread2({}, contextValue), {}, {
        data: data
      })
    }, /*#__PURE__*/React__default.createElement(Line$1, _extends$U({
      ref: ref
    }, props)));
  });
});
var GappedLine = GappedLineSegment;

var _excluded$m = ["tooltips", "tooltipValueFormat", "gradientStart", "gradientEnd", "baseline"];
var GradientPolygonSegment = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$tooltips = props.tooltips,
      tooltips = _props$tooltips === void 0 ? false : _props$tooltips,
      _props$tooltipValueFo = props.tooltipValueFormat,
      tooltipValueFormat = _props$tooltipValueFo === void 0 ? function (n) {
    return n;
  } : _props$tooltipValueFo,
      _props$gradientStart = props.gradientStart,
      gradientStart = _props$gradientStart === void 0 ? "var(--chart-gradient-polygon-segment-gradient-start)" : _props$gradientStart,
      _props$gradientEnd = props.gradientEnd,
      gradientEnd = _props$gradientEnd === void 0 ? "var(--chart-gradient-polygon-segment-gradient-end)" : _props$gradientEnd,
      _props$baseline = props.baseline,
      baseline = _props$baseline === void 0 ? 0 : _props$baseline,
      polygonProps = _objectWithoutProperties(props, _excluded$m);

  var _useContext = useContext(ChartContext),
      chartWidth = _useContext.chartWidth,
      chartHeight = _useContext.chartHeight,
      chartPadTop = _useContext.chartPadTop,
      chartPadLeft = _useContext.chartPadLeft,
      isCanvas = _useContext.isCanvas,
      chartRef = _useContext.chartRef,
      canvasRefreshCounter = _useContext.canvasRefreshCounter;

  var _useContext2 = useContext(ChartDataSourceContext),
      data = _useContext2.data,
      tooltipLabel = _useContext2.tooltipLabel,
      tooltipValueLabel = _useContext2.tooltipValueLabel,
      valueScale = _useContext2.valueScale,
      timeScale = _useContext2.timeScale,
      mapValue = _useContext2.mapValue;

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    if (data.length == 0 || !valueScale || !timeScale) return;
    var minDate = timeScale.min,
        maxDate = timeScale.max;
    var minValue = valueScale.min,
        maxValue = valueScale.max;
    if (minValue == Infinity || maxValue == -Infinity) return;
    var positionedData = data.map(function (_ref) {
      var value = _ref.value,
          date = _ref.date;
      return {
        top: minValue == maxValue ? 1 : 1 - (value - minValue) / (maxValue - minValue),
        left: (date - minDate) / (maxDate - minDate),
        friendlyDate: moment(date).format("lll"),
        friendlyValue: tooltipValueFormat(mapValue ? mapValue(value) : value)
      };
    });

    if (baseline > 0) {
      positionedData = positionedData.map(function (datum) {
        var totalHeight = 1 - baseline;
        return _objectSpread2(_objectSpread2({}, datum), {}, {
          top: datum.top * totalHeight
        });
      });
    }

    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    var gradient = ctx.createLinearGradient(0, 0, chartWidth * dpr, chartHeight * dpr);
    gradient.addColorStop(0.05, translateColorToSafeString(gradientStart, chartRef.current));
    gradient.addColorStop(0.95, translateColorToSafeString(gradientEnd, chartRef.current));
    ctx.fillStyle = gradient;
    ctx.beginPath();
    var moved = false;

    for (var _i = 0, _arr = [{
      top: 1,
      left: 0
    }].concat(_toConsumableArray(positionedData), [{
      top: 1,
      left: 1
    }]); _i < _arr.length; _i++) {
      var point = _arr[_i];
      var left = point.left * chartWidth + chartPadLeft;
      var top = point.top * chartHeight + chartPadTop;

      if (!moved) {
        ctx.moveTo(left * dpr, top * dpr);
        moved = true;
      } else {
        ctx.lineTo(left * dpr, top * dpr);
      }
    }

    ctx.closePath();
    ctx.fill();
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, data, valueScale, timeScale]);
  if (isCanvas) return null;
  if (data.length == 0 || !valueScale || !timeScale) return null;
  var minDate = timeScale.min,
      maxDate = timeScale.max;
  var minValue = valueScale.min,
      maxValue = valueScale.max;
  if (minValue == Infinity || maxValue == -Infinity) return null;
  var positionedData = data.map(function (_ref2) {
    var value = _ref2.value,
        date = _ref2.date;
    return {
      top: minValue == maxValue ? 1 : 1 - (value - minValue) / (maxValue - minValue),
      left: (date - minDate) / (maxDate - minDate),
      friendlyDate: moment(date).format("lll"),
      friendlyValue: tooltipValueFormat(mapValue ? mapValue(value) : value)
    };
  });

  if (baseline > 0) {
    positionedData = positionedData.map(function (datum) {
      var totalHeight = 1 - baseline;
      return _objectSpread2(_objectSpread2({}, datum), {}, {
        top: datum.top * totalHeight
      });
    });
  }

  var polygonPoints = [{
    top: 1,
    left: 0
  }].concat(_toConsumableArray(positionedData), [{
    top: 1,
    left: 1
  }]).map(function (point) {
    return "".concat(point.left * chartWidth + chartPadLeft, ",").concat(point.top * chartHeight + chartPadTop);
  }).join(" ");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "gradient-".concat(id),
    gradientTransform: "rotate(-45)"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "5%",
    stopColor: gradientStart
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "95%",
    stopColor: gradientEnd
  }))), /*#__PURE__*/React__default.createElement("polygon", _extends$U({
    ref: ref
  }, polygonProps, {
    fill: "url(#gradient-".concat(id, ")"),
    stroke: "none",
    points: polygonPoints
  })), tooltips && positionedData.map(function (_ref3, index) {
    var top = _ref3.top,
        left = _ref3.left,
        friendlyDate = _ref3.friendlyDate,
        friendlyValue = _ref3.friendlyValue;
    return /*#__PURE__*/React__default.createElement(ChartPoint$1, {
      key: index,
      top: top,
      left: left,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, tooltipLabel), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, tooltipValueLabel, friendlyValue), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, friendlyDate), /*#__PURE__*/React__default.createElement("br", null))
    });
  }));
});
GradientPolygonSegment.propTypes = {
  tooltips: PropTypes.bool,
  tooltipValueFormat: PropTypes.func,
  gradientStart: PropTypes.string,
  gradientEnd: PropTypes.string,
  baseline: PropTypes.number
};
var GradientPolygon = GradientPolygonSegment;

var Segments = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Line: Line$1,
  Bar: Bar$1,
  HeatMap: HeatMap,
  GappedLine: GappedLine,
  GradientPolygon: GradientPolygon
});

var defaultTickFormat = function defaultTickFormat(tick) {
  if (isNaN(tick)) return tick;
  return parseFloat(tick).toFixed(1);
};

var YAxis = function YAxis(props) {
  var _props$numericTicks = props.numericTicks,
      numericTicks = _props$numericTicks === void 0 ? 5 : _props$numericTicks,
      _props$tickFormat = props.tickFormat,
      tickFormat = _props$tickFormat === void 0 ? defaultTickFormat : _props$tickFormat,
      _props$decimals = props.decimals,
      decimals = _props$decimals === void 0 ? 1 : _props$decimals,
      _props$gridStroke = props.gridStroke,
      gridStroke = _props$gridStroke === void 0 ? "var(--chart-y-axis-grid-stroke)" : _props$gridStroke,
      _props$gridStrokeWidt = props.gridStrokeWidth,
      gridStrokeWidth = _props$gridStrokeWidt === void 0 ? 2 : _props$gridStrokeWidt,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? "var(--chart-y-axis-text-color)" : _props$textColor;

  var _useContext = useContext(ChartContext),
      registerYAxis = _useContext.registerYAxis,
      unregisterYAxis = _useContext.unregisterYAxis,
      yAxesPositioning = _useContext.yAxesPositioning,
      chartWidth = _useContext.chartWidth,
      chartHeight = _useContext.chartHeight,
      chartPadTop = _useContext.chartPadTop,
      chartPadLeft = _useContext.chartPadLeft,
      isCanvas = _useContext.isCanvas,
      chartRef = _useContext.chartRef,
      canvasRefreshCounter = _useContext.canvasRefreshCounter;

  var _useContext2 = useContext(ChartDataSourceContext),
      valueScale = _useContext2.valueScale;

  var usingNumericScale = valueScale && !valueScale.valueLabels;

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      registered = _useState4[0],
      setRegistered = _useState4[1];

  useEffect(function () {
    try {
      var longestExpectedValueLabelLength;

      if (valueScale && valueScale.valueLabels) {
        longestExpectedValueLabelLength = Object.values(valueScale.valueLabels).sort(function (a, b) {
          return b.length - a.length;
        })[0].length;
      } else {
        longestExpectedValueLabelLength = valueScale.max.toFixed(decimals).length;
      }

      registerYAxis(id, usingNumericScale, longestExpectedValueLabelLength);
      setRegistered(true);
    } catch (e) {
      setRegistered(false);
    }

    return function () {
      return unregisterYAxis(id);
    };
  }, [id, usingNumericScale]);
  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    if (!registered) return;
    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    var positioning = yAxesPositioning[id];

    if (usingNumericScale) {
      var range = valueScale.max - valueScale.min,
          step = Math.round(range / numericTicks * Math.pow(10, decimals)) / Math.pow(10, decimals);
      if (range == -Infinity) return;

      for (var i = 1; i < numericTicks; i++) {
        var top = range == 0 ? 1 : 1 - i * step / range;
        ctx.beginPath();
        ctx.strokeStyle = translateColorToSafeString(gridStroke, chartRef.current);
        ctx.moveTo(chartPadLeft * dpr, (top * chartHeight + chartPadTop) * dpr);
        ctx.lineTo((chartWidth + chartPadLeft) * dpr, (top * chartHeight + chartPadTop) * dpr);
        ctx.stroke();

        if (positioning) {
          ctx.beginPath();
          ctx.strokeStyle = translateColorToSafeString(textColor, chartRef.current);
          ctx.fillStyle = translateColorToSafeString(textColor, chartRef.current);
          ctx.lineWidth = 1;
          ctx.textAlign = "end";
          ctx.textBaseline = "middle";
          ctx.font = "".concat(dpr * 12, "px Source Sans Pro");
          ctx.fillText(tickFormat(Math.round((valueScale.min + i * step) * Math.pow(10, decimals)) / Math.pow(10, decimals)), (positioning.left + positioning.width) * dpr, (top * chartHeight + chartPadTop) * dpr);
          ctx.stroke();
        }
      }
    } else {
      var _range = valueScale.max - valueScale.min;

      for (var _i in valueScale.valueLabels) {
        var _top = 1 - _i / _range;

        ctx.beginPath();
        ctx.strokeStyle = translateColorToSafeString(gridStroke, chartRef.current);
        ctx.moveTo(chartPadLeft * dpr, (_top * chartHeight + chartPadTop) * dpr);
        ctx.lineTo((chartWidth + chartPadLeft) * dpr, (_top * chartHeight + chartPadTop) * dpr);
        ctx.stroke();

        if (positioning) {
          ctx.beginPath();
          ctx.strokeStyle = translateColorToSafeString(textColor, chartRef.current);
          ctx.fillStyle = translateColorToSafeString(textColor, chartRef.current);
          ctx.lineWidth = 1;
          ctx.textAlign = "end";
          ctx.textBaseline = "middle";
          ctx.font = "".concat(dpr * 12, "px Source Sans Pro");
          ctx.fillText(valueScale.valueLabels[_i], (positioning.left + positioning.width) * dpr, (_top * chartHeight + chartPadTop) * dpr);
          ctx.stroke();
        }
      }
    }
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, valueScale, usingNumericScale]);
  if (isCanvas) return null;
  if (!registered) return null;
  var positioning = yAxesPositioning[id];
  var axisNodes = [];

  if (usingNumericScale) {
    var range = valueScale.max - valueScale.min,
        step = Math.round(range / numericTicks * Math.pow(10, decimals)) / Math.pow(10, decimals);
    if (range == -Infinity) return null;

    for (var i = 1; i < numericTicks; i++) {
      var top = range == 0 ? 1 : 1 - i * step / range;
      axisNodes.push( /*#__PURE__*/React__default.createElement("polyline", {
        key: "y-".concat(id, "-").concat(i),
        stroke: gridStroke,
        strokeWidth: gridStrokeWidth,
        points: [{
          top: top,
          left: 0
        }, {
          top: top,
          left: 1
        }].map(function (point) {
          return "".concat(point.left * chartWidth + chartPadLeft, ",").concat(point.top * chartHeight + chartPadTop);
        }).join(" ")
      }));

      if (positioning) {
        var left = positioning.left,
            width = positioning.width;
        axisNodes.push( /*#__PURE__*/React__default.createElement("text", {
          key: "y-label-".concat(id, "-").concat(i),
          fill: textColor,
          style: {
            fontVariantNumeric: "tabular-nums",
            fontSize: 12
          },
          textAnchor: "end",
          dominantBaseline: "middle",
          x: left + width,
          y: top * chartHeight + chartPadTop
        }, tickFormat(Math.round((valueScale.min + i * step) * Math.pow(10, decimals)) / Math.pow(10, decimals))));
      }
    }
  } else {
    var _range2 = valueScale.max - valueScale.min;

    for (var _i2 in valueScale.valueLabels) {
      var _top2 = 1 - _i2 / _range2;

      axisNodes.push( /*#__PURE__*/React__default.createElement("polyline", {
        key: "y-".concat(id, "-").concat(_i2),
        stroke: gridStroke,
        strokeWidth: gridStrokeWidth,
        points: [{
          top: _top2,
          left: 0
        }, {
          top: _top2,
          left: 1
        }].map(function (point) {
          return "".concat(point.left * chartWidth + chartPadLeft, ",").concat(point.top * chartHeight + chartPadTop);
        }).join(" ")
      }));

      if (positioning) {
        var _left = positioning.left,
            _width = positioning.width;
        axisNodes.push( /*#__PURE__*/React__default.createElement("text", {
          key: "y-label-".concat(id, "-").concat(_i2),
          fill: textColor,
          style: {
            fontVariantNumeric: "tabular-nums",
            fontSize: 12
          },
          textAnchor: "end",
          dominantBaseline: "middle",
          x: _left + _width,
          y: _top2 * chartHeight + chartPadTop
        }, valueScale.valueLabels[_i2]));
      }
    }
  }

  return axisNodes;
};

YAxis.propTypes = {
  numericTicks: PropTypes.number,
  tickFormat: PropTypes.func,
  decimals: PropTypes.number,
  gridStroke: PropTypes.string,
  textColor: PropTypes.string
};
var YAxis$1 = YAxis;

var XAxis = function XAxis(props) {
  var _props$dateFormat = props.dateFormat,
      dateFormat = _props$dateFormat === void 0 ? function (date) {
    return moment(date).format("h a");
  } : _props$dateFormat,
      _props$gridStroke = props.gridStroke,
      gridStroke = _props$gridStroke === void 0 ? "var(--chart-x-axis-grid-stroke)" : _props$gridStroke,
      _props$gridStrokeWidt = props.gridStrokeWidth,
      gridStrokeWidth = _props$gridStrokeWidt === void 0 ? 2 : _props$gridStrokeWidt,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? "var(--chart-x-axis-text-color)" : _props$textColor;
  var _props$maxDateTicks = props.maxDateTicks,
      maxDateTicks = _props$maxDateTicks === void 0 ? 5 : _props$maxDateTicks;

  var _useContext = useContext(ChartContext),
      registerXAxis = _useContext.registerXAxis,
      unregisterXAxis = _useContext.unregisterXAxis,
      xAxesPositioning = _useContext.xAxesPositioning,
      chartWidth = _useContext.chartWidth,
      chartHeight = _useContext.chartHeight,
      chartPadTop = _useContext.chartPadTop,
      chartPadLeft = _useContext.chartPadLeft,
      isCanvas = _useContext.isCanvas,
      chartRef = _useContext.chartRef,
      canvasRefreshCounter = _useContext.canvasRefreshCounter;

  var _useContext2 = useContext(ChartDataSourceContext),
      timeScale = _useContext2.timeScale;

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      registered = _useState4[0],
      setRegistered = _useState4[1];

  useEffect(function () {
    try {
      registerXAxis(id);
      setRegistered(true);
    } catch (e) {
      setRegistered(false);
    }

    return function () {
      return unregisterXAxis(id);
    };
  }, [id]);
  useEffect(function () {
    if (!isCanvas || !(chartRef !== null && chartRef !== void 0 && chartRef.current)) return;
    if (!registered || !timeScale) return;
    var positioning = xAxesPositioning[id];
    var labelWidth = dateFormat(timeScale.min).length * 7;
    maxDateTicks = Math.min(Math.floor(chartWidth / labelWidth), maxDateTicks);
    var range = timeScale.max - timeScale.min,
        step = Math.round(range / maxDateTicks);
    if (range == -Infinity) return;
    var ctx = chartRef.current.getContext("2d");
    var dpr = window.devicePixelRatio || 1;

    for (var i = 1; i < maxDateTicks; i++) {
      var left = 1 - (maxDateTicks - i) * step / range;
      ctx.beginPath();
      ctx.strokeStyle = translateColorToSafeString(gridStroke, chartRef.current);
      ctx.moveTo((left * chartWidth + chartPadLeft) * dpr, chartPadTop * dpr);
      ctx.lineTo((left * chartWidth + chartPadLeft) * dpr, (chartHeight + chartPadTop) * dpr);
      ctx.stroke();

      if (positioning) {
        ctx.beginPath();
        ctx.strokeStyle = translateColorToSafeString(textColor, chartRef.current);
        ctx.fillStyle = translateColorToSafeString(textColor, chartRef.current);
        ctx.lineWidth = 1;
        ctx.textAlign = "center";
        ctx.font = "".concat(dpr * 12, "px Source Sans Pro");
        ctx.fillText(dateFormat(moment(timeScale.max - (maxDateTicks - i) * step).toDate()), (left * chartWidth + chartPadLeft) * dpr, positioning.top * dpr);
        ctx.stroke();
      }
    }
  }, [isCanvas, chartRef, canvasRefreshCounter, chartWidth, chartHeight, chartPadTop, chartPadLeft, timeScale]);
  if (isCanvas) return null;
  if (!registered || !timeScale) return null;
  var positioning = xAxesPositioning[id];
  var axisNodes = [];
  var labelWidth = dateFormat(timeScale.min).length * 7;
  maxDateTicks = Math.min(Math.floor(chartWidth / labelWidth), maxDateTicks);
  var range = timeScale.max - timeScale.min,
      step = Math.round(range / maxDateTicks);
  if (range == -Infinity) return null;

  for (var i = 1; i < maxDateTicks; i++) {
    var left = 1 - (maxDateTicks - i) * step / range;
    axisNodes.push( /*#__PURE__*/React__default.createElement("polyline", {
      key: "x-".concat(id, "-").concat(i),
      stroke: gridStroke,
      strokeWidth: gridStrokeWidth,
      points: [{
        top: 0,
        left: left
      }, {
        top: 1,
        left: left
      }].map(function (p) {
        return "".concat(p.left * chartWidth + chartPadLeft, ",").concat(p.top * chartHeight + chartPadTop);
      }).join(" ")
    }));

    if (positioning) {
      var top = positioning.top;
      axisNodes.push( /*#__PURE__*/React__default.createElement("text", {
        key: "x-label-".concat(id, "-").concat(i),
        fill: textColor,
        style: {
          fontSize: 12
        },
        textAnchor: "middle",
        x: left * chartWidth + chartPadLeft,
        y: top
      }, dateFormat(moment(timeScale.max - (maxDateTicks - i) * step).toDate())));
    }
  }

  return axisNodes;
};

XAxis.propTypes = {
  maxDateTicks: PropTypes.number,
  decimals: PropTypes.number,
  gridStroke: PropTypes.string,
  textColor: PropTypes.string
};
var XAxis$1 = XAxis;

var Axes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  YAxis: YAxis$1,
  XAxis: XAxis$1
});

var insertInstantChangeSnapshots$1 = function insertInstantChangeSnapshots(data) {
  return data.reduce(function (newData, datum) {
    var insert = [datum];

    if (newData[newData.length - 1] && newData[newData.length - 1].value !== datum.value) {
      insert.unshift({
        date: datum.date - 1,
        value: newData[newData.length - 1].value
      });
    }

    return newData.concat(insert);
  }, []);
};

var yAxisSortOrder = ["overpower", "on", "off", "heating", "heat", "cooling", "cool", "auto", "standby"];

var PointSnapshotChartDataSource = function PointSnapshotChartDataSource(props) {
  var hideEmpty = props.hideEmpty,
      children = props.children,
      equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      start = props.start,
      end = props.end,
      resolution = props.resolution,
      parseValue = props.parseValue;
  var chariot = useChariot();

  var _useContext = useContext(ChartContext),
      registerYScale = _useContext.registerYScale,
      unregisterYScale = _useContext.unregisterYScale,
      numericScale = _useContext.numericScale;

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  var _useState3 = useState(function () {
    return function (n) {
      return n;
    };
  }),
      _useState4 = _slicedToArray$1(_useState3, 2),
      mapValueFn = _useState4[0],
      setMapValueFn = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      yScale = _useState8[0],
      setYScale = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray$1(_useState9, 2),
      xScale = _useState10[0],
      setXScale = _useState10[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (!(point_id && equipment)) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return equipment.getPoints();

            case 4:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 18;
              break;

            case 8:
              if (!(point_name && equipment)) {
                _context.next = 14;
                break;
              }

              _context.next = 11;
              return equipment.findPointByName(point_name);

            case 11:
              point = _context.sent;
              _context.next = 18;
              break;

            case 14:
              if (!point_id) {
                _context.next = 18;
                break;
              }

              _context.next = 17;
              return chariot.Point.get(point_id);

            case 17:
              point = _context.sent;

            case 18:
              if (mounted) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              setPoint(point);
              if (point) setMapValueFn(function () {
                return point.mapValue.bind(point);
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment, pointFromProps && pointFromProps._.id, point_name, point_id]);
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var newData, valueLabels, yMin, yMax, xMin, xMax, newMapValueFn, chartValues, _filter$sort, _filter$sort2, smallestYValue, _filter$sort3, _filter$sort4, largestYValue;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!point) {
                _context2.next = 25;
                break;
              }

              _context2.next = 3;
              return point.getValueSnapshots(start, end, resolution);

            case 3:
              newData = _context2.sent;

              if (mounted) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              valueLabels = null, yMin = 0, yMax = 0, xMin = 0, xMax = 0, newMapValueFn = null;

              if (!(newData.length > 0)) {
                _context2.next = 11;
                break;
              }

              if (point.getValueOptions().length > 0) {
                chartValues = point.getValueOptions().sort(function (_ref4, _ref5) {
                  var labelA = _ref4.label;
                  var labelB = _ref5.label;
                  return yAxisSortOrder.indexOf(labelB.toLowerCase()) - yAxisSortOrder.indexOf(labelA.toLowerCase());
                }).reduce(function (map, option, index) {
                  map.set(option.label, index + 1);
                  return map;
                }, new Map());
                chartValues.set(undefined, 0);

                newMapValueFn = function newMapValueFn(v) {
                  return Array.from(chartValues.keys()).find(function (k) {
                    return chartValues.get(k) == v;
                  });
                };

                newData = newData.map(function (d) {
                  return {
                    date: +new Date(d.snapshot),
                    value: chartValues.get(point.mapValue(d.value)) || 0
                  };
                });
                newData = insertInstantChangeSnapshots$1(newData);
                valueLabels = Array.from(chartValues.keys()).reduce(function (object, key) {
                  return _objectSpread2(_objectSpread2({}, object), {}, _defineProperty$3({}, chartValues.get(key), key));
                }, {});
                yMin = 0;
                yMax = Math.max(chartValues.size, 1);
              } else {
                newData = newData.map(function (d) {
                  return {
                    date: +new Date(d.snapshot),
                    value: parseValue ? parseValue(d.value, point, d) : isNaN(d.value) || !d.value ? null : parseFloat(d.value)
                  };
                });
                _filter$sort = _toConsumableArray(newData).filter(function (_ref6) {
                  var value = _ref6.value;
                  return value !== null;
                }).sort(function (_ref7, _ref8) {
                  var aValue = _ref7.value;
                  var bValue = _ref8.value;
                  return aValue - bValue;
                }), _filter$sort2 = _slicedToArray$1(_filter$sort, 1), smallestYValue = _filter$sort2[0];
                if (smallestYValue) yMin = smallestYValue.value;
                _filter$sort3 = _toConsumableArray(newData).filter(function (_ref9) {
                  var value = _ref9.value;
                  return value !== null;
                }).sort(function (_ref10, _ref11) {
                  var aValue = _ref10.value;
                  var bValue = _ref11.value;
                  return bValue - aValue;
                }), _filter$sort4 = _slicedToArray$1(_filter$sort3, 1), largestYValue = _filter$sort4[0];
                if (largestYValue) yMax = largestYValue.value;
              }

              _context2.next = 16;
              break;

            case 11:
              if (hideEmpty) {
                _context2.next = 15;
                break;
              }

              newData = [{
                date: +start,
                value: 0
              }, {
                date: +end,
                value: 0
              }];
              _context2.next = 16;
              break;

            case 15:
              return _context2.abrupt("return");

            case 16:
              if (newData[0].date !== +start) {
                newData = newData.filter(function (_ref12) {
                  var date = _ref12.date;
                  return date >= +start;
                });
                newData.unshift({
                  date: +start,
                  value: newData[0].value
                });
              }

              if (newData[newData.length - 1].date !== +end) {
                newData = newData.filter(function (_ref13) {
                  var date = _ref13.date;
                  return date <= +end;
                });
                newData.push({
                  date: +end,
                  value: newData[newData.length - 1].value
                });
              }

              xMin = _toConsumableArray(newData).sort(function (_ref14, _ref15) {
                var aDate = _ref14.date;
                var bDate = _ref15.date;
                return aDate - bDate;
              })[0].date;
              xMax = _toConsumableArray(newData).sort(function (_ref16, _ref17) {
                var aDate = _ref16.date;
                var bDate = _ref17.date;
                return bDate - aDate;
              })[0].date;
              newData = newData.filter(function (_ref18) {
                var value = _ref18.value;
                return value !== null;
              });
              setYScale({
                min: yMin,
                max: yMax,
                valueLabels: valueLabels
              });
              setXScale({
                min: xMin,
                max: xMax
              });

              if (newMapValueFn) {
                setMapValueFn(function () {
                  return newMapValueFn;
                });
              }

              setData(newData);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();

    return function () {
      mounted = false;
    };
  }, [point, start && start.toISOString(), end && end.toISOString(), resolution]);
  useEffect(function () {
    if (yScale) registerYScale(yScale);
    return function () {
      return unregisterYScale(yScale);
    };
  }, [yScale]);
  var contextValue = {
    data: data.sort(function (_ref19, _ref20) {
      var aDate = _ref19.date;
      var bDate = _ref20.date;
      return aDate - bDate;
    }),
    tooltipLabel: point === null || point === void 0 ? void 0 : point.getDisplayName(),
    tooltipValueLabel: "Value: ",
    mapValue: mapValueFn,
    valueScale: yScale !== null && yScale !== void 0 && yScale.valueLabels ? yScale : numericScale,
    timeScale: xScale
  };
  return /*#__PURE__*/React__default.createElement(ChartDataSourceContext.Provider, {
    value: contextValue
  }, children);
};

PointSnapshotChartDataSource.propTypes = {
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (!Object.keys(Segments).find(function (SegmentType) {
        return child && child.type == Segments[SegmentType];
      }) && !Object.keys(Axes).find(function (AxisType) {
        return child && child.type == Axes[AxisType];
      })) {
        return new Error("".concat(componentName, " children should be a Segment or Axis"));
      }

      return true;
    });
    return error;
  },
  hideEmpty: PropTypes.bool,
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  resolution: PropTypes.oneOf(RESOLUTIONS),
  parseValue: PropTypes.func
};
var PointSnapshotChartDataSource$1 = PointSnapshotChartDataSource;

var insertInstantChangeSnapshots = function insertInstantChangeSnapshots(data) {
  return data.reduce(function (newData, datum) {
    var insert = [datum];

    if (newData[newData.length - 1] && newData[newData.length - 1].value !== datum.value) {
      insert.unshift({
        date: datum.date - 1,
        value: newData[newData.length - 1].value
      });
    }

    return newData.concat(insert);
  }, []);
};

var PointActivityAtValueChartDataSource = function PointActivityAtValueChartDataSource(props) {
  var children = props.children,
      equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      mappedValue = props.value,
      start = props.start,
      end = props.end,
      resolution = props.resolution;

  var _useContext = useContext(ChartContext),
      registerYScale = _useContext.registerYScale,
      unregisterYScale = _useContext.unregisterYScale;

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      yScale = _useState6[0],
      setYScale = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      xScale = _useState8[0],
      setXScale = _useState8[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (!(point_id && equipment)) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return equipment.getPoints();

            case 4:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 12;
              break;

            case 8:
              if (!(point_name && equipment)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return equipment.findPointByName(point_name);

            case 11:
              point = _context.sent;

            case 12:
              if (mounted) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return");

            case 14:
              setPoint(point);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment, pointFromProps && pointFromProps._.id, point_name, point_id]);
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var newData, valueLabels, yMin, yMax, xMin, xMax;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!point) {
                _context2.next = 15;
                break;
              }

              _context2.next = 3;
              return point.getValueSnapshots(start, end, resolution);

            case 3:
              newData = _context2.sent;

              if (mounted) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              valueLabels = null, yMin = 0, yMax = 1, xMin = 0, xMax = 0;

              if (newData.length > 0) {
                newData = newData.map(function (datum) {
                  return {
                    date: +new Date(datum.snapshot),
                    value: "".concat(point.mapValue(datum.value)).toLowerCase() == "".concat(mappedValue).toLowerCase() ? 1 : 0
                  };
                });
                newData = insertInstantChangeSnapshots(newData);
                valueLabels = {
                  0: undefined,
                  1: mappedValue
                };
              } else {
                newData = [{
                  date: +start,
                  value: 0
                }, {
                  date: +end,
                  value: 0
                }];
              }

              if (newData[0].date !== +start) {
                newData.unshift({
                  date: +start,
                  value: newData[0].value
                });
              }

              if (newData[newData.length - 1].date !== +end) {
                newData.push({
                  date: +end,
                  value: newData[newData.length - 1].value
                });
              }

              xMin = _toConsumableArray(newData).sort(function (_ref4, _ref5) {
                var aDate = _ref4.date;
                var bDate = _ref5.date;
                return aDate - bDate;
              })[0].date;
              xMax = _toConsumableArray(newData).sort(function (_ref6, _ref7) {
                var aDate = _ref6.date;
                var bDate = _ref7.date;
                return bDate - aDate;
              })[0].date;
              setYScale({
                min: yMin,
                max: yMax,
                valueLabels: valueLabels
              });
              setXScale({
                min: xMin,
                max: xMax
              });
              setData(newData);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();

    return function () {
      mounted = false;
    };
  }, [point, start && start.toISOString(), end && end.toISOString(), resolution]);
  useEffect(function () {
    if (yScale) registerYScale(yScale);
    return function () {
      return unregisterYScale(yScale);
    };
  }, [yScale]);
  var contextValue = {
    data: data.sort(function (_ref8, _ref9) {
      var aDate = _ref8.date;
      var bDate = _ref9.date;
      return aDate - bDate;
    }),
    tooltipLabel: point === null || point === void 0 ? void 0 : point.getDisplayName(),
    tooltipValueLabel: "Value: ",
    mapValue: function mapValue(value) {
      return value == 1 ? mappedValue : null;
    },
    valueScale: yScale,
    timeScale: xScale
  };
  return /*#__PURE__*/React__default.createElement(ChartDataSourceContext.Provider, {
    value: contextValue
  }, children);
};

PointActivityAtValueChartDataSource.propTypes = {
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (!Object.keys(Segments).find(function (SegmentType) {
        return child.type == Segments[SegmentType];
      }) && !Object.keys(Axes).find(function (AxisType) {
        return child.type == Axes[AxisType];
      })) {
        return new Error("".concat(componentName, " children should be a Segment or Axis"));
      }

      return true;
    });
    return error;
  },
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  value: PropTypes.string.isRequired,
  resolution: PropTypes.oneOf(RESOLUTIONS)
};
var PointActivityAtValueChartDataSource$1 = PointActivityAtValueChartDataSource;

var WeatherChartDataSource = function WeatherChartDataSource(props) {
  var chariot = useChariot();
  var hideEmpty = props.hideEmpty,
      children = props.children,
      siteFromProps = props.site,
      site_id = props.site_id,
      _props$dataKey = props.dataKey,
      dataKey = _props$dataKey === void 0 ? "temperature" : _props$dataKey,
      start = props.start,
      end = props.end;

  var _useContext = useContext(ChartContext),
      registerYScale = _useContext.registerYScale,
      unregisterYScale = _useContext.unregisterYScale,
      numericScale = _useContext.numericScale;

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      yScale = _useState4[0],
      setYScale = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      xScale = _useState6[0],
      setXScale = _useState6[1];

  var _useState7 = useState(siteFromProps),
      _useState8 = _slicedToArray$1(_useState7, 2),
      site = _useState8[0],
      setSite = _useState8[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var site;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              site = siteFromProps;

              if (!(site_id && !site)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return chariot.Site.get(site_id);

            case 4:
              site = _context.sent;

            case 5:
              if (mounted) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              setSite(site);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [siteFromProps && siteFromProps._.id, site_id]);
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var newData, valueLabels, yMin, yMax, xMin, xMax;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!site) {
                _context2.next = 25;
                break;
              }

              _context2.next = 3;
              return chariot.RestApi.request({
                path: "/weather",
                params: {
                  lat: site._.latitude,
                  lng: site._.longitude,
                  fromDate: start.toISOString(),
                  toDate: end.toISOString()
                }
              });

            case 3:
              newData = _context2.sent;

              if (mounted) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              valueLabels = null, yMin = 0, yMax = 0, xMin = 0, xMax = 0;

              if (!(newData.length > 0)) {
                _context2.next = 13;
                break;
              }

              newData = newData.map(function (d) {
                return {
                  date: +new Date(d.time * 1000),
                  value: d[dataKey]
                };
              });
              yMin = _toConsumableArray(newData).sort(function (_ref3, _ref4) {
                var aValue = _ref3.value;
                var bValue = _ref4.value;
                return aValue - bValue;
              })[0].value;
              yMax = _toConsumableArray(newData).sort(function (_ref5, _ref6) {
                var aValue = _ref5.value;
                var bValue = _ref6.value;
                return bValue - aValue;
              })[0].value;
              _context2.next = 18;
              break;

            case 13:
              if (hideEmpty) {
                _context2.next = 17;
                break;
              }

              newData = [{
                date: +start,
                value: 0
              }, {
                date: +end,
                value: 0
              }];
              _context2.next = 18;
              break;

            case 17:
              return _context2.abrupt("return");

            case 18:
              if (newData[0].date !== +start) {
                newData.unshift({
                  date: +start,
                  value: newData[0].value
                });
              }

              if (newData[newData.length - 1].date !== +end) {
                newData.push({
                  date: +end,
                  value: newData[newData.length - 1].value
                });
              }

              xMin = _toConsumableArray(newData).sort(function (_ref7, _ref8) {
                var aDate = _ref7.date;
                var bDate = _ref8.date;
                return aDate - bDate;
              })[0].date;
              xMax = _toConsumableArray(newData).sort(function (_ref9, _ref10) {
                var aDate = _ref9.date;
                var bDate = _ref10.date;
                return bDate - aDate;
              })[0].date;
              setYScale({
                min: yMin,
                max: yMax,
                valueLabels: valueLabels
              });
              setXScale({
                min: xMin,
                max: xMax
              });
              setData(newData);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();

    return function () {
      mounted = false;
    };
  }, [site, start && start.toISOString(), end && end.toISOString(), dataKey]);
  useEffect(function () {
    if (yScale) registerYScale(yScale);
    return function () {
      return unregisterYScale(yScale);
    };
  }, [yScale]);
  var tooltipValueLabel = "Temperature: ";
  if (dataKey == "humidity") tooltipValueLabel = "Humidity: ";

  var mapValue = function mapValue(n) {
    return "".concat(n, "\xB0F");
  };

  if (dataKey == "humidity") mapValue = function mapValue(n) {
    return "".concat(n, "%");
  };
  var contextValue = {
    data: data.sort(function (_ref11, _ref12) {
      var aDate = _ref11.date;
      var bDate = _ref12.date;
      return aDate - bDate;
    }),
    tooltipLabel: "".concat(site === null || site === void 0 ? void 0 : site.getDisplayName(), " Weather"),
    tooltipValueLabel: tooltipValueLabel,
    mapValue: mapValue,
    valueScale: numericScale,
    timeScale: xScale
  };
  return /*#__PURE__*/React__default.createElement(ChartDataSourceContext.Provider, {
    value: contextValue
  }, children);
};

WeatherChartDataSource.propTypes = {
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (!Object.keys(Segments).find(function (SegmentType) {
        return child && child.type == Segments[SegmentType];
      }) && !Object.keys(Axes).find(function (AxisType) {
        return child && child.type == Axes[AxisType];
      })) {
        return new Error("".concat(componentName, " children should be a Segment or Axis"));
      }

      return true;
    });
    return error;
  },
  hideEmpty: PropTypes.bool,
  site: PropTypes.instanceOf(Site),
  site_id: PropTypes.string,
  dataKey: PropTypes.oneOf(["humidity", "temperature"]),
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired
};
var WeatherChartDataSource$1 = WeatherChartDataSource;

var DataSources = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PointSnapshotChartDataSource: PointSnapshotChartDataSource$1,
  PointActivityAtValueChartDataSource: PointActivityAtValueChartDataSource$1,
  ChartDataSourceContext: ChartDataSourceContext,
  WeatherChartDataSource: WeatherChartDataSource$1
});

function _extends$O() {
  _extends$O = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$O.apply(this, arguments);
}

var useLatest = (function (val) {
  var ref = useRef(val);
  ref.current = val;
  return ref;
});

var observerErr = "💡 react-cool-dimensions: the browser doesn't support Resize Observer, please use polyfill: https://github.com/wellyshen/react-cool-dimensions#resizeobserver-polyfill";
var borderBoxWarn = "💡 react-cool-dimensions: the browser doesn't support border-box size, fallback to content-box size. Please see: https://github.com/wellyshen/react-cool-dimensions#border-box-size-measurement";

var getCurrentBreakpoint = function getCurrentBreakpoint(bps, w) {
  var curBp = "";
  var max = -1;
  Object.keys(bps).forEach(function (key) {
    var val = bps[key];

    if (w >= val && val > max) {
      curBp = key;
      max = val;
    }
  });
  return curBp;
};

var useDimensions = function useDimensions(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      useBorderBoxSize = _ref.useBorderBoxSize,
      breakpoints = _ref.breakpoints,
      updateOnBreakpointChange = _ref.updateOnBreakpointChange,
      shouldUpdate = _ref.shouldUpdate,
      onResize = _ref.onResize,
      polyfill = _ref.polyfill;

  var _useState = useState({
    currentBreakpoint: "",
    width: 0,
    height: 0
  }),
      state = _useState[0],
      setState = _useState[1];

  var prevSizeRef = useRef({});
  var prevBreakpointRef = useRef();
  var observerRef = useRef();
  var warnedRef = useRef(false);
  var ref = useRef();
  var onResizeRef = useLatest(onResize);
  var shouldUpdateRef = useLatest(shouldUpdate);
  var unobserve = useCallback(function () {
    if (observerRef.current) observerRef.current.disconnect();
  }, []);
  var observe = useCallback(function (element) {
    if (element && element !== ref.current) {
      unobserve();
      ref.current = element;
    }

    if (observerRef.current && ref.current) observerRef.current.observe(ref.current);
  }, [unobserve]);
  useEffect(function () {
    if ((!("ResizeObserver" in window) || !("ResizeObserverEntry" in window)) && !polyfill) {
      console.error(observerErr);
      return function () {
        return null;
      };
    }

    var raf = null; // eslint-disable-next-line compat/compat

    observerRef.current = new (polyfill || ResizeObserver)(function (_ref2) {
      var entry = _ref2[0];
      raf = requestAnimationFrame(function () {
        var contentBoxSize = entry.contentBoxSize,
            borderBoxSize = entry.borderBoxSize,
            contentRect = entry.contentRect;
        var boxSize = contentBoxSize;
        if (useBorderBoxSize) if (borderBoxSize) {
          boxSize = borderBoxSize;
        } else if (!warnedRef.current) {
          console.warn(borderBoxWarn);
          warnedRef.current = true;
        } // @juggle/resize-observer polyfill has different data structure

        boxSize = Array.isArray(boxSize) ? boxSize[0] : boxSize;
        var width = boxSize ? boxSize.inlineSize : contentRect.width;
        var height = boxSize ? boxSize.blockSize : contentRect.height;
        if (width === prevSizeRef.current.width && height === prevSizeRef.current.height) return;
        prevSizeRef.current = {
          width: width,
          height: height
        };
        var e = {
          currentBreakpoint: "",
          width: width,
          height: height,
          entry: entry,
          observe: observe,
          unobserve: unobserve
        };

        if (breakpoints) {
          e.currentBreakpoint = getCurrentBreakpoint(breakpoints, width);

          if (e.currentBreakpoint !== prevBreakpointRef.current) {
            if (onResizeRef.current) onResizeRef.current(e);
            prevBreakpointRef.current = e.currentBreakpoint;
          }
        } else if (onResizeRef.current) {
          onResizeRef.current(e);
        }

        var next = {
          currentBreakpoint: e.currentBreakpoint,
          width: width,
          height: height,
          entry: entry
        };
        if (shouldUpdateRef.current && !shouldUpdateRef.current(next)) return;

        if (!shouldUpdateRef.current && breakpoints && updateOnBreakpointChange) {
          setState(function (prev) {
            return prev.currentBreakpoint !== next.currentBreakpoint ? next : prev;
          });
          return;
        }

        setState(next);
      });
    });
    observe();
    return function () {
      unobserve();
      if (raf) cancelAnimationFrame(raf);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(breakpoints), useBorderBoxSize, observe, unobserve, updateOnBreakpointChange]);
  return _extends$O({}, state, {
    observe: observe,
    unobserve: unobserve
  });
};

var useDimensions$1 = useDimensions;

var BarProvider = /*#__PURE__*/function (_React$Component) {
  _inherits$2(BarProvider, _React$Component);

  var _super = _createSuper$4(BarProvider);

  function BarProvider(props) {
    var _this;

    _classCallCheck$2(this, BarProvider);

    _this = _super.call(this, props);
    _this.barSegmentIds = [];
    _this.barHeightMaps = new Map();
    _this.registerBarSegment = _this.registerBarSegment.bind(_assertThisInitialized$2(_this));
    _this.unregisterBarSegment = _this.unregisterBarSegment.bind(_assertThisInitialized$2(_this));
    _this.getBarXOffset = _this.getBarXOffset.bind(_assertThisInitialized$2(_this));
    _this.getBarYOffset = _this.getBarYOffset.bind(_assertThisInitialized$2(_this));
    return _this;
  }

  _createClass$2(BarProvider, [{
    key: "registerBarSegment",
    value: function registerBarSegment(barSegmentId) {
      this.barSegmentIds = this.barSegmentIds.filter(function (id) {
        return id !== barSegmentId;
      }).concat(barSegmentId);
      this.forceUpdate();
    }
  }, {
    key: "unregisterBarSegment",
    value: function unregisterBarSegment(barSegmentId) {
      this.barSegmentIds = this.barSegmentIds.filter(function (id) {
        return id !== barSegmentId;
      });
      this.forceUpdate();
    }
  }, {
    key: "getBarXOffset",
    value: function getBarXOffset(barSegmentId) {
      if (this.props.stacked) return 0;
      var barIndex = this.barSegmentIds.indexOf(barSegmentId);
      if (barIndex < 0) return 0;
      return barIndex * (this.getBarWidth() + this.props.barPadding);
    }
  }, {
    key: "getBarYOffset",
    value: function getBarYOffset(barSegmentId, barIndex, value) {
      var _this2 = this;

      if (!this.props.stacked) return 0;
      if (!this.barHeightMaps.has(barSegmentId)) this.barHeightMaps.set(barSegmentId, []);
      var heightArray = this.barHeightMaps.get(barSegmentId);
      heightArray[barIndex] = value;
      this.barHeightMaps.set(heightArray);
      var followingBarIds = this.barSegmentIds.slice(0, this.barSegmentIds.indexOf(barSegmentId));
      var offset = followingBarIds.reduce(function (total, barId) {
        var heightArray = _this2.barHeightMaps.get(barId);

        if (!heightArray) return total;
        return total + (heightArray[barIndex] || 0);
      }, 0);
      return offset;
    }
  }, {
    key: "getBarWidth",
    value: function getBarWidth() {
      if (this.props.barWidth) return this.props.barWidth;
      var chartWidth = this.context.chartWidth;
      var _this$props = this.props,
          numberOfBars = _this$props.count,
          stacked = _this$props.stacked,
          barPadding = _this$props.barPadding;
      if (!numberOfBars) return 4;
      var numberOfBarSegments = this.barSegmentIds.length;

      if (numberOfBarSegments > 1 && !stacked) {
        var clusterWidth = this.getBarClusterWidth();
        return (clusterWidth - (numberOfBarSegments - 1) * barPadding) / numberOfBarSegments;
      } else {
        return (chartWidth - (numberOfBars - 1) * barPadding) / numberOfBars;
      }
    }
  }, {
    key: "getBarClusterWidth",
    value: function getBarClusterWidth() {
      var chartWidth = this.context.chartWidth;
      var _this$props2 = this.props,
          numberOfBars = _this$props2.count,
          barGroupPadding = _this$props2.barGroupPadding;
      var numberOfBarSegments = this.barSegmentIds.length;
      if (numberOfBarSegments < 2) return this.getBarWidth();
      return (chartWidth - (numberOfBars - 1) * barGroupPadding) / numberOfBars;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          count = _this$props3.count,
          stacked = _this$props3.stacked,
          barPadding = _this$props3.barPadding,
          barGroupPadding = _this$props3.barGroupPadding;
      var chartWidth = this.context.chartWidth;
      var numberOfBarSegments = this.barSegmentIds.length;
      var barDisplayWidth = this.getBarWidth();
      var barClusterWidth = this.getBarClusterWidth();
      var numberOfBars = count;

      if (barDisplayWidth && !numberOfBars) {
        if (numberOfBarSegments > 1 && !stacked) {
          var clusterWidth = numberOfBarSegments * (barDisplayWidth + barPadding) - barPadding + barGroupPadding;
          numberOfBars = Math.floor(Math.max(chartWidth, 0) / clusterWidth);
        } else {
          numberOfBars = Math.floor(Math.max(chartWidth, 0) / (barDisplayWidth + barPadding));
        }
      }

      var contextValue = {
        registerBarSegment: this.registerBarSegment,
        unregisterBarSegment: this.unregisterBarSegment,
        getBarXOffset: this.getBarXOffset,
        getBarYOffset: this.getBarYOffset,
        numberOfBars: numberOfBars,
        barDisplayWidth: barDisplayWidth,
        barClusterWidth: barClusterWidth
      };
      return /*#__PURE__*/React__default.createElement(BarContext.Provider, {
        value: contextValue
      }, children);
    }
  }]);

  return BarProvider;
}(React__default.Component);

BarProvider.propTypes = {
  children: PropTypes.any,
  count: PropTypes.number,
  stacked: PropTypes.bool,
  barWidth: PropTypes.number,
  barPadding: PropTypes.number,
  barGroupPadding: PropTypes.number
};
BarProvider.defaultProps = {
  stacked: false,
  barPadding: 2,
  barGroupPadding: 6
};
BarProvider.contextType = ChartContext;
var BarProvider$1 = BarProvider;

var HeatMapProvider = /*#__PURE__*/function (_React$Component) {
  _inherits$2(HeatMapProvider, _React$Component);

  var _super = _createSuper$4(HeatMapProvider);

  function HeatMapProvider(props) {
    var _this;

    _classCallCheck$2(this, HeatMapProvider);

    _this = _super.call(this, props);
    _this.tileLabels = [];
    _this.registerTileLabel = _this.registerTileLabel.bind(_assertThisInitialized$2(_this));
    _this.unregisterTileLabel = _this.unregisterTileLabel.bind(_assertThisInitialized$2(_this));
    _this.getFormattedTileLabel = _this.getFormattedTileLabel.bind(_assertThisInitialized$2(_this));
    return _this;
  }

  _createClass$2(HeatMapProvider, [{
    key: "registerTileLabel",
    value: function registerTileLabel(segmentId, tileIndex, start, end, label) {
      if (!this.tileLabels[tileIndex]) this.tileLabels[tileIndex] = {};
      this.tileLabels[tileIndex][segmentId] = {
        start: start,
        end: end,
        label: label
      };
      this.forceUpdate();
    }
  }, {
    key: "unregisterTileLabel",
    value: function unregisterTileLabel(segmentId, tileIndex) {
      if (!this.tileLabels[tileIndex]) return;
      delete this.tileLabels[tileIndex][segmentId];
      if (Object.values(this.tileLabels).length == 0) this.tileLabels[tileIndex] = undefined;
      this.forceUpdate();
    }
  }, {
    key: "getFormattedTileLabel",
    value: function getFormattedTileLabel(tileIndex) {
      if (!this.tileLabels[tileIndex]) return null;
      var labels = Object.values(this.tileLabels[tileIndex]).reduce(function (dateMap, _ref) {
        var start = _ref.start,
            end = _ref.end,
            label = _ref.label;
        var showDate = moment(start).format("L") !== moment(end).format("L");
        var dateLabel = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
          style: {
            whiteSpace: "nowrap"
          }
        }, moment(start).format("lll")), " - ", /*#__PURE__*/React__default.createElement("span", {
          style: {
            whiteSpace: "nowrap"
          }
        }, showDate ? moment(end).format("lll") : moment(end).format("LT")));
        if (!dateMap.has(dateLabel)) dateMap.set(dateLabel, []);
        dateMap.set(dateLabel, [].concat(_toConsumableArray(dateMap.get(dateLabel)), ["".concat(label)]));
        return dateMap;
      }, new Map());
      if (labels.size == 0) return null;
      return Array.from(labels.keys()).map(function (dateLabel) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: dateLabel
        }, /*#__PURE__*/React__default.createElement("strong", null, dateLabel), /*#__PURE__*/React__default.createElement("br", null), labels.get(dateLabel).map(function (spanContents, index) {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
            key: index
          }, index !== 0 && /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
            style: {
              whiteSpace: "nowrap"
            }
          }, spanContents));
        }));
      });
    }
  }, {
    key: "getBestCounts",
    value: function getBestCounts() {
      var numberOfTiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
      var _this$context = this.context,
          chartWidth = _this$context.chartWidth,
          chartHeight = _this$context.chartHeight;
      var tilePadding = this.props.tilePadding;
      var options = [];

      for (var _countPerRow = 1; _countPerRow <= numberOfTiles / 2; _countPerRow += 1) {
        var _rowCount = Math.ceil(numberOfTiles / _countPerRow);

        var tileWidth = (chartWidth - (_countPerRow - 1) * tilePadding) / _countPerRow;
        var tileHeight = (chartHeight - (_rowCount - 1) * tilePadding) / _rowCount;
        options.push({
          rowCount: _rowCount,
          countPerRow: _countPerRow,
          delta: Math.abs(tileWidth - tileHeight)
        });
      }

      var _options$sort = options.sort(function (_ref2, _ref3) {
        var deltaA = _ref2.delta;
        var deltaB = _ref3.delta;
        return deltaA - deltaB;
      }),
          _options$sort2 = _slicedToArray$1(_options$sort, 1),
          _options$sort2$ = _options$sort2[0],
          rowCount = _options$sort2$.rowCount,
          countPerRow = _options$sort2$.countPerRow;

      return {
        rowCount: rowCount,
        countPerRow: countPerRow
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context2 = this.context,
          chartWidth = _this$context2.chartWidth,
          chartHeight = _this$context2.chartHeight;
      var _this$props = this.props,
          tileSize = _this$props.tileSize,
          numberOfTilesFromProps = _this$props.count,
          tilePadding = _this$props.tilePadding,
          children = _this$props.children;
      var numberOfTileRows = 0,
          numberOfTilesPerRow = 0,
          numberOfTiles = numberOfTilesFromProps;

      if (!numberOfTiles && tileSize) {
        numberOfTileRows = Math.floor(chartHeight / (tileSize + tilePadding));
        numberOfTilesPerRow = Math.floor(chartWidth / (tileSize + tilePadding));
        numberOfTiles = numberOfTileRows * numberOfTilesPerRow;
      } else if (numberOfTiles) {
        var _this$getBestCounts = this.getBestCounts(numberOfTiles),
            rowCount = _this$getBestCounts.rowCount,
            countPerRow = _this$getBestCounts.countPerRow;

        numberOfTileRows = rowCount;
        numberOfTilesPerRow = countPerRow;
      }

      var tileWidth = (chartWidth - (numberOfTilesPerRow - 1) * tilePadding) / numberOfTilesPerRow;
      var tileHeight = (chartHeight - (numberOfTileRows - 1) * tilePadding) / numberOfTileRows;
      var contextValue = {
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        tilePadding: tilePadding,
        numberOfTiles: numberOfTiles,
        numberOfTilesPerRow: numberOfTilesPerRow,
        registerTileLabel: this.registerTileLabel,
        unregisterTileLabel: this.unregisterTileLabel,
        getFormattedTileLabel: this.getFormattedTileLabel
      };
      return /*#__PURE__*/React__default.createElement(HeatMapContext.Provider, {
        value: contextValue
      }, children);
    }
  }]);

  return HeatMapProvider;
}(React__default.Component);

HeatMapProvider.propTypes = {
  tileSize: PropTypes.number,
  count: PropTypes.number,
  tilePadding: PropTypes.number,
  children: PropTypes.any
};
HeatMapProvider.defaultProps = {
  tilePadding: 1
};
HeatMapProvider.contextType = ChartContext;
var HeatMapProvider$1 = HeatMapProvider;

var _excluded$l = ["className", "children", "chartClassName", "useCanvas", "chartRef", "wrapperRef", "width", "height", "barConfig", "heatMapConfig"];

var Chart = /*#__PURE__*/function (_React$Component) {
  _inherits$2(Chart, _React$Component);

  var _super = _createSuper$4(Chart);

  function Chart(props) {
    var _this;

    _classCallCheck$2(this, Chart);

    _this = _super.call(this, props);
    _this.state = {
      allYScales: []
    };
    _this.yAxes = new Map();
    _this.numericYAxisID = null;
    _this.canvasRefreshCounter = 0;
    _this.xAxes = new Map();
    _this.registerYScale = _this.registerYScale.bind(_assertThisInitialized$2(_this));
    _this.unregisterYScale = _this.unregisterYScale.bind(_assertThisInitialized$2(_this));
    _this.registerYAxis = _this.registerYAxis.bind(_assertThisInitialized$2(_this));
    _this.unregisterYAxis = _this.unregisterYAxis.bind(_assertThisInitialized$2(_this));
    _this.registerXAxis = _this.registerXAxis.bind(_assertThisInitialized$2(_this));
    _this.unregisterXAxis = _this.unregisterXAxis.bind(_assertThisInitialized$2(_this));
    return _this;
  }

  _createClass$2(Chart, [{
    key: "registerYScale",
    value: function registerYScale(yScale) {
      var allYScales = this.state.allYScales;

      if (!allYScales.includes(yScale)) {
        this.setState({
          allYScales: allYScales.concat(yScale)
        });
        this.clearCanvas();
      }
    }
  }, {
    key: "unregisterYScale",
    value: function unregisterYScale(yScale) {
      var allYScales = this.state.allYScales;
      this.setState({
        allYScales: allYScales.filter(function (_yScale) {
          return _yScale !== yScale;
        })
      });
      this.clearCanvas();
    }
  }, {
    key: "registerYAxis",
    value: function registerYAxis(yAxisID) {
      var usingNumericScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var longestExpectedValueLabelLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
      if (this.numericYAxisID && this.numericYAxisID !== yAxisID && usingNumericScale) throw new Error("Numeric Y Axis already registered");

      if (!this.yAxes.has(yAxisID)) {
        this.yAxes.set(yAxisID, {
          valueLength: longestExpectedValueLabelLength
        });
        if (usingNumericScale) this.numericYAxisID = yAxisID;
        this.clearCanvas();
        this.forceUpdate();
      }
    }
  }, {
    key: "unregisterYAxis",
    value: function unregisterYAxis(yAxisID) {
      this.yAxes.delete(yAxisID);

      if (this.numericYAxisID == yAxisID) {
        this.numericYAxisID = null;
      }

      this.clearCanvas();
      this.forceUpdate();
    }
  }, {
    key: "registerXAxis",
    value: function registerXAxis(xAxisID) {
      if (!this.xAxes.has(xAxisID)) {
        this.xAxes.set(xAxisID, {});
        this.clearCanvas();
        this.forceUpdate();
      }
    }
  }, {
    key: "unregisterXAxis",
    value: function unregisterXAxis(xAxisID) {
      this.xAxes.delete(xAxisID);
      this.clearCanvas();
      this.forceUpdate();
    }
  }, {
    key: "clearCanvas",
    value: function clearCanvas() {
      if (this.props.useCanvas) {
        var canvas = this.props.chartRef.current;

        if (canvas) {
          var context = canvas.getContext("2d");
          context.clearRect(0, 0, canvas.width, canvas.height);
          this.canvasRefreshCounter += 1;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          chartClassName = _this$props.chartClassName,
          useCanvas = _this$props.useCanvas,
          chartRef = _this$props.chartRef,
          wrapperRef = _this$props.wrapperRef,
          width = _this$props.width,
          height = _this$props.height,
          barConfig = _this$props.barConfig,
          heatMapConfig = _this$props.heatMapConfig,
          chartProps = _objectWithoutProperties(_this$props, _excluded$l);

      var allYScales = this.state.allYScales;
      var numericScale = allYScales.filter(function (_ref) {
        var valueLabels = _ref.valueLabels;
        return !valueLabels;
      }).reduce(function (scale, _ref2) {
        var min = _ref2.min,
            max = _ref2.max;
        return _objectSpread2(_objectSpread2({}, scale), {}, {
          min: Math.min(scale.min, min),
          max: Math.max(scale.max, max)
        });
      }, {
        min: Infinity,
        max: -Infinity
      });
      var yAxesWidth = 0;
      var yAxesPositioning = Array.from(this.yAxes.keys()).reduce(function (pos, axisId, index) {
        var left = yAxesWidth,
            width = _this2.yAxes.get(axisId).valueLength * 7;
        if (index > 0) width += 15;
        yAxesWidth += width;
        return _objectSpread2(_objectSpread2({}, pos), {}, _defineProperty$3({}, axisId, {
          left: left,
          width: width
        }));
      }, {});
      var chartPadTop = 5;
      var chartWidth = width;
      var chartPadLeft = 0;
      var chartHeight = height - chartPadTop;

      if (yAxesWidth > 0) {
        chartWidth -= yAxesWidth + 15;
        chartPadLeft += yAxesWidth + 15;
      }

      var xAxesPositioning = Array.from(this.xAxes.keys()).reduce(function (pos, axisId, index) {
        if (index > 0) chartHeight -= 10;
        if (index == 0) chartHeight -= 5;
        return _objectSpread2(_objectSpread2({}, pos), {}, _defineProperty$3({}, axisId, {
          top: chartHeight + chartPadTop,
          height: 10
        }));
      }, {});
      if (this.xAxes.size > 0) chartHeight -= 15;
      var contextValue = {
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        chartPadTop: chartPadTop,
        chartPadLeft: chartPadLeft,
        chartRef: chartRef,
        isCanvas: useCanvas,
        registerYScale: this.registerYScale,
        unregisterYScale: this.unregisterYScale,
        registerYAxis: this.registerYAxis,
        unregisterYAxis: this.unregisterYAxis,
        registerXAxis: this.registerXAxis,
        unregisterXAxis: this.unregisterXAxis,
        canvasRefreshCounter: this.canvasRefreshCounter,
        numericScale: numericScale,
        yAxesPositioning: yAxesPositioning,
        xAxesPositioning: xAxesPositioning
      };

      var RootNode = useCanvas ? "canvas" : "svg",
          rootProps = _objectSpread2(_objectSpread2({}, chartProps), {}, {
        ref: chartRef,
        className: chartClassName
      });

      if (RootNode == "svg") {
        rootProps.xmlns = "http://www.w3.org/2000/svg";
        rootProps.viewBox = "0 0 ".concat(width, " ").concat(height);
      }

      if (RootNode == "canvas") {
        var dpr = window.devicePixelRatio || 1;
        rootProps.width = width * dpr;
        rootProps.height = height * dpr;
        rootProps.style = {
          width: width,
          height: height
        };
      }

      return /*#__PURE__*/React__default.createElement("div", {
        ref: wrapperRef,
        className: "chart ".concat(className ? className : "")
      }, allYScales.length == 0 && /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null), /*#__PURE__*/React__default.createElement(RootNode, rootProps, /*#__PURE__*/React__default.createElement(ChartContext.Provider, {
        value: contextValue
      }, /*#__PURE__*/React__default.createElement(BarProvider$1, barConfig, /*#__PURE__*/React__default.createElement(HeatMapProvider$1, heatMapConfig, children)))));
    }
  }]);

  return Chart;
}(React__default.Component);

Chart.propTypes = {
  className: PropTypes.string,
  useCanvas: PropTypes.bool,
  chartClassName: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  chartRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  wrapperRef: PropTypes.any,
  barConfig: PropTypes.shape({
    count: PropTypes.number,
    stacked: PropTypes.bool,
    barWidth: PropTypes.number,
    barPadding: PropTypes.number,
    barGroupPadding: PropTypes.number
  }),
  heatMapConfig: PropTypes.shape({}),
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (!Object.keys(DataSources).find(function (DataSourceType) {
        return child.type == DataSources[DataSourceType];
      })) {
        error = new Error("".concat(componentName, " children should be of type [").concat(Object.keys(DataSources).join(", "), "]"));
      }
    });
    return error;
  }
};
var Chart$1 = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width,
      height = _useDimensions.height;

  var chartRef = useRef();
  return /*#__PURE__*/React__default.createElement(Chart, _extends$U({
    wrapperRef: observe,
    chartRef: ref || chartRef,
    width: width,
    height: height
  }, props));
});

var LoadingString = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var defaultLength = _ref.length,
      width = _ref.width,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 20 : _ref$max;

  var _useState = useState(defaultLength || min),
      _useState2 = _slicedToArray$1(_useState, 2),
      length = _useState2[0],
      setLength = _useState2[1];

  useEffect(function () {
    if (!defaultLength) setLength(Math.round(Math.abs(Math.random() * (max - min) + min)));
  }, []);
  return /*#__PURE__*/React__default.createElement("span", {
    className: "loading-string",
    style: width ? {
      width: width
    } : null,
    ref: ref
  }, /*#__PURE__*/React__default.createElement("span", null), !width && " ".repeat(length).split("").map(function (_, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, "\xA0");
  }));
});
LoadingString.propTypes = {
  length: PropTypes.number,
  width: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number
};
var LoadingString$1 = LoadingString;

var _path$L;

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var SvgRule = function SvgRule(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19.8",
    ref: ref
  }, props), _path$L || (_path$L = /*#__PURE__*/React$1.createElement("path", {
    d: "M11.3 3.7c1.5.3 2.7 1.5 3 3m-3-6.1c3.2.4 5.7 2.9 6.1 6.1M13.7 10.7V13c0 1.3 1 2.3 2.3 2.3H.6c1.3 0 2.3-1 2.3-2.3V9.2c0-2.6 1.8-4.8 4.3-5.3m2.4 14.5c-.4.7-1.4 1-2.1.6-.2-.1-.4-.3-.6-.6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
};

var ForwardRef$N = /*#__PURE__*/forwardRef(SvgRule);

var RuleEvent = function RuleEvent(_ref) {
  var event = _ref.event,
      usePointMap = _ref.usePointMap,
      pointMap = _ref.pointMap;
  if (!event) return null;
  var i18n = useI18n$1();
  var firstActorRef = useRef();
  var moreActorsRef = useRef();
  var resolvedRef = useRef();
  var ruleLinkRef = useRef();

  var _useChariotGet = useChariotGet("Rule", event._.rule_id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 1),
      rule = _useChariotGet2[0];

  var firstActor, firstActorError, moreActors;

  if (!usePointMap) {
    var _event$_$actors$map = event._.actors.map(function (_ref2) {
      var id = _ref2.id;
      return useChariotGet("Point", id);
    }),
        _event$_$actors$map2 = _toArray$1(_event$_$actors$map),
        _event$_$actors$map2$ = _slicedToArray$1(_event$_$actors$map2[0], 2),
        _firstActor = _event$_$actors$map2$[0],
        _firstActorError = _event$_$actors$map2$[1],
        _moreActors = _event$_$actors$map2.slice(1);

    firstActor = _firstActor;
    firstActorError = _firstActorError;
    moreActors = _moreActors;
  } else {
    var firstActorId = event._.actors[0].id;
    firstActor = pointMap[firstActorId];
    firstActorError = pointMap[firstActorId] === null;
    moreActors = event._.actors.slice(1, event._.actors.length).map(function (_ref3) {
      var id = _ref3.id;
      return [pointMap[id]];
    });
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "5",
    fill: !event._.resolved ? "#EF4552" : "#36b0a7"
  })), firstActorError ? /*#__PURE__*/React__default.createElement("span", null, i18n.t("rules.errorLoadingPoint")) : firstActor ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    ref: firstActorRef
  }, firstActor.getDisplayName()), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: firstActorRef
  }, firstActor.getDisplayName(), ": ", firstActor.mapValue(event._.actors[0].value.str || event._.actors[0].value.avg))) : /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 18
  }), moreActors && moreActors.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    ref: moreActorsRef
  }, i18n.t("rules.nMoreActors", {
    n: moreActors.length
  })), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: moreActorsRef
  }, moreActors.map(function (_ref4, index) {
    var _ref5 = _slicedToArray$1(_ref4, 1),
        actor = _ref5[0];

    if (!actor) return null;
    var value = event.actors[index + 1].value.str || event.actors[index + 1].value.avg;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, actor.getDisplayName(), ": ", value);
  })), event._.resolved ? /*#__PURE__*/React__default.createElement("span", {
    ref: resolvedRef
  }, i18n.t("rules.multipleOutOfRangeResolved")) : /*#__PURE__*/React__default.createElement("span", null, i18n.t("rules.multipleOutOfRange"))) : event._.resolved ? /*#__PURE__*/React__default.createElement("span", {
    ref: resolvedRef
  }, i18n.t("rules.outOfRangeResolved")) : /*#__PURE__*/React__default.createElement("span", null, i18n.t("rules.outOfRange")), /*#__PURE__*/React__default.createElement(Button$1, {
    ref: ruleLinkRef,
    component: Link,
    to: "/rules/".concat(event._.rule_id, "/events")
  }, /*#__PURE__*/React__default.createElement(ForwardRef$N, null)), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, moment(event._.start).format("LTS")), event._.resolved && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: resolvedRef
  }, i18n.t("rules.resolvedLabel"), " ", moment(event._.resolved).format("lll")), rule && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: ruleLinkRef
  }, rule._.name));
};

RuleEvent.propTypes = {
  event: PropTypes.instanceOf(RuleEvent$2),
  usePointMap: PropTypes.bool,
  pointMap: PropTypes.object
};
var RuleEvent$1 = RuleEvent;

var RuleEventList = function RuleEventList(_ref) {
  var filters = _ref.filters;

  var _useChariotList = useChariotList("RuleEvent", {
    filters: filters
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      ruleEvents = _useChariotList2[0],
      error = _useChariotList2[1],
      loading = _useChariotList2[2];

  var dateMap = new Map();

  if (ruleEvents && ruleEvents.length > 0) {
    var sortedRuleEvents = ruleEvents.sort(function (ruleEventA, ruleEventB) {
      return new Date(ruleEventB._.start) - new Date(ruleEventA._.start);
    });

    var _iterator = _createForOfIteratorHelper(sortedRuleEvents),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ruleEvent = _step.value;
        var dateKey = moment(ruleEvent._.start).format("L");
        if (!dateMap.has(dateKey)) dateMap.set(dateKey, []);
        dateMap.set(dateKey, [].concat(_toConsumableArray(dateMap.get(dateKey)), [ruleEvent]));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event-list"
  }, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), loading || !ruleEvents || ruleEvents.length == 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "loading-rule-section"
  }, /*#__PURE__*/React__default.createElement("h4", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 6,
    max: 8
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  })))) : Array.from(dateMap.keys()).map(function (dateKey) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: dateKey
    }, /*#__PURE__*/React__default.createElement("h4", null, /*#__PURE__*/React__default.createElement("span", null, dateKey)), dateMap.get(dateKey).map(function (ruleEvent) {
      return /*#__PURE__*/React__default.createElement(RuleEvent$1, {
        key: ruleEvent._.id,
        event: ruleEvent
      });
    }));
  }));
};

RuleEventList.propTypes = {
  filters: PropTypes.shape({
    rule_id: PropTypes.string,
    site_id: PropTypes.string,
    point_ids: PropTypes.arrayOf(PropTypes.string),
    from_date: PropTypes.instanceOf(Date),
    to_date: PropTypes.instanceOf(Date)
  })
};
var RuleEventList$1 = RuleEventList;

var EquipmentNotificationHistoryCard = function EquipmentNotificationHistoryCard(_ref) {
  var equipment = _ref.equipment;
  var i18n = useI18n$1();

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      points = _useState2[0],
      setPoints = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _points;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              if (!equipment) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return equipment.getPoints();

            case 4:
              _points = _context.sent;

              if (mounted) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              setPoints(_points);

            case 8:
              if (mounted) setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment]);
  var from_date = moment().subtract(30, "days").toDate(),
      to_date = new Date();
  return /*#__PURE__*/React__default.createElement(Card$1, {
    loading: loading,
    className: "equipment-notification-history-card"
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.notificationHistoryHeader")
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(RuleEventList$1, {
    filters: {
      point_ids: points.map(function (_ref3) {
        var _ = _ref3._;
        return _.id;
      }),
      from_date: from_date,
      to_date: to_date
    }
  })));
};

EquipmentNotificationHistoryCard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2)
};
var EquipmentNotificationHistoryCard$1 = EquipmentNotificationHistoryCard;

var _path$K;

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var SvgCloudOff = function SvgCloudOff(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-off",
    ref: ref
  }, props), _path$K || (_path$K = /*#__PURE__*/React$1.createElement("path", {
    d: "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3M1 1l22 22"
  })));
};

var ForwardRef$M = /*#__PURE__*/forwardRef(SvgCloudOff);

var _path$J, _path2$e, _path3;

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var SvgOnlineCheck = function SvgOnlineCheck(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$L({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$J || (_path$J = /*#__PURE__*/React$1.createElement("path", {
    d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z",
    fill: "#00B69B"
  })), _path2$e || (_path2$e = /*#__PURE__*/React$1.createElement("path", {
    d: "M10.11 4.667 5.543 9.334 3.89 7.648",
    fill: "#00B69B"
  })), _path3 || (_path3 = /*#__PURE__*/React$1.createElement("path", {
    d: "M10.11 4.667 5.543 9.334 3.89 7.648",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef$L = /*#__PURE__*/forwardRef(SvgOnlineCheck);

var EquipmentStatusCard = function EquipmentStatusCard(_ref) {
  var equipment = _ref.equipment;
  var i18n = useI18n$1();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      downPointLabel = _useState2[0],
      setDownPointLabel = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$1(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var points, criticalPoints, firstDownPoint, andOtherCounter, _iterator, _step, point, status;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              if (!equipment) {
                _context.next = 29;
                break;
              }

              _context.next = 4;
              return equipment.getPoints();

            case 4:
              points = _context.sent;
              criticalPoints = points.filter(function (_ref3) {
                var _ = _ref3._;
                return _.critical;
              });
              firstDownPoint = null, andOtherCounter = 0;
              _iterator = _createForOfIteratorHelper(criticalPoints);
              _context.prev = 8;

              _iterator.s();

            case 10:
              if ((_step = _iterator.n()).done) {
                _context.next = 18;
                break;
              }

              point = _step.value;
              _context.next = 14;
              return point.getStatus();

            case 14:
              status = _context.sent;

              if (status !== "ok") {
                if (!firstDownPoint) {
                  firstDownPoint = point;
                } else {
                  andOtherCounter++;
                }
              }

            case 16:
              _context.next = 10;
              break;

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](8);

              _iterator.e(_context.t0);

            case 23:
              _context.prev = 23;

              _iterator.f();

              return _context.finish(23);

            case 26:
              if (mounted) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return");

            case 28:
              if (firstDownPoint) {
                if (andOtherCounter > 0) {
                  setDownPointLabel(i18n.t("equipment.multipleDownPoints", {
                    firstPointName: firstDownPoint.getDisplayName(),
                    otherCount: andOtherCounter
                  }));
                } else {
                  setDownPointLabel(i18n.t("equipment.downPoint", {
                    pointName: firstDownPoint.getDisplayName()
                  }));
                }
              } else {
                setDownPointLabel(null);
              }

            case 29:
              if (mounted) setLoading(false);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 20, 23, 26]]);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment]);
  return /*#__PURE__*/React__default.createElement(Card$1, {
    loading: loading,
    className: "equipment-status-card"
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: downPointLabel ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$M, {
      width: "1.75rem",
      height: "1.75rem"
    }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.equipmentOffline"))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$L, {
      width: "1.75rem",
      height: "1.75rem"
    }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.equipmentOnline")))
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, downPointLabel && /*#__PURE__*/React__default.createElement("span", null, downPointLabel)));
};

EquipmentStatusCard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2)
};
var EquipmentStatusCard$1 = EquipmentStatusCard;

var PointValueDisplay = function PointValueDisplay(props) {
  var equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      onReceivedValue = props.onReceivedValue,
      display = props.display,
      _props$expectedValueL = props.expectedValueLength,
      expectedValueLength = _props$expectedValueL === void 0 ? 2 : _props$expectedValueL,
      noToolTip = props.noToolTip,
      toolTipPosition = props.toolTipPosition;

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      receivedValueOnce = _useState6[0],
      setReceivedValueOnce = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      valueSubscription = _useState8[0],
      setValueSubscription = _useState8[1];

  var tooltip = useRef();
  var tooltipAnchor = useCallback(function (node) {
    if (!noToolTip) {
      var _tooltip$current;

      (_tooltip$current = tooltip.current) === null || _tooltip$current === void 0 ? void 0 : _tooltip$current.rebindAnchor({
        current: node
      });
    }
  }, []);
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points, handleNewValue;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (point) {
                _context.next = 18;
                break;
              }

              if (equipment) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (!point_id) {
                _context.next = 11;
                break;
              }

              _context.next = 7;
              return equipment.getPoints();

            case 7:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 15;
              break;

            case 11:
              if (!point_name) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return equipment.findPointByName(point_name);

            case 14:
              point = _context.sent;

            case 15:
              if (mounted) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              if (point) setPoint(point);

            case 18:
              if (!point) {
                _context.next = 31;
                break;
              }

              if (valueSubscription) valueSubscription.cancel();

              handleNewValue = function handleNewValue(newValue) {
                if (newValue === undefined) newValue = null;
                if (!mounted) return;
                setReceivedValueOnce(true);
                setValue(newValue);
                if (onReceivedValue) onReceivedValue(newValue, point);
              };

              if (mounted) {
                _context.next = 23;
                break;
              }

              return _context.abrupt("return");

            case 23:
              setValueSubscription(point.subscribe(handleNewValue));
              _context.t0 = handleNewValue;
              _context.next = 27;
              return point.getValue();

            case 27:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              _context.next = 34;
              break;

            case 31:
              if (mounted) {
                _context.next = 33;
                break;
              }

              return _context.abrupt("return");

            case 33:
              setValue(null);

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      mounted = false;
      if (valueSubscription) valueSubscription.cancel();
    };
  }, [equipment && equipment._.id, pointFromProps && pointFromProps._.id, point_name, point_id]);

  if (!point || !receivedValueOnce
  /* || true */
  ) {
    if (display) return display(null);
    return /*#__PURE__*/React__default.createElement(LoadingString$1, {
      length: expectedValueLength
    });
  }

  var renderedValue = value;

  try {
    if (point.mapValue(renderedValue)) renderedValue = point.mapValue(renderedValue);
  } catch (e) {// pass
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !noToolTip && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: toolTipPosition,
    ref: tooltip
  }, /*#__PURE__*/React__default.createElement("strong", null, point && point.getDisplayName()), " ", /*#__PURE__*/React__default.createElement("br", null), point && moment(point.lastReceivedValueTimestamp * 1000).format("lll")), display ? display(renderedValue, point, tooltipAnchor) : /*#__PURE__*/React__default.createElement("span", {
    ref: tooltipAnchor
  }, renderedValue));
};

PointValueDisplay.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  onReceivedValue: PropTypes.func,
  display: PropTypes.func,
  expectedValueLength: PropTypes.number,
  noToolTip: PropTypes.bool,
  toolTipPosition: PropTypes.oneOf(["top", "bottom", "left", "right"])
};
var PointValueDisplay$1 = PointValueDisplay;

var PointValueCard = function PointValueCard(_ref) {
  var label = _ref.label,
      equipment = _ref.equipment,
      point_name = _ref.point_name,
      _display = _ref.display;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2);
      _useState2[0];
      var setValue = _useState2[1];

  useRef();
  var cardState = "",
      warningMessage = ""; // set cardState and warningMessage based on value

  return /*#__PURE__*/React__default.createElement(Card$1, {
    className: "point-value-card ".concat(cardState)
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: label
  }, warningMessage ), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    equipment: equipment,
    point_name: point_name,
    display: function display(value, point, anchor) {
      if (value !== null && value !== undefined) {
        return _display(value, point, anchor);
      }

      return /*#__PURE__*/React__default.createElement("span", null, "N/A");
    },
    onReceivedValue: function onReceivedValue(value, point) {
      if (!point) return;
      setValue(point.mapValue(value));
    }
  })));
};

PointValueCard.propTypes = {
  label: PropTypes.string,
  equipment: PropTypes.instanceOf(Equipment$2),
  point_name: PropTypes.string,
  display: PropTypes.func.isRequired
};
var PointValueCard$1 = PointValueCard;

var PieGraph = function PieGraph(props) {
  var filledColor = props.filledColor,
      unFilledColor = props.unFilledColor,
      loading = props.loading,
      className = props.className,
      children = props.children;
  if (loading) return /*#__PURE__*/React__default.createElement("div", {
    className: "pie-graph loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));
  var styles = {};
  if (filledColor) styles["--pie-graph-filled-color"] = filledColor;
  if (unFilledColor) styles["--pie-graph-unfilled-color"] = unFilledColor;
  var filled = props.filled;
  if (filled > 1) filled = 1;
  if (filled < 0) filled = 0;

  if (filled == 0) {
    styles["backgroundColor"] = "var(--pie-graph-unfilled-color)";
  } else if (filled == 1) {
    styles["backgroundColor"] = "var(--pie-graph-filled-color)";
  } else if (filled < 0.5) {
    styles["backgroundImage"] = "linear-gradient(".concat(90 + 360 * filled, "deg, transparent 50%, var(--pie-graph-unfilled-color) 50%), \n                                 linear-gradient(90deg, var(--pie-graph-unfilled-color) 50%, transparent 50%)");
  } else {
    styles["backgroundImage"] = "linear-gradient(90deg, transparent 50%, var(--pie-graph-filled-color) 50%),\n                                 linear-gradient(".concat(-90 + 360 * (filled - 0.5), "deg, transparent 50%, var(--pie-graph-unfilled-color) 50%)");
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "pie-graph ".concat(className ? className : ""),
    style: styles
  }, children && /*#__PURE__*/React__default.createElement("div", {
    className: "overlay"
  }, children));
};

PieGraph.propTypes = {
  filled: PropTypes.number.isRequired,
  filledColor: PropTypes.string,
  unFilledColor: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string
};
var PieGraph$1 = PieGraph;

var StackedBar = function StackedBar(props) {
  var filled = props.filled,
      filledColor = props.filledColor,
      unFilledColor = props.unFilledColor,
      className = props.className;
  var segments;

  if (typeof filled == "number") {
    segments = [{
      color: filledColor || "var(--stacked-bar-filled-color)",
      filled: filled
    }];
  } else {
    segments = filled;
  }

  var totalFilled = segments.reduce(function (total, segment) {
    return total + segment.filled;
  }, 0);
  var styles = {};
  if (unFilledColor) styles["--stacked-bar-unfilled-color"] = unFilledColor;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "stacked-bar ".concat(className ? className : ""),
    style: styles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filled",
    style: {
      '--size': "".concat(totalFilled * 100, "%")
    }
  }, segments.map(function (segment, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "segment",
      style: {
        '--size': "".concat(totalFilled ? segment.filled / totalFilled * 100 : 0, "%"),
        '--stacked-bar-filled-color': segment.color
      }
    });
  })));
};

StackedBar.propTypes = {
  className: PropTypes.string,
  filled: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    filled: PropTypes.number.isRequired
  }))]).isRequired,
  filledColor: PropTypes.string,
  unFilledColor: PropTypes.string
};
var StackedBar$1 = StackedBar;

var StackedBarChart = function StackedBarChart(props) {
  var bars = props.bars,
      className = props.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "stacked-bar-chart ".concat(className ? className : "")
  }, bars.map(function (_ref, index) {
    var timestamp = _ref.timestamp,
        segments = _ref.segments;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "bar-wrapper"
    }, /*#__PURE__*/React__default.createElement(StackedBar$1, {
      filled: segments
    }), index % 3 == 0 && /*#__PURE__*/React__default.createElement("div", {
      className: "timestamp"
    }, moment(timestamp).format("ha")));
  }));
};

StackedBarChart.propTypes = {
  className: PropTypes.string,
  bars: PropTypes.arrayOf(PropTypes.shape({
    timestamp: PropTypes.instanceOf(Date).isRequired,
    segments: PropTypes.arrayOf(PropTypes.shape({
      color: PropTypes.string.isRequired,
      filled: PropTypes.number.isRequired
    })).isRequired
  })).isRequired
};
var StackedBarChart$1 = StackedBarChart;

var PIE_WIDTH = 126;
var BAR_WIDTH$1 = 29.6;

var convertMsToFriendlyHours = function convertMsToFriendlyHours(ms) {
  var hours = ms / 1000 / 60 / 60;
  return "".concat(hours.toFixed(1), " Hour").concat(hours !== 1 ? "s" : "");
};

var EquipmentSummaryCard = function EquipmentSummaryCard(props) {
  var i18n = useI18n$1();
  var label = props.label,
      className = props.className,
      equipment = props.equipment;

  var _useState = useState([{
    value: 0
  }]),
      _useState2 = _slicedToArray$1(_useState, 2),
      pieData = _useState2[0],
      setPieData = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      hourlyData = _useState4[0],
      setHourlyData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  if (!Array.isArray(equipment) && equipment) equipment = [equipment];
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var from, to, data, _pieData, coolingHourlyData, heatingHourlyData, totalMs, _iterator, _step, _step$value, coolingData, heatingData, index, _index, _hourlyData, _data, _pieData2, _hourlyData2, _totalMs, _iterator2, _step2, lightingActivityData, _index2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              from = moment().startOf("hour").subtract(1, "day").toDate(), to = moment().endOf("hour").toDate();

              if (!equipment[0]) {
                _context.next = 34;
                break;
              }

              if (!(equipment[0].type == HVAC$1)) {
                _context.next = 19;
                break;
              }

              _context.next = 6;
              return Promise.all(equipment.map(function (e) {
                return Promise.all([e.getCoolingActivityForPeriod(from, to), e.getHeatingActivityForPeriod(from, to)]);
              }));

            case 6:
              data = _context.sent;
              _pieData = [{
                label: "equipment.heating",
                value: 0,
                friendlyValue: "0 Hours",
                color: "#EA7884"
              }, {
                label: "equipment.cooling",
                value: 0,
                friendlyValue: "0 Hours",
                color: "#4040DC"
              }];
              coolingHourlyData = [], heatingHourlyData = [];
              totalMs = 1000 * 60 * 60 * 24 * equipment.length;
              _iterator = _createForOfIteratorHelper(data);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray$1(_step.value, 2), coolingData = _step$value[0], heatingData = _step$value[1];

                  if (coolingData.ms > 0) {
                    _pieData[1].value += coolingData.ms / totalMs;
                    _pieData[1].friendlyValue = convertMsToFriendlyHours(_pieData[1].value * totalMs);
                  }

                  if (heatingData.ms > 0) {
                    _pieData[0].value += heatingData.ms / totalMs;
                    _pieData[0].friendlyValue = convertMsToFriendlyHours(_pieData[0].value * totalMs);
                  }

                  if (coolingHourlyData.length == 0) {
                    coolingHourlyData = coolingData.hourly;
                  } else {
                    for (index = 0; index < coolingData.hourly.length; index += 1) {
                      coolingHourlyData[index].ms += coolingData.hourly[index].ms;
                      coolingHourlyData[index].percent = coolingHourlyData[index].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }

                  if (heatingHourlyData.length == 0) {
                    heatingHourlyData = heatingData.hourly;
                  } else {
                    for (_index = 0; _index < heatingData.hourly.length; _index += 1) {
                      heatingHourlyData[_index].ms += heatingData.hourly[_index].ms;
                      heatingHourlyData[_index].percent = heatingHourlyData[_index].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _hourlyData = heatingHourlyData.map(function (_ref2, index) {
                var percent = _ref2.percent,
                    timestamp = _ref2.timestamp;
                return {
                  timestamp: timestamp,
                  segments: [{
                    color: "#EA7884",
                    filled: percent
                  }, {
                    color: "#4040DC",
                    filled: coolingHourlyData[index].percent
                  }]
                };
              });

              if (mounted) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return");

            case 15:
              setPieData(_pieData);
              setHourlyData(_hourlyData);
              _context.next = 33;
              break;

            case 19:
              if (!(equipment[0].type == Lighting$1)) {
                _context.next = 33;
                break;
              }

              _context.next = 22;
              return Promise.all(equipment.map(function (e) {
                return e.getLightActivityForPeriod(from, to);
              }));

            case 22:
              _data = _context.sent;
              _pieData2 = [{
                label: "equipment.lightOn",
                value: 0,
                friendlyValue: "0 Hours",
                color: "#4040DC"
              }];
              _hourlyData2 = [];
              _totalMs = 1000 * 60 * 60 * 24 * equipment.length;
              _iterator2 = _createForOfIteratorHelper(_data);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  lightingActivityData = _step2.value;

                  if (lightingActivityData.ms > 0) {
                    _pieData2[0].value += lightingActivityData.ms / _totalMs;
                    _pieData2[0].friendlyValue = convertMsToFriendlyHours(_pieData2[0].value * _totalMs);
                  }

                  if (_hourlyData2.length == 0) {
                    _hourlyData2 = lightingActivityData.hourly;
                  } else {
                    for (_index2 = 0; _index2 < lightingActivityData.hourly.length; _index2 += 1) {
                      _hourlyData2[_index2].ms += lightingActivityData.hourly[_index2].ms;
                      _hourlyData2[_index2].percent = _hourlyData2[_index2].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              _hourlyData2 = _hourlyData2.map(function (_ref3) {
                var percent = _ref3.percent,
                    timestamp = _ref3.timestamp;
                return {
                  timestamp: timestamp,
                  segments: [{
                    color: "#4040DC",
                    filled: percent
                  }]
                };
              });

              if (mounted) {
                _context.next = 31;
                break;
              }

              return _context.abrupt("return");

            case 31:
              setPieData(_pieData2);
              setHourlyData(_hourlyData2);

            case 33:
              setLoading(false);

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      mounted = false;
    };
  }, [equipment && JSON.stringify(equipment.map(function (e) {
    return e && e._;
  }))]);
  var collapsedHourlyData = hourlyData;

  while (width && (width > 535 && width - 32 - pieData.length * PIE_WIDTH < collapsedHourlyData.length * BAR_WIDTH$1 || width <= 535 && width - 32 < collapsedHourlyData.length * BAR_WIDTH$1)) {
    var reCollapsedHourlyData = [];

    for (var i = 0; i < collapsedHourlyData.length; i += 2) {
      var _collapsedHourlyData$ = collapsedHourlyData[i],
          timestamp = _collapsedHourlyData$.timestamp,
          segments = _collapsedHourlyData$.segments;

      if (collapsedHourlyData[i + 1]) {
        segments = segments.concat(collapsedHourlyData[i + 1].segments).reduce(function (s, _ref4) {
          var color = _ref4.color,
              filled = _ref4.filled;
          var existingIndex = s.findIndex(function (se) {
            return se.color == color;
          });

          if (existingIndex >= 0) {
            s[existingIndex].filled += filled / 2;
          } else {
            s.push({
              color: color,
              filled: filled / 2
            });
          }

          return s;
        }, []);
      }

      reCollapsedHourlyData.push({
        timestamp: timestamp,
        segments: segments
      });
    }

    collapsedHourlyData = reCollapsedHourlyData;
  }

  return /*#__PURE__*/React__default.createElement(Card$1, {
    ref: observe,
    className: "equipment-summary ".concat(className ? className : "", " ").concat(loading ? "loading" : "")
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: label,
    className: "equipment-summary--header"
  }), /*#__PURE__*/React__default.createElement(CardBody$1, {
    className: "equipment-summary--data"
  }, loading ? /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, pieData.map(function (_ref5, index) {
    var label = _ref5.label,
        value = _ref5.value,
        friendlyValue = _ref5.friendlyValue,
        color = _ref5.color;
    return /*#__PURE__*/React__default.createElement(PieGraph$1, {
      key: index,
      filled: value,
      filledColor: color,
      loading: loading
    }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.todayTimeframeDesc")), /*#__PURE__*/React__default.createElement("strong", null, friendlyValue), /*#__PURE__*/React__default.createElement("span", null, i18n.t(label)));
  }), /*#__PURE__*/React__default.createElement(StackedBarChart$1, {
    bars: collapsedHourlyData
  }))));
};

EquipmentSummaryCard.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (!equipment || Array.isArray(equipment) && equipment.length == 0) return null;

    if (Array.isArray(equipment) && equipment.length > 0) {
      var firstType = equipment[0].type;

      if (firstType !== HVAC$1 && firstType !== Lighting$1) {
        return new Error("Equipment primitive type must be Lighting or HVAC, found: ".concat(firstType.name));
      }

      if (!equipment.every(function (_ref6) {
        var type = _ref6.type;
        return type == firstType;
      })) {
        return new Error("All equipment in array must be of the same type.");
      }
    } else if (equipment.type !== HVAC$1 && equipment.type !== Lighting$1) {
      return new Error("Equipment primitive type must be Lighting or HVAC, found: ".concat(equipment.type.name));
    }

    return null;
  }
};
var EquipmentSummaryCard$1 = EquipmentSummaryCard;

var GatewayDashboard = function GatewayDashboard(props) {
  var equipment = props.equipment,
      _props$resolution = props.resolution,
      resolution = _props$resolution === void 0 ? "15M" : _props$resolution,
      useCanvasCharts = props.useCanvasCharts;
  var i18n = useI18n$1();
  var comparisonRanges = {
    '72hr': {
      start: moment().subtract(72, "hours").toDate(),
      end: moment().toDate()
    },
    '24hr': {
      start: moment().subtract(24, "hours").toDate(),
      end: moment().toDate()
    },
    '24hrLastWeek': {
      start: moment().subtract(1, "week").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "week").toDate()
    },
    '24hrLastMonth': {
      start: moment().subtract(1, "month").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "month").toDate()
    },
    '24hrLastYear': {
      start: moment().subtract(1, "year").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "year").toDate()
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-dashboard gateway"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-row small"
  }, /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("gateway.lanLabel"),
    equipment: equipment,
    point_name: equipment.pointNames.lanIp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value);
    }
  }), /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("gateway.wanLabel"),
    equipment: equipment,
    point_name: equipment.pointNames.wanIp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value);
    }
  }), /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("gateway.publicIpLabel"),
    equipment: equipment,
    point_name: equipment.pointNames.publicIp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value);
    }
  }), /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("gateway.virtualIpLabel"),
    equipment: equipment,
    point_name: equipment.pointNames.virtualIp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value);
    }
  }), /*#__PURE__*/React__default.createElement(EquipmentStatusCard$1, {
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.24HrRangeSuffix", {
      prefix: i18n.t("gateway.uptimeLabel")
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.uptimeLabel"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.uptime,
    parseValue: function parseValue(value, point, _ref) {
      var snapshot = _ref.snapshot;

      var _value$split$map = value.split(":").map(function (n) {
        return parseInt(n);
      }),
          _value$split$map2 = _slicedToArray$1(_value$split$map, 3),
          h = _value$split$map2[0],
          m = _value$split$map2[1],
          s = _value$split$map2[2];

      var milliseconds = ((h * 60 + m) * 60 + s) * 1000;
      return milliseconds / (+new Date(snapshot) % 86400000);
    }
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 3,
    tickFormat: function tickFormat(n) {
      return "".concat(parseInt(n * 100), "%");
    }
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line, {
    tooltips: true,
    stroke: "#313341",
    tooltipValueFormat: function tooltipValueFormat(n) {
      return "".concat(parseInt(n * 100), "%");
    }
  }))))), /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.24HrRangeSuffix", {
      prefix: "".concat(i18n.t("gateway.memoryLabel"), " ").concat(i18n.t("gateway.memoryPctLabel"))
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.memoryLabel"), " ", i18n.t("gateway.memoryPctLabel"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.memoryUsed
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line, {
    tooltips: true,
    stroke: "#313341"
  }))))), /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.24HrRangeSuffix", {
      prefix: "".concat(i18n.t("gateway.storageLabel"), " ").concat(i18n.t("gateway.storageUsageLabel"))
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.storageLabel"), " ", i18n.t("gateway.storageUsageLabel"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.storageAvailable,
    parseValue: function parseValue(value) {
      return parseFloat(value);
    }
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 1,
    tickFormat: function tickFormat(n) {
      return "".concat(n, "M");
    }
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line, {
    tooltips: true,
    stroke: "#313341",
    tooltipValueFormat: function tooltipValueFormat(n) {
      return "".concat(n, "M");
    }
  })))))));
};

GatewayDashboard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  site: PropTypes.instanceOf(Site),
  resolution: PropTypes.oneOf(RESOLUTIONS),
  useCanvasCharts: PropTypes.bool
};
var GatewayDashboard$1 = GatewayDashboard;

var _path$I;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var SvgSnowflake = function SvgSnowflake(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _path$I || (_path$I = /*#__PURE__*/React$1.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.5 1.16v22.68M1.16 12.5h22.68m-6.24 8.63-5.05-4.96-5.15 4.96m0-17.26 5.05 4.96 5.15-4.96m3.53 3.53-4.96 5.05 4.96 5.15m-17.26 0 4.96-5.05L3.87 7.4"
  })));
};

var ForwardRef$K = /*#__PURE__*/forwardRef(SvgSnowflake);

var _g$1;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var SvgSupplyAir = function SvgSupplyAir(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$J({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React$1.createElement("g", {
    opacity: 0.5,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M13.82 3.926c-.046 1.107-.45 2.266-.817 3.385-.437 1.33-.666 2.585-.534 3.817.039.315.096.627.183.937"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "m14 11.246-1.5 1.487-1.5-1.487M8.82 3.926c-.046 1.107-.45 2.266-.817 3.385-.437 1.33-.666 2.585-.534 3.817.039.315.096.627.183.937"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "m9 11.246-1.5 1.487L6 11.246M3.82 3.926c-.046 1.107-.45 2.266-.817 3.385-.437 1.33-.666 2.585-.534 3.817.039.315.096.627.183.937"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "m4 11.246-1.5 1.487L1 11.246M15 1H1.717"
  }))));
};

var ForwardRef$J = /*#__PURE__*/forwardRef(SvgSupplyAir);

var _path$H;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var SvgDroplet = function SvgDroplet(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$I({
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$H || (_path$H = /*#__PURE__*/React$1.createElement("path", {
    d: "m6.926 1 4.196 4.195a5.93 5.93 0 1 1-8.384 0L6.926 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$I = /*#__PURE__*/forwardRef(SvgDroplet);

var _g;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var SvgFan = function SvgFan(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$H({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React$1.createElement("g", {
    opacity: 0.5,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M6.524 8.505c.011 1.106.934 2.018 2.008 2.008 1.095-.01 2.018-.934 2.007-2.018 0-1.095-.912-1.997-2.018-2.008-1.084 0-2.007.934-1.997 2.018ZM7.244 6.509c-.42-.516-.795-1.181-.967-1.933-.236-1.04-.204-2.04.655-2.834.655-.59 1.46-.762 2.308-.74.687.021 1.353.182 1.922.6a1.59 1.59 0 0 1 .182 2.46c-.386.386-.826.73-1.16 1.148-.246.322-.386.73-.547 1.106M6.589 9.74c-.58.472-1.246.848-2.008 1.02-1.6.365-2.79-.086-3.338-1.546-.397-1.074-.312-2.169.29-3.178.59-.998 1.825-1.116 2.619-.279.333.344.665.709 1.02 1.042.171.171.386.31.612.429.193.107.343.161.472.172"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M9.83 10.33c.323.698.72 1.342.913 2.03.687 2.425-.912 3.692-2.941 3.638-.698-.021-1.364-.204-1.943-.633a1.586 1.586 0 0 1-.172-2.394c.386-.386.827-.72 1.16-1.149.257-.322.407-.74.579-1.137M10.475 7.27a4.883 4.883 0 0 1 2.276-1.083c1.921-.344 3.07.762 3.252 2.437.086.783-.021 1.535-.408 2.232-.612 1.117-1.878 1.267-2.737.344-.333-.354-.666-.72-1.02-1.052a2.433 2.433 0 0 0-.655-.419c-.236-.107-.376-.16-.504-.14"
  }))));
};

var ForwardRef$H = /*#__PURE__*/forwardRef(SvgFan);

var tempFormatter = function tempFormatter(n) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "".concat(parseFloat(n).toFixed(d), "\xB0F");
};

var HVACDashboard = function HVACDashboard(props) {
  var equipment = props.equipment,
      site = props.site,
      _props$resolution = props.resolution,
      resolution = _props$resolution === void 0 ? "15M" : _props$resolution,
      useCanvasCharts = props.useCanvasCharts;
  var i18n = useI18n$1();
  var comparisonRanges = {
    '72hr': {
      start: moment().subtract(72, "hours").toDate(),
      end: moment().toDate()
    },
    '24hr': {
      start: moment().subtract(24, "hours").toDate(),
      end: moment().toDate()
    },
    '24hrLastWeek': {
      start: moment().subtract(1, "week").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "week").toDate()
    },
    '24hrLastMonth': {
      start: moment().subtract(1, "month").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "month").toDate()
    },
    '24hrLastYear': {
      start: moment().subtract(1, "year").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "year").toDate()
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-dashboard hvac"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-row small"
  }, /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("equipment.spaceTemp"),
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$K, {
        width: "2rem",
        height: "2rem"
      }), /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, parseFloat(value).toFixed(1), "\xB0", /*#__PURE__*/React__default.createElement("small", null, "F")));
    }
  }), /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("equipment.supplyTemp"),
    equipment: equipment,
    point_name: equipment.pointNames.supplyTemp,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$J, {
        width: "2rem",
        height: "2rem"
      }), /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, parseFloat(value).toFixed(1), "\xB0", /*#__PURE__*/React__default.createElement("small", null, "F")));
    }
  }), (equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.humidity) && /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("equipment.humidity"),
    equipment: equipment,
    point_name: equipment.pointNames.humidity,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$I, {
        width: "2rem",
        height: "2rem"
      }), /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, "".concat(parseInt(value), "%")));
    }
  }), /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("equipment.fanStatus"),
    equipment: equipment,
    point_name: equipment.pointNames.fanStatus,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$H, {
        width: "2rem",
        height: "2rem"
      }), /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value));
    }
  }), /*#__PURE__*/React__default.createElement(EquipmentStatusCard$1, {
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(EquipmentSummaryCard$1, {
    label: i18n.t("equipment.24hrRuntime"),
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.72hrTrend")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.spaceTemp"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "dashed line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.supplyTemp"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#4F53E6"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.cooling"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#E85B82"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.heating"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "swatch",
    style: {
      backgroundColor: "rgba(192, 203, 226, 0.3)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.fanOn"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointActivityAtValueChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.fanStatus,
    value: "On"
  }), /*#__PURE__*/React__default.createElement(GradientPolygon, {
    gradientStart: "rgba(192, 203, 226, 0.3)",
    gradientEnd: "rgba(192, 203, 226, 0.3)"
  })), /*#__PURE__*/React__default.createElement(PointActivityAtValueChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.coolingStage1,
    value: "On"
  }), /*#__PURE__*/React__default.createElement(GappedLine, {
    stroke: "#4F53E6"
  })), /*#__PURE__*/React__default.createElement(PointActivityAtValueChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.coolingStage2,
    value: "On"
  }), /*#__PURE__*/React__default.createElement(GappedLine, {
    stroke: "#4F53E6"
  })), /*#__PURE__*/React__default.createElement(PointActivityAtValueChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.heatingStage1,
    value: "On"
  }), /*#__PURE__*/React__default.createElement(GappedLine, {
    stroke: "#E85B82"
  })), /*#__PURE__*/React__default.createElement(PointActivityAtValueChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.heatingStage2,
    value: "On"
  }), /*#__PURE__*/React__default.createElement(GappedLine, {
    stroke: "#E85B82"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.supplyTemp
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "rgba(86, 99, 132, 0.75)",
    strokeDasharray: "4 2"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0,
    tickFormat: function tickFormat(n) {
      return tempFormatter(n, 0);
    }
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("ddd h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "rgba(86, 99, 132, 0.75)"
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.blankTodayVs", {
      blank: i18n.t("equipment.spaceTemp")
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "dashed line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastYear"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#566384"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastMonth"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastWeek"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#4F53E6"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.today"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastYear"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "rgba(86, 99, 132, 0.75)",
    strokeDasharray: "4 2"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastMonth"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "#566384"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastWeek"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "#313341"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.spaceTemp
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0,
    tickFormat: function tickFormat(n) {
      return tempFormatter(n, 0);
    }
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    tooltipValueFormat: tempFormatter,
    stroke: "#4F53E6"
  }))))), /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.blankTodayVs", {
      blank: i18n.t("equipment.outsideTemp")
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "dashed line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastYear"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#566384"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastMonth"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastWeek"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#4F53E6"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.today"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastYear"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "rgba(86, 99, 132, 0.75)",
    strokeDasharray: "4 2"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastMonth"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#566384"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastWeek"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#313341"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0,
    tickFormat: function tickFormat(n) {
      return tempFormatter(n, 0);
    }
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#4F53E6"
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(EquipmentNotificationHistoryCard$1, {
    equipment: equipment
  })));
};

HVACDashboard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  site: PropTypes.instanceOf(Site),
  resolution: PropTypes.oneOf(RESOLUTIONS),
  useCanvasCharts: PropTypes.bool
};
var HVACDashboard$1 = HVACDashboard;

var _path$G;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var SvgLight = function SvgLight(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$G({
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$G || (_path$G = /*#__PURE__*/React$1.createElement("path", {
    d: "M9.783 16.21c0-.547.048-1.036-.02-1.516-.143-.997.23-1.611 1.075-2.196 2.042-1.42 2.963-3.453 2.656-5.936-.633-5.17-7.039-7.385-10.74-3.817C.92 4.509.383 6.686 1.064 9.14c.48 1.746 1.65 2.954 3.146 3.884.326.202.45.441.431.825-.028.787 0 1.563 0 2.379 1.736 0 3.395-.01 5.14-.02ZM4.796 19l4.843-.02",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$G = /*#__PURE__*/forwardRef(SvgLight);

var LightingDashboard = function LightingDashboard(props) {
  var equipment = props.equipment,
      _props$resolution = props.resolution,
      resolution = _props$resolution === void 0 ? "15M" : _props$resolution,
      useCanvasCharts = props.useCanvasCharts;
  var i18n = useI18n$1();
  var comparisonRanges = {
    '72hr': {
      start: moment().subtract(72, "hours").toDate(),
      end: moment().toDate()
    },
    '24hr': {
      start: moment().subtract(24, "hours").toDate(),
      end: moment().toDate()
    },
    '24hrLastWeek': {
      start: moment().subtract(1, "week").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "week").toDate()
    },
    '24hrLastMonth': {
      start: moment().subtract(1, "month").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "month").toDate()
    },
    '24hrLastYear': {
      start: moment().subtract(1, "year").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "year").toDate()
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-dashboard lighting"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-row small"
  }, /*#__PURE__*/React__default.createElement(PointValueCard$1, {
    label: i18n.t("equipment.lightState"),
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle,
    display: function display(value, point, ref) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$G, {
        width: "2rem",
        height: "2rem"
      }), /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, value));
    }
  }), /*#__PURE__*/React__default.createElement(EquipmentStatusCard$1, {
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(EquipmentSummaryCard$1, {
    label: i18n.t("equipment.24hrRuntime"),
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.72hrTrend")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.lightState"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["72hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("ddd h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "rgba(86, 99, 132, 0.75)"
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.blankTodayVs", {
      blank: i18n.t("equipment.lightState")
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "dashed line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastYear"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#566384"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastMonth"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastWeek"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#4F53E6"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.today"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastYear"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "rgba(86, 99, 132, 0.75)",
    strokeDasharray: "4 2"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastMonth"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#566384"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastWeek"], {
    hideEmpty: true,
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#313341"
  })), /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    equipment: equipment,
    point_name: equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#4F53E6"
  }))))), /*#__PURE__*/React__default.createElement(EquipmentNotificationHistoryCard$1, {
    equipment: equipment
  })));
};

LightingDashboard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  site: PropTypes.instanceOf(Site),
  resolution: PropTypes.oneOf(RESOLUTIONS),
  useCanvasCharts: PropTypes.bool
};
var LightingDashboard$1 = LightingDashboard;

var _excluded$k = ["color", "dashed"];

var TemperatureSensorDashboard = function TemperatureSensorDashboard(props) {
  var equipment = props.equipment,
      site = props.site,
      _props$resolution = props.resolution,
      resolution = _props$resolution === void 0 ? "15M" : _props$resolution,
      useCanvasCharts = props.useCanvasCharts;
  var i18n = useI18n$1();
  var comparisonRanges = {
    '72hr': {
      start: moment().subtract(72, "hours").toDate(),
      end: moment().toDate()
    },
    '24hr': {
      start: moment().subtract(24, "hours").toDate(),
      end: moment().toDate()
    },
    '24hrLastWeek': {
      start: moment().subtract(1, "week").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "week").toDate()
    },
    '24hrLastMonth': {
      start: moment().subtract(1, "month").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "month").toDate()
    },
    '24hrLastYear': {
      start: moment().subtract(1, "year").subtract(24, "hours").toDate(),
      end: moment().subtract(1, "year").toDate()
    }
  };

  var _ref = (equipment === null || equipment === void 0 ? void 0 : equipment.pointNames) || {},
      _ref$temperaturePoint = _ref.temperaturePoints,
      temperaturePoints = _ref$temperaturePoint === void 0 ? [] : _ref$temperaturePoint,
      _ref$humidityPoints = _ref.humidityPoints,
      humidityPoints = _ref$humidityPoints === void 0 ? [] : _ref$humidityPoints;

  var colors = ["rgba(86, 99, 132, 0.75)", "#566384", "#313341"];
  var chartPoints = [];

  var _iterator = _createForOfIteratorHelper(temperaturePoints),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var point_name = _step.value;
      var index = temperaturePoints.indexOf(point_name);
      chartPoints.push({
        resolution: resolution,
        equipment: equipment,
        point_name: point_name,
        label: i18n.t("equipment.temperatureN", {
          n: index + 1
        }),
        color: colors[index]
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(humidityPoints),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _point_name = _step2.value;

      var _index = humidityPoints.indexOf(_point_name);

      chartPoints.push({
        resolution: resolution,
        equipment: equipment,
        point_name: _point_name,
        label: i18n.t("equipment.humidityN", {
          n: _index + 1
        }),
        color: colors[_index],
        dashed: true
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-dashboard lighting"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-row small"
  }, temperaturePoints.map(function (pointName, index) {
    return /*#__PURE__*/React__default.createElement(PointValueCard$1, {
      key: pointName,
      label: i18n.t("equipment.temperatureN", {
        n: index + 1
      }),
      equipment: equipment,
      point_name: pointName,
      display: function display(value, point, ref) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$K, {
          width: "2rem",
          height: "2rem"
        }), /*#__PURE__*/React__default.createElement("span", {
          ref: ref
        }, parseFloat(value).toFixed(1), "\xB0", /*#__PURE__*/React__default.createElement("small", null, "F")));
      }
    });
  }), humidityPoints.map(function (pointName, index) {
    return /*#__PURE__*/React__default.createElement(PointValueCard$1, {
      key: pointName,
      label: i18n.t("equipment.humidityN", {
        n: index + 1
      }),
      equipment: equipment,
      point_name: pointName,
      display: function display(value, point, ref) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$I, {
          width: "2rem",
          height: "2rem"
        }), /*#__PURE__*/React__default.createElement("span", {
          ref: ref
        }, parseInt(value), "%"));
      }
    });
  }), /*#__PURE__*/React__default.createElement(EquipmentStatusCard$1, {
    equipment: equipment
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.72hrTrend")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, chartPoints.map(function (_ref2) {
    var point_name = _ref2.point_name,
        label = _ref2.label,
        color = _ref2.color,
        dashed = _ref2.dashed;
    return /*#__PURE__*/React__default.createElement("span", {
      key: point_name
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "line ".concat(dashed ? "dashed" : ""),
      style: {
        borderColor: color
      }
    }), /*#__PURE__*/React__default.createElement("span", null, label));
  }))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, chartPoints.map(function (_ref3) {
    var color = _ref3.color,
        dashed = _ref3.dashed,
        dataSourceProps = _objectWithoutProperties(_ref3, _excluded$k);

    return /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, _extends$U({
      key: dataSourceProps.point_name
    }, comparisonRanges["72hr"], dataSourceProps), /*#__PURE__*/React__default.createElement(YAxis$1, {
      gridStroke: "none",
      decimals: 0
    }), /*#__PURE__*/React__default.createElement(XAxis$1, {
      gridStroke: "none",
      dateFormat: function dateFormat(date) {
        return moment(date).format("ddd h a");
      }
    }), /*#__PURE__*/React__default.createElement(Line$1, {
      tooltips: true,
      stroke: color,
      strokeDasharray: dashed ? "4 2" : null
    }));
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "card-row"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("equipment.blankTodayVs", {
      blank: i18n.t("equipment.outsideTemp")
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "dashed line",
    style: {
      borderColor: "rgba(86, 99, 132, 0.75)"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastYear"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#566384"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastMonth"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#313341"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.lastWeek"))), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("i", {
    className: "line",
    style: {
      borderColor: "#4F53E6"
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.today"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: useCanvasCharts
  }, /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastYear"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "rgba(86, 99, 132, 0.75)",
    strokeDasharray: "4 2"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastMonth"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#566384"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hrLastWeek"], {
    hideEmpty: true,
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#313341"
  })), /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, _extends$U({}, comparisonRanges["24hr"], {
    resolution: resolution,
    site: site
  }), /*#__PURE__*/React__default.createElement(YAxis$1, {
    gridStroke: "none",
    decimals: 0
  }), /*#__PURE__*/React__default.createElement(XAxis$1, {
    gridStroke: "none",
    dateFormat: function dateFormat(date) {
      return moment(date).format("h a");
    }
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    tooltips: true,
    stroke: "#4F53E6"
  }))))), /*#__PURE__*/React__default.createElement(EquipmentNotificationHistoryCard$1, {
    equipment: equipment
  })));
};

TemperatureSensorDashboard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  site: PropTypes.instanceOf(Site),
  resolution: PropTypes.oneOf(RESOLUTIONS),
  useCanvasCharts: PropTypes.bool
};
var TemperatureSensorDashboard$1 = TemperatureSensorDashboard;

var equipmentDashboardRenderMap = new Map();
equipmentDashboardRenderMap.set(HVAC$1, HVACDashboard$1);
equipmentDashboardRenderMap.set(Lighting$1, LightingDashboard$1);
equipmentDashboardRenderMap.set(Gateway$1, GatewayDashboard$1);
equipmentDashboardRenderMap.set(TemperatureSensor$1, TemperatureSensorDashboard$1);
var getEquipmentDashboardComponent = function getEquipmentDashboardComponent(equipment) {
  var component = equipmentDashboardRenderMap.get(equipment.type);

  if (!component) {
    return "div";
  }

  return component;
};

var _excluded$j = ["equipment"];

var EquipmentDashboard = function EquipmentDashboard(_ref) {
  var equipment = _ref.equipment,
      props = _objectWithoutProperties(_ref, _excluded$j);

  if (!equipment) return null;
  var DashboardComponent = getEquipmentDashboardComponent(equipment);
  return /*#__PURE__*/React__default.createElement(DashboardComponent, _extends$U({
    equipment: equipment
  }, props));
};

EquipmentDashboard.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  site: PropTypes.instanceOf(Site)
};
var EquipmentDashboard$1 = EquipmentDashboard;

var BAR_WIDTH = 15;

var EquipmentHourlyActivity = function EquipmentHourlyActivity(props) {
  var className = props.className,
      equipment = props.equipment;

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      hourlyData = _useState2[0],
      setHourlyData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  if (!Array.isArray(equipment) && equipment) equipment = [equipment];
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var from, to, data, coolingHourlyData, heatingHourlyData, _iterator, _step, _step$value, coolingData, heatingData, index, _index, _hourlyData, _data, _hourlyData2, _iterator2, _step2, lightingActivityData, _index2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              from = moment().startOf("hour").subtract(1, "day").toDate(), to = moment().endOf("hour").toDate();

              if (!(equipment && equipment[0])) {
                _context3.next = 28;
                break;
              }

              if (!(equipment[0].type == HVAC$1)) {
                _context3.next = 16;
                break;
              }

              _context3.next = 6;
              return Promise.all(equipment.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                  var coolingActivity, heatingActivity;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return e.getCoolingActivityForPeriod(from, to);

                        case 3:
                          coolingActivity = _context.sent;
                          _context.next = 10;
                          break;

                        case 6:
                          _context.prev = 6;
                          _context.t0 = _context["catch"](0);
                          console.error(_context.t0);
                          coolingActivity = {
                            ms: 0,
                            percent: 0,
                            hourly: []
                          };

                        case 10:
                          _context.prev = 10;
                          _context.next = 13;
                          return e.getHeatingActivityForPeriod(from, to);

                        case 13:
                          heatingActivity = _context.sent;
                          _context.next = 20;
                          break;

                        case 16:
                          _context.prev = 16;
                          _context.t1 = _context["catch"](10);
                          console.error(_context.t1);
                          heatingActivity = {
                            ms: 0,
                            percent: 0,
                            hourly: []
                          };

                        case 20:
                          return _context.abrupt("return", [coolingActivity, heatingActivity]);

                        case 21:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 6], [10, 16]]);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 6:
              data = _context3.sent;
              coolingHourlyData = [], heatingHourlyData = [];
              _iterator = _createForOfIteratorHelper(data);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray$1(_step.value, 2), coolingData = _step$value[0], heatingData = _step$value[1];

                  if (coolingHourlyData.length == 0) {
                    coolingHourlyData = coolingData.hourly;
                  } else {
                    for (index = 0; index < coolingData.hourly.length; index += 1) {
                      coolingHourlyData[index].ms += coolingData.hourly[index].ms;
                      coolingHourlyData[index].percent = coolingHourlyData[index].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }

                  if (heatingHourlyData.length == 0) {
                    heatingHourlyData = heatingData.hourly;
                  } else {
                    for (_index = 0; _index < heatingData.hourly.length; _index += 1) {
                      heatingHourlyData[_index].ms += heatingData.hourly[_index].ms;
                      heatingHourlyData[_index].percent = heatingHourlyData[_index].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _hourlyData = heatingHourlyData.map(function (_ref3, index) {
                var percent = _ref3.percent,
                    timestamp = _ref3.timestamp;
                return {
                  timestamp: timestamp,
                  segments: [{
                    color: "#EA7884",
                    filled: percent
                  }, {
                    color: "#4040DC",
                    filled: coolingHourlyData[index].percent
                  }]
                };
              });

              if (mounted) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return");

            case 13:
              setHourlyData(_hourlyData);
              _context3.next = 27;
              break;

            case 16:
              if (!(equipment[0].type == Lighting$1)) {
                _context3.next = 27;
                break;
              }

              _context3.next = 19;
              return Promise.all(equipment.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                  var lightActivity;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return e.getLightActivityForPeriod(from, to);

                        case 3:
                          lightActivity = _context2.sent;
                          _context2.next = 10;
                          break;

                        case 6:
                          _context2.prev = 6;
                          _context2.t0 = _context2["catch"](0);
                          console.error(_context2.t0);
                          lightActivity = {
                            ms: 0,
                            percent: 0,
                            hourly: []
                          };

                        case 10:
                          return _context2.abrupt("return", lightActivity);

                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 6]]);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 19:
              _data = _context3.sent;
              _hourlyData2 = [];
              _iterator2 = _createForOfIteratorHelper(_data);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  lightingActivityData = _step2.value;

                  if (_hourlyData2.length == 0) {
                    _hourlyData2 = lightingActivityData.hourly;
                  } else {
                    for (_index2 = 0; _index2 < lightingActivityData.hourly.length; _index2 += 1) {
                      _hourlyData2[_index2].ms += lightingActivityData.hourly[_index2].ms;
                      _hourlyData2[_index2].percent = _hourlyData2[_index2].ms / (1000 * 60 * 60 * equipment.length);
                    }
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              _hourlyData2 = _hourlyData2.map(function (_ref5) {
                var percent = _ref5.percent,
                    timestamp = _ref5.timestamp;
                return {
                  timestamp: timestamp,
                  segments: [{
                    color: "#4040DC",
                    filled: percent
                  }]
                };
              });

              if (mounted) {
                _context3.next = 26;
                break;
              }

              return _context3.abrupt("return");

            case 26:
              setHourlyData(_hourlyData2);

            case 27:
              setLoading(false);

            case 28:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();

    return function () {
      mounted = false;
    };
  }, [equipment && JSON.stringify(equipment.map(function (e) {
    return e && e._;
  }))]);
  var collapsedHourlyData = hourlyData;

  while (width && width < collapsedHourlyData.length * BAR_WIDTH) {
    var reCollapsedHourlyData = [];

    for (var i = 0; i < collapsedHourlyData.length; i += 2) {
      var _collapsedHourlyData$ = collapsedHourlyData[i],
          timestamp = _collapsedHourlyData$.timestamp,
          segments = _collapsedHourlyData$.segments;

      if (collapsedHourlyData[i + 1]) {
        segments = segments.concat(collapsedHourlyData[i + 1].segments).reduce(function (s, _ref6) {
          var color = _ref6.color,
              filled = _ref6.filled;
          var existingIndex = s.findIndex(function (se) {
            return se.color == color;
          });

          if (existingIndex >= 0) {
            s[existingIndex].filled += filled / 2;
          } else {
            s.push({
              color: color,
              filled: filled / 2
            });
          }

          return s;
        }, []);
      }

      reCollapsedHourlyData.push({
        timestamp: timestamp,
        segments: segments
      });
    }

    collapsedHourlyData = reCollapsedHourlyData;
  }

  if (loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: observe,
      className: "equipment-hourly-activity loading ".concat(className ? className : "")
    }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: observe,
    className: "equipment-hourly-activity ".concat(className ? className : "")
  }, /*#__PURE__*/React__default.createElement(StackedBarChart$1, {
    bars: collapsedHourlyData
  }));
};

EquipmentHourlyActivity.propTypes = {
  className: PropTypes.string,
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (!equipment || Array.isArray(equipment) && equipment.length == 0) return null;

    if (Array.isArray(equipment) && equipment.length > 0) {
      var firstType = equipment[0].type;

      if (firstType !== HVAC$1 && firstType !== Lighting$1) {
        return new Error("Equipment primitive type must be Lighting or HVAC, found: ".concat(firstType.name));
      }

      if (!equipment.every(function (_ref7) {
        var type = _ref7.type;
        return type == firstType;
      })) {
        return new Error("All equipment in array must be of the same type.");
      }
    } else if (equipment.type !== HVAC$1 && equipment.type !== Lighting$1) {
      return new Error("Equipment primitive type must be Lighting or HVAC, found: ".concat(equipment.type.name));
    }

    return null;
  }
};
var EquipmentHourlyActivity$1 = EquipmentHourlyActivity;

var _rect$2, _path$F;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var SvgOffline = function SvgOffline(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$F({
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React$1.createElement("rect", {
    x: 0.003,
    width: 24.671,
    height: 22,
    rx: 11,
    fill: "#F2CC0F"
  })), _path$F || (_path$F = /*#__PURE__*/React$1.createElement("path", {
    d: "m5.003 5 11.658 11.658M11.938 17h.007M9.626 14.147a4.006 4.006 0 0 1 2.41-.813c.863 0 1.705.284 2.409.813M7.315 11.536c1.37-1.208 3.097-1.869 4.881-1.869 1.784 0 3.51.661 4.881 1.869M5.003 8.932C7.03 7.042 9.638 6 12.34 6c2.7 0 5.309 1.043 7.335 2.932",
    stroke: "#313341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$F = /*#__PURE__*/forwardRef(SvgOffline);

var OfflineIndicator = function OfflineIndicator() {
  var i18n = useI18n$1();
  var icon = useRef();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$F, {
    className: "equipment-offline-indicator",
    ref: icon
  }), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: "bottom",
    anchor: icon
  }, i18n.t("equipment.offlineFromCriticalPoints")));
};

var EquipmentOfflineIndicator = OfflineIndicator;

var _path$E, _path2$d;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var SvgEquipmentUnknown = function SvgEquipmentUnknown(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$E({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$E || (_path$E = /*#__PURE__*/React$1.createElement("path", {
    d: "M18 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$d || (_path2$d = /*#__PURE__*/React$1.createElement("path", {
    d: "M15 9H9v6h6V9ZM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$E = /*#__PURE__*/forwardRef(SvgEquipmentUnknown);

var PointTrend = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      fromDate = props.fromDate,
      toDate = props.toDate,
      _props$baseline = props.baseline,
      baseline = _props$baseline === void 0 ? 0.15 : _props$baseline,
      toolTipPosition = props.toolTipPosition,
      timeframeDescription = props.timeframeDescription,
      resolution = props.resolution;
  var toolTipAnchor = useRef(ref);

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (equipment) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!point_id) {
                _context.next = 10;
                break;
              }

              _context.next = 6;
              return equipment.getPoints();

            case 6:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 14;
              break;

            case 10:
              if (!point_name) {
                _context.next = 14;
                break;
              }

              _context.next = 13;
              return equipment.findPointByName(point_name);

            case 13:
              point = _context.sent;

            case 14:
              if (mounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              setPoint(point);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment, pointFromProps && pointFromProps._.id, point_name, point_id]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "point-trend ".concat(className ? className : "")
  }, /*#__PURE__*/React__default.createElement(Chart$1, {
    useCanvas: true,
    ref: toolTipAnchor
  }, /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, {
    start: fromDate,
    end: toDate,
    equipment: equipment,
    point: pointFromProps,
    point_name: point_name,
    point_id: point_id,
    resolution: resolution
  }, /*#__PURE__*/React__default.createElement(Line$1, {
    draw: true,
    baseline: baseline,
    stroke: "var(--point-trend-line-color)"
  }), /*#__PURE__*/React__default.createElement(GradientPolygon, {
    baseline: baseline,
    gradientStart: "var(--point-trend-fill-gradient-start)",
    gradientEnd: "var(--point-trend-fill-gradient-end)"
  }))), toolTipPosition && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: toolTipPosition,
    anchor: toolTipAnchor
  }, /*#__PURE__*/React__default.createElement("strong", null, point && point.getDisplayName()), timeframeDescription && /*#__PURE__*/React__default.createElement("br", null), timeframeDescription));
});
PointTrend.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  className: PropTypes.string,
  fromDate: PropTypes.instanceOf(Date).isRequired,
  toDate: PropTypes.instanceOf(Date).isRequired,
  baseline: PropTypes.number,
  toolTipPosition: PropTypes.string,
  timeframeDescription: PropTypes.string,
  resolution: PropTypes.oneOf(RESOLUTIONS)
};
var PointTrend$1 = PointTrend;

var PointCard = function PointCard(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? ForwardRef$E : _ref$icon,
      equipment = _ref.equipment,
      point_name = _ref.point_name,
      formatValue = _ref.formatValue,
      actions = _ref.actions,
      trendResolutionFromProps = _ref.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;
  var online = useEquipmentStatus$1(equipment);
  var i18n = useI18n$1(); // let { upper_limit, lower_limit } = point._.metadata;

  return /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    equipment: equipment,
    point_name: point_name,
    display: function display(mappedValue, point, ref) {
      if (!point) return null;
      var formattedValue = formatValue ? formatValue(mappedValue) : typeof mappedValue == "string" ? mappedValue : JSON.stringify(mappedValue);
      return /*#__PURE__*/React__default.createElement(Card$1, {
        className: "point-card ".concat(!online ? "offline" : "")
      }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
        icon: icon,
        label: equipment.getDisplayName(),
        className: "point-card--header",
        actions: actions
      }, !online && /*#__PURE__*/React__default.createElement(EquipmentOfflineIndicator, null)), /*#__PURE__*/React__default.createElement(CardBody$1, {
        className: "point-card--value-wrapper"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, /*#__PURE__*/React__default.createElement("span", null, point.getDisplayName())), /*#__PURE__*/React__default.createElement("span", {
        ref: ref,
        className: "value ".concat(formattedValue.length > 10 ? "long" : "")
      }, /*#__PURE__*/React__default.createElement("span", null, formattedValue))), /*#__PURE__*/React__default.createElement(PointTrend$1, {
        className: "point-card--point-trend",
        point: point,
        fromDate: moment().subtract(24, "hours").startOf("hour").toDate(),
        toDate: moment().endOf("hour").toDate(),
        timeframeDescription: i18n.t("equipment.last24HTimeframeDesc"),
        baseline: 0.15,
        resolution: trendResolution
      }));
    }
  });
};

PointCard.propTypes = {
  icon: PropTypes.elementType,
  equipment: PropTypes.instanceOf(Equipment$2),
  point_name: PropTypes.string,
  formatValue: PropTypes.func,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var PointCard$1 = PointCard;

var Unknown = function Unknown(props) {
  var equipment = props.equipment,
      actions = props.actions,
      trendResolutionFromProps = props.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      points = _useState2[0],
      setPoints = _useState2[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _points;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!equipment) {
                _context.next = 7;
                break;
              }

              _context.next = 3;
              return equipment.getPoints();

            case 3:
              _points = _context.sent;

              if (mounted) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setPoints(_points);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment]);

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true,
      className: "unknown-equipment"
    });
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, points.map(function (_ref2) {
    var _ = _ref2._;
    return /*#__PURE__*/React__default.createElement(PointCard$1, {
      key: _.id,
      equipment: equipment,
      point_name: _.name,
      actions: actions,
      trendResolution: trendResolution
    });
  }));
};

Unknown.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== Unknown$1) return new Error("equipment must be type: Unknown");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var UnknownComponent = Unknown;

var BooleanSensor = UnknownComponent;
var BooleanSensorComponent = BooleanSensor;

var _path$D;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-down",
    ref: ref
  }, props), _path$D || (_path$D = /*#__PURE__*/React$1.createElement("path", {
    d: "m6 9 6 6 6-6"
  })));
};

var ForwardRef$D = /*#__PURE__*/forwardRef(SvgChevronDown);

var _excluded$i = ["icon", "className", "loading", "children", "placeholder", "onEnter", "value"];
var SelectInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.icon,
      className = props.className,
      loading = props.loading,
      children = props.children,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? "Select" : _props$placeholder,
      onEnter = props.onEnter,
      value = props.value,
      selectProps = _objectWithoutProperties(props, _excluded$i);

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(selectProps.id || generateRandomString()),
      _useState4 = _slicedToArray$1(_useState3, 1),
      id = _useState4[0];

  if (onEnter) {
    selectProps.onKeyPress = function (e) {
      return e.key == "Enter" ? onEnter() : true;
    };
  }

  var dirty = !!value;
  if (loading) selectProps.disabled = true;
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "select-input" + (focused ? " focus" : "") + (selectProps.disabled ? " disabled" : "") + (selectProps.multiple ? " multiple" : "") + (loading ? " loading" : "") + (dirty ? " dirty" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("select", _extends$U({}, selectProps, {
    ref: ref,
    id: id,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    value: value || ""
  }), !selectProps.multiple && /*#__PURE__*/React__default.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), children), !selectProps.multiple && /*#__PURE__*/React__default.createElement(ForwardRef$D, {
    width: "2rem",
    height: "2rem"
  }));
});
SelectInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  loading: PropTypes.bool,
  onEnter: PropTypes.func,
  value: PropTypes.any,
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (child && child.type !== "option") error = new Error("".concat(componentName, " children should be of type option"));
    });
    return error;
  },
  placeholder: PropTypes.any
};
var SelectInput$1 = SelectInput;

var _rect$1, _path$C;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var SvgLock = function SvgLock(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-lock",
    ref: ref
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React$1.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  })), _path$C || (_path$C = /*#__PURE__*/React$1.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })));
};

var ForwardRef$C = /*#__PURE__*/forwardRef(SvgLock);

var _excluded$h = ["icon", "className", "locked", "loading"];
var ToggleInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.icon,
      className = props.className,
      locked = props.locked,
      loading = props.loading,
      inputProps = _objectWithoutProperties(props, _excluded$h);

  var RenderedIcon = Icon;

  if (locked) {
    if (!Icon) RenderedIcon = ForwardRef$C;
    inputProps.disabled = true;
  }

  if (loading) {
    inputProps.disabled = true;
  }

  var _useState = useState(inputProps.id || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    ref: ref,
    className: "toggle-input" + (inputProps.value ? " on" : "") + (inputProps.disabled ? " disabled" : "") + (locked ? " locked" : "") + (loading ? " loading" : "") + (className ? " ".concat(className) : "")
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "thumb"
  }, !loading && RenderedIcon && /*#__PURE__*/React__default.createElement(RenderedIcon, {
    width: "1.65rem",
    height: "1.65rem"
  }), loading && /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), /*#__PURE__*/React__default.createElement("input", _extends$U({}, inputProps, {
    checked: inputProps.value,
    type: "checkbox",
    id: id
  })));
});
ToggleInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  locked: PropTypes.bool
};
var ToggleInput$1 = ToggleInput;

var createFakeChangeEvent = function createFakeChangeEvent(value) {
  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "value";
  return {
    target: _defineProperty$3({}, valueKey, value)
  };
};

var _path$B;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var SvgCheck = function SvgCheck(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check",
    ref: ref
  }, props), _path$B || (_path$B = /*#__PURE__*/React$1.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })));
};

var ForwardRef$B = /*#__PURE__*/forwardRef(SvgCheck);

var _excluded$g = ["className", "locked"];
var CheckboxInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      locked = props.locked,
      inputProps = _objectWithoutProperties(props, _excluded$g);

  var _useState = useState(inputProps.id || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "checkbox-input" + (inputProps.value ? " on" : "") + (inputProps.disabled ? " disabled" : "") + (locked ? " locked" : "") + (className ? " ".concat(className) : "")
  }, inputProps.value && /*#__PURE__*/React__default.createElement(ForwardRef$B, null), /*#__PURE__*/React__default.createElement("input", _extends$U({}, inputProps, {
    checked: inputProps.value,
    type: "checkbox",
    ref: ref,
    id: id
  })));
});
CheckboxInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  locked: PropTypes.bool
};
var CheckboxInput$1 = CheckboxInput;

var _path$A;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var SvgPlus = function SvgPlus(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$A({
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$A || (_path$A = /*#__PURE__*/React$1.createElement("path", {
    d: "M5.304 1v8M1.073 5h8.463",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$A = /*#__PURE__*/forwardRef(SvgPlus);

var _path$z;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var SvgMinus = function SvgMinus(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$z({
    viewBox: "0 0 11 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$z || (_path$z = /*#__PURE__*/React$1.createElement("path", {
    d: "M1.406 1H9.87",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$z = /*#__PURE__*/forwardRef(SvgMinus);

var StepInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.icon,
      className = props.className,
      loading = props.loading,
      _props$increment = props.increment,
      increment = _props$increment === void 0 ? 1 : _props$increment,
      min = props.min,
      max = props.max,
      onChange = props.onChange,
      value = props.value,
      disabled = props.disabled,
      display = props.display;
  if (loading) disabled = true;
  var minusDisabled = false,
      plusDisabled = false;
  if (value - increment < min || disabled) minusDisabled = true;
  if (value + increment > max || disabled) plusDisabled = true;

  if (isNaN(value) || !value) {
    value = 0;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: "step-input" + (loading ? " loading" : "") + (props.disabled ? " disabled" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), className && className.split(" ").includes("failed") && /*#__PURE__*/React__default.createElement("div", {
    className: "failure-overlay"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$P, {
    width: "2rem",
    height: "2rem"
  })), /*#__PURE__*/React__default.createElement(Button$1, {
    className: "decrease",
    onClick: function onClick() {
      return onChange(createFakeChangeEvent(value - increment));
    },
    disabled: minusDisabled
  }, /*#__PURE__*/React__default.createElement(ForwardRef$z, {
    width: "1rem",
    height: "1rem"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "value-wrapper"
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Icon && /*#__PURE__*/React__default.createElement(Icon, {
    width: "1.5rem",
    height: "1.5rem"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "value"
  }, display ? display(value) : value))), /*#__PURE__*/React__default.createElement(Button$1, {
    className: "increase",
    onClick: function onClick() {
      return onChange(createFakeChangeEvent(parseInt(value) + increment));
    },
    disabled: plusDisabled
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, {
    width: "1rem",
    height: "1rem"
  })));
});
StepInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  increment: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.any,
  display: PropTypes.func
};
var StepInput$1 = StepInput;

var _path$y;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var SvgChevronUp = function SvgChevronUp(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-up",
    ref: ref
  }, props), _path$y || (_path$y = /*#__PURE__*/React$1.createElement("path", {
    d: "m18 15-6-6-6 6"
  })));
};

var ForwardRef$y = /*#__PURE__*/forwardRef(SvgChevronUp);

var _path$x;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var SvgKeyboardTab = function SvgKeyboardTab(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path$x || (_path$x = /*#__PURE__*/React$1.createElement("path", {
    d: "M12.29 8.12 15.17 11H2c-.55 0-1 .45-1 1s.45 1 1 1h13.17l-2.88 2.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L13.7 6.7a.996.996 0 0 0-1.41 0c-.38.39-.39 1.03 0 1.42zM20 7v10c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1z"
  })));
};

var ForwardRef$x = /*#__PURE__*/forwardRef(SvgKeyboardTab);

var _path$w;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var SvgKeyboardReturn = function SvgKeyboardReturn(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path$w || (_path$w = /*#__PURE__*/React$1.createElement("path", {
    d: "M19 8v3H5.83l2.88-2.88A.996.996 0 1 0 7.3 6.71L2.71 11.3a.996.996 0 0 0 0 1.41L7.3 17.3a.996.996 0 1 0 1.41-1.41L5.83 13H20c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1z"
  })));
};

var ForwardRef$w = /*#__PURE__*/forwardRef(SvgKeyboardReturn);

var _excluded$f = ["icon", "labelRef", "className", "loading", "type", "increment", "min", "max", "onChange", "onEnter", "value", "onFocus", "onBlur", "onKeyDown", "tabAutoCompleteValue", "returnAutoCompleteValue"];
var TextInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.icon,
      labelRef = props.labelRef,
      className = props.className,
      loading = props.loading,
      _props$type = props.type,
      type = _props$type === void 0 ? "text" : _props$type,
      _props$increment = props.increment,
      increment = _props$increment === void 0 ? 1 : _props$increment,
      min = props.min,
      max = props.max,
      onChange = props.onChange,
      onEnter = props.onEnter,
      value = props.value,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      onKeyDown = props.onKeyDown,
      tabAutoCompleteValue = props.tabAutoCompleteValue,
      returnAutoCompleteValue = props.returnAutoCompleteValue,
      inputProps = _objectWithoutProperties(props, _excluded$f);

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(inputProps.id || generateRandomString()),
      _useState4 = _slicedToArray$1(_useState3, 1),
      id = _useState4[0];

  var Component = type == "multiline" ? "textarea" : "input";

  inputProps.onKeyPress = function (e) {
    if (onEnter && e.key == "Enter") {
      e.preventDefault();
      onEnter();
      return false;
    }

    return true;
  };

  inputProps.onKeyDown = function (e) {
    if (tabAutoCompleteValue && e.key == "Tab") {
      e.preventDefault();
      e.stopPropagation();
      onChange(createFakeChangeEvent(tabAutoCompleteValue));
      return false;
    }

    if (onKeyDown) return onKeyDown(e);
    return true;
  };

  if (loading) inputProps.disabled = true;
  return /*#__PURE__*/React__default.createElement("label", {
    ref: labelRef,
    htmlFor: id,
    className: "text-input" + (type == "number" ? " number-input" : "") + (focused ? " focus" : "") + (loading ? " loading" : "") + (inputProps.disabled ? " disabled" : "") + (value && value.length > 0 ? " dirty" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("div", {
    className: "input-container"
  }, tabAutoCompleteValue && focused && value && value.length > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "autocomplete"
  }, /*#__PURE__*/React__default.createElement("span", null, tabAutoCompleteValue), tabAutoCompleteValue !== value && /*#__PURE__*/React__default.createElement(ForwardRef$x, {
    width: "18",
    height: "18"
  }), tabAutoCompleteValue == value && /*#__PURE__*/React__default.createElement(ForwardRef$w, {
    width: "18",
    height: "18"
  })), returnAutoCompleteValue && focused && /*#__PURE__*/React__default.createElement("span", {
    className: "autocomplete"
  }, /*#__PURE__*/React__default.createElement("span", null, returnAutoCompleteValue), /*#__PURE__*/React__default.createElement(ForwardRef$w, {
    width: "18",
    height: "18"
  })), /*#__PURE__*/React__default.createElement(Component, _extends$U({}, inputProps, {
    ref: ref,
    onChange: onChange,
    value: value,
    id: id,
    type: type,
    min: min,
    max: max,
    onFocus: function onFocus(e) {
      setFocused(true);
      _onFocus && _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setFocused(false);
      _onBlur && _onBlur(e);
    }
  }))), type == "number" && /*#__PURE__*/React__default.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: inputProps.disabled,
    onClick: function onClick() {
      return onChange(createFakeChangeEvent(parseFloat(value) + increment));
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$y, {
    width: "2rem",
    height: "2rem"
  })), /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: inputProps.disabled,
    onClick: function onClick() {
      return onChange(createFakeChangeEvent(parseFloat(value) - increment));
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$D, {
    width: "2rem",
    height: "2rem"
  }))));
});
TextInput.propTypes = {
  labelRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  icon: PropTypes.elementType,
  tabAutoCompleteValue: PropTypes.string,
  returnAutoCompleteValue: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  increment: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any
};
var TextInput$1 = TextInput;

var _path$v;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var SvgFlame = function SvgFlame(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _path$v || (_path$v = /*#__PURE__*/React$1.createElement("path", {
    d: "M4.42 17.3c-.34-2.67.6-5.4.51-8.09 0-.2 2.35 4.27 3.09 4.17C10.66 11 7.65 1 7.65 1s5.25 2.69 8.26 12.45a18.32 18.32 0 0 0 1.46-7.19 12 12 0 0 1 2.83 11.56 8.46 8.46 0 0 1-10.29 5.84 7.62 7.62 0 0 1-5.23-5.09 8 8 0 0 1-.26-1.27z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};

var ForwardRef$v = /*#__PURE__*/forwardRef(SvgFlame);

var _excluded$e = ["equipment", "point", "point_name", "point_id", "component", "value", "onChange", "getDefaultValue", "className", "debounceMs"];
var PointControl$2 = /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref3, _point$_$type3;

  var i18n = useI18n$1();

  var equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      component = props.component,
      valueFromProps = props.value,
      onChange = props.onChange,
      getDefaultValue = props.getDefaultValue,
      className = props.className,
      debounceMs = props.debounceMs,
      inputProps = _objectWithoutProperties(props, _excluded$e);

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      defaultValue = _useState4[0],
      setDefaultValue = _useState4[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points, newValue;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (point) {
                _context.next = 18;
                break;
              }

              if (equipment) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (!point_id) {
                _context.next = 11;
                break;
              }

              _context.next = 7;
              return equipment.getPoints();

            case 7:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 15;
              break;

            case 11:
              if (!point_name) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return equipment.findPointByName(point_name);

            case 14:
              point = _context.sent;

            case 15:
              if (mounted) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              if (point) setPoint(point);

            case 18:
              if (!(point && getDefaultValue)) {
                _context.next = 28;
                break;
              }

              _context.next = 21;
              return point.getValue();

            case 21:
              newValue = _context.sent;

              if (mounted) {
                _context.next = 24;
                break;
              }

              return _context.abrupt("return");

            case 24:
              setDefaultValue(newValue);

              if ((value == null || value == undefined || value == "") && newValue != null && newValue != undefined && onChange) {
                onChange(createFakeChangeEvent(newValue));
              }

              _context.next = 29;
              break;

            case 28:
              setDefaultValue(null);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [equipment && equipment._.id, pointFromProps && pointFromProps._.id, point_name, point_id, getDefaultValue]);
  var Component = component;

  if (!point) {
    var LoadingComponent = Component || SelectInput$1,
        loadingValue = value || "";
    if (LoadingComponent == ToggleInput$1) loadingValue = false;
    return /*#__PURE__*/React__default.createElement(LoadingComponent, {
      className: className,
      value: loadingValue,
      onChange: function onChange() {
        return null;
      },
      loading: true
    });
  }

  var value = (_ref3 = valueFromProps !== null && valueFromProps !== void 0 ? valueFromProps : defaultValue) !== null && _ref3 !== void 0 ? _ref3 : "";

  var handleValueChange = function handleValueChange(value) {
    var changeEvent = createFakeChangeEvent(value);

    if ([SelectInput$1, TextInput$1, StepInput$1].includes(Component)) {
      changeEvent.DEBOUNCE_MS = 1000;
    }

    if (debounceMs && debounceMs !== "default") {
      changeEvent.DEBOUNCE_MS = debounceMs;
    }

    onChange && onChange(changeEvent);
  };

  var moreProps = {
    value: value,
    disabled: !point._.settable || inputProps.disabled,
    className: className
  },
      valueOptions = point.getValueOptions(),
      children;

  if (!Component) {
    var _point$_$type;

    if (((_point$_$type = point._.type) === null || _point$_$type === void 0 ? void 0 : _point$_$type.toLowerCase()) == "boolean") {
      Component = ToggleInput$1;
    } else if (valueOptions && valueOptions.length > 0) {
      var lowerCaseOptions = Object.keys(point._.mapping_info).map(function (k) {
        return k.toLowerCase();
      });

      if (valueOptions.length == 2 && lowerCaseOptions.includes("on") && lowerCaseOptions.includes("off")) {
        Component = ToggleInput$1;
      } else {
        Component = SelectInput$1;

        if (moreProps.value === null) {
          moreProps.value = "";
        }
      }
    } else {
      var _point$_$type2;

      if (["number", "temperature"].includes((_point$_$type2 = point._.type) === null || _point$_$type2 === void 0 ? void 0 : _point$_$type2.toLowerCase()) && !isNaN(value) || typeof value == "number") {
        moreProps.type = "number";
      }

      Component = TextInput$1;
    }
  }

  if (((_point$_$type3 = point._.type) === null || _point$_$type3 === void 0 ? void 0 : _point$_$type3.toLowerCase()) == "temperature") {
    moreProps.icon = ForwardRef$K;

    if (point.getDisplayName().toLowerCase().includes("heat")) {
      moreProps.icon = ForwardRef$v;
    }
  }

  if (Component == ToggleInput$1 || Component == CheckboxInput$1) {
    var nextValue, currentValue;

    if (valueOptions.length == 2) {
      var nonMatchingValueOptions = Object.values(point._.mapping_info).filter(function (v) {
        return v !== value;
      });
      var coercedValue = value;

      try {
        coercedValue = JSON.parse(value);
      } catch (e) {// pass
      }

      if (nonMatchingValueOptions.length == 0 || nonMatchingValueOptions.length == 2) {
        try {
          nextValue = Object.values(point._.mapping_info).filter(function (v) {
            return v !== coercedValue;
          })[0];
        } catch (e) {// pass
        }
      } else {
        nextValue = nonMatchingValueOptions[0];
      }

      var currentValueKey = Object.keys(point._.mapping_info).find(function (key) {
        return point._.mapping_info[key] == coercedValue;
      });

      if (currentValueKey && ["on", "off"].includes(currentValueKey.toLowerCase())) {
        currentValue = currentValueKey && currentValueKey.toLowerCase() == "on" ? true : false;
      } else if ([0, 1].includes(coercedValue) && [0, 1].includes(nextValue)) {
        currentValue = coercedValue == 1;
      } else if ([true, false].includes(coercedValue) && [true, false].includes(nextValue)) {
        currentValue = coercedValue;
      }
    } else if (valueOptions.length == 0) {
      if (typeof value == "boolean") {
        nextValue = !value;
        currentValue = value;
      } else if (typeof value == "number") {
        nextValue = value == 0 ? 1 : 0;
        currentValue = value == 0 ? false : true;
      } else if (typeof value == "string") {
        if (["true", "false"].includes(value)) {
          nextValue = value == "true" ? "false" : "true";
          currentValue = value == "true" ? true : false;
        } else if (["0", "1"].includes(value)) {
          nextValue = value == "1" ? "0" : "1";
          currentValue = value == "1" ? true : false;
        }
      }
    } else if (valueOptions.find(function (option) {
      return option.label.toLowerCase() == "on" && option.value == value;
    }) && valueOptions.find(function (option) {
      return option.label.toLowerCase() == "off";
    })) {
      nextValue = valueOptions.find(function (option) {
        return option.label.toLowerCase() == "off";
      }).value;
      currentValue = true;
    } else if (valueOptions.find(function (option) {
      return option.label.toLowerCase() == "off" && option.value == value;
    }) && valueOptions.find(function (option) {
      return option.label.toLowerCase() == "on";
    })) {
      nextValue = valueOptions.find(function (option) {
        return option.label.toLowerCase() == "on";
      }).value;
      currentValue = false;
    }

    moreProps.onChange = function () {
      return handleValueChange(nextValue);
    };

    moreProps.value = currentValue;
  } else if (Component == SelectInput$1) {
    children = valueOptions.map(function (_ref4) {
      var label = _ref4.label,
          value = _ref4.value;
      return /*#__PURE__*/React__default.createElement("option", {
        key: value,
        value: value
      }, label);
    });

    moreProps.onChange = function (e) {
      var _valueOptions$find = valueOptions.find(function (_ref5) {
        var value = _ref5.value;
        return value == e.target.value;
      }),
          value = _valueOptions$find.value;

      handleValueChange(value);
    };
  } else if (Component == TextInput$1) {
    moreProps.onChange = function (e) {
      var newValue = "".concat(e.target.value);

      if (typeof value == "number") {
        if (newValue.includes(".")) {
          newValue = parseFloat(newValue);
        } else {
          newValue = parseInt(newValue);
        }
      }

      handleValueChange(newValue);
    };
  } else if (Component == StepInput$1) {
    moreProps.onChange = function (e) {
      handleValueChange(e.target.value);
    };
  } else {
    moreProps.onClick = function () {
      var index = valueOptions.findIndex(function (o) {
        return o.value === value;
      });

      if (valueOptions[index + 1]) {
        handleValueChange(valueOptions[index + 1].value);
      } else if (valueOptions[0]) {
        handleValueChange(valueOptions[0].value);
      }
    };
  }

  if (moreProps.value === null || moreProps.value === undefined) {
    moreProps.disabled = true;
    moreProps.placeholder = i18n.t("point.noValue");
    moreProps.value = "";

    if (Component == ToggleInput$1 || Component == CheckboxInput$1) {
      moreProps.value = false;
    } else if (Component == StepInput$1) {
      moreProps.value = 0;
    }
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends$U({
    ref: ref
  }, inputProps, moreProps), children);
});
PointControl$2.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  value: PropTypes.any,
  debounceMs: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["default"])]),
  onChange: PropTypes.func,
  getDefaultValue: PropTypes.bool,
  className: PropTypes.string
};
var PointValueInput = PointControl$2;

var _excluded$d = ["equipment", "point", "point_name", "point_id", "component", "onReceivedValue", "debounceMs", "className", "toolTipPosition", "defaultInputStyles"];

var PointControl = function PointControl(props) {
  var equipment = props.equipment,
      pointFromProps = props.point,
      point_name = props.point_name,
      point_id = props.point_id,
      component = props.component,
      onReceivedValue = props.onReceivedValue,
      debounceMs = props.debounceMs,
      classNameFromProps = props.className,
      toolTipPosition = props.toolTipPosition,
      defaultInputStyles = props.defaultInputStyles,
      inputProps = _objectWithoutProperties(props, _excluded$d);

  var _useState = useState(pointFromProps),
      _useState2 = _slicedToArray$1(_useState, 2),
      point = _useState2[0],
      setPoint = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      receivedValue = _useState4[0],
      setReceivedValue = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      intendedValue = _useState6[0],
      setIntendedValue = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      valueSubscription = _useState8[0],
      setValueSubscription = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      intentFailed = _useState10[0],
      setIntentFailure = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$1(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = useState(-1),
      _useState14 = _slicedToArray$1(_useState13, 2),
      debounceTimeoutId = _useState14[0],
      setDebounceTimeoutId = _useState14[1];

  var tooltipAnchor = useRef(null);
  var className = "".concat(!defaultInputStyles ? "point-control" : "", " ").concat(classNameFromProps ? classNameFromProps : "", " ").concat(intendedValue === null ? "" : "dirty", " ").concat(intentFailed ? "failed" : "");
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var point, points, handleNewValue, _value;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              point = pointFromProps;

              if (point) {
                _context.next = 18;
                break;
              }

              if (equipment) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (!point_id) {
                _context.next = 11;
                break;
              }

              _context.next = 7;
              return equipment.getPoints();

            case 7:
              points = _context.sent;
              point = points.find(function (_ref2) {
                var _ = _ref2._;
                return _.id == point_id;
              }) || null;
              _context.next = 15;
              break;

            case 11:
              if (!point_name) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return equipment.findPointByName(point_name);

            case 14:
              point = _context.sent;

            case 15:
              if (mounted) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              if (point) setPoint(point);

            case 18:
              if (!point) {
                _context.next = 30;
                break;
              }

              if (valueSubscription) valueSubscription.cancel();

              handleNewValue = function handleNewValue(newValue) {
                if (newValue === undefined) newValue = null;
                setReceivedValue(newValue);
                if (onReceivedValue) onReceivedValue(newValue, point);
              };

              _context.next = 23;
              return point.getValue();

            case 23:
              _value = _context.sent;

              if (mounted) {
                _context.next = 26;
                break;
              }

              return _context.abrupt("return");

            case 26:
              setValueSubscription(point.subscribe(handleNewValue));
              handleNewValue(_value);
              _context.next = 31;
              break;

            case 30:
              setReceivedValue(null);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      mounted = false;
      if (valueSubscription) valueSubscription.cancel();
    };
  }, [equipment && equipment._.id, pointFromProps && pointFromProps._.id, point_name, point_id]);

  if (!point) {
    var LoadingComponent = component || SelectInput$1,
        loadingValue = value || "";
    if (LoadingComponent == ToggleInput$1) loadingValue = false;
    return /*#__PURE__*/React__default.createElement(LoadingComponent, {
      className: className,
      value: loadingValue,
      onChange: function onChange() {
        return null;
      },
      loading: true
    });
  }

  var handleSetValue = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(newValue) {
      var timeoutMs,
          _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              timeoutMs = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
              setIntendedValue(newValue);
              clearTimeout(debounceTimeoutId);
              setDebounceTimeoutId(setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        setIntentFailure(false);
                        setLoading(true);
                        _context2.prev = 2;
                        _context2.next = 5;
                        return point.setValue(newValue);

                      case 5:
                        _context2.next = 10;
                        break;

                      case 7:
                        _context2.prev = 7;
                        _context2.t0 = _context2["catch"](2);
                        setIntentFailure(true);

                      case 10:
                        setLoading(false);
                        setIntendedValue(null);

                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[2, 7]]);
              })), timeoutMs));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSetValue(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var value = intendedValue || receivedValue;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PointValueInput, _extends$U({
    ref: tooltipAnchor
  }, inputProps, {
    value: value,
    point: point,
    component: component,
    className: className,
    loading: loading,
    debounceMs: debounceMs,
    onChange: function onChange(e) {
      return handleSetValue(e.target.value, e.DEBOUNCE_MS);
    }
  })), toolTipPosition && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: toolTipPosition,
    anchor: {
      current: tooltipAnchor === null || tooltipAnchor === void 0 ? void 0 : tooltipAnchor.current
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, point && point.getDisplayName()), /*#__PURE__*/React__default.createElement("br", null), point && moment(point.lastReceivedValueTimestamp * 1000).format("lll")));
};

PointControl.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  point: PropTypes.instanceOf(Point),
  point_name: PropTypes.string,
  point_id: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  onReceivedValue: PropTypes.func,
  debounceMs: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["default"])]),
  className: PropTypes.string,
  toolTipPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  defaultInputStyles: PropTypes.bool
};
var PointControl$1 = PointControl;

var _excluded$c = ["children", "label", "className", "required"];

var InputWrapper = function InputWrapper(_ref) {
  var children = _ref.children,
      label = _ref.label,
      className = _ref.className,
      required = _ref.required,
      props = _objectWithoutProperties(_ref, _excluded$c);

  var _useState = useState(props.htmlFor || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  if (React__default.Children.count(children) > 1) return null;
  return /*#__PURE__*/React__default.createElement("label", _extends$U({
    htmlFor: id,
    className: "input-wrapper ".concat(className || "")
  }, props), /*#__PURE__*/React__default.createElement("span", null, label, " ", required && /*#__PURE__*/React__default.createElement("span", {
    className: "required"
  }, "*")), /*#__PURE__*/React__default.cloneElement(React__default.Children.only(children), {
    id: id
  }));
};

InputWrapper.propTypes = {
  label: PropTypes.any.isRequired,
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child, index) {
      if (index > 0) return error = new Error("".concat(componentName, " only expects a single child."));
      return true;
    });
    return error;
  }
};
var InputWrapper$1 = InputWrapper;

var SortableTable = function SortableTable(props) {
  var i18n = useI18n$1();
  var className = props.className,
      _props$emptyDataText = props.emptyDataText,
      emptyDataText = _props$emptyDataText === void 0 ? i18n.t("table.noData") : _props$emptyDataText,
      data = props.data,
      columns = props.columns,
      _props$getIdentifier = props.getIdentifier,
      getIdentifier = _props$getIdentifier === void 0 ? function (n) {
    return n._.id;
  } : _props$getIdentifier,
      defaultSort = props.defaultSort,
      sort = props.sort,
      rowComponent = props.rowComponent,
      _props$rowProps = props.rowProps,
      rowProps = _props$rowProps === void 0 ? function () {
    return {};
  } : _props$rowProps,
      loading = props.loading,
      loadingRows = props.loadingRows;
  var tableData = props.tableData,
      setSort = props.setSort;

  if (!columns || columns.length == 0) {
    console.log("Must provide columns to SortableTable");
    return null;
  }

  var _useState = useState(columns[0].key),
      _useState2 = _slicedToArray$1(_useState, 2),
      localSortKey = _useState2[0],
      setLocalSortKey = _useState2[1];

  var _useState3 = useState("+"),
      _useState4 = _slicedToArray$1(_useState3, 2),
      localSortDirection = _useState4[0],
      setLocalSortDirection = _useState4[1];

  useEffect(function () {
    if (defaultSort) {
      setLocalSortDirection(defaultSort[0]);
      setLocalSortKey(defaultSort.slice(1, defaultSort.length));
    }
  }, [defaultSort]);
  var sortKey = localSortKey,
      sortDirection = localSortDirection;

  if (sort) {
    sortDirection = sort[0];
    sortKey = sort.slice(1, sort.length);
  }

  if (!setSort) {
    setSort = function setSort(newSort) {
      var newSortDirection = newSort[0],
          newSortKey = newSort.slice(1, newSort.length);
      if (newSortDirection !== sortDirection) setLocalSortDirection(newSortDirection);
      if (newSortKey !== sortKey) setLocalSortKey(newSortKey);
    };
  }

  var updateSort = function updateSort(key) {
    if (key == sortKey) {
      if (sortDirection == "+") setSort("-".concat(sortKey));
      if (sortDirection == "-") setSort("+".concat(sortKey));
    } else {
      setSort("+".concat(key));
    }
  };

  if (!tableData) {
    if (data) {
      tableData = (data || []).map(function (datum) {
        return columns.reduce(function (c, _ref) {
          var key = _ref.key,
              display = _ref.display,
              sort = _ref.sort;
          return _objectSpread2(_objectSpread2({}, c), {}, _defineProperty$3({}, key, {
            __display: display(datum),
            __sort: (sort || display)(datum)
          }));
        }, {
          __original: datum,
          __id: getIdentifier(datum)
        });
      });
      tableData = tableData.sort(function (datumA, datumB) {
        var _a = datumA[sortKey].__sort,
            _b = datumB[sortKey].__sort;

        if (sortDirection == "+") {
          if (_a > _b) return 1;
          if (_a < _b) return -1;
          return 0;
        } else if (sortDirection == "-") {
          if (_a < _b) return 1;
          if (_a > _b) return -1;
          return 0;
        } else {
          return 0;
        }
      });
    } else {
      tableData = [];
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "sortable-table table-wrapper ".concat(className ? className : "")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "table"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "thead"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tr"
  }, columns.map(function (_ref2) {
    var key = _ref2.key,
        label = _ref2.label,
        nosort = _ref2.nosort;
    return /*#__PURE__*/React__default.createElement("label", {
      key: key,
      className: "th ".concat(key == sortKey ? "sorting" : "", " ").concat(nosort ? "nosort" : ""),
      onClick: nosort ? null : function () {
        return updateSort(key);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, label), key == sortKey && (sortDirection == "+" ? /*#__PURE__*/React__default.createElement(ForwardRef$y, null) : sortDirection == "-" ? /*#__PURE__*/React__default.createElement(ForwardRef$D, null) : null));
  }))), (!tableData || tableData.length == 0) && !loading && /*#__PURE__*/React__default.createElement("div", {
    className: "empty-data"
  }, /*#__PURE__*/React__default.createElement("em", null, emptyDataText)), /*#__PURE__*/React__default.createElement("div", {
    className: "tbody"
  }, loadingRows && loadingRows.length > 0 ? loadingRows.map(function (r, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "tr"
    }, columns.map(function (_ref3) {
      var key = _ref3.key;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "td",
        key: "".concat(index, "-").concat(key)
      }, "\xA0");
    }));
  }) : tableData.map(function (row) {
    var Component = rowComponent || "div";
    return /*#__PURE__*/React__default.createElement(Component, _extends$U({
      key: row.__id,
      className: "tr"
    }, rowProps(row)), columns.map(function (_ref4) {
      var key = _ref4.key;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "td",
        key: "".concat(row.__id, "-").concat(key)
      }, row[key].__display);
    }));
  }))), loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)));
};

SortableTable.propTypes = {
  className: PropTypes.string,
  emptyDataText: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  tableData: PropTypes.arrayOf(PropTypes.shape({
    __original: PropTypes.object,
    __id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    display: PropTypes.func,
    sort: PropTypes.func
  })),
  getIdentifier: PropTypes.func,
  defaultSort: PropTypes.string,
  sort: PropTypes.string,
  setSort: PropTypes.func,
  rowComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  rowProps: PropTypes.func,
  loading: PropTypes.bool,
  loadingRows: PropTypes.arrayOf(PropTypes.any)
};
var SortableTable$1 = SortableTable;

var EquipmentNameLabelFromExternalId = function EquipmentNameLabelFromExternalId(_ref) {
  var external_id = _ref.external_id;
  var chariot = useChariot();
  var i18n = useI18n$1();

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      equipment = _useState2[0],
      setEquipment = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$1(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _equipment;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (external_id) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return chariot.Equipment.find({
                params: {
                  external_id: external_id
                }
              });

            case 6:
              _equipment = _context.sent;

              if (mounted) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              setEquipment(_equipment);
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              if (mounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              setEquipment(null);

            case 17:
              setLoading(false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }))();

    return function () {
      mounted = false;
    };
  }, [external_id]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, equipment ? equipment.getDisplayName() : loading ? i18n.t("equipment.loading") : i18n.t("equipment.unknown"));
};

EquipmentNameLabelFromExternalId.propTypes = {
  external_id: PropTypes.string.isRequired
};
var EquipmentNameLabelFromExternalId$1 = EquipmentNameLabelFromExternalId;

var Gateway = function Gateway(props) {
  var i18n = useI18n$1();
  var equipment = props.equipment,
      actions = props.actions;
  var online = useEquipmentStatus$1(equipment);

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      clients = _useState2[0],
      setClients = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      uptime = _useState4[0],
      setUptime = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      memory = _useState6[0],
      setMemory = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      storageUsage = _useState8[0],
      setStorageUsage = _useState8[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _clients, _uptime, _memory, _storageUsage;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!equipment) {
                _context.next = 49;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return equipment.getClients();

            case 4:
              _clients = _context.sent;

              if (mounted) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              setClients(_clients);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error("An error occurred while retrieving clients for the Gateway", _context.t0);

            case 13:
              _context.prev = 13;
              _context.next = 16;
              return equipment.getUptime();

            case 16:
              _uptime = _context.sent;

              if (mounted) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              setUptime(_uptime);
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](13);
              console.error("An error occurred while retrieving uptime for the Gateway", _context.t1);

            case 25:
              _context.prev = 25;
              _context.next = 28;
              return equipment.getMemory();

            case 28:
              _memory = _context.sent;

              if (mounted) {
                _context.next = 31;
                break;
              }

              return _context.abrupt("return");

            case 31:
              setMemory(_memory);
              _context.next = 37;
              break;

            case 34:
              _context.prev = 34;
              _context.t2 = _context["catch"](25);
              console.error("An error occurred while retrieving memory for the Gateway", _context.t2);

            case 37:
              _context.prev = 37;
              _context.next = 40;
              return equipment.getStorageUsage();

            case 40:
              _storageUsage = _context.sent;

              if (mounted) {
                _context.next = 43;
                break;
              }

              return _context.abrupt("return");

            case 43:
              setStorageUsage(_storageUsage);
              _context.next = 49;
              break;

            case 46:
              _context.prev = 46;
              _context.t3 = _context["catch"](37);
              console.error("An error occurred while retrieving storage usage for the Gateway", _context.t3);

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10], [13, 22], [25, 34], [37, 46]]);
    }))();

    return function () {
      mounted = false;
    };
  }, [equipment && equipment._.id]);

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "gateway-equipment"
    }, /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "gateway-equipment ".concat(!online ? "offline" : "")
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: equipment.getDisplayName(),
    actions: actions
  }, !online && /*#__PURE__*/React__default.createElement(EquipmentOfflineIndicator, null))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "gateway--health",
    loading: !(uptime && memory && storageUsage)
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("gateway.healthHeader")
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(PieGraph$1, {
    filled: (uptime === null || uptime === void 0 ? void 0 : uptime.percent) / 100,
    filledColor: getHexForColorLabel(uptime === null || uptime === void 0 ? void 0 : uptime.color)
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.uptimeLabel")), /*#__PURE__*/React__default.createElement("strong", null, uptime === null || uptime === void 0 ? void 0 : uptime.percent, "%"), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.uptimeTimespanLabel"))), /*#__PURE__*/React__default.createElement(PieGraph$1, {
    filled: (memory === null || memory === void 0 ? void 0 : memory.percent) / 100,
    filledColor: getHexForColorLabel(memory === null || memory === void 0 ? void 0 : memory.color)
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.memoryLabel")), /*#__PURE__*/React__default.createElement("strong", null, memory === null || memory === void 0 ? void 0 : memory.percent, "%"), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.memoryPctLabel"))), /*#__PURE__*/React__default.createElement(PieGraph$1, {
    filled: (storageUsage === null || storageUsage === void 0 ? void 0 : storageUsage.percent) / 100,
    filledColor: getHexForColorLabel(storageUsage === null || storageUsage === void 0 ? void 0 : storageUsage.color)
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.storageLabel")), /*#__PURE__*/React__default.createElement("strong", null, storageUsage === null || storageUsage === void 0 ? void 0 : storageUsage.percent, "%"), /*#__PURE__*/React__default.createElement("span", null, i18n.t("gateway.storageUsageLabel"))))), /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("gateway.networkDetailsHeader")
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("gateway.lanLabel")
  }, /*#__PURE__*/React__default.createElement(PointControl$1, {
    disabled: true,
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.lanIp,
    component: TextInput$1
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("gateway.wanLabel")
  }, /*#__PURE__*/React__default.createElement(PointControl$1, {
    disabled: true,
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.wanIp,
    component: TextInput$1
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("gateway.publicIpLabel")
  }, /*#__PURE__*/React__default.createElement(PointControl$1, {
    disabled: true,
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.publicIp,
    component: TextInput$1
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("gateway.virtualIpLabel")
  }, /*#__PURE__*/React__default.createElement(PointControl$1, {
    disabled: true,
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.virtualIp,
    component: TextInput$1
  })))), /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("gateway.clientsHeader")
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(SortableTable$1, {
    data: clients || [],
    getIdentifier: function getIdentifier(client) {
      return client.mac || client.id;
    },
    columns: [{
      key: "equipment",
      label: i18n.t("gateway.equipmentHeader"),
      display: function display(client) {
        return /*#__PURE__*/React__default.createElement(EquipmentNameLabelFromExternalId$1, {
          external_id: client.mac || client.id
        });
      },
      sort: function sort(client) {
        return client.mac;
      }
    }, {
      key: "mac",
      label: i18n.t("gateway.macHeader"),
      display: function display(client) {
        return client.mac;
      }
    }, {
      key: "ip",
      label: i18n.t("gateway.ipv4Header"),
      display: function display(client) {
        return client.ip;
      }
    }]
  }))));
};

var getHexForColorLabel = function getHexForColorLabel(color) {
  switch (color) {
    case "red":
      return "#ef4552";

    case "blue":
      return "#4040DC";

    case "green":
      return "#36b0a7";
  }
};

Gateway.displayName = "Gateway";
Gateway.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== Gateway$1) return new Error("equipment must be type: Gateway");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  }))
};
var GatewayComponent = Gateway;

var destructureDataIntoOrderedArray = function destructureDataIntoOrderedArray(data, point_names) {
  return point_names.map(function (name) {
    return data[name];
  });
};

var GroupedPointValueDisplay = function GroupedPointValueDisplay(props) {
  var equipment = props.equipment,
      point_names = props.point_names,
      _onReceivedValue = props.onReceivedValue,
      display = props.display,
      toolTipPosition = props.toolTipPosition,
      toolTipContent = props.toolTipContent;

  var _useState = useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var tooltipAnchor = useRef(null);

  var copyOfData = _objectSpread2({}, data);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, point_names.map(function (point_name, index) {
    return /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
      noToolTip: true,
      key: point_name || index,
      equipment: equipment,
      point_name: point_name,
      display: function display() {
        return null;
      },
      onReceivedValue: function onReceivedValue(value, point) {
        copyOfData = _objectSpread2(_objectSpread2({}, copyOfData), {}, _defineProperty$3({}, point_name, [value, point]));
        setData(copyOfData);

        _onReceivedValue(destructureDataIntoOrderedArray(copyOfData, point_names));
      }
    });
  }), display && display(destructureDataIntoOrderedArray(data, point_names), tooltipAnchor), toolTipContent && /*#__PURE__*/React__default.createElement(ToolTip$1, {
    position: toolTipPosition,
    anchor: tooltipAnchor
  }, toolTipContent));
};

GroupedPointValueDisplay.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  point_names: PropTypes.arrayOf(PropTypes.string),
  onReceivedValue: PropTypes.func,
  display: PropTypes.func,
  toolTipPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  toolTipContent: PropTypes.any
};
var GroupedPointValueDisplay$1 = GroupedPointValueDisplay;

var _path$u;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var SvgEquipmentHvac = function SvgEquipmentHvac(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$u({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$u || (_path$u = /*#__PURE__*/React$1.createElement("path", {
    d: "m4.5 2.313 3.5 3.5M8 10.188l-3.5 3.5M8 1v14M2.313 11.5l3.5-3.5-3.5-3.5M1 8h7M11 11.182a3.182 3.182 0 1 0 0-6.364M18 8h-1.273M15.95 3.05l-.903.903M11 1v1.273M11 13.727V15M15.047 12.047l.904.904",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$u = /*#__PURE__*/forwardRef(SvgEquipmentHvac);

var HVAC = function HVAC(props) {
  var i18n = useI18n$1();

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  var equipment = props.equipment,
      actions = props.actions,
      trendResolutionFromProps = props.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;
  var online = useEquipmentStatus$1(equipment);

  var _useState = useState("standby"),
      _useState2 = _slicedToArray$1(_useState, 2),
      hvacState = _useState2[0],
      setHvacState = _useState2[1];

  var _useState3 = useState("unoccupied"),
      _useState4 = _slicedToArray$1(_useState3, 2),
      occupancyMode = _useState4[0],
      setOccupancyMode = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      stateLabel = _useState6[0],
      setStateLabel = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray$1(_useState7, 2),
      mode = _useState8[0],
      setMode = _useState8[1];

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true,
      className: "hvac-equipment standby"
    });
  }

  var coolSetpointPointName = equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.coolingSetpoint,
      heatSetpointPointName = equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.heatingSetpoint;

  if (equipment !== null && equipment !== void 0 && equipment.supports.occupancyMode && occupancyMode == "unoccupied") {
    coolSetpointPointName = equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.unOccupiedCoolingSetpoint;
    heatSetpointPointName = equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.unOccupiedHeatingSetpoint;
  }

  var sizeClass = "xs";
  if (width > 350) sizeClass = "lg";
  return /*#__PURE__*/React__default.createElement(Card$1, {
    ref: observe,
    className: "hvac-equipment ".concat(hvacState, " ").concat(!online ? "offline" : "", " ").concat(sizeClass)
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: equipment.getDisplayName(),
    icon: ForwardRef$u,
    className: "hvac--header",
    actions: actions
  }, !online ? /*#__PURE__*/React__default.createElement(EquipmentOfflineIndicator, null) : /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.mode,
    onReceivedValue: function onReceivedValue(value, point) {
      if (!point) return;
      setMode("".concat(point.mapValue(value)).toLowerCase());
    }
  })), /*#__PURE__*/React__default.createElement(CardBody$1, {
    className: "hvac--display-values"
  }, (equipment === null || equipment === void 0 ? void 0 : equipment.supports.occupancyMode) && /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    noToolTip: true,
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.occupancyMode,
    display: function display() {
      return null;
    },
    onReceivedValue: function onReceivedValue(value, point) {
      if (!point) return;
      var mappedValue = point.mapValue(value);

      if (mappedValue && (mappedValue.toLowerCase() == "occupied" || mappedValue.toLowerCase() == "unoccupied")) {
        setOccupancyMode(mappedValue.toLowerCase());
      }
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "spacetemp"
  }, (equipment !== null && equipment !== void 0 && equipment.pointNames.coolingStage1 || equipment !== null && equipment !== void 0 && equipment.pointNames.coolingStage2) && (equipment !== null && equipment !== void 0 && equipment.pointNames.heatingStage1 || equipment !== null && equipment !== void 0 && equipment.pointNames.heatingStage2) ? /*#__PURE__*/React__default.createElement(GroupedPointValueDisplay$1, {
    equipment: equipment,
    toolTipPosition: "bottom",
    toolTipContent: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, hvacState.charAt(0).toUpperCase() + hvacState.slice(1)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, stateLabel ? stateLabel : i18n.t("equipment.combinedPointsDesc"))),
    point_names: [equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.coolingStage1, equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.coolingStage2, equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.heatingStage1, equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.heatingStage2],
    display: function display(data, ref) {
      var _data$map = data.map(function (p) {
        if (!p) return undefined;

        var _p = _slicedToArray$1(p, 2),
            value = _p[0],
            point = _p[1];

        if (!point) return undefined;
        return "".concat(point.mapValue(value)).toLowerCase();
      }),
          _data$map2 = _slicedToArray$1(_data$map, 4),
          _data$map2$ = _data$map2[0],
          cool1 = _data$map2$ === void 0 ? "off" : _data$map2$,
          _data$map2$2 = _data$map2[1],
          cool2 = _data$map2$2 === void 0 ? "off" : _data$map2$2,
          _data$map2$3 = _data$map2[2],
          heat1 = _data$map2$3 === void 0 ? "off" : _data$map2$3,
          _data$map2$4 = _data$map2[3],
          heat2 = _data$map2$4 === void 0 ? "off" : _data$map2$4;

      if (cool1 == "on" || cool2 == "on") {
        return /*#__PURE__*/React__default.createElement(ForwardRef$K, {
          ref: ref,
          className: "hvac-state-icon",
          width: "18.46",
          height: "18.46"
        });
      } else if (heat1 == "on" || heat2 == "on") {
        return /*#__PURE__*/React__default.createElement(ForwardRef$v, {
          ref: ref,
          className: "hvac-state-icon",
          width: "15.09",
          height: "20.09"
        });
      }

      return null;
    },
    onReceivedValue: function onReceivedValue(data) {
      var _data$map3 = data.map(function (p) {
        if (!p) return [undefined, undefined];

        var _p2 = _slicedToArray$1(p, 2),
            value = _p2[0],
            point = _p2[1];

        if (!point) return undefined;
        return ["".concat(point.mapValue(value)).toLowerCase(), point.getDisplayName()];
      }),
          _data$map4 = _slicedToArray$1(_data$map3, 4),
          _data$map4$ = _slicedToArray$1(_data$map4[0], 2),
          _data$map4$$ = _data$map4$[0],
          cool1 = _data$map4$$ === void 0 ? "off" : _data$map4$$,
          cool1Name = _data$map4$[1],
          _data$map4$2 = _slicedToArray$1(_data$map4[1], 2),
          _data$map4$2$ = _data$map4$2[0],
          cool2 = _data$map4$2$ === void 0 ? "off" : _data$map4$2$,
          cool2Name = _data$map4$2[1],
          _data$map4$3 = _slicedToArray$1(_data$map4[2], 2),
          _data$map4$3$ = _data$map4$3[0],
          heat1 = _data$map4$3$ === void 0 ? "off" : _data$map4$3$,
          heat1Name = _data$map4$3[1],
          _data$map4$4 = _slicedToArray$1(_data$map4[3], 2),
          _data$map4$4$ = _data$map4$4[0],
          heat2 = _data$map4$4$ === void 0 ? "off" : _data$map4$4$,
          heat2Name = _data$map4$4[1];

      if (cool2 == "on") {
        setStateLabel(cool2Name);
      } else if (cool1 == "on") {
        setStateLabel(cool1Name);
      } else if (heat2 == "on") {
        setStateLabel(heat2Name);
      } else if (heat1 == "on") {
        setStateLabel(heat1Name);
      } else {
        setStateLabel(null);
      }

      if (cool1 == "on" || cool2 == "on") {
        setHvacState("cooling");
      } else if (heat1 == "on" || heat2 == "on") {
        setHvacState("heating");
      } else {
        setHvacState("standby");
      }
    }
  }) : /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    toolTipPosition: "bottom",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.status,
    display: function display(mappedValue, point, ref) {
      if (!mappedValue) return null;

      if (mappedValue.toLowerCase().includes("heat")) {
        return /*#__PURE__*/React__default.createElement(ForwardRef$v, {
          ref: ref,
          className: "hvac-state-icon",
          width: "15.09",
          height: "20.09"
        });
      } else if (mappedValue.toLowerCase().includes("cool")) {
        return /*#__PURE__*/React__default.createElement(ForwardRef$K, {
          ref: ref,
          className: "hvac-state-icon",
          width: "18.46",
          height: "18.46"
        });
      }

      return null;
    },
    onReceivedValue: function onReceivedValue(value, point) {
      if (!point) return;
      var mappedValue = point.mapValue(value);

      if (mappedValue) {
        if (mappedValue.toLowerCase() == "heating") {
          setHvacState("heating");
        } else if (mappedValue.toLowerCase() == "cooling") {
          setHvacState("cooling");
        } else {
          setHvacState("standby");
        }
      }
    }
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("span", {
    className: "value"
  }, /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    toolTipPosition: "bottom",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.spaceTemp,
    display: function display(value, point, ref) {
      return value ? /*#__PURE__*/React__default.createElement("span", {
        ref: ref
      }, Math.round(value)) : /*#__PURE__*/React__default.createElement(LoadingString$1, {
        ref: ref,
        width: 60
      });
    }
  })), "\xB0", /*#__PURE__*/React__default.createElement("small", null, "F"))), /*#__PURE__*/React__default.createElement("div", {
    className: "hvac-meta-points"
  }, /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    toolTipPosition: "right",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.humidity,
    display: function display(mappedValue, point, ref) {
      if (!mappedValue || !point) return null;
      return /*#__PURE__*/React__default.createElement("span", {
        className: "point",
        ref: ref
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "value"
      }, mappedValue, "%"), /*#__PURE__*/React__default.createElement("span", {
        className: "svg-wrapper"
      }, /*#__PURE__*/React__default.createElement(ForwardRef$I, {
        width: "11.86",
        height: "14.32"
      })));
    }
  }), /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    toolTipPosition: "right",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.supplyTemp,
    display: function display(mappedValue, point, ref) {
      if (!mappedValue || !point) return null;
      return /*#__PURE__*/React__default.createElement("span", {
        className: "point",
        ref: ref
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "value"
      }, mappedValue, "\xB0"), /*#__PURE__*/React__default.createElement("span", {
        className: "svg-wrapper"
      }, /*#__PURE__*/React__default.createElement(ForwardRef$J, {
        width: "14",
        height: "11.73"
      })));
    }
  }), /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    toolTipPosition: "right",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.fanStatus,
    display: function display(mappedValue, point, ref) {
      if (!mappedValue || !point) return null;
      return /*#__PURE__*/React__default.createElement("span", {
        className: "point",
        ref: ref
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "value"
      }, mappedValue), /*#__PURE__*/React__default.createElement("span", {
        className: "svg-wrapper ".concat(mappedValue && mappedValue.toLowerCase() == "on" ? "spin" : "")
      }, /*#__PURE__*/React__default.createElement(ForwardRef$H, {
        width: "15",
        height: "15"
      })));
    }
  }))), /*#__PURE__*/React__default.createElement(PointTrend$1, {
    key: "trend-".concat(hvacState),
    className: "hvac--point-trend",
    equipment: equipment,
    point_name: "spacetemp",
    toolTipPosition: "right",
    fromDate: moment().subtract(24, "hours").startOf("hour").toDate(),
    toDate: moment().endOf("hour").toDate(),
    timeframeDescription: i18n.t("equipment.last24HTimeframeDesc"),
    resolution: trendResolution,
    baseline: 0.8
  }), (!mode || !mode.includes("cool")) && /*#__PURE__*/React__default.createElement(PointControl$1, {
    toolTipPosition: "bottom",
    className: "hvac--heat-temp-control",
    display: function display(value) {
      return "".concat(parseInt(value), "\xB0");
    },
    equipment: equipment,
    point_name: heatSetpointPointName,
    component: StepInput$1,
    disabled: !online
  }), (!mode || !mode.includes("heat")) && /*#__PURE__*/React__default.createElement(PointControl$1, {
    toolTipPosition: "bottom",
    className: "hvac--cool-temp-control",
    display: function display(value) {
      return "".concat(parseInt(value), "\xB0");
    },
    equipment: equipment,
    point_name: coolSetpointPointName,
    component: StepInput$1,
    disabled: !online
  }));
};

HVAC.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== HVAC$1) return new Error("equipment must be type: HVAC");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var HVACComponent = HVAC;

var _path$t;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var SvgEquipmentLighting = function SvgEquipmentLighting(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$t({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$t || (_path$t = /*#__PURE__*/React$1.createElement("path", {
    d: "M8.001 12.83c0-.426.037-.806-.015-1.18-.112-.775.18-1.252.835-1.707 1.59-1.104 2.305-2.685 2.067-4.617-.493-4.02-5.475-5.744-8.354-2.969C1.109 3.73.69 5.423 1.22 7.332c.373 1.358 1.283 2.298 2.446 3.021.254.157.35.343.336.642-.022.611 0 1.215 0 1.85 1.35 0 2.64-.008 3.998-.016ZM4.122 15l3.767-.015",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$t = /*#__PURE__*/forwardRef(SvgEquipmentLighting);

var Lighting = function Lighting(props) {
  var _equipment$supports;

  var i18n = useI18n$1();
  var equipment = props.equipment,
      actions = props.actions,
      trendResolutionFromProps = props.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;
  var online = useEquipmentStatus$1(equipment);

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      mappedValue = _useState4[0],
      setMappedValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      locked = _useState6[0],
      setLocked = _useState6[1];

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true,
      className: "lighting-equipment"
    });
  }

  var colorClass = "off";

  if (mappedValue) {
    if (mappedValue.toLowerCase() == "on") {
      colorClass = "on";
    }
  } else if (value !== null) {
    if (!value !== false) {
      colorClass = "on";
    }
  }

  return /*#__PURE__*/React__default.createElement(Card$1, {
    className: "lighting-equipment ".concat(colorClass, " ").concat(!online ? "offline" : "")
  }, (equipment === null || equipment === void 0 ? void 0 : (_equipment$supports = equipment.supports) === null || _equipment$supports === void 0 ? void 0 : _equipment$supports.overrideLock) && /*#__PURE__*/React__default.createElement(GroupedPointValueDisplay$1, {
    equipment: equipment,
    point_names: [equipment.pointNames.lightToggle, equipment.pointNames.lightOverride],
    display: function display() {
      return null;
    },
    onReceivedValue: function onReceivedValue(data) {
      var _data$map = data.map(function (p) {
        if (!p) return undefined;

        var _p = _slicedToArray$1(p, 2),
            value = _p[0],
            point = _p[1];

        if (!point) return undefined;
        return "".concat(point.mapValue(value)).toLowerCase();
      }),
          _data$map2 = _slicedToArray$1(_data$map, 2),
          _data$map2$ = _data$map2[0],
          command = _data$map2$ === void 0 ? "off" : _data$map2$,
          _data$map2$2 = _data$map2[1],
          override = _data$map2$2 === void 0 ? "off" : _data$map2$2;

      if (override == "on" || command == "on") {
        setLocked(true);
      } else {
        setLocked(false);
      }
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: equipment.getDisplayName(),
    icon: ForwardRef$t,
    className: "lighting--header",
    actions: actions
  }, !online && /*#__PURE__*/React__default.createElement(EquipmentOfflineIndicator, null)), /*#__PURE__*/React__default.createElement(CardBody$1, {
    className: "lighting--point-control-wrapper"
  }, /*#__PURE__*/React__default.createElement(PointValueDisplay$1, {
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.lightToggle
  }), /*#__PURE__*/React__default.createElement(PointControl$1, {
    toolTipPosition: "bottom",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.lightToggle,
    component: ToggleInput$1,
    locked: locked,
    onReceivedValue: function onReceivedValue(value, point) {
      setValue(value);
      setMappedValue(point.mapValue(value));
    },
    disabled: !online
  })), /*#__PURE__*/React__default.createElement(PointTrend$1, {
    className: "lighting--point-trend",
    equipment: equipment,
    point_name: equipment === null || equipment === void 0 ? void 0 : equipment.pointNames.lightToggle,
    toolTipPosition: "bottom",
    fromDate: moment().subtract(24, "hours").startOf("hour").toDate(),
    toDate: moment().endOf("hour").toDate(),
    timeframeDescription: i18n.t("equipment.last24HTimeframeDesc"),
    resolution: trendResolution,
    baseline: 0.15
  }));
};

Lighting.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== Lighting$1) return new Error("equipment must be type: Lighting");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var LightingComponent = Lighting;

var _path$s, _path2$c;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var SvgEquipmentSettings = function SvgEquipmentSettings(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$s({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$s || (_path$s = /*#__PURE__*/React$1.createElement("path", {
    d: "M8 9.909a1.91 1.91 0 1 0 0-3.818 1.91 1.91 0 0 0 0 3.818Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$c || (_path2$c = /*#__PURE__*/React$1.createElement("path", {
    d: "M12.71 9.91a1.05 1.05 0 0 0 .21 1.157l.037.038a1.272 1.272 0 0 1-.9 2.175 1.272 1.272 0 0 1-.9-.374l-.039-.038a1.05 1.05 0 0 0-1.158-.21 1.05 1.05 0 0 0-.636.961v.108a1.273 1.273 0 0 1-2.546 0v-.057a1.05 1.05 0 0 0-.687-.96 1.05 1.05 0 0 0-1.158.21l-.038.037a1.272 1.272 0 1 1-1.801-1.8l.038-.039a1.05 1.05 0 0 0 .21-1.158 1.05 1.05 0 0 0-.961-.636h-.108a1.273 1.273 0 0 1 0-2.546h.057a1.05 1.05 0 0 0 .96-.687 1.05 1.05 0 0 0-.21-1.158l-.037-.038a1.273 1.273 0 1 1 1.8-1.801l.039.038a1.05 1.05 0 0 0 1.158.21h.05a1.05 1.05 0 0 0 .637-.961v-.108a1.273 1.273 0 0 1 2.546 0v.057a1.05 1.05 0 0 0 .636.96 1.05 1.05 0 0 0 1.158-.21l.038-.037a1.272 1.272 0 1 1 1.801 1.8l-.038.039a1.05 1.05 0 0 0-.21 1.158v.05a1.05 1.05 0 0 0 .961.637h.108a1.273 1.273 0 0 1 0 2.546h-.057a1.05 1.05 0 0 0-.96.636v0Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$s = /*#__PURE__*/forwardRef(SvgEquipmentSettings);

var Settings = function Settings(props) {
  var equipment = props.equipment,
      actions = props.actions;

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  var online = useEquipmentStatus$1(equipment);

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      points = _useState2[0],
      setPoints = _useState2[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _points;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!equipment) {
                _context.next = 7;
                break;
              }

              _context.next = 3;
              return equipment.getPoints();

            case 3:
              _points = _context.sent;

              if (mounted) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setPoints(_points);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      mounted = false;
    };
  }, [equipment && equipment._.id]);

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true,
      className: "settings-equipment"
    });
  }

  var sizeClass = "xs";
  if (width > 500) sizeClass = "sm";
  if (width > 750) sizeClass = "md";
  if (width > 1000) sizeClass = "lg";
  return /*#__PURE__*/React__default.createElement(Card$1, {
    ref: observe,
    className: "settings-equipment ".concat(!online ? "offline" : "", " ").concat(sizeClass)
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    icon: ForwardRef$s,
    label: equipment.getDisplayName(),
    className: "settings-equipment--header",
    actions: actions
  }, !online && /*#__PURE__*/React__default.createElement(EquipmentOfflineIndicator, null)), /*#__PURE__*/React__default.createElement(CardBody$1, {
    className: "settings-equipment--point-control-wrapper"
  }, points.map(function (point) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: point._.id,
      className: "settings-point-control"
    }, /*#__PURE__*/React__default.createElement("span", null, point.getDisplayName()), /*#__PURE__*/React__default.createElement(PointControl$1, {
      defaultInputStyles: true,
      point: point
    }));
  })));
};

Settings.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== Settings$1) return new Error("equipment must be type: Settings");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  }))
};
var SettingsComponent = Settings;

var _path$r;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var SvgThermometer = function SvgThermometer(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$r({
    viewBox: "0 0 10 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path$r || (_path$r = /*#__PURE__*/React$1.createElement("path", {
    d: "M6.833 12.467V3.083a2.083 2.083 0 0 0-4.166 0v9.384a3.75 3.75 0 1 0 4.166 0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef$r = /*#__PURE__*/forwardRef(SvgThermometer);

var TemperatureSensor = function TemperatureSensor(props) {
  var equipment = props.equipment,
      actions = props.actions,
      trendResolutionFromProps = props.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;

  if (!equipment) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      loading: true,
      className: "temperature-sensor-equipment"
    });
  }

  var _equipment$pointNames = equipment.pointNames,
      _equipment$pointNames2 = _equipment$pointNames.temperaturePoints,
      temperaturePoints = _equipment$pointNames2 === void 0 ? [] : _equipment$pointNames2,
      _equipment$pointNames3 = _equipment$pointNames.humidityPoints,
      humidityPoints = _equipment$pointNames3 === void 0 ? [] : _equipment$pointNames3;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, temperaturePoints.map(function (point_name) {
    return /*#__PURE__*/React__default.createElement(PointCard$1, {
      key: point_name,
      formatValue: function formatValue(value) {
        return "".concat(value, "\xB0F");
      },
      equipment: equipment,
      point_name: point_name,
      icon: ForwardRef$r,
      actions: actions,
      trendResolution: trendResolution
    });
  }), humidityPoints.map(function (point_name) {
    return /*#__PURE__*/React__default.createElement(PointCard$1, {
      key: point_name,
      equipment: equipment,
      point_name: point_name,
      icon: ForwardRef$I,
      actions: actions,
      trendResolution: trendResolution
    });
  }));
};

TemperatureSensor.propTypes = {
  equipment: function equipment(props, propName) {
    var equipment = props[propName];
    if (equipment && !(equipment instanceof Equipment$2)) return new Error("equipment must be chariot.js Equipment");
    if (equipment && equipment.type !== TemperatureSensor$1) return new Error("equipment must be type: TemperatureSensor");
    return null;
  },
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var TemperatureSensorComponent = TemperatureSensor;

var equipmentRenderMap = new Map();
equipmentRenderMap.set(BooleanSensor$1, BooleanSensorComponent);
equipmentRenderMap.set(Gateway$1, GatewayComponent);
equipmentRenderMap.set(HVAC$1, HVACComponent);
equipmentRenderMap.set(Lighting$1, LightingComponent);
equipmentRenderMap.set(Settings$1, SettingsComponent);
equipmentRenderMap.set(TemperatureSensor$1, TemperatureSensorComponent);
equipmentRenderMap.set(Unknown$1, UnknownComponent);
var getEquipmentComponent = function getEquipmentComponent(equipment) {
  var component = equipmentRenderMap.get(equipment === null || equipment === void 0 ? void 0 : equipment.type);
  if (!component) return UnknownComponent;
  return component;
};
var groupEquipmentByPrimitiveType = function groupEquipmentByPrimitiveType(equipment) {
  var equipmentClassMap = new Map();

  var _iterator = _createForOfIteratorHelper(equipment),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      if (!equipmentClassMap.has(e.type)) equipmentClassMap.set(e.type, []);
      equipmentClassMap.set(e.type, [].concat(_toConsumableArray(equipmentClassMap.get(e.type)), [e]));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return equipmentClassMap;
};

var _excluded$b = ["equipment"];

var Equipment = function Equipment(_ref) {
  var equipment = _ref.equipment,
      props = _objectWithoutProperties(_ref, _excluded$b);

  if (!equipment) return null;
  var Component = getEquipmentComponent(equipment);
  return /*#__PURE__*/React__default.createElement(Component, _extends$U({
    equipment: equipment
  }, props));
};

Equipment.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2)
};
var Equipment$1 = Equipment;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends$2(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */
var roundNumber = function (num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */
var checkIsNumber = function (num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};

var handleCallback = function (context, event, callback) {
    if (callback && typeof callback === "function") {
        callback(context, event);
    }
};

/**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */
var easeOut = function (t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var linear = function (t) {
    return t;
};
// accelerating from zero velocity
var easeInQuad = function (t) {
    return t * t;
};
// decelerating to zero velocity
var easeOutQuad = function (t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var easeInOutQuad = function (t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var easeInCubic = function (t) {
    return t * t * t;
};
// decelerating to zero velocity
var easeOutCubic = function (t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var easeInOutCubic = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var easeInQuart = function (t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuart = function (t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var easeInQuint = function (t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuint = function (t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuint = function (t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var animations = {
    easeOut: easeOut,
    linear: linear,
    easeInQuad: easeInQuad,
    easeOutQuad: easeOutQuad,
    easeInOutQuad: easeInOutQuad,
    easeInCubic: easeInCubic,
    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
};

var handleCancelAnimationFrame = function (animation) {
    if (typeof animation === "number") {
        cancelAnimationFrame(animation);
    }
};
var handleCancelAnimation = function (contextInstance) {
    if (!contextInstance.mounted)
        return;
    handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted)
        return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function () {
        if (!contextInstance.mounted) {
            return handleCancelAnimationFrame(contextInstance.animation);
        }
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        }
        else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid)
        return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) {
        setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    }
    else {
        // animation start timestamp
        handleSetupAnimation(contextInstance, animationName, animationTime, function (step) {
            var newScale = scale + scaleDiff * step;
            var newPositionX = positionX + positionXDiff * step;
            var newPositionY = positionY + positionYDiff * step;
            setTransformState(newScale, newPositionX, newPositionY);
        });
    }
}
function isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (isNaN(scale) || isNaN(positionX) || isNaN(positionY)) {
        return false;
    }
    return true;
}

function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight,
    };
}
var getBounds = function (wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth
        ? diffWidth * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight
        ? diffHeight * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return { minPositionX: minPositionX, maxPositionX: maxPositionX, minPositionY: minPositionY, maxPositionY: maxPositionY };
};
var calculateBounds = function (contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) {
        throw new Error("Components are not mounted");
    }
    var _a = getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
var handleCalculateBounds = function (contextInstance, newScale) {
    var bounds = calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return { x: x, y: y };
}
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */
var boundLimiter = function (value, minBound, maxBound, isActive) {
    if (!isActive)
        return roundNumber(value, 2);
    if (value < minBound)
        return roundNumber(minBound, 2);
    if (value > maxBound)
        return roundNumber(maxBound, 2);
    return roundNumber(value, 2);
};

function handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return { x: positionX, y: positionY };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!isNaN(maxScale) && zoom >= maxScale)
        return maxScale;
    if (!isNaN(minScale) && zoom <= minScaleWithPadding)
        return minScaleWithPadding;
    return zoom;
}

var isPanningStartAllowed = function (contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPanningAllowed = function (contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed)
        return false;
    return true;
};
var handlePanningSetup = function (contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = { x: x - positionX, y: y - positionY };
};
var handleTouchPanningSetup = function (contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = { x: x - positionX, y: y - positionY };
    }
};
function handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds)
        return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX
        ? wrapperComponent.offsetWidth
        : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY
        ? wrapperComponent.offsetHeight
        : contextInstance.setup.minPositionY || 0;
    var _d = handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY,
    };
}
function handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var hasPositionXChanged = newPositionX !== positionX;
    var hasPositionYChanged = newPositionY !== positionY;
    var hasNewPosition = !hasPositionXChanged || !hasPositionYChanged;
    if (!wrapperComponent || hasNewPosition || !bounds) {
        return;
    }
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var getPanningClientPosition = function (contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) {
        return { x: positionX, y: positionY };
    }
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return { x: newPositionX, y: newPositionY };
};
var getPaddingValue = function (contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale;
    if (size > 0 && scale >= minScale) {
        return size;
    }
    return 0;
};

var isVelocityCalculationAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    return true;
};
var isVelocityAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    if (!velocity || !bounds)
        return false;
    return true;
};
function getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) {
        return animationTime * velocity * sensitivity;
    }
    return animationTime;
}
function getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget)
                return maxTarget;
            if (calculatedPosition < maxPosition)
                return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget)
                return minTarget;
            if (calculatedPosition > minPosition)
                return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked)
        return startPosition;
    return boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}

function getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) {
        return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    }
    return defaultMultiplier;
}
function handleCalculateVelocity(contextInstance, position) {
    var isAllowed = isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) {
        return;
    }
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = { velocityX: velocityX, velocityY: velocityY, total: velocity };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) {
        return;
    }
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var paddingX = (paddingValueX * wrapperComponent.offsetWidth) / 100;
    var paddingY = (paddingValueY * wrapperComponent.offsetHeight) / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function (step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) {
            contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
        }
    });
}

function handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    handleCancelAnimation(contextInstance);
    handleCalculateBounds(contextInstance, scale);
    if (event.touches) {
        handleTouchPanningSetup(contextInstance, event);
    }
    else {
        handlePanningSetup(contextInstance, event);
    }
}
function handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords)
        return;
    var _b = getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    handleCalculateVelocity(contextInstance, { x: x, y: y });
    handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) {
            handleVelocityPanning(contextInstance);
        }
        else {
            handleAlignToBounds(contextInstance);
        }
    }
}
function handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || (!sizeX && !sizeY);
    if (isDisabled)
        return;
    var targetState = handlePanToBounds(contextInstance);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}

function handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) {
        // fire fit to bounds animation
        handleAlignToBounds(contextInstance);
    }
    if (isDisabled || !wrapperComponent || !contextInstance.mounted)
        return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}
function handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var _b = handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return { scale: newScale, positionX: x, positionY: y };
}

var initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0,
};
var contextInitialState = __assign$2(__assign$2({}, initialState), { setComponents: function () { return undefined; }, contextInstance: null });
var initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    wheel: {
        step: 0.2,
        disabled: false,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: [],
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        activationKeys: [],
        excluded: [],
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: [],
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: [],
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut",
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut",
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true,
    },
};

var createState = function (props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : initialState.positionY,
    };
};
var createSetup = function (props) {
    var newSetup = __assign$2({}, initialSetup);
    Object.keys(props).forEach(function (key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call(initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) {
                newSetup[key] = __assign$2(__assign$2({}, initialSetup[key]), props[key]);
            }
            else if (isArray) {
                newSetup[key] = __spreadArray(__spreadArray([], initialSetup[key]), props[key]);
            }
            else {
                newSetup[key] = props[key];
            }
        }
    });
    return newSetup;
};

var handleCalculateButtonZoom = function (contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale * Math.exp(delta * step);
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
function resetTransformations(contextInstance, animationTime, animationType) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return;
    var newBounds = calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y,
    };
    if (scale === initialTransformation.scale &&
        positionX === initialTransformation.positionX &&
        positionY === initialTransformation.positionY) {
        return;
    }
    animate(contextInstance, newState, animationTime, animationType);
}
function calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent)
        return initialState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = getOffset(node);
    var nodeLeft = nodeRect.x;
    var nodeTop = nodeRect.y;
    var nodeWidth = node.offsetWidth;
    var nodeHeight = node.offsetHeight;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = calculateBounds(contextInstance, newScale);
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return { positionX: x, positionY: y, scale: newScale };
}
function getOffset(element) {
    var el = element;
    var offsetLeft = 0;
    var offsetTop = 0;
    while (el) {
        offsetLeft += el.offsetLeft;
        offsetTop += el.offsetTop;
        el = el.offsetParent;
    }
    return {
        x: offsetLeft,
        y: offsetTop,
    };
}
function isValidZoomNode(node) {
    if (!node) {
        console.error("Zoom node not found");
        return false;
    }
    else if ((node === null || node === void 0 ? void 0 : node.offsetWidth) === undefined ||
        (node === null || node === void 0 ? void 0 : node.offsetHeight) === undefined) {
        console.error("Zoom node is not valid - it must contain offsetWidth and offsetHeight");
        return false;
    }
    return true;
}

var zoomIn = function (contextInstance) { return function (step, animationTime, animationType) {
    if (step === void 0) { step = 0.5; }
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
}; };
var zoomOut = function (contextInstance) { return function (step, animationTime, animationType) {
    if (step === void 0) { step = 0.5; }
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
}; };
var setTransform = function (contextInstance) { return function (newPositionX, newPositionY, newScale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var disabled = contextInstance.setup.disabled;
    if (disabled || !wrapperComponent || !contentComponent)
        return;
    var targetState = {
        positionX: isNaN(newPositionX) ? positionX : newPositionX,
        positionY: isNaN(newPositionY) ? positionY : newPositionY,
        scale: isNaN(newScale) ? scale : newScale,
    };
    animate(contextInstance, targetState, animationTime, animationType);
}; };
var resetTransform = function (contextInstance) { return function (animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 200; }
    if (animationType === void 0) { animationType = "easeOut"; }
    resetTransformations(contextInstance, animationTime, animationType);
}; };
var centerView = function (contextInstance) { return function (scale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 200; }
    if (animationType === void 0) { animationType = "easeOut"; }
    var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    if (wrapperComponent && contentComponent) {
        var targetState = getCenterPosition(scale || transformState.scale, wrapperComponent, contentComponent);
        animate(contextInstance, targetState, animationTime, animationType);
    }
}; };
var zoomToElement = function (contextInstance) { return function (node, scale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 600; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleCancelAnimation(contextInstance);
    var wrapperComponent = contextInstance.wrapperComponent;
    var target = typeof node === "string" ? document.getElementById(node) : node;
    if (wrapperComponent &&
        isValidZoomNode(target) &&
        target &&
        wrapperComponent.contains(target)) {
        var targetState = calculateZoomToNode(contextInstance, target, scale);
        animate(contextInstance, targetState, animationTime, animationType);
    }
}; };

var getContext = function (contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState,
        zoomIn: zoomIn(contextInstance),
        zoomOut: zoomOut(contextInstance),
        setTransform: setTransform(contextInstance),
        resetTransform: resetTransform(contextInstance),
        centerView: centerView(contextInstance),
        zoomToElement: zoomToElement(contextInstance),
    };
};

// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var passiveSupported = false;
function makePassiveEventOption() {
    try {
        var options = {
            get passive() {
                // This function will be called when the browser
                //   attempts to access the passive property.
                passiveSupported = true;
                return false;
            },
        };
        return options;
    }
    catch (err) {
        passiveSupported = false;
        return passiveSupported;
    }
}

var isExcludedNode = function (node, excluded) {
    var targetTagName = node.tagName.toUpperCase();
    var isExcludedTag = excluded.find(function (tag) { return tag.toUpperCase() === targetTagName; });
    if (isExcludedTag)
        return true;
    var isExcludedClassName = excluded.find(function (className) {
        return node.classList.contains(className);
    });
    if (isExcludedClassName)
        return true;
    return false;
};
var cancelTimeout = function (timeout) {
    if (timeout) {
        clearTimeout(timeout);
    }
};

var getTransformStyles = function (x, y, scale) {
    return "translate3d(" + x + "px, " + y + "px, 0) scale(" + scale + ")";
};
var getCenterPosition = function (scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY,
    };
};

var isWheelAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed)
        return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey)
        return false;
    if (touchPadDisabled && event.ctrlKey)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
function getDelta(event, customDelta) {
    var deltaY = event ? (event.deltaY < 0 ? 1 : -1) : 0;
    var delta = checkIsNumber(customDelta, deltaY);
    return delta;
}
function getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    }
    else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (isNaN(mouseX) || isNaN(mouseY))
        console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY,
    };
}
var handleCalculateWheelZoom = function (contextInstance, delta, step, disablePadding, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale + delta * (scale - scale * step) * step;
    if (getTarget)
        return targetScale;
    var paddingEnabled = disablePadding ? false : !disabled;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled);
    return newScale;
};
var handleWheelZoomStop = function (contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent)
        return false;
    if (scale < maxScale || scale > minScale)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY)
        return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    return false;
};

var isPinchStartAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPinchAllowed = function (contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed)
        return false;
    return true;
};
var calculateTouchMidPoint = function (event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale,
    };
};
var getTouchDistance = function (event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) +
        Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var calculatePinchZoom = function (contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) {
        throw new Error("Pinch touches distance was not provided");
    }
    if (currentDistance < 0) {
        return contextInstance.transformState.scale;
    }
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled);
};

var wheelStopEventTime = 160;
var wheelAnimationTime = 100;
var handleWheelStart = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        handleCancelAnimation(contextInstance);
        handleCallback(getContext(contextInstance), event, onWheelStart);
        handleCallback(getContext(contextInstance), event, onZoomStart);
    }
};
var handleWheelZoom = function (contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step;
    if (!contentComponent) {
        throw new Error("Component not mounted");
    }
    event.preventDefault();
    event.stopPropagation();
    var delta = getDelta(event, null);
    var newScale = handleCalculateWheelZoom(contextInstance, delta, step, !event.ctrlKey);
    // if scale not change
    if (scale === newScale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    handleCallback(getContext(contextInstance), event, onWheel);
    handleCallback(getContext(contextInstance), event, onZoom);
};
var handleWheelStop = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function () {
        if (!contextInstance.mounted)
            return;
        handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function () {
            if (!contextInstance.mounted)
                return;
            contextInstance.wheelStopEventTimer = null;
            handleCallback(getContext(contextInstance), event, onWheelStop);
            handleCallback(getContext(contextInstance), event, onZoomStop);
        }, wheelStopEventTime);
    }
};

var handlePinchStart = function (contextInstance, event) {
    var distance = getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    handleCancelAnimation(contextInstance);
};
var handlePinchZoom = function (contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent)
        return;
    var midPoint = calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!isFinite(midPoint.x) || !isFinite(midPoint.y))
        return;
    var currentDistance = getTouchDistance(event);
    var newScale = calculatePinchZoom(contextInstance, currentDistance);
    if (newScale === scale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    contextInstance.setTransformState(newScale, x, y);
};
var handlePinchStop = function (contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};

function handleDoubleClick(contextInstance, event) {
    var _a = contextInstance.setup.doubleClick, disabled = _a.disabled, mode = _a.mode, step = _a.step, animationTime = _a.animationTime, animationType = _a.animationType;
    if (disabled)
        return;
    if (mode === "reset") {
        return resetTransformations(contextInstance, animationTime, animationType);
    }
    var scale = contextInstance.transformState.scale;
    var contentComponent = contextInstance.contentComponent;
    if (!contentComponent)
        return console.error("No ContentComponent found");
    var delta = mode === "zoomOut" ? -1 : 1;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var targetState = handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
var isDoubleClickAllowed = function (contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    if (!isAllowed)
        return false;
    return true;
};

var Context = React__default.createContext(contextInitialState);
var TransformContext = /** @class */ (function (_super) {
    __extends$2(TransformContext, _super);
    function TransformContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mounted = true;
        _this.transformState = createState(_this.props);
        _this.setup = createSetup(_this.props);
        // Components
        _this.wrapperComponent = null;
        _this.contentComponent = null;
        // Initialization
        _this.isInitialized = false;
        _this.bounds = null;
        // wheel helpers
        _this.previousWheelEvent = null;
        _this.wheelStopEventTimer = null;
        _this.wheelAnimationTimer = null;
        // panning helpers
        _this.isPanning = false;
        _this.startCoords = null;
        _this.lastTouch = null;
        // pinch helpers
        _this.distance = null;
        _this.lastDistance = null;
        _this.pinchStartDistance = null;
        _this.pinchStartScale = null;
        _this.pinchMidpoint = null;
        // velocity helpers
        _this.velocity = null;
        _this.velocityTime = null;
        _this.lastMousePosition = null;
        // animations helpers
        _this.animate = false;
        _this.animation = null;
        _this.maxBounds = null;
        // key press
        _this.pressedKeys = {};
        _this.handleInitializeWrapperEvents = function (wrapper) {
            // Zooming events on wrapper
            var passive = makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        _this.handleInitialize = function () {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.forceUpdate();
            if (centerOnInit) {
                // this has to be redone once the right solution is found
                // problem is - we need to execute it after mounted component specify it's height / width, images are fetched async so it's tricky
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 50);
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 100);
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 200);
            }
        };
        //////////
        // Zoom
        //////////
        _this.onWheelZoom = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isWheelAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed)
                return;
            handleWheelStart(_this, event);
            handleWheelZoom(_this, event);
            handleWheelStop(_this, event);
        };
        //////////
        // Pan
        //////////
        _this.onPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handleCancelAnimation(_this);
            handlePanningStart(_this, event);
            handleCallback(getContext(_this), event, onPanningStart);
        };
        _this.onPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled)
                return;
            var isAllowed = isPanningAllowed(_this);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePanning(_this, event.clientX, event.clientY);
            handleCallback(getContext(_this), event, onPanning);
        };
        _this.onPanningStop = function (event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                handlePanningEnd(_this);
                handleCallback(getContext(_this), event, onPanningStop);
            }
        };
        //////////
        // Pinch
        //////////
        _this.onPinchStart = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled)
                return;
            var isAllowed = isPinchStartAllowed(_this, event);
            if (!isAllowed)
                return;
            handlePinchStart(_this, event);
            handleCancelAnimation(_this);
            handleCallback(getContext(_this), event, onPinchingStart);
            handleCallback(getContext(_this), event, onZoomStart);
        };
        _this.onPinch = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled)
                return;
            var isAllowed = isPinchAllowed(_this);
            if (!isAllowed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePinchZoom(_this, event);
            handleCallback(getContext(_this), event, onPinching);
            handleCallback(getContext(_this), event, onZoom);
        };
        _this.onPinchStop = function (event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                handlePinchStop(_this);
                handleCallback(getContext(_this), event, onPinchingStop);
                handleCallback(getContext(_this), event, onZoomStop);
            }
        };
        //////////
        // Touch
        //////////
        _this.onTouchPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) {
                _this.onDoubleClick(event);
            }
            else {
                _this.lastTouch = +new Date();
                handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    handleCancelAnimation(_this);
                    handlePanningStart(_this, event);
                    handleCallback(getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) {
                    _this.onPinchStart(event);
                }
            }
        };
        _this.onTouchPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled)
                    return;
                var isAllowed = isPanningAllowed(_this);
                if (!isAllowed)
                    return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                handlePanning(_this, touch.clientX, touch.clientY);
                handleCallback(getContext(_this), event, onPanning);
            }
            else if (event.touches.length > 1) {
                _this.onPinch(event);
            }
        };
        _this.onTouchPanningStop = function (event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        //////////
        // Double Click
        //////////
        _this.onDoubleClick = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isDoubleClickAllowed(_this, event);
            if (!isAllowed)
                return;
            handleDoubleClick(_this, event);
        };
        //////////
        // Helpers
        //////////
        _this.clearPanning = function (event) {
            if (_this.isPanning) {
                _this.onPanningStop(event);
            }
        };
        _this.setKeyPressed = function (e) {
            _this.pressedKeys[e.key] = true;
        };
        _this.setKeyUnPressed = function (e) {
            _this.pressedKeys[e.key] = false;
        };
        _this.isPressingKeys = function (keys) {
            if (!keys.length) {
                return true;
            }
            return Boolean(keys.find(function (key) { return _this.pressedKeys[key]; }));
        };
        _this.setComponents = function (wrapperComponent, contentComponent) {
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize();
            _this.handleRef();
            _this.isInitialized = true;
            handleCallback(getContext(_this), undefined, _this.props.onInit);
        };
        _this.setTransformState = function (scale, positionX, positionY) {
            if (!isNaN(scale) && !isNaN(positionX) && !isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
            }
            else {
                console.error("Detected NaN set state values");
            }
        };
        _this.setCenter = function () {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = getCenterPosition(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        _this.applyTransformation = function () {
            if (!_this.mounted || !_this.contentComponent)
                return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = getTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
            _this.handleRef();
        };
        _this.handleRef = function () {
            _this.props.setRef(getContext(_this));
        };
        return _this;
    }
    TransformContext.prototype.componentDidMount = function () {
        var passive = makePassiveEventOption();
        // Panning on window to allow panning when mouse is out of component wrapper
        window.addEventListener("mousedown", this.onPanningStart, passive);
        window.addEventListener("mousemove", this.onPanning, passive);
        window.addEventListener("mouseup", this.onPanningStop, passive);
        document.addEventListener("mouseleave", this.clearPanning, passive);
        window.addEventListener("keyup", this.setKeyUnPressed, passive);
        window.addEventListener("keydown", this.setKeyPressed, passive);
        this.handleRef();
    };
    TransformContext.prototype.componentWillUnmount = function () {
        var passive = makePassiveEventOption();
        window.removeEventListener("mousedown", this.onPanningStart, passive);
        window.removeEventListener("mousemove", this.onPanning, passive);
        window.removeEventListener("mouseup", this.onPanningStop, passive);
        window.removeEventListener("keyup", this.setKeyUnPressed, passive);
        window.removeEventListener("keydown", this.setKeyPressed, passive);
        handleCancelAnimation(this);
    };
    TransformContext.prototype.componentDidUpdate = function (oldProps) {
        if (oldProps !== this.props) {
            handleCalculateBounds(this, this.transformState.scale);
            this.setup = createSetup(this.props);
        }
    };
    TransformContext.prototype.render = function () {
        var value = getContext(this);
        var children = this.props.children;
        var content = typeof children === "function" ? children(value) : children;
        return (React__default.createElement(Context.Provider, { value: __assign$2(__assign$2({}, this.transformState), { setComponents: this.setComponents, contextInstance: this }) }, content));
    };
    return TransformContext;
}(Component));

var TransformWrapper = React__default.forwardRef(function (props, ref) {
    var _a = useState(null), innerRef = _a[0], setRef = _a[1];
    useImperativeHandle(ref, function () { return innerRef; }, [innerRef]);
    return React__default.createElement(TransformContext, __assign$2({}, props, { setRef: setRef }));
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".transform-component-module_wrapper__1_Fgj {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__2jYgh {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__2jYgh img {\n  pointer-events: none;\n}\n";
var styles$1 = {"wrapper":"transform-component-module_wrapper__1_Fgj","content":"transform-component-module_content__2jYgh"};
styleInject(css_248z);

var TransformComponent = function (_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle;
    var setComponents = useContext(Context).setComponents;
    var wrapperRef = useRef(null);
    var contentRef = useRef(null);
    useEffect(function () {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && setComponents) {
            setComponents(wrapper, content);
        }
    }, []);
    return (React__default.createElement("div", { ref: wrapperRef, className: "react-transform-wrapper " + styles$1.wrapper + " " + wrapperClass, style: wrapperStyle },
        React__default.createElement("div", { ref: contentRef, className: "react-transform-component " + styles$1.content + " " + contentClass, style: contentStyle }, children)));
};

var _path$q;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var SvgResetMap = function SvgResetMap(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path$q || (_path$q = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M15.85 3.85 17.3 5.3l-2.18 2.16c-.39.39-.39 1.03 0 1.42.39.39 1.03.39 1.42 0L18.7 6.7l1.45 1.45a.5.5 0 0 0 .85-.36V3.5c0-.28-.22-.5-.5-.5h-4.29a.5.5 0 0 0-.36.85zm-12 4.3L5.3 6.7l2.16 2.18c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42L6.7 5.3l1.45-1.45A.5.5 0 0 0 7.79 3H3.5c-.28 0-.5.22-.5.5v4.29c0 .45.54.67.85.36zm4.3 12L6.7 18.7l2.18-2.16c.39-.39.39-1.03 0-1.42-.39-.39-1.03-.39-1.42 0L5.3 17.3l-1.45-1.45a.5.5 0 0 0-.85.36v4.29c0 .28.22.5.5.5h4.29a.5.5 0 0 0 .36-.85zm12-4.3L18.7 17.3l-2.16-2.18c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l2.18 2.16-1.45 1.45a.5.5 0 0 0 .36.85h4.29c.28 0 .5-.22.5-.5v-4.29a.5.5 0 0 0-.85-.36z"
  })));
};

var ForwardRef$q = /*#__PURE__*/forwardRef(SvgResetMap);

var _path$p;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var SvgZoomOut = function SvgZoomOut(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path$p || (_path$p = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z"
  })));
};

var ForwardRef$p = /*#__PURE__*/forwardRef(SvgZoomOut);

var _path$o;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var SvgZoomIn = function SvgZoomIn(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path$o || (_path$o = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z"
  })));
};

var ForwardRef$o = /*#__PURE__*/forwardRef(SvgZoomIn);

var FloorplanMapTools = function FloorplanMapTools(_ref) {
  var zoomIn = _ref.zoomIn,
      zoomOut = _ref.zoomOut,
      resetTransform = _ref.resetTransform;
  return /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    className: "floorplan-map-tools"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: resetTransform
  }, /*#__PURE__*/React__default.createElement(ForwardRef$q, null)), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: zoomOut
  }, /*#__PURE__*/React__default.createElement(ForwardRef$p, null)), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: zoomIn
  }, /*#__PURE__*/React__default.createElement(ForwardRef$o, null)));
};

FloorplanMapTools.propTypes = {
  zoomIn: PropTypes.func.isRequired,
  zoomOut: PropTypes.func.isRequired,
  resetTransform: PropTypes.func.isRequired
};
var FloorplanMapTools$1 = FloorplanMapTools;

var _circle$b, _path$n, _path2$b;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var SvgFloorplanAcUnit = function SvgFloorplanAcUnit(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$b || (_circle$b = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#fff"
  })), _path$n || (_path$n = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$b || (_path2$b = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M32.9 23h-3.2l2.5-2.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.9 4h-2v-2l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0L25 18.2V15c0-.6-.4-1-1-1-.5 0-1 .4-1 1v3.2l-2.5-2.5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.9 4v2h-2l-3.9-4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.5 2.5H15c-.5 0-1 .4-1 1 0 .5.5 1 1 1h3.2l-2.5 2.5c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.9-4h2v2L19 31c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.5-2.5V33c0 .5.5 1 1 1 .6 0 1-.5 1-1v-3.2l2.5 2.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-3.9v-2h2l4 4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L29.8 25H33c.5 0 1-.5 1-1-.1-.5-.5-1-1.1-1z"
  })));
};

var ForwardRef$n = /*#__PURE__*/forwardRef(SvgFloorplanAcUnit);

var _circle$a, _path$m, _path2$a;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var SvgFloorplanAcUnitActive = function SvgFloorplanAcUnitActive(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$a || (_circle$a = /*#__PURE__*/React$1.createElement("circle", {
    className: "feature-icon-theme",
    cx: 24,
    cy: 24,
    r: 19
  })), _path$m || (_path$m = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$a || (_path2$a = /*#__PURE__*/React$1.createElement("path", {
    d: "M32.9 23h-3.2l2.5-2.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.9 4h-2v-2l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0L25 18.2V15c0-.6-.4-1-1-1-.5 0-1 .4-1 1v3.2l-2.5-2.5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.9 4v2h-2l-3.9-4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.5 2.5H15c-.5 0-1 .4-1 1 0 .5.5 1 1 1h3.2l-2.5 2.5c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.9-4h2v2L19 31c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.5-2.5V33c0 .5.5 1 1 1 .6 0 1-.5 1-1v-3.2l2.5 2.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-3.9v-2h2l4 4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L29.8 25H33c.5 0 1-.5 1-1-.1-.5-.5-1-1.1-1z",
    fill: "#fff"
  })));
};

var ForwardRef$m = /*#__PURE__*/forwardRef(SvgFloorplanAcUnitActive);

var _circle$9, _path$l, _path2$9;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var SvgFloorplanAcUnitHover = function SvgFloorplanAcUnitHover(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$9 || (_circle$9 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#edeff3"
  })), _path$l || (_path$l = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M32.9 23h-3.2l2.5-2.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.9 4h-2v-2l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0L25 18.2V15c0-.6-.4-1-1-1-.5 0-1 .4-1 1v3.2l-2.5-2.5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.9 4v2h-2l-3.9-4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.5 2.5H15c-.5 0-1 .4-1 1 0 .5.5 1 1 1h3.2l-2.5 2.5c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.9-4h2v2L19 31c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.5-2.5V33c0 .5.5 1 1 1 .6 0 1-.5 1-1v-3.2l2.5 2.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-3.9v-2h2l4 4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L29.8 25H33c.5 0 1-.5 1-1-.1-.5-.5-1-1.1-1z"
  })));
};

var ForwardRef$l = /*#__PURE__*/forwardRef(SvgFloorplanAcUnitHover);

var _circle$8, _path$k, _path2$8;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgFloorplanLighting = function SvgFloorplanLighting(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$8 || (_circle$8 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#fff"
  })), _path$k || (_path$k = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "m18.3 26.3 2.4 2.4c.2.2.3.4.3.7V33c0 .5.4 1 1 1h4c.5 0 1-.4 1-1v-3.6c0-.3.1-.5.3-.7l2.4-2.4c.2-.2.3-.4.3-.7V22c0-.5-.4-1-1-1H19c-.5 0-1 .4-1 1v3.6c0 .3.1.5.3.7zM21 23h6c.5 0 1 .4 1 1v.8c0 .3-.1.5-.3.7l-2.4 2.4c-.2.2-.3.4-.3.7V31c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-2.4c0-.3-.1-.5-.3-.7l-2.4-2.4c-.2-.2-.3-.4-.3-.7V24c0-.6.4-1 1-1zm3-9c.6 0 1 .4 1 1v1c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-1c0-.6.4-1 1-1zm-7.8 3.2c.4-.4 1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-.7-.7c-.4-.4-.4-1 0-1.4zm13.5.7.7-.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-.7.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
  })));
};

var ForwardRef$k = /*#__PURE__*/forwardRef(SvgFloorplanLighting);

var _circle$7, _path$j, _path2$7;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgFloorplanLightingActive = function SvgFloorplanLightingActive(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$7 || (_circle$7 = /*#__PURE__*/React$1.createElement("circle", {
    className: "feature-icon-theme",
    cx: 24,
    cy: 24,
    r: 19
  })), _path$j || (_path$j = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React$1.createElement("path", {
    d: "m18.3 26.3 2.4 2.4c.2.2.3.4.3.7V33c0 .5.4 1 1 1h4c.5 0 1-.4 1-1v-3.6c0-.3.1-.5.3-.7l2.4-2.4c.2-.2.3-.4.3-.7V22c0-.5-.4-1-1-1H19c-.5 0-1 .4-1 1v3.6c0 .3.1.5.3.7zM21 23h6c.5 0 1 .4 1 1v.8c0 .3-.1.5-.3.7l-2.4 2.4c-.2.2-.3.4-.3.7V31c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-2.4c0-.3-.1-.5-.3-.7l-2.4-2.4c-.2-.2-.3-.4-.3-.7V24c0-.6.4-1 1-1zm3-9c.6 0 1 .4 1 1v1c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-1c0-.6.4-1 1-1zm-7.8 3.2c.4-.4 1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-.7-.7c-.4-.4-.4-1 0-1.4zm13.5.7.7-.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-.7.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z",
    fill: "#fff"
  })));
};

var ForwardRef$j = /*#__PURE__*/forwardRef(SvgFloorplanLightingActive);

var _circle$6, _path$i, _path2$6;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgFloorplanLightingHover = function SvgFloorplanLightingHover(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$6 || (_circle$6 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#edeff3"
  })), _path$i || (_path$i = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "m18.3 26.3 2.4 2.4c.2.2.3.4.3.7V33c0 .5.4 1 1 1h4c.5 0 1-.4 1-1v-3.6c0-.3.1-.5.3-.7l2.4-2.4c.2-.2.3-.4.3-.7V22c0-.5-.4-1-1-1H19c-.5 0-1 .4-1 1v3.6c0 .3.1.5.3.7zM21 23h6c.5 0 1 .4 1 1v.8c0 .3-.1.5-.3.7l-2.4 2.4c-.2.2-.3.4-.3.7V31c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-2.4c0-.3-.1-.5-.3-.7l-2.4-2.4c-.2-.2-.3-.4-.3-.7V24c0-.6.4-1 1-1zm3-9c.6 0 1 .4 1 1v1c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-1c0-.6.4-1 1-1zm-7.8 3.2c.4-.4 1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-.7-.7c-.4-.4-.4-1 0-1.4zm13.5.7.7-.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-.7.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
  })));
};

var ForwardRef$i = /*#__PURE__*/forwardRef(SvgFloorplanLightingHover);

var _circle$5, _path$h, _path2$5;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgFloorplanOther = function SvgFloorplanOther(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$5 || (_circle$5 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#fff"
  })), _path$h || (_path$h = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M21 15h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4l-.1-4H21v4zm0 4h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm10-6h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm-2-8c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
  })));
};

var ForwardRef$h = /*#__PURE__*/forwardRef(SvgFloorplanOther);

var _circle$4, _path$g, _path2$4;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgFloorplanOtherActive = function SvgFloorplanOtherActive(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$4 || (_circle$4 = /*#__PURE__*/React$1.createElement("circle", {
    className: "feature-icon-theme",
    cx: 24,
    cy: 24,
    r: 19
  })), _path$g || (_path$g = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React$1.createElement("path", {
    d: "M21 15h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4l-.1-4H21v4zm0 4h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm10-6h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm-2-8c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z",
    fill: "#fff"
  })));
};

var ForwardRef$g = /*#__PURE__*/forwardRef(SvgFloorplanOtherActive);

var _circle$3, _path$f, _path2$3;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgFloorplanOtherHover = function SvgFloorplanOtherHover(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "#edeff3"
  })), _path$f || (_path$f = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M24 6c9.9 0 18 8.1 18 18s-8.1 18-18 18S6 33.9 6 24 14.1 6 24 6m0-2C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React$1.createElement("path", {
    className: "feature-icon-theme",
    d: "M21 15h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4l-.1-4H21v4zm0 4h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm10-6h-4c-1.3 0-2 1-2 2v4c0 1.3 1 2 2 2h4c1.3 0 2-1 2-2v-4c0-1.3-1-2-2-2zm0 6h-4v-4h4v4zm-2-8c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
  })));
};

var ForwardRef$f = /*#__PURE__*/forwardRef(SvgFloorplanOtherHover);

var ICONS = {
  'ac-unit': {
    default: ForwardRef$n,
    active: ForwardRef$m,
    hover: ForwardRef$l
  },
  'lighting': {
    default: ForwardRef$k,
    active: ForwardRef$j,
    hover: ForwardRef$i
  },
  'other': {
    default: ForwardRef$h,
    active: ForwardRef$g,
    hover: ForwardRef$f
  }
};
var getIconForEquipment = function getIconForEquipment(equipment) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
  if (!equipment) return ICONS["other"][state];
  if (equipment && equipment.type == HVAC$1) return ICONS["ac-unit"][state];
  if (equipment && equipment.type == Lighting$1) return ICONS["lighting"][state];
  return ICONS["other"][state];
};

var FloorplanEquipmentIcon = function FloorplanEquipmentIcon(_ref) {
  var equipment = _ref.equipment,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? "default" : _ref$state;
  if (!equipment) return null;
  var Icon = getIconForEquipment(equipment, state);
  return /*#__PURE__*/React__default.createElement(Icon, null);
};

FloorplanEquipmentIcon.propTypes = {
  equipment: PropTypes.instanceOf(Equipment$2),
  state: PropTypes.oneOf(["active", "hover", "default"])
};
var FloorplanEquipmentIcon$1 = FloorplanEquipmentIcon;

var FloorplanMapFeature = function FloorplanMapFeature(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      onClick = _ref.onClick,
      _ref$draggable = _ref.draggable,
      draggable = _ref$draggable === void 0 ? false : _ref$draggable,
      _ref$mapping = _ref.mapping,
      mapping = _ref$mapping === void 0 ? {} : _ref$mapping;
  if (!mapping || mapping.type != "equipment") return null;
  var id = mapping.id,
      position = mapping.position;

  var _useChariotGet = useChariotGet("Equipment", id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      equipment = _useChariotGet2[0],
      loading = _useChariotGet2[2];

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-map-feature ".concat(loading ? "loading" : ""),
    draggable: draggable,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick,
    onDragStart: function onDragStart(event) {
      return event.dataTransfer.setData("mapping", JSON.stringify(mapping));
    },
    style: {
      top: "".concat(position.y, "%"),
      left: "".concat(position.x, "%")
    }
  }, loading ? /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null) : /*#__PURE__*/React__default.createElement(FloorplanEquipmentIcon$1, {
    equipment: equipment,
    state: active ? "active" : hover ? "hover" : "default"
  }));
};

FloorplanMapFeature.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  draggable: PropTypes.bool,
  mapping: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    position: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })
  })
};
var FloorplanMapFeature$1 = FloorplanMapFeature;

var FloorplanMap = function FloorplanMap(_ref) {
  var imageUrl = _ref.image,
      mappings = _ref.mappings,
      onMappingChange = _ref.onMappingChange,
      allowMappingChanges = _ref.allowMappingChanges,
      activeMappingId = _ref.activeMappingId,
      setActiveMappingId = _ref.setActiveMappingId;

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width,
      height = _useDimensions.height;

  var imageWrapper = useRef();

  var _useState = useState(1),
      _useState2 = _slicedToArray$1(_useState, 2),
      imageAspectRatio = _useState2[0],
      setImageAspectRatio = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      imageCached = _useState4[0],
      setImageCached = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      imageLoadError = _useState6[0],
      setImageLoadError = _useState6[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var image;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (imageUrl) {
                image = new Image();

                image.onload = function () {
                  if (!mounted) return;
                  setImageAspectRatio(this.height / this.width);
                  setImageCached(true);
                  setImageLoadError(null);
                };

                image.onerror = function () {
                  if (!mounted) return;
                  setImageLoadError(new Error("An error occurred while loading the image"));
                };

                image.src = imageUrl;
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [imageUrl, allowMappingChanges]);
  var handleDragOver = useCallback(function (e) {
    return e.preventDefault();
  });
  var handleDrop = useCallback(function (e) {
    if (!imageWrapper.current) return;

    var _imageWrapper$current = imageWrapper.current.getBoundingClientRect(),
        top = _imageWrapper$current.top,
        left = _imageWrapper$current.left,
        width = _imageWrapper$current.width,
        height = _imageWrapper$current.height,
        x = Math.round((e.clientX - left) / width * 100000) / 1000,
        y = Math.round((e.clientY - top) / height * 100000) / 1000,
        type,
        id,
        icon = "default";

    if (e.dataTransfer.types.includes("mapping")) {
      var _JSON$parse = JSON.parse(e.dataTransfer.getData("mapping"));

      type = _JSON$parse.type;
      id = _JSON$parse.id;
      icon = _JSON$parse.icon;
    } else if (e.dataTransfer.types.includes("identifier")) {
      var _e$dataTransfer$getDa = e.dataTransfer.getData("identifier").split(":");

      var _e$dataTransfer$getDa2 = _slicedToArray$1(_e$dataTransfer$getDa, 2);

      type = _e$dataTransfer$getDa2[0];
      id = _e$dataTransfer$getDa2[1];
    } else {
      return;
    }

    var newMappings = _toConsumableArray(mappings.filter(function (mapping) {
      return mapping.id !== id;
    }));

    newMappings.push({
      type: type,
      id: id,
      icon: icon,
      position: {
        x: x,
        y: y
      }
    });
    onMappingChange(createFakeChangeEvent(newMappings));
  }, [imageWrapper, mappings, onMappingChange]);

  if (imageLoadError) {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: observe,
      className: "floorplan-map"
    }, /*#__PURE__*/React__default.createElement(AppError$1, null, imageLoadError.message));
  }

  if (!imageCached) {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: observe,
      className: "floorplan-map loading"
    }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));
  }

  var imageDimensionsFromAspectRatio = {};

  if (imageAspectRatio > 1) {
    imageDimensionsFromAspectRatio.height = height * 0.80;
    imageDimensionsFromAspectRatio.width = imageDimensionsFromAspectRatio.height / imageAspectRatio;
  } else {
    imageDimensionsFromAspectRatio.width = width * 0.80;
    imageDimensionsFromAspectRatio.height = imageDimensionsFromAspectRatio.width * imageAspectRatio;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: observe,
    className: "floorplan-map"
  }, /*#__PURE__*/React__default.createElement(TransformWrapper, {
    panning: allowMappingChanges ? {
      excluded: [".floorplan-map-feature", ".floorplan-map-feature *"]
    } : {},
    wheel: {
      step: 0.1
    }
  }, function (_ref3) {
    var _zoomIn = _ref3.zoomIn,
        _zoomOut = _ref3.zoomOut,
        _resetTransform = _ref3.resetTransform;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TransformComponent, null, /*#__PURE__*/React__default.createElement("div", {
      ref: imageWrapper,
      className: "image-wrapper",
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      style: imageDimensionsFromAspectRatio
    }, /*#__PURE__*/React__default.createElement("img", _extends$U({
      src: imageUrl
    }, imageDimensionsFromAspectRatio)), mappings.map(function (mapping) {
      var active = mapping.id == activeMappingId;
      return /*#__PURE__*/React__default.createElement(FloorplanMapFeature$1, {
        key: "".concat(mapping.type, ":").concat(mapping.id),
        draggable: allowMappingChanges,
        mapping: mapping,
        active: active,
        onClick: function onClick() {
          return active ? setActiveMappingId(null) : setActiveMappingId(mapping.id);
        }
      });
    }))), /*#__PURE__*/React__default.createElement(FloorplanMapTools$1, {
      zoomIn: function zoomIn() {
        return _zoomIn();
      },
      zoomOut: function zoomOut() {
        return _zoomOut();
      },
      resetTransform: function resetTransform() {
        return _resetTransform();
      }
    }));
  }));
};

FloorplanMap.propTypes = {
  image: PropTypes.string.isRequired,
  mappings: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })
  })).isRequired,
  onMappingChange: PropTypes.func.isRequired,
  allowMappingChanges: PropTypes.bool,
  activeMappingId: PropTypes.string,
  setActiveMappingId: PropTypes.func
};
var FloorplanMap$1 = FloorplanMap;

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgTrash2 = function SvgTrash2(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trash-2",
    ref: ref
  }, props), _path$e || (_path$e = /*#__PURE__*/React$1.createElement("path", {
    d: "M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"
  })));
};

var ForwardRef$e = /*#__PURE__*/forwardRef(SvgTrash2);

var FloorplanEquipmentDetails = function FloorplanEquipmentDetails(_ref) {
  var equipment_id = _ref.equipment_id,
      close = _ref.close,
      remove = _ref.remove,
      trendResolutionFromProps = _ref.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;
  var i18n = useI18n$1();

  var _useChariotGet = useChariotGet("Equipment", equipment_id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      equipment = _useChariotGet2[0],
      error = _useChariotGet2[1],
      loading = _useChariotGet2[2];

  var popOverActions = [],
      quickActions = [];

  if (close) {
    popOverActions.push({
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$P, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("floorplans.closeDetailsButtonLabel"))),
      onClick: close
    });
    quickActions.push({
      handler: close,
      label: i18n.t("floorplans.closeDetailsActionLabel"),
      description: i18n.t("floorplans.closeDetailsActionDesc"),
      shortcut: "escape"
    });
  }

  if (remove) {
    popOverActions.push({
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("floorplans.removeButtonLabel"))),
      onClick: remove,
      className: "warning"
    });
    quickActions.push({
      handler: remove,
      label: i18n.t("floorplans.removeActionLabel"),
      description: i18n.t("floorplans.removeActionDesc"),
      shortcut: "backspace"
    });
  }

  if (loading) return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-equipment-details loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));
  if (error) return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-equipment-details error"
  }, /*#__PURE__*/React__default.createElement(Card$1, null, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("floorplans.equipmentLoadFailedLabel"),
    actions: popOverActions
  })), quickActions.map(function (quickActionProps, index) {
    return /*#__PURE__*/React__default.createElement(QuickAction$1, _extends$U({
      key: index
    }, quickActionProps));
  }), /*#__PURE__*/React__default.createElement(AppError$1, null, error.message));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-equipment-details"
  }, quickActions.map(function (quickActionProps, index) {
    return /*#__PURE__*/React__default.createElement(QuickAction$1, _extends$U({
      key: index
    }, quickActionProps));
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-control"
  }, /*#__PURE__*/React__default.createElement(Equipment$1, {
    equipment: equipment,
    actions: popOverActions,
    trendResolution: trendResolution
  })));
};

FloorplanEquipmentDetails.propTypes = {
  equipment_id: PropTypes.string.isRequired,
  close: PropTypes.func,
  remove: PropTypes.func,
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var FloorplanEquipmentDetails$1 = FloorplanEquipmentDetails;

var _circle$2, _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-search",
    ref: ref
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  })), _path$d || (_path$d = /*#__PURE__*/React$1.createElement("path", {
    d: "m21 21-4.35-4.35"
  })));
};

var ForwardRef$d = /*#__PURE__*/forwardRef(SvgSearch);

var FloorplanAddFeaturePanel = function FloorplanAddFeaturePanel(_ref) {
  var site_id = _ref.site_id,
      mappings = _ref.mappings;
  var i18n = useI18n$1();

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      draggingId = _useState4[0],
      setDraggingId = _useState4[1];

  var _useChariotList = useChariotList("Equipment", {
    params: {
      site_id: site_id
    }
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      equipment = _useChariotList2[0],
      error = _useChariotList2[1],
      loading = _useChariotList2[2];

  var filteredEquipment = equipment || [];
  filteredEquipment = filteredEquipment.filter(function (_ref2) {
    var _ = _ref2._;
    return !mappings.some(function (_ref3) {
      var id = _ref3.id;
      return _.id == id;
    });
  });

  if (searchText && equipment) {
    filteredEquipment = filteredEquipment.filter(function (e) {
      return e.getDisplayName().toLowerCase().includes(searchText.toLowerCase());
    });
  }

  var handleDragStart = useCallback(function (equipment, event) {
    setDraggingId(equipment._.id);
    var buffer = document.getElementById("floorplan-buffer");
    if (!buffer) return;
    buffer.innerHTML = renderToString( /*#__PURE__*/React__default.createElement("div", {
      className: "floorplan-map-feature"
    }, /*#__PURE__*/React__default.createElement(FloorplanEquipmentIcon$1, {
      equipment: equipment
    })));
    event.dataTransfer.setData("identifier", "equipment:".concat(equipment._.id));
    event.dataTransfer.setDragImage(buffer.firstChild, 16, 16);
  }, [setDraggingId]);
  if (loading) return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-add-feature-panel loading"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)));
  if (error) return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-add-feature-panel error"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React__default.createElement(AppError$1, null, error.message)));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan-add-feature-panel"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React__default.createElement("p", null, i18n.t("floorplans.addItemsHelp")), /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: i18n.t("floorplans.searchPlaceholder"),
    icon: ForwardRef$d,
    value: searchText,
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    }
  }), filteredEquipment.length == 0 && /*#__PURE__*/React__default.createElement("p", {
    className: "empty"
  }, searchText.length > 0 ? i18n.t("floorplans.searchItemsNoMatchesHelp") : i18n.t("floorplans.searchItemsNoRemainingHelp")), /*#__PURE__*/React__default.createElement("ul", null, filteredEquipment.map(function (e) {
    return /*#__PURE__*/React__default.createElement("li", {
      draggable: true,
      key: e._.id,
      className: draggingId == e._.id ? "active" : "",
      onDragStart: handleDragStart.bind(null, e)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "floorplan-map-feature"
    }, /*#__PURE__*/React__default.createElement(FloorplanEquipmentIcon$1, {
      equipment: e
    })), /*#__PURE__*/React__default.createElement("span", null, e.getDisplayName()));
  }))));
};

FloorplanAddFeaturePanel.propTypes = {
  site_id: PropTypes.string.isRequired,
  mappings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    position: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })
  }))
};
var FloorplanAddFeaturePanel$1 = FloorplanAddFeaturePanel;

var Floorplan = function Floorplan(_ref) {
  var floorplan = _ref.floorplan,
      editable = _ref.editable,
      onMappingsChange = _ref.onMappingsChange,
      trendResolutionFromProps = _ref.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      mappings = _useState4[0],
      setMappings = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      activeMappingId = _useState6[0],
      setActiveMappingId = _useState6[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoaded(false);

              if (!floorplan) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return floorplan.expanded;

            case 4:
              if (mounted) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setMappings(floorplan._.mappings);
              setLoaded(true);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [floorplan]);
  var activeMapping = mappings.find(function (_ref3) {
    var id = _ref3.id;
    return id == activeMappingId;
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "floorplan ".concat(loaded ? "" : "loading")
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "floorplan-buffer"
  }), editable && floorplan && /*#__PURE__*/React__default.createElement(FloorplanAddFeaturePanel$1, {
    site_id: floorplan._.site_id,
    mappings: mappings
  }), loaded ? /*#__PURE__*/React__default.createElement(FloorplanMap$1, {
    image: floorplan._.image,
    mappings: mappings,
    onMappingChange: function onMappingChange(e) {
      setMappings(e.target.value);
      onMappingsChange && onMappingsChange(e.target.value);
    },
    allowMappingChanges: editable,
    activeMappingId: activeMappingId,
    setActiveMappingId: setActiveMappingId
  }) : /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null), activeMapping && /*#__PURE__*/React__default.createElement(FloorplanEquipmentDetails$1, {
    equipment_id: activeMappingId,
    close: function close() {
      return setActiveMappingId(null);
    },
    remove: editable ? function () {
      return setMappings(_toConsumableArray(mappings).filter(function (_ref4) {
        var id = _ref4.id;
        return id !== activeMappingId;
      }));
    } : null,
    trendResolution: trendResolution
  }));
};

Floorplan.propTypes = {
  floorplan: PropTypes.instanceOf(Floorplan$2),
  onMappingsChange: PropTypes.func,
  editable: PropTypes.bool,
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var Floorplan$1 = Floorplan;

var _circle$1, _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var SvgClock = function SvgClock(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-clock",
    ref: ref
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path$c || (_path$c = /*#__PURE__*/React$1.createElement("path", {
    d: "M12 6v6l4 2"
  })));
};

var ForwardRef$c = /*#__PURE__*/forwardRef(SvgClock);

var SiteClock = function SiteClock(_ref) {
  var site = _ref.site;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      timezoneData = _useState2[0],
      setTimezoneData = _useState2[1];

  var _useState3 = useState(Date.now()),
      _useState4 = _slicedToArray$1(_useState3, 2),
      time = _useState4[0],
      setTime = _useState4[1];

  useEffect(function () {
    var mounted = true;
    if (!site) return;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return site.getTimezone();

            case 3:
              data = _context.sent;

              if (mounted) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setTimezoneData(data);
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }))();

    var tick = setInterval(function () {
      setTime(Date.now());
    }, 1000);
    return function () {
      mounted = false;
      clearInterval(tick);
    };
  }, [site && site._.id]);
  if (!timezoneData) return /*#__PURE__*/React__default.createElement("div", {
    className: "site-clock"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$c, {
    width: "1.5em",
    height: "1.5em"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 7
  }), " ", /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 2
  }), " ", /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 3
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "site-clock"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$c, {
    width: "1.5em",
    height: "1.5em"
  }), /*#__PURE__*/React__default.createElement("span", null, moment(time).utcOffset(timezoneData.gmtOffset / 60).format("h:mm:ss a"), " ", timezoneData.abbreviation));
};

SiteClock.propTypes = {
  site: PropTypes.instanceOf(Site)
};
var SiteClock$1 = SiteClock;

var SiteControls = function SiteControls(props) {
  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  var site = props.site,
      includeTypes = props.includeTypes,
      excludeTypes = props.excludeTypes,
      _props$getEquipmentAc = props.getEquipmentActions,
      getEquipmentActions = _props$getEquipmentAc === void 0 ? function () {
    return null;
  } : _props$getEquipmentAc,
      trendResolutionFromProps = props.trendResolution;
  var defaultTrendResolution = useDefaultResolution$1();
  var trendResolution = trendResolutionFromProps || defaultTrendResolution;

  var _useChariotList = useChariotList("Equipment", {
    params: {
      site_id: site && site._.id
    }
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      equipment = _useChariotList2[0],
      error = _useChariotList2[1],
      loading = _useChariotList2[2];

  var filteredEquipment = equipment;

  if (equipment) {
    if (includeTypes) {
      filteredEquipment = filteredEquipment.filter(function (_ref) {
        var type = _ref.type;
        return includeTypes.includes(type);
      });
    } else if (excludeTypes) {
      filteredEquipment = filteredEquipment.filter(function (_ref2) {
        var type = _ref2.type;
        return !excludeTypes.includes(type);
      });
    }
  }

  var typeGroups = groupEquipmentByPrimitiveType(filteredEquipment || []);
  if (!error && !site || loading || !width) return /*#__PURE__*/React__default.createElement("div", {
    ref: observe,
    className: "site-controls loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));
  var sizeClass = "xs";
  if (width > 500) sizeClass = "sm";
  if (width > 750) sizeClass = "md";
  if (width > 1000) sizeClass = "lg";
  return /*#__PURE__*/React__default.createElement("div", {
    ref: observe,
    className: "site-controls ".concat(sizeClass)
  }, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), Array.from(typeGroups.keys()).sort(function (typeA, typeB) {
    var indexA = EquipmentPrimitiveTypes.indexOf(typeA),
        indexB = EquipmentPrimitiveTypes.indexOf(typeB);
    if (indexA == -1) indexA = EquipmentPrimitiveTypes.length;
    if (indexB == -1) indexB = EquipmentPrimitiveTypes.length;
    if (indexA > indexB) return 1;
    if (indexA < indexB) return -1;
    if (typeA.name > typeB.name) return 1;
    if (typeA.name < typeB.name) return -1;
    return 0;
  }).map(function (type) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: type.name,
      className: "type-wrapper"
    }, typeGroups.get(type).sort(function (equipmentA, equipmentB) {
      var displayNameA = equipmentA.getDisplayName(),
          displayNameB = equipmentB.getDisplayName();
      if (displayNameA < displayNameB) return -1;
      if (displayNameB < displayNameA) return 1;
      return 0;
    }).map(function (equipment) {
      return /*#__PURE__*/React__default.createElement(Equipment$1, {
        key: equipment._.id,
        equipment: equipment,
        actions: getEquipmentActions(equipment),
        trendResolution: trendResolution
      });
    }));
  }));
};

SiteControls.propTypes = {
  site: PropTypes.instanceOf(Site),
  includeTypes: PropTypes.arrayOf(PropTypes.instanceOf(EquipmentPrimitiveType)),
  excludeTypes: PropTypes.arrayOf(PropTypes.instanceOf(EquipmentPrimitiveType)),
  getEquipmentActions: PropTypes.func,
  trendResolution: PropTypes.oneOf(RESOLUTIONS)
};
var SiteControls$1 = SiteControls;

var ChariotResourceLabel = function ChariotResourceLabel(_ref) {
  var type = _ref.type,
      id = _ref.id;
  var i18n = useI18n$1();

  var _useChariotGet = useChariotGet(type, id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      resource = _useChariotGet2[0],
      error = _useChariotGet2[1],
      loading = _useChariotGet2[2];

  if (loading) return i18n.t("global.loading");
  if (error) return i18n.t("global.errorFetchingBlank", {
    blank: type
  });
  if (resource.getDisplayName) return resource.getDisplayName();
  return resource._.name;
};

var ChariotResourceLabel$1 = ChariotResourceLabel;

var SiteStatusEvent = function SiteStatusEvent(_ref) {
  var event = _ref.event;
  if (!event) return null;
  var i18n = useI18n$1();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "site-status-event"
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "5",
    fill: event.status == "down" ? "#EF4552" : "#36b0a7"
  })), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
    type: "Site",
    id: event.site_id
  })), /*#__PURE__*/React__default.createElement("span", null, event.status == "down" ? i18n.t("site.wentOffline") : i18n.t("site.cameOnline")), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, moment(event.timestamp).format("LTS")));
};

SiteStatusEvent.propTypes = {
  event: PropTypes.shape({
    status: PropTypes.string,
    timestamp: PropTypes.string,
    site_id: PropTypes.string
  })
};
var SiteStatusEvent$1 = SiteStatusEvent;

var SiteEventList = function SiteEventList(_ref) {
  var site = _ref.site;
  if (!site) return null;
  var chariot = useChariot();
  var from_date = moment().endOf("hour").subtract(30, "days").toDate(),
      to_date = moment().endOf("hour").toDate();
  useChariotList("Rule");

  var _useChariotList = useChariotList("RuleEvent", {
    filters: {
      from_date: from_date,
      to_date: to_date,
      site_id: site === null || site === void 0 ? void 0 : site._.id
    },
    pageSize: 100,
    selectionSet: "{\n      id\n      resolved\n      rule_id\n      start\n      actors {\n        id\n        value {\n          avg\n          str\n        }\n      }\n    }"
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      ruleEvents = _useChariotList2[0],
      ruleEventsError = _useChariotList2[1],
      ruleEventsLoading = _useChariotList2[2];

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      statusLog = _useState2[0],
      setStatusLog = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      statusLogLoading = _useState4[0],
      setStatusLogLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      statusLogError = _useState6[0],
      setStatusLogError = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray$1(_useState7, 2),
      pointMap = _useState8[0],
      setPointMap = _useState8[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var log;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (site) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setStatusLogLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return site.getStatusLog(from_date, to_date);

            case 6:
              log = _context.sent;

              if (mounted) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              setStatusLog(log);
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              if (mounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              setStatusLogError(_context.t0);

            case 17:
              setStatusLogLoading(false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }))();

    return function () {
      return mounted = false;
    };
  }, [site]);
  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var newPointMap, allPointIds, uniquePointIds, _i, _uniquePointIds, pointId;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!ruleEvents || ruleEvents.length == 0)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              newPointMap = {};
              allPointIds = ruleEvents.reduce(function (pointIds, ruleEvent) {
                return pointIds.concat(ruleEvent._.actors.map(function (_ref4) {
                  var id = _ref4.id;
                  return id;
                }));
              }, []);
              uniquePointIds = Array.from(new Set(allPointIds));
              _i = 0, _uniquePointIds = uniquePointIds;

            case 6:
              if (!(_i < _uniquePointIds.length)) {
                _context2.next = 23;
                break;
              }

              pointId = _uniquePointIds[_i];
              _context2.prev = 8;
              _context2.next = 11;
              return chariot.Point.get(pointId);

            case 11:
              newPointMap[pointId] = _context2.sent;
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](8);
              console.error(_context2.t0);
              newPointMap[pointId] = null;

            case 18:
              if (mounted) {
                _context2.next = 20;
                break;
              }

              return _context2.abrupt("return");

            case 20:
              _i++;
              _context2.next = 6;
              break;

            case 23:
              setPointMap(newPointMap);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 14]]);
    }))();

    return function () {
      return mounted = false;
    };
  }, [ruleEvents]);
  var dateMap = new Map();

  if (ruleEvents && ruleEvents.length > 0) {
    var _iterator = _createForOfIteratorHelper(ruleEvents),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ruleEvent = _step.value;
        var dateKey = moment(ruleEvent._.start).format("L");
        if (!dateMap.has(dateKey)) dateMap.set(dateKey, []);
        dateMap.set(dateKey, [].concat(_toConsumableArray(dateMap.get(dateKey)), [ruleEvent]));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (statusLog && statusLog.length > 0) {
    var _iterator2 = _createForOfIteratorHelper(statusLog),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var log = _step2.value;

        var _dateKey = moment(log.timestamp).format("L");

        if (!dateMap.has(_dateKey)) dateMap.set(_dateKey, []);
        dateMap.set(_dateKey, [].concat(_toConsumableArray(dateMap.get(_dateKey)), [log]));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  var error = ruleEventsError || statusLogError;
  var loading = ruleEventsLoading || statusLogLoading;
  var hasData = ruleEvents && ruleEvents.length > 0 || statusLog && statusLog.length > 0;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "site-event-list"
  }, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), loading || !hasData ? /*#__PURE__*/React__default.createElement("div", {
    className: "loading-rule-section"
  }, /*#__PURE__*/React__default.createElement("h4", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 6,
    max: 8
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "rule-event"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    min: 12,
    max: 27
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "timestamp"
  }, /*#__PURE__*/React__default.createElement(LoadingString$1, {
    length: 6
  })))) : Array.from(dateMap.keys()).sort(function (dateA, dateB) {
    return new Date(dateB) - new Date(dateA);
  }).map(function (dateKey) {
    var events = dateMap.get(dateKey);
    events.sort(function (eventA, eventB) {
      var timestampA, timestampB;

      if (eventA instanceof RuleEvent$2) {
        timestampA = new Date(eventA._.start);
      } else {
        timestampA = new Date(eventA.timstamp);
      }

      if (eventB instanceof RuleEvent$2) {
        timestampB = new Date(eventB._.start);
      } else {
        timestampB = new Date(eventB.timstamp);
      }

      return timestampB - timestampA;
    });
    return /*#__PURE__*/React__default.createElement("div", {
      key: dateKey
    }, /*#__PURE__*/React__default.createElement("h4", null, /*#__PURE__*/React__default.createElement("span", null, dateKey)), dateMap.get(dateKey).map(function (event, index) {
      return event instanceof RuleEvent$2 ? /*#__PURE__*/React__default.createElement(RuleEvent$1, {
        key: event._.id,
        event: event,
        usePointMap: true,
        pointMap: pointMap
      }) : /*#__PURE__*/React__default.createElement(SiteStatusEvent$1, {
        key: "".concat(event.timestamp, "-").concat(event.site_id, "-").concat(index),
        event: event
      });
    }));
  }));
};

SiteEventList.propTypes = {
  site: PropTypes.instanceOf(Site).isRequired
};
var SiteEventList$1 = SiteEventList;

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var SvgStar = function SvgStar(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-star",
    ref: ref
  }, props), _path$b || (_path$b = /*#__PURE__*/React$1.createElement("path", {
    d: "m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
  })));
};

var ForwardRef$b = /*#__PURE__*/forwardRef(SvgStar);

var _excluded$a = ["site", "invisibleWhenInactive"];
var SiteStar = /*#__PURE__*/forwardRef(function (props, ref) {
  var site = props.site,
      invisibleWhenInactive = props.invisibleWhenInactive,
      buttonProps = _objectWithoutProperties(props, _excluded$a);

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      clickClass = _useState6[0],
      setClickClass = _useState6[1];

  useEffect(function () {
    var mounted = true;
    setLoading(true);
    var subscription;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$site$chariot$g, client_settings, favorite_sites;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (site) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              _context.next = 4;
              return site.chariot.getUserSettings();

            case 4:
              _yield$site$chariot$g = _context.sent;
              client_settings = _yield$site$chariot$g.client_settings;
              favorite_sites = client_settings.favorite_sites || [];

              if (mounted) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              if (favorite_sites && favorite_sites.includes(site._.id)) {
                if (!active) setActive(true);
              } else {
                if (active) setActive(false);
              }

              setLoading(false);
              subscription = site.chariot.onClientSettingsChanged.subscribe(function (_ref2) {
                var favorite_sites = _ref2.favorite_sites;
                if (!mounted) return;

                if (favorite_sites && favorite_sites.includes(site._.id)) {
                  setActive(true);
                } else {
                  setActive(false);
                }

                setClickClass("");
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      mounted = false;
      if (subscription) subscription.cancel();
    };
  }, [site && site._.id]);

  var toggle = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var _yield$site$chariot$g2, client_settings, favorite_sites;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              setClickClass("clicked ".concat(active ? "deactivating" : "activating"));
              _context2.next = 4;
              return site.chariot.getUserSettings();

            case 4:
              _yield$site$chariot$g2 = _context2.sent;
              client_settings = _yield$site$chariot$g2.client_settings;
              favorite_sites = (client_settings.favorite_sites || []).slice(0);

              if (favorite_sites.includes(site._.id)) {
                favorite_sites = favorite_sites.filter(function (s) {
                  return s !== site._.id;
                });
              } else {
                favorite_sites = favorite_sites.concat(site._.id);
              }

              site.chariot.updateUserSettings({
                client_settings: {
                  favorite_sites: favorite_sites
                }
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function toggle(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default.createElement(Button$1, _extends$U({
    ref: ref
  }, buttonProps, {
    disabled: loading,
    className: "site-star" + "".concat(clickClass ? " ".concat(clickClass) : "") + "".concat(active ? " active" : "") + "".concat(loading ? " loading" : "") + "".concat(invisibleWhenInactive ? " invisible-when-inactive" : ""),
    onClick: toggle
  }), /*#__PURE__*/React__default.createElement(ForwardRef$b, null));
});
SiteStar.propTypes = {
  site: PropTypes.instanceOf(Site),
  invisibleWhenInactive: PropTypes.bool
};
var SiteStar$1 = SiteStar;

var _excluded$9 = ["className", "_ref", "value", "onChange"];

var ColorInput = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ColorInput, _React$Component);

  var _super = _createSuper$4(ColorInput);

  function ColorInput(props) {
    var _this;

    _classCallCheck$2(this, ColorInput);

    _this = _super.call(this, props);
    _this.pushTimeoutId = -1;
    _this.id = props.id || generateRandomString();
    _this.state = {
      localValue: props.value
    };
    return _this;
  }

  _createClass$2(ColorInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setStateFromProps();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) this.setStateFromProps();
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps() {
      this.setState({
        localValue: this.props.value
      });
    }
  }, {
    key: "onChangeProxy",
    value: function onChangeProxy(event) {
      var _this2 = this;

      try {
        clearTimeout(this.pushTimeoutId);
        this.setState({
          localValue: event.target.value
        });
        this.pushTimeoutId = setTimeout(function () {
          return _this2.pushValue();
        }, 100);
      } catch (e) {//pass
      }
    }
  }, {
    key: "pushValue",
    value: function pushValue() {
      try {
        var onChange = this.props.onChange;
        var localValue = this.state.localValue;
        onChange && onChange(createFakeChangeEvent(localValue));
      } catch (e) {// pass
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          ref = _this$props._ref;
          _this$props.value;
          _this$props.onChange;
          var props = _objectWithoutProperties(_this$props, _excluded$9);

      var localValue = this.state.localValue;
      return /*#__PURE__*/React__default.createElement("label", {
        htmlFor: this.id,
        ref: ref,
        className: "color-input" + (className ? " ".concat(className) : "")
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "value-swatch",
        style: {
          backgroundColor: localValue
        }
      }), /*#__PURE__*/React__default.createElement("input", _extends$U({}, props, {
        onChange: this.onChangeProxy.bind(this),
        value: localValue,
        type: "color",
        id: this.id
      })));
    }
  }]);

  return ColorInput;
}(React__default.Component);

ColorInput.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  _ref: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
var ColorInput$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ColorInput, _extends$U({}, props, {
    _ref: ref
  }));
});

var _excluded$8 = ["_ref", "value", "onChange"];

var DateTimeInput = /*#__PURE__*/function (_React$Component) {
  _inherits$2(DateTimeInput, _React$Component);

  var _super = _createSuper$4(DateTimeInput);

  function DateTimeInput(props) {
    var _this;

    _classCallCheck$2(this, DateTimeInput);

    _this = _super.call(this, props);
    _this.pushTimeoutId = -1;
    _this.state = {
      localValue: ""
    };
    return _this;
  }

  _createClass$2(DateTimeInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setStateFromProps();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) this.setStateFromProps();
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps() {
      var value = this.props.value;
      var adjustedValue = new Date(value);

      if (!value || adjustedValue == "Invalid Date") {
        this.setState({
          localValue: ""
        });
      }

      adjustedValue.setMinutes(value.getMinutes() - value.getTimezoneOffset());
      this.setState({
        localValue: adjustedValue.toISOString().slice(0, 16)
      });
    }
  }, {
    key: "pushValue",
    value: function pushValue() {
      try {
        var onChange = this.props.onChange;
        clearTimeout(this.pushTimeoutId);
        var newValue = new Date(this.state.localValue);

        if (newValue != "Invalid Date") {
          onChange(createFakeChangeEvent(newValue));
        }
      } catch (e) {// pass
      }
    }
  }, {
    key: "onChangeProxy",
    value: function onChangeProxy(event) {
      var _this2 = this;

      try {
        clearTimeout(this.pushTimeoutId);
        this.setState({
          localValue: event.target.value
        });
        this.pushTimeoutId = setTimeout(function () {
          return _this2.pushValue();
        }, 2000);
      } catch (e) {//pass
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ref = _this$props._ref;
          _this$props.value;
          _this$props.onChange;
          var props = _objectWithoutProperties(_this$props, _excluded$8);

      var localValue = this.state.localValue;
      return /*#__PURE__*/React__default.createElement(TextInput$1, _extends$U({
        ref: ref
      }, props, {
        type: "datetime-local",
        value: localValue,
        onChange: this.onChangeProxy.bind(this),
        onBlur: this.pushValue.bind(this)
      }));
    }
  }]);

  return DateTimeInput;
}(React__default.Component);

DateTimeInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func,
  _ref: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
var DateTimeInput$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(DateTimeInput, _extends$U({}, props, {
    _ref: ref
  }));
});

var _path$a, _path2$2;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var SvgFile = function SvgFile(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file",
    ref: ref
  }, props), _path$a || (_path$a = /*#__PURE__*/React$1.createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React$1.createElement("path", {
    d: "M13 2v7h7"
  })));
};

var ForwardRef$a = /*#__PURE__*/forwardRef(SvgFile);

var formatBytes = function formatBytes(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var k = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1024;
  var d = Math.floor(Math.log(a) / Math.log(k));
  return 0 == a ? "0 Bytes" : parseFloat((a / Math.pow(k, d)).toFixed(Math.max(0, b))) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
};

var FileThumbnail = function FileThumbnail(_ref) {
  var file = _ref.file,
      remove = _ref.remove;
  var name = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isImage = _useState2[0],
      setIsImage = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      imageData = _useState4[0],
      setImageData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      fileExt = _useState6[0],
      setFileExt = _useState6[1];

  useEffect(function () {
    var mounted = true;

    if (file) {
      if (file.type.startsWith("image/")) {
        setIsImage(true);
        var reader = new FileReader();

        reader.onload = function (event) {
          if (!mounted) return;
          setImageData(event.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        setIsImage(false);

        var _file$name$match = file.name.match(/(?<=\.)[^.]+$/),
            _file$name$match2 = _slicedToArray$1(_file$name$match, 1),
            ext = _file$name$match2[0];

        setFileExt(ext);
      }
    } else {
      setIsImage(false);
      setImageData(null);
      setFileExt(null);
    }

    return function () {
      return mounted = false;
    };
  }, [file]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "file-thumbnail ".concat(isImage ? "image" : ""),
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, remove && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "remove",
    onClick: remove
  }, /*#__PURE__*/React__default.createElement(ForwardRef$e, null)), isImage && imageData ? /*#__PURE__*/React__default.createElement("img", {
    src: imageData,
    height: "80px"
  }) : /*#__PURE__*/React__default.createElement("span", {
    className: "extension"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$a, {
    width: "18",
    height: "18"
  }), " ", fileExt), /*#__PURE__*/React__default.createElement("div", {
    className: "file-header"
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: name
  }, file.name), /*#__PURE__*/React__default.createElement("span", {
    className: "size"
  }, formatBytes(file.size))), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: name,
    position: "bottom",
    delay: 0
  }, /*#__PURE__*/React__default.createElement("strong", null, file.name), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, "Last Modified: ", moment(file.lastModified).format("lll"))));
};

FileThumbnail.propTypes = {
  file: PropTypes.instanceOf(File).isRequired,
  remove: PropTypes.func
};
var FileThumbnail$1 = FileThumbnail;

var _path$9, _path2$1;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgFilePlus = function SvgFilePlus(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-plus",
    ref: ref
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React$1.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React$1.createElement("path", {
    d: "M14 2v6h6M12 18v-6M9 15h6"
  })));
};

var ForwardRef$9 = /*#__PURE__*/forwardRef(SvgFilePlus);

var _excluded$7 = ["value", "onChange", "className", "loading", "image", "accept"];
var FileInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var i18n = useI18n$1();

  var value = props.value,
      onChange = props.onChange,
      className = props.className,
      loading = props.loading,
      image = props.image,
      acceptFromProps = props.accept,
      inputProps = _objectWithoutProperties(props, _excluded$7);

  var input = useRef();
  useEffect(function () {
    if (ref) ref.current = input.current;
  }, [input.current]);

  var _useState = useState(inputProps.id || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      draggingOver = _useState4[0],
      setDraggingOver = _useState4[1];

  if (loading) inputProps.disabled = true;
  var accept = "";

  if (acceptFromProps) {
    accept = acceptFromProps;
  } else if (image) {
    accept = "image/*";
  }

  var acceptValidators = accept.split(",").filter(function (item) {
    return !!item;
  }).map(function (item) {
    item = item.trim();

    if (item.includes("/")) {
      if (item.endsWith("*")) {
        item = item.slice(0, item.length - 1);
        return function (file) {
          return file.type.startsWith(item);
        };
      }

      return function (file) {
        return file.type == item;
      };
    } else if (item.includes(".")) {
      return function (file) {
        return file.name.endsWith(item);
      };
    } else {
      console.error("Found invalid 'accept' value for input[type=\"file\"]: ".concat(item));
      return function () {
        return true;
      };
    }
  });

  var handleValueChange = function handleValueChange(event) {
    var files = Array.from(event.target.files);

    if (inputProps.multiple) {
      onChange(createFakeChangeEvent([].concat(_toConsumableArray(value || []), _toConsumableArray(files))));
    } else {
      onChange(createFakeChangeEvent(files[0] || null));
    }

    if (input && input.current) {
      input.current.value = "";
    }
  };

  var removeFileAtIndex = function removeFileAtIndex(index) {
    if (inputProps.multiple) {
      var files = _toConsumableArray(value);

      files.splice(index, 1);
      onChange(createFakeChangeEvent(files));
    } else {
      onChange(createFakeChangeEvent(null));
    }
  };

  var valueAsArray = [];

  if (Array.isArray(value)) {
    valueAsArray = value;
  } else if (value) {
    valueAsArray = [value];
  }

  if (!inputProps.multiple && value) inputProps.disabled = true;
  var handleDragOver = useCallback(function (event) {
    event.persist();
    event.preventDefault();
    setDraggingOver(true);
  }, [setDraggingOver]);
  var handleDragLeave = useCallback(function () {
    setDraggingOver(false);
  }, [setDraggingOver]);
  var handleDrop = useCallback(function (event) {
    event.persist();
    event.preventDefault();

    if (inputProps.multiple) {
      var files = _toConsumableArray(value || []);

      var _iterator = _createForOfIteratorHelper(event.dataTransfer.files),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          if (acceptValidators.every(function (validate) {
            return validate(file);
          })) {
            files.push(file);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      onChange(createFakeChangeEvent(files));
    } else {
      var file = event.dataTransfer.files[0];

      if (file && acceptValidators.every(function (validate) {
        return validate(file);
      })) {
        onChange(createFakeChangeEvent(file));
      }
    }

    setDraggingOver(false);
  }, [value, acceptValidators, onChange]);
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "file-input" + (loading ? " loading" : "") + (inputProps.disabled ? " disabled" : "") + (value ? " dirty" : "") + (draggingOver ? " dragging-over" : "") + (className ? " ".concat(className) : ""),
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop
  }, valueAsArray.map(function (file, index) {
    return /*#__PURE__*/React__default.createElement(FileThumbnail$1, {
      key: index,
      file: file,
      remove: function remove() {
        return removeFileAtIndex(index);
      }
    });
  }), (valueAsArray.length < 1 || inputProps.multiple) && /*#__PURE__*/React__default.createElement("div", {
    className: "file-placeholder"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$9, {
    width: "18",
    height: "18"
  }), /*#__PURE__*/React__default.createElement("span", null, inputProps.multiple ? i18n.t("inputs.fileInputMulitplePlaceholder") : i18n.t("inputs.fileInputPlaceholder"))), draggingOver && /*#__PURE__*/React__default.createElement("div", {
    className: "dropzone"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$9, {
    width: "18",
    height: "18"
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("inputs.fileInputDropzoneText"))), /*#__PURE__*/React__default.createElement("input", _extends$U({}, inputProps, {
    ref: input,
    type: "file",
    id: id,
    accept: accept,
    onChange: handleValueChange
  })));
});
FileInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.arrayOf(PropTypes.instanceOf(File))]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  loading: PropTypes.bool,
  accept: PropTypes.string,
  image: PropTypes.bool
};
var FileInput$1 = FileInput;

var _excluded$6 = ["icon", "className", "loading", "onChange", "value"];
var ipAddressRegexp = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

var IPAddressInput = function IPAddressInput(props) {
  var Icon = props.icon,
      className = props.className,
      loading = props.loading,
      onChange = props.onChange,
      value = props.value,
      inputProps = _objectWithoutProperties(props, _excluded$6);

  var _useState = useState(["", "", "", ""]),
      _useState2 = _slicedToArray$1(_useState, 2),
      inputValues = _useState2[0],
      setInputValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var copyOfInputValues = _toConsumableArray(inputValues);

  var ref0 = useRef();
  var ref1 = useRef();
  var ref2 = useRef();
  var ref3 = useRef();
  useEffect(function () {
    if (!value || typeof value != "string") return;
    copyOfInputValues = value.split(".");

    while (copyOfInputValues.length < 4) {
      copyOfInputValues.push("");
    }

    if (copyOfInputValues.length > 4) copyOfInputValues = copyOfInputValues.slice(0, 3);
    setInputValues(copyOfInputValues);
  }, [value]);
  useEffect(function () {
    var newValue = copyOfInputValues.join(".");
    if (newValue !== value) onChange(createFakeChangeEvent(newValue));
  }, [JSON.stringify(copyOfInputValues)]);
  var valid = ipAddressRegexp.test(value) && value.split(".").every(function (s) {
    return parseInt(s) <= 255;
  });
  if (loading) inputProps.disabled = true;
  var inputs = [{
    key: "ip-input-0",
    value: inputValues[0],
    ref: ref0
  }, {
    key: "ip-input-1",
    value: inputValues[1],
    ref: ref1
  }, {
    key: "ip-input-2",
    value: inputValues[2],
    ref: ref2
  }, {
    key: "ip-input-3",
    value: inputValues[3],
    ref: ref3
  }];
  return /*#__PURE__*/React__default.createElement("label", {
    className: "ip-address-input" + (focused ? " focus" : "") + (loading ? " loading" : "") + (!valid ? " invalid" : "") + (props.disabled ? " disabled" : "") + (props.value && props.value.length > 0 ? " dirty" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), Icon && /*#__PURE__*/React__default.createElement(Icon, null), inputs.map(function (inputConfigProps, index) {
    return /*#__PURE__*/React__default.createElement(TextInput$1, _extends$U({}, inputConfigProps, {
      placeholder: "xxx",
      onFocus: function onFocus(e) {
        e.target.select();
        setFocused(true);
      },
      onPaste: function onPaste(e) {
        var pasteValue = (e.clipboardData || window.clipboardData).getData("text");

        if (ipAddressRegexp.test(pasteValue)) {
          onChange(createFakeChangeEvent(pasteValue));
          e.preventDefault();
          return false;
        }
      },
      onBlur: function onBlur() {
        return setFocused(false);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key == "Backspace" && e.target.selectionEnd == 0) {
          var prevInput = inputs[index - 1];

          if (prevInput && prevInput.ref.current) {
            prevInput.ref.current.focus();

            var newInputValues = _toConsumableArray(inputValues),
                prevInputValue = newInputValues[index - 1];

            if (prevInputValue.length > 0) prevInputValue = prevInputValue.slice(0, prevInputValue.length - 1);
            newInputValues[index - 1] = prevInputValue;
            setInputValues(newInputValues);
          }
        }
      },
      onChange: function onChange(e) {
        var newInputValues = _toConsumableArray(inputValues),
            newValue = e.target.value;

        if (isNaN(newValue)) newValue = "";
        if (!isNaN(newValue)) newValue = parseInt(newValue).toString();

        if (newValue.length > 3) {
          return false;
        }

        if (newValue == "NaN") newValue = "";

        if (newValue.length == 3) {
          var nextInput = inputs[index + 1];

          if (nextInput && nextInput.ref.current) {
            nextInput.ref.current.focus();
          }
        }

        newInputValues[index] = newValue;
        setInputValues(newInputValues);
      }
    }, inputProps));
  }));
};

IPAddressInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string
};
var IPAddressInput$1 = IPAddressInput;

var deepFreezeEs6 = {exports: {}};

function deepFreeze(obj) {
    if (obj instanceof Map) {
        obj.clear = obj.delete = obj.set = function () {
            throw new Error('map is read-only');
        };
    } else if (obj instanceof Set) {
        obj.add = obj.clear = obj.delete = function () {
            throw new Error('set is read-only');
        };
    }

    // Freeze self
    Object.freeze(obj);

    Object.getOwnPropertyNames(obj).forEach(function (name) {
        var prop = obj[name];

        // Freeze prop if it is an object
        if (typeof prop == 'object' && !Object.isFrozen(prop)) {
            deepFreeze(prop);
        }
    });

    return obj;
}

deepFreezeEs6.exports = deepFreeze;
deepFreezeEs6.exports.default = deepFreeze;

var deepFreeze$1 = deepFreezeEs6.exports;

/** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */
/** @typedef {import('highlight.js').CompiledMode} CompiledMode */
/** @implements CallbackResponse */

class Response {
  /**
   * @param {CompiledMode} mode
   */
  constructor(mode) {
    // eslint-disable-next-line no-undefined
    if (mode.data === undefined) mode.data = {};

    this.data = mode.data;
    this.isMatchIgnored = false;
  }

  ignoreMatch() {
    this.isMatchIgnored = true;
  }
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHTML(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}

/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */
function inherit$1(original, ...objects) {
  /** @type Record<string,any> */
  const result = Object.create(null);

  for (const key in original) {
    result[key] = original[key];
  }
  objects.forEach(function(obj) {
    for (const key in obj) {
      result[key] = obj[key];
    }
  });
  return /** @type {T} */ (result);
}

/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */

/** @typedef {{kind?: string, sublanguage?: boolean}} Node */
/** @typedef {{walk: (r: Renderer) => void}} Tree */
/** */

const SPAN_CLOSE = '</span>';

/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */
const emitsWrappingTags = (node) => {
  return !!node.kind;
};

/**
 *
 * @param {string} name
 * @param {{prefix:string}} options
 */
const expandScopeName = (name, { prefix }) => {
  if (name.includes(".")) {
    const pieces = name.split(".");
    return [
      `${prefix}${pieces.shift()}`,
      ...(pieces.map((x, i) => `${x}${"_".repeat(i + 1)}`))
    ].join(" ");
  }
  return `${prefix}${name}`;
};

/** @type {Renderer} */
class HTMLRenderer {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(parseTree, options) {
    this.buffer = "";
    this.classPrefix = options.classPrefix;
    parseTree.walk(this);
  }

  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(text) {
    this.buffer += escapeHTML(text);
  }

  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(node) {
    if (!emitsWrappingTags(node)) return;

    let scope = node.kind;
    if (node.sublanguage) {
      scope = `language-${scope}`;
    } else {
      scope = expandScopeName(scope, { prefix: this.classPrefix });
    }
    this.span(scope);
  }

  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(node) {
    if (!emitsWrappingTags(node)) return;

    this.buffer += SPAN_CLOSE;
  }

  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }

  // helpers

  /**
   * Builds a span element
   *
   * @param {string} className */
  span(className) {
    this.buffer += `<span class="${className}">`;
  }
}

/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */
/** @typedef {import('highlight.js').Emitter} Emitter */
/**  */

class TokenTree {
  constructor() {
    /** @type DataNode */
    this.rootNode = { children: [] };
    this.stack = [this.rootNode];
  }

  get top() {
    return this.stack[this.stack.length - 1];
  }

  get root() { return this.rootNode; }

  /** @param {Node} node */
  add(node) {
    this.top.children.push(node);
  }

  /** @param {string} kind */
  openNode(kind) {
    /** @type Node */
    const node = { kind, children: [] };
    this.add(node);
    this.stack.push(node);
  }

  closeNode() {
    if (this.stack.length > 1) {
      return this.stack.pop();
    }
    // eslint-disable-next-line no-undefined
    return undefined;
  }

  closeAllNodes() {
    while (this.closeNode());
  }

  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }

  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(builder) {
    // this does not
    return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
  }

  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(builder, node) {
    if (typeof node === "string") {
      builder.addText(node);
    } else if (node.children) {
      builder.openNode(node);
      node.children.forEach((child) => this._walk(builder, child));
      builder.closeNode(node);
    }
    return builder;
  }

  /**
   * @param {Node} node
   */
  static _collapse(node) {
    if (typeof node === "string") return;
    if (!node.children) return;

    if (node.children.every(el => typeof el === "string")) {
      // node.text = node.children.join("");
      // delete node.children;
      node.children = [node.children.join("")];
    } else {
      node.children.forEach((child) => {
        TokenTree._collapse(child);
      });
    }
  }
}

/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/

/**
 * @implements {Emitter}
 */
class TokenTreeEmitter extends TokenTree {
  /**
   * @param {*} options
   */
  constructor(options) {
    super();
    this.options = options;
  }

  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(text, kind) {
    if (text === "") { return; }

    this.openNode(kind);
    this.addText(text);
    this.closeNode();
  }

  /**
   * @param {string} text
   */
  addText(text) {
    if (text === "") { return; }

    this.add(text);
  }

  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(emitter, name) {
    /** @type DataNode */
    const node = emitter.root;
    node.kind = name;
    node.sublanguage = true;
    this.add(node);
  }

  toHTML() {
    const renderer = new HTMLRenderer(this, this.options);
    return renderer.value();
  }

  finalize() {
    return true;
  }
}

/**
 * @param {string} value
 * @returns {RegExp}
 * */

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function lookahead(re) {
  return concat('(?=', re, ')');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function anyNumberOfTimes(re) {
  return concat('(?:', re, ')*');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function optional(re) {
  return concat('(?:', re, ')?');
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => source(x)).join("");
  return joined;
}

/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */
function stripOptionsFromArgs(args) {
  const opts = args[args.length - 1];

  if (typeof opts === 'object' && opts.constructor === Object) {
    args.splice(args.length - 1, 1);
    return opts;
  } else {
    return {};
  }
}

/** @typedef { {capture?: boolean} } RegexEitherOptions */

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */
function either(...args) {
  /** @type { object & {capture?: boolean} }  */
  const opts = stripOptionsFromArgs(args);
  const joined = '('
    + (opts.capture ? "" : "?:")
    + args.map((x) => source(x)).join("|") + ")";
  return joined;
}

/**
 * @param {RegExp | string} re
 * @returns {number}
 */
function countMatchGroups(re) {
  return (new RegExp(re.toString() + '|')).exec('').length - 1;
}

/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */
function startsWith(re, lexeme) {
  const match = re && re.exec(lexeme);
  return match && match.index === 0;
}

// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

// **INTERNAL** Not intended for outside usage
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {{joinWith: string}} opts
 * @returns {string}
 */
function _rewriteBackreferences(regexps, { joinWith }) {
  let numCaptures = 0;

  return regexps.map((regex) => {
    numCaptures += 1;
    const offset = numCaptures;
    let re = source(regex);
    let out = '';

    while (re.length > 0) {
      const match = BACKREF_RE.exec(re);
      if (!match) {
        out += re;
        break;
      }
      out += re.substring(0, match.index);
      re = re.substring(match.index + match[0].length);
      if (match[0][0] === '\\' && match[1]) {
        // Adjust the backreference.
        out += '\\' + String(Number(match[1]) + offset);
      } else {
        out += match[0];
        if (match[0] === '(') {
          numCaptures++;
        }
      }
    }
    return out;
  }).map(re => `(${re})`).join(joinWith);
}

/** @typedef {import('highlight.js').Mode} Mode */
/** @typedef {import('highlight.js').ModeCallback} ModeCallback */

// Common regexps
const MATCH_NOTHING_RE = /\b\B/;
const IDENT_RE = '[a-zA-Z]\\w*';
const UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/
const SHEBANG = (opts = {}) => {
  const beginShebang = /^#![ ]*\//;
  if (opts.binary) {
    opts.begin = concat(
      beginShebang,
      /.*\b/,
      opts.binary,
      /\b.*/);
  }
  return inherit$1({
    scope: 'meta',
    begin: beginShebang,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (m, resp) => {
      if (m.index !== 0) resp.ignoreMatch();
    }
  }, opts);
};

// Common modes
const BACKSLASH_ESCAPE = {
  begin: '\\\\[\\s\\S]', relevance: 0
};
const APOS_STRING_MODE = {
  scope: 'string',
  begin: '\'',
  end: '\'',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const QUOTE_STRING_MODE = {
  scope: 'string',
  begin: '"',
  end: '"',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const PHRASAL_WORDS_MODE = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */
const COMMENT = function(begin, end, modeOptions = {}) {
  const mode = inherit$1(
    {
      scope: 'comment',
      begin,
      end,
      contains: []
    },
    modeOptions
  );
  mode.contains.push({
    scope: 'doctag',
    // hack to avoid the space from being included. the space is necessary to
    // match here to prevent the plain text rule below from gobbling up doctags
    begin: '[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)',
    end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
    excludeBegin: true,
    relevance: 0
  });
  const ENGLISH_WORD = either(
    // list of common 1 and 2 letter words in English
    "I",
    "a",
    "is",
    "so",
    "us",
    "to",
    "at",
    "if",
    "in",
    "it",
    "on",
    // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, // contractions - can't we'd they're let's, etc
    /[A-Za-z]+[-][a-z]+/, // `no-way`, etc.
    /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
  );
  // looking like plain text, more likely to be a comment
  mode.contains.push(
    {
      // TODO: how to include ", (, ) without breaking grammars that use these for
      // comment delimiters?
      // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
      // ---

      // this tries to find sequences of 3 english words in a row (without any
      // "programming" type syntax) this gives us a strong signal that we've
      // TRULY found a comment - vs perhaps scanning with the wrong language.
      // It's possible to find something that LOOKS like the start of the
      // comment - but then if there is no readable text - good chance it is a
      // false match and not a comment.
      //
      // for a visual example please see:
      // https://github.com/highlightjs/highlight.js/issues/2827

      begin: concat(
        /[ ]+/, // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
        '(',
        ENGLISH_WORD,
        /[.]?[:]?([.][ ]|[ ])/,
        '){3}') // look for 3 words in a row
    }
  );
  return mode;
};
const C_LINE_COMMENT_MODE = COMMENT('//', '$');
const C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
const HASH_COMMENT_MODE = COMMENT('#', '$');
const NUMBER_MODE = {
  scope: 'number',
  begin: NUMBER_RE,
  relevance: 0
};
const C_NUMBER_MODE = {
  scope: 'number',
  begin: C_NUMBER_RE,
  relevance: 0
};
const BINARY_NUMBER_MODE = {
  scope: 'number',
  begin: BINARY_NUMBER_RE,
  relevance: 0
};
const REGEXP_MODE = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    scope: 'regexp',
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      BACKSLASH_ESCAPE,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [BACKSLASH_ESCAPE]
      }
    ]
  }]
};
const TITLE_MODE = {
  scope: 'title',
  begin: IDENT_RE,
  relevance: 0
};
const UNDERSCORE_TITLE_MODE = {
  scope: 'title',
  begin: UNDERSCORE_IDENT_RE,
  relevance: 0
};
const METHOD_GUARD = {
  // excludes method names from keyword processing
  begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
  relevance: 0
};

/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */
const END_SAME_AS_BEGIN = function(mode) {
  return Object.assign(mode,
    {
      /** @type {ModeCallback} */
      'on:begin': (m, resp) => { resp.data._beginMatch = m[1]; },
      /** @type {ModeCallback} */
      'on:end': (m, resp) => { if (resp.data._beginMatch !== m[1]) resp.ignoreMatch(); }
    });
};

var MODES = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: MATCH_NOTHING_RE,
    IDENT_RE: IDENT_RE,
    UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
    NUMBER_RE: NUMBER_RE,
    C_NUMBER_RE: C_NUMBER_RE,
    BINARY_NUMBER_RE: BINARY_NUMBER_RE,
    RE_STARTERS_RE: RE_STARTERS_RE,
    SHEBANG: SHEBANG,
    BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
    APOS_STRING_MODE: APOS_STRING_MODE,
    QUOTE_STRING_MODE: QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
    COMMENT: COMMENT,
    C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE: HASH_COMMENT_MODE,
    NUMBER_MODE: NUMBER_MODE,
    C_NUMBER_MODE: C_NUMBER_MODE,
    BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
    REGEXP_MODE: REGEXP_MODE,
    TITLE_MODE: TITLE_MODE,
    UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE,
    METHOD_GUARD: METHOD_GUARD,
    END_SAME_AS_BEGIN: END_SAME_AS_BEGIN
});

/**
@typedef {import('highlight.js').CallbackResponse} CallbackResponse
@typedef {import('highlight.js').CompilerExt} CompilerExt
*/

// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833

// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.

// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.

// ------

// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */
function skipIfHasPrecedingDot(match, response) {
  const before = match.input[match.index - 1];
  if (before === ".") {
    response.ignoreMatch();
  }
}

/**
 *
 * @type {CompilerExt}
 */
function scopeClassName(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.className !== undefined) {
    mode.scope = mode.className;
    delete mode.className;
  }
}

/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */
function beginKeywords(mode, parent) {
  if (!parent) return;
  if (!mode.beginKeywords) return;

  // for languages with keywords that include non-word characters checking for
  // a word boundary is not sufficient, so instead we check for a word boundary
  // or whitespace - this does no harm in any case since our keyword engine
  // doesn't allow spaces in keywords anyways and we still check for the boundary
  // first
  mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
  mode.__beforeBegin = skipIfHasPrecedingDot;
  mode.keywords = mode.keywords || mode.beginKeywords;
  delete mode.beginKeywords;

  // prevents double relevance, the keywords themselves provide
  // relevance, the mode doesn't need to double it
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 0;
}

/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */
function compileIllegal(mode, _parent) {
  if (!Array.isArray(mode.illegal)) return;

  mode.illegal = either(...mode.illegal);
}

/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */
function compileMatch(mode, _parent) {
  if (!mode.match) return;
  if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");

  mode.begin = mode.match;
  delete mode.match;
}

/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */
function compileRelevance(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 1;
}

// allow beforeMatch to act as a "qualifier" for the match
// the full match begin must be [beforeMatch][begin]
const beforeMatchExt = (mode, parent) => {
  if (!mode.beforeMatch) return;
  // starts conflicts with endsParent which we need to make sure the child
  // rule is not matched multiple times
  if (mode.starts) throw new Error("beforeMatch cannot be used with starts");

  const originalMode = Object.assign({}, mode);
  Object.keys(mode).forEach((key) => { delete mode[key]; });

  mode.keywords = originalMode.keywords;
  mode.begin = concat(originalMode.beforeMatch, lookahead(originalMode.begin));
  mode.starts = {
    relevance: 0,
    contains: [
      Object.assign(originalMode, { endsParent: true })
    ]
  };
  mode.relevance = 0;

  delete originalMode.beforeMatch;
};

// keywords that should have no default relevance value
const COMMON_KEYWORDS = [
  'of',
  'and',
  'for',
  'in',
  'not',
  'or',
  'if',
  'then',
  'parent', // common variable name
  'list', // common variable name
  'value' // common variable name
];

const DEFAULT_KEYWORD_SCOPE = "keyword";

/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */
function compileKeywords(rawKeywords, caseInsensitive, scopeName = DEFAULT_KEYWORD_SCOPE) {
  /** @type KeywordDict */
  const compiledKeywords = Object.create(null);

  // input can be a string of keywords, an array of keywords, or a object with
  // named keys representing scopeName (which can then point to a string or array)
  if (typeof rawKeywords === 'string') {
    compileList(scopeName, rawKeywords.split(" "));
  } else if (Array.isArray(rawKeywords)) {
    compileList(scopeName, rawKeywords);
  } else {
    Object.keys(rawKeywords).forEach(function(scopeName) {
      // collapse all our objects back into the parent object
      Object.assign(
        compiledKeywords,
        compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName)
      );
    });
  }
  return compiledKeywords;

  // ---

  /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} scopeName
   * @param {Array<string>} keywordList
   */
  function compileList(scopeName, keywordList) {
    if (caseInsensitive) {
      keywordList = keywordList.map(x => x.toLowerCase());
    }
    keywordList.forEach(function(keyword) {
      const pair = keyword.split('|');
      compiledKeywords[pair[0]] = [scopeName, scoreForKeyword(pair[0], pair[1])];
    });
  }
}

/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */
function scoreForKeyword(keyword, providedScore) {
  // manual scores always win over common keywords
  // so you can force a score of 1 if you really insist
  if (providedScore) {
    return Number(providedScore);
  }

  return commonKeyword(keyword) ? 0 : 1;
}

/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */
function commonKeyword(keyword) {
  return COMMON_KEYWORDS.includes(keyword.toLowerCase());
}

/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/

/**
 * @type {Record<string, boolean>}
 */
const seenDeprecations = {};

/**
 * @param {string} message
 */
const error = (message) => {
  console.error(message);
};

/**
 * @param {string} message
 * @param {any} args
 */
const warn = (message, ...args) => {
  console.log(`WARN: ${message}`, ...args);
};

/**
 * @param {string} version
 * @param {string} message
 */
const deprecated = (version, message) => {
  if (seenDeprecations[`${version}/${message}`]) return;

  console.log(`Deprecated as of ${version}. ${message}`);
  seenDeprecations[`${version}/${message}`] = true;
};

/* eslint-disable no-throw-literal */

/**
@typedef {import('highlight.js').CompiledMode} CompiledMode
*/

const MultiClassError = new Error();

/**
 * Renumbers labeled scope names to account for additional inner match
 * groups that otherwise would break everything.
 *
 * Lets say we 3 match scopes:
 *
 *   { 1 => ..., 2 => ..., 3 => ... }
 *
 * So what we need is a clean match like this:
 *
 *   (a)(b)(c) => [ "a", "b", "c" ]
 *
 * But this falls apart with inner match groups:
 *
 * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
 *
 * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
 * What needs to happen is the numbers are remapped:
 *
 *   { 1 => ..., 2 => ..., 5 => ... }
 *
 * We also need to know that the ONLY groups that should be output
 * are 1, 2, and 5.  This function handles this behavior.
 *
 * @param {CompiledMode} mode
 * @param {Array<RegExp | string>} regexes
 * @param {{key: "beginScope"|"endScope"}} opts
 */
function remapScopeNames(mode, regexes, { key }) {
  let offset = 0;
  const scopeNames = mode[key];
  /** @type Record<number,boolean> */
  const emit = {};
  /** @type Record<number,string> */
  const positions = {};

  for (let i = 1; i <= regexes.length; i++) {
    positions[i + offset] = scopeNames[i];
    emit[i + offset] = true;
    offset += countMatchGroups(regexes[i - 1]);
  }
  // we use _emit to keep track of which match groups are "top-level" to avoid double
  // output from inside match groups
  mode[key] = positions;
  mode[key]._emit = emit;
  mode[key]._multi = true;
}

/**
 * @param {CompiledMode} mode
 */
function beginMultiClass(mode) {
  if (!Array.isArray(mode.begin)) return;

  if (mode.skip || mode.excludeBegin || mode.returnBegin) {
    error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
    throw MultiClassError;
  }

  if (typeof mode.beginScope !== "object" || mode.beginScope === null) {
    error("beginScope must be object");
    throw MultiClassError;
  }

  remapScopeNames(mode, mode.begin, { key: "beginScope" });
  mode.begin = _rewriteBackreferences(mode.begin, { joinWith: "" });
}

/**
 * @param {CompiledMode} mode
 */
function endMultiClass(mode) {
  if (!Array.isArray(mode.end)) return;

  if (mode.skip || mode.excludeEnd || mode.returnEnd) {
    error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
    throw MultiClassError;
  }

  if (typeof mode.endScope !== "object" || mode.endScope === null) {
    error("endScope must be object");
    throw MultiClassError;
  }

  remapScopeNames(mode, mode.end, { key: "endScope" });
  mode.end = _rewriteBackreferences(mode.end, { joinWith: "" });
}

/**
 * this exists only to allow `scope: {}` to be used beside `match:`
 * Otherwise `beginScope` would necessary and that would look weird

  {
    match: [ /def/, /\w+/ ]
    scope: { 1: "keyword" , 2: "title" }
  }

 * @param {CompiledMode} mode
 */
function scopeSugar(mode) {
  if (mode.scope && typeof mode.scope === "object" && mode.scope !== null) {
    mode.beginScope = mode.scope;
    delete mode.scope;
  }
}

/**
 * @param {CompiledMode} mode
 */
function MultiClass(mode) {
  scopeSugar(mode);

  if (typeof mode.beginScope === "string") {
    mode.beginScope = { _wrap: mode.beginScope };
  }
  if (typeof mode.endScope === "string") {
    mode.endScope = { _wrap: mode.endScope };
  }

  beginMultiClass(mode);
  endMultiClass(mode);
}

/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
*/

// compilation

/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @returns {CompiledLanguage}
 */
function compileLanguage(language) {
  /**
   * Builds a regex with the case sensitivity of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */
  function langRe(value, global) {
    return new RegExp(
      source(value),
      'm'
      + (language.case_insensitive ? 'i' : '')
      + (language.unicodeRegex ? 'u' : '')
      + (global ? 'g' : '')
    );
  }

  /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */
  class MultiRegex {
    constructor() {
      this.matchIndexes = {};
      // @ts-ignore
      this.regexes = [];
      this.matchAt = 1;
      this.position = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      opts.position = this.position++;
      // @ts-ignore
      this.matchIndexes[this.matchAt] = opts;
      this.regexes.push([opts, re]);
      this.matchAt += countMatchGroups(re) + 1;
    }

    compile() {
      if (this.regexes.length === 0) {
        // avoids the need to check length every time exec is called
        // @ts-ignore
        this.exec = () => null;
      }
      const terminators = this.regexes.map(el => el[1]);
      this.matcherRe = langRe(_rewriteBackreferences(terminators, { joinWith: '|' }), true);
      this.lastIndex = 0;
    }

    /** @param {string} s */
    exec(s) {
      this.matcherRe.lastIndex = this.lastIndex;
      const match = this.matcherRe.exec(s);
      if (!match) { return null; }

      // eslint-disable-next-line no-undefined
      const i = match.findIndex((el, i) => i > 0 && el !== undefined);
      // @ts-ignore
      const matchData = this.matchIndexes[i];
      // trim off any earlier non-relevant match groups (ie, the other regex
      // match groups that make up the multi-matcher)
      match.splice(0, i);

      return Object.assign(match, matchData);
    }
  }

  /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */
  class ResumableMultiRegex {
    constructor() {
      // @ts-ignore
      this.rules = [];
      // @ts-ignore
      this.multiRegexes = [];
      this.count = 0;

      this.lastIndex = 0;
      this.regexIndex = 0;
    }

    // @ts-ignore
    getMatcher(index) {
      if (this.multiRegexes[index]) return this.multiRegexes[index];

      const matcher = new MultiRegex();
      this.rules.slice(index).forEach(([re, opts]) => matcher.addRule(re, opts));
      matcher.compile();
      this.multiRegexes[index] = matcher;
      return matcher;
    }

    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }

    considerAll() {
      this.regexIndex = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      this.rules.push([re, opts]);
      if (opts.type === "begin") this.count++;
    }

    /** @param {string} s */
    exec(s) {
      const m = this.getMatcher(this.regexIndex);
      m.lastIndex = this.lastIndex;
      let result = m.exec(s);

      // The following is because we have no easy way to say "resume scanning at the
      // existing position but also skip the current rule ONLY". What happens is
      // all prior rules are also skipped which can result in matching the wrong
      // thing. Example of matching "booger":

      // our matcher is [string, "booger", number]
      //
      // ....booger....

      // if "booger" is ignored then we'd really need a regex to scan from the
      // SAME position for only: [string, number] but ignoring "booger" (if it
      // was the first match), a simple resume would scan ahead who knows how
      // far looking only for "number", ignoring potential string matches (or
      // future "booger" matches that might be valid.)

      // So what we do: We execute two matchers, one resuming at the same
      // position, but the second full matcher starting at the position after:

      //     /--- resume first regex match here (for [number])
      //     |/---- full match here for [string, "booger", number]
      //     vv
      // ....booger....

      // Which ever results in a match first is then used. So this 3-4 step
      // process essentially allows us to say "match at this position, excluding
      // a prior rule that was ignored".
      //
      // 1. Match "booger" first, ignore. Also proves that [string] does non match.
      // 2. Resume matching for [number]
      // 3. Match at index + 1 for [string, "booger", number]
      // 4. If #2 and #3 result in matches, which came first?
      if (this.resumingScanAtSamePosition()) {
        if (result && result.index === this.lastIndex) ; else { // use the second matcher result
          const m2 = this.getMatcher(0);
          m2.lastIndex = this.lastIndex + 1;
          result = m2.exec(s);
        }
      }

      if (result) {
        this.regexIndex += result.position + 1;
        if (this.regexIndex === this.count) {
          // wrap-around to considering all matches again
          this.considerAll();
        }
      }

      return result;
    }
  }

  /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */
  function buildModeRegex(mode) {
    const mm = new ResumableMultiRegex();

    mode.contains.forEach(term => mm.addRule(term.begin, { rule: term, type: "begin" }));

    if (mode.terminatorEnd) {
      mm.addRule(mode.terminatorEnd, { type: "end" });
    }
    if (mode.illegal) {
      mm.addRule(mode.illegal, { type: "illegal" });
    }

    return mm;
  }

  /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */

  /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */
  function compileMode(mode, parent) {
    const cmode = /** @type CompiledMode */ (mode);
    if (mode.isCompiled) return cmode;

    [
      scopeClassName,
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      compileMatch,
      MultiClass,
      beforeMatchExt
    ].forEach(ext => ext(mode, parent));

    language.compilerExtensions.forEach(ext => ext(mode, parent));

    // __beforeBegin is considered private API, internal use only
    mode.__beforeBegin = null;

    [
      beginKeywords,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      compileIllegal,
      // default to 1 relevance if not specified
      compileRelevance
    ].forEach(ext => ext(mode, parent));

    mode.isCompiled = true;

    let keywordPattern = null;
    if (typeof mode.keywords === "object" && mode.keywords.$pattern) {
      // we need a copy because keywords might be compiled multiple times
      // so we can't go deleting $pattern from the original on the first
      // pass
      mode.keywords = Object.assign({}, mode.keywords);
      keywordPattern = mode.keywords.$pattern;
      delete mode.keywords.$pattern;
    }
    keywordPattern = keywordPattern || /\w+/;

    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
    }

    cmode.keywordPatternRe = langRe(keywordPattern, true);

    if (parent) {
      if (!mode.begin) mode.begin = /\B|\b/;
      cmode.beginRe = langRe(cmode.begin);
      if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
      if (mode.end) cmode.endRe = langRe(cmode.end);
      cmode.terminatorEnd = source(cmode.end) || '';
      if (mode.endsWithParent && parent.terminatorEnd) {
        cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
      }
    }
    if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ (mode.illegal));
    if (!mode.contains) mode.contains = [];

    mode.contains = [].concat(...mode.contains.map(function(c) {
      return expandOrCloneMode(c === 'self' ? mode : c);
    }));
    mode.contains.forEach(function(c) { compileMode(/** @type Mode */ (c), cmode); });

    if (mode.starts) {
      compileMode(mode.starts, parent);
    }

    cmode.matcher = buildModeRegex(cmode);
    return cmode;
  }

  if (!language.compilerExtensions) language.compilerExtensions = [];

  // self is not valid at the top-level
  if (language.contains && language.contains.includes('self')) {
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  }

  // we need a null object, which inherit will guarantee
  language.classNameAliases = inherit$1(language.classNameAliases || {});

  return compileMode(/** @type Mode */ (language));
}

/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */
function dependencyOnParent(mode) {
  if (!mode) return false;

  return mode.endsWithParent || dependencyOnParent(mode.starts);
}

/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */
function expandOrCloneMode(mode) {
  if (mode.variants && !mode.cachedVariants) {
    mode.cachedVariants = mode.variants.map(function(variant) {
      return inherit$1(mode, { variants: null }, variant);
    });
  }

  // EXPAND
  // if we have variants then essentially "replace" the mode with the variants
  // this happens in compileMode, where this function is called from
  if (mode.cachedVariants) {
    return mode.cachedVariants;
  }

  // CLONE
  // if we have dependencies on parents then we need a unique
  // instance of ourselves, so we can be reused with many
  // different parents without issue
  if (dependencyOnParent(mode)) {
    return inherit$1(mode, { starts: mode.starts ? inherit$1(mode.starts) : null });
  }

  if (Object.isFrozen(mode)) {
    return inherit$1(mode);
  }

  // no special dependency issues, just return ourselves
  return mode;
}

var version = "11.5.0";

class HTMLInjectionError extends Error {
  constructor(reason, html) {
    super(reason);
    this.name = "HTMLInjectionError";
    this.html = html;
  }
}

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').CompiledScope} CompiledScope
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSApi} HLJSApi
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').PluginEvent} PluginEvent
@typedef {import('highlight.js').HLJSOptions} HLJSOptions
@typedef {import('highlight.js').LanguageFn} LanguageFn
@typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
@typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
@typedef {import('highlight.js/private').MatchType} MatchType
@typedef {import('highlight.js/private').KeywordData} KeywordData
@typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
@typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
@typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
@typedef {import('highlight.js').HighlightOptions} HighlightOptions
@typedef {import('highlight.js').HighlightResult} HighlightResult
*/


const escape = escapeHTML;
const inherit = inherit$1;
const NO_MATCH = Symbol("nomatch");
const MAX_KEYWORD_HITS = 7;

/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */
const HLJS = function(hljs) {
  // Global internal variables used within the highlight.js library.
  /** @type {Record<string, Language>} */
  const languages = Object.create(null);
  /** @type {Record<string, string>} */
  const aliases = Object.create(null);
  /** @type {HLJSPlugin[]} */
  const plugins = [];

  // safe/production mode - swallows more errors, tries to keep running
  // even if a single syntax or parse hits a fatal error
  let SAFE_MODE = true;
  const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
  /** @type {Language} */
  const PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: 'Plain text', contains: [] };

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  /** @type HLJSOptions */
  let options = {
    ignoreUnescapedHTML: false,
    throwUnescapedHTML: false,
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: 'hljs-',
    cssSelector: 'pre code',
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: TokenTreeEmitter
  };

  /* Utility functions */

  /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */
  function shouldNotHighlight(languageName) {
    return options.noHighlightRe.test(languageName);
  }

  /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */
  function blockLanguage(block) {
    let classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    const match = options.languageDetectRe.exec(classes);
    if (match) {
      const language = getLanguage(match[1]);
      if (!language) {
        warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
        warn("Falling back to no-highlight mode for this block.", block);
      }
      return language ? match[1] : 'no-highlight';
    }

    return classes
      .split(/\s+/)
      .find((_class) => shouldNotHighlight(_class) || getLanguage(_class));
  }

  /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrLanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */
  function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
    let code = "";
    let languageName = "";
    if (typeof optionsOrCode === "object") {
      code = codeOrLanguageName;
      ignoreIllegals = optionsOrCode.ignoreIllegals;
      languageName = optionsOrCode.language;
    } else {
      // old API
      deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
      deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
      languageName = codeOrLanguageName;
      code = optionsOrCode;
    }

    // https://github.com/highlightjs/highlight.js/issues/3149
    // eslint-disable-next-line no-undefined
    if (ignoreIllegals === undefined) { ignoreIllegals = true; }

    /** @type {BeforeHighlightContext} */
    const context = {
      code,
      language: languageName
    };
    // the plugin can change the desired language or the code to be highlighted
    // just be changing the object it was passed
    fire("before:highlight", context);

    // a before plugin can usurp the result completely by providing it's own
    // in which case we don't even need to call highlight
    const result = context.result
      ? context.result
      : _highlight(context.language, context.code, ignoreIllegals);

    result.code = context.code;
    // the plugin can change anything in result to suite it
    fire("after:highlight", result);

    return result;
  }

  /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */
  function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
    const keywordHits = Object.create(null);

    /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {string} matchText - the textual match
     * @returns {KeywordData | false}
     */
    function keywordData(mode, matchText) {
      return mode.keywords[matchText];
    }

    function processKeywords() {
      if (!top.keywords) {
        emitter.addText(modeBuffer);
        return;
      }

      let lastIndex = 0;
      top.keywordPatternRe.lastIndex = 0;
      let match = top.keywordPatternRe.exec(modeBuffer);
      let buf = "";

      while (match) {
        buf += modeBuffer.substring(lastIndex, match.index);
        const word = language.case_insensitive ? match[0].toLowerCase() : match[0];
        const data = keywordData(top, word);
        if (data) {
          const [kind, keywordRelevance] = data;
          emitter.addText(buf);
          buf = "";

          keywordHits[word] = (keywordHits[word] || 0) + 1;
          if (keywordHits[word] <= MAX_KEYWORD_HITS) relevance += keywordRelevance;
          if (kind.startsWith("_")) {
            // _ implied for relevance only, do not highlight
            // by applying a class name
            buf += match[0];
          } else {
            const cssClass = language.classNameAliases[kind] || kind;
            emitter.addKeyword(match[0], cssClass);
          }
        } else {
          buf += match[0];
        }
        lastIndex = top.keywordPatternRe.lastIndex;
        match = top.keywordPatternRe.exec(modeBuffer);
      }
      buf += modeBuffer.substr(lastIndex);
      emitter.addText(buf);
    }

    function processSubLanguage() {
      if (modeBuffer === "") return;
      /** @type HighlightResult */
      let result = null;

      if (typeof top.subLanguage === 'string') {
        if (!languages[top.subLanguage]) {
          emitter.addText(modeBuffer);
          return;
        }
        result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
        continuations[top.subLanguage] = /** @type {CompiledMode} */ (result._top);
      } else {
        result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
      }

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Use case in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      emitter.addSublanguage(result._emitter, result.language);
    }

    function processBuffer() {
      if (top.subLanguage != null) {
        processSubLanguage();
      } else {
        processKeywords();
      }
      modeBuffer = '';
    }

    /**
     * @param {CompiledScope} scope
     * @param {RegExpMatchArray} match
     */
    function emitMultiClass(scope, match) {
      let i = 1;
      const max = match.length - 1;
      while (i <= max) {
        if (!scope._emit[i]) { i++; continue; }
        const klass = language.classNameAliases[scope[i]] || scope[i];
        const text = match[i];
        if (klass) {
          emitter.addKeyword(text, klass);
        } else {
          modeBuffer = text;
          processKeywords();
          modeBuffer = "";
        }
        i++;
      }
    }

    /**
     * @param {CompiledMode} mode - new mode to start
     * @param {RegExpMatchArray} match
     */
    function startNewMode(mode, match) {
      if (mode.scope && typeof mode.scope === "string") {
        emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
      }
      if (mode.beginScope) {
        // beginScope just wraps the begin match itself in a scope
        if (mode.beginScope._wrap) {
          emitter.addKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
          modeBuffer = "";
        } else if (mode.beginScope._multi) {
          // at this point modeBuffer should just be the match
          emitMultiClass(mode.beginScope, match);
          modeBuffer = "";
        }
      }

      top = Object.create(mode, { parent: { value: top } });
      return top;
    }

    /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */
    function endOfMode(mode, match, matchPlusRemainder) {
      let matched = startsWith(mode.endRe, matchPlusRemainder);

      if (matched) {
        if (mode["on:end"]) {
          const resp = new Response(mode);
          mode["on:end"](match, resp);
          if (resp.isMatchIgnored) matched = false;
        }

        if (matched) {
          while (mode.endsParent && mode.parent) {
            mode = mode.parent;
          }
          return mode;
        }
      }
      // even if on:end fires an `ignore` it's still possible
      // that we might trigger the end node because of a parent mode
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, match, matchPlusRemainder);
      }
    }

    /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */
    function doIgnore(lexeme) {
      if (top.matcher.regexIndex === 0) {
        // no more regexes to potentially match here, so we move the cursor forward one
        // space
        modeBuffer += lexeme[0];
        return 1;
      } else {
        // no need to move the cursor, we still have additional regexes to try and
        // match at this very spot
        resumeScanAtSamePosition = true;
        return 0;
      }
    }

    /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */
    function doBeginMatch(match) {
      const lexeme = match[0];
      const newMode = match.rule;

      const resp = new Response(newMode);
      // first internal before callbacks, then the public ones
      const beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
      for (const cb of beforeCallbacks) {
        if (!cb) continue;
        cb(match, resp);
        if (resp.isMatchIgnored) return doIgnore(lexeme);
      }

      if (newMode.skip) {
        modeBuffer += lexeme;
      } else {
        if (newMode.excludeBegin) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (!newMode.returnBegin && !newMode.excludeBegin) {
          modeBuffer = lexeme;
        }
      }
      startNewMode(newMode, match);
      return newMode.returnBegin ? 0 : lexeme.length;
    }

    /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */
    function doEndMatch(match) {
      const lexeme = match[0];
      const matchPlusRemainder = codeToHighlight.substr(match.index);

      const endMode = endOfMode(top, match, matchPlusRemainder);
      if (!endMode) { return NO_MATCH; }

      const origin = top;
      if (top.endScope && top.endScope._wrap) {
        processBuffer();
        emitter.addKeyword(lexeme, top.endScope._wrap);
      } else if (top.endScope && top.endScope._multi) {
        processBuffer();
        emitMultiClass(top.endScope, match);
      } else if (origin.skip) {
        modeBuffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          modeBuffer = lexeme;
        }
      }
      do {
        if (top.scope) {
          emitter.closeNode();
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== endMode.parent);
      if (endMode.starts) {
        startNewMode(endMode.starts, match);
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }

    function processContinuations() {
      const list = [];
      for (let current = top; current !== language; current = current.parent) {
        if (current.scope) {
          list.unshift(current.scope);
        }
      }
      list.forEach(item => emitter.openNode(item));
    }

    /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
    let lastMatch = {};

    /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */
    function processLexeme(textBeforeMatch, match) {
      const lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      modeBuffer += textBeforeMatch;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
        if (!SAFE_MODE) {
          /** @type {AnnotatedError} */
          const err = new Error(`0 width match regex (${languageName})`);
          err.languageName = languageName;
          err.badRule = lastMatch.rule;
          throw err;
        }
        return 1;
      }
      lastMatch = match;

      if (match.type === "begin") {
        return doBeginMatch(match);
      } else if (match.type === "illegal" && !ignoreIllegals) {
        // illegal match, we do not continue processing
        /** @type {AnnotatedError} */
        const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || '<unnamed>') + '"');
        err.mode = top;
        throw err;
      } else if (match.type === "end") {
        const processed = doEndMatch(match);
        if (processed !== NO_MATCH) {
          return processed;
        }
      }

      // edge case for when illegal matches $ (end of line) which is technically
      // a 0 width match but not a begin/end match so it's not caught by the
      // first handler (when ignoreIllegals is true)
      if (match.type === "illegal" && lexeme === "") {
        // advance so we aren't stuck in an infinite loop
        return 1;
      }

      // infinite loops are BAD, this is a last ditch catch all. if we have a
      // decent number of iterations yet our index (cursor position in our
      // parsing) still 3x behind our index then something is very wrong
      // so we bail
      if (iterations > 100000 && iterations > match.index * 3) {
        const err = new Error('potential infinite loop, way more iterations than matches');
        throw err;
      }

      /*
      Why might be find ourselves here?  An potential end match that was
      triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
      (this could be because a callback requests the match be ignored, etc)

      This causes no real harm other than stopping a few times too many.
      */

      modeBuffer += lexeme;
      return lexeme.length;
    }

    const language = getLanguage(languageName);
    if (!language) {
      error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
      throw new Error('Unknown language: "' + languageName + '"');
    }

    const md = compileLanguage(language);
    let result = '';
    /** @type {CompiledMode} */
    let top = continuation || md;
    /** @type Record<string,CompiledMode> */
    const continuations = {}; // keep continuations for sub-languages
    const emitter = new options.__emitter(options);
    processContinuations();
    let modeBuffer = '';
    let relevance = 0;
    let index = 0;
    let iterations = 0;
    let resumeScanAtSamePosition = false;

    try {
      top.matcher.considerAll();

      for (;;) {
        iterations++;
        if (resumeScanAtSamePosition) {
          // only regexes not matched previously will now be
          // considered for a potential match
          resumeScanAtSamePosition = false;
        } else {
          top.matcher.considerAll();
        }
        top.matcher.lastIndex = index;

        const match = top.matcher.exec(codeToHighlight);
        // console.log("match", match[0], match.rule && match.rule.begin)

        if (!match) break;

        const beforeMatch = codeToHighlight.substring(index, match.index);
        const processedCount = processLexeme(beforeMatch, match);
        index = match.index + processedCount;
      }
      processLexeme(codeToHighlight.substr(index));
      emitter.closeAllNodes();
      emitter.finalize();
      result = emitter.toHTML();

      return {
        language: languageName,
        value: result,
        relevance: relevance,
        illegal: false,
        _emitter: emitter,
        _top: top
      };
    } catch (err) {
      if (err.message && err.message.includes('Illegal')) {
        return {
          language: languageName,
          value: escape(codeToHighlight),
          illegal: true,
          relevance: 0,
          _illegalBy: {
            message: err.message,
            index: index,
            context: codeToHighlight.slice(index - 100, index + 100),
            mode: err.mode,
            resultSoFar: result
          },
          _emitter: emitter
        };
      } else if (SAFE_MODE) {
        return {
          language: languageName,
          value: escape(codeToHighlight),
          illegal: false,
          relevance: 0,
          errorRaised: err,
          _emitter: emitter,
          _top: top
        };
      } else {
        throw err;
      }
    }
  }

  /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */
  function justTextHighlightResult(code) {
    const result = {
      value: escape(code),
      illegal: false,
      relevance: 0,
      _top: PLAINTEXT_LANGUAGE,
      _emitter: new options.__emitter(options)
    };
    result._emitter.addText(code);
    return result;
  }

  /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - secondBest (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */
  function highlightAuto(code, languageSubset) {
    languageSubset = languageSubset || options.languages || Object.keys(languages);
    const plaintext = justTextHighlightResult(code);

    const results = languageSubset.filter(getLanguage).filter(autoDetection).map(name =>
      _highlight(name, code, false)
    );
    results.unshift(plaintext); // plaintext is always an option

    const sorted = results.sort((a, b) => {
      // sort base on relevance
      if (a.relevance !== b.relevance) return b.relevance - a.relevance;

      // always award the tie to the base language
      // ie if C++ and Arduino are tied, it's more likely to be C++
      if (a.language && b.language) {
        if (getLanguage(a.language).supersetOf === b.language) {
          return 1;
        } else if (getLanguage(b.language).supersetOf === a.language) {
          return -1;
        }
      }

      // otherwise say they are equal, which has the effect of sorting on
      // relevance while preserving the original ordering - which is how ties
      // have historically been settled, ie the language that comes first always
      // wins in the case of a tie
      return 0;
    });

    const [best, secondBest] = sorted;

    /** @type {AutoHighlightResult} */
    const result = best;
    result.secondBest = secondBest;

    return result;
  }

  /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */
  function updateClassName(element, currentLang, resultLang) {
    const language = (currentLang && aliases[currentLang]) || resultLang;

    element.classList.add("hljs");
    element.classList.add(`language-${language}`);
  }

  /**
   * Applies highlighting to a DOM node containing code.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */
  function highlightElement(element) {
    /** @type HTMLElement */
    let node = null;
    const language = blockLanguage(element);

    if (shouldNotHighlight(language)) return;

    fire("before:highlightElement",
      { el: element, language: language });

    // we should be all text, no child nodes (unescaped HTML) - this is possibly
    // an HTML injection attack - it's likely too late if this is already in
    // production (the code has likely already done its damage by the time
    // we're seeing it)... but we yell loudly about this so that hopefully it's
    // more likely to be caught in development before making it to production
    if (element.children.length > 0) {
      if (!options.ignoreUnescapedHTML) {
        console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
        console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
        console.warn("The element with unescaped HTML:");
        console.warn(element);
      }
      if (options.throwUnescapedHTML) {
        const err = new HTMLInjectionError(
          "One of your code blocks includes unescaped HTML.",
          element.innerHTML
        );
        throw err;
      }
    }

    node = element;
    const text = node.textContent;
    const result = language ? highlight(text, { language, ignoreIllegals: true }) : highlightAuto(text);

    element.innerHTML = result.value;
    updateClassName(element, language, result.language);
    element.result = {
      language: result.language,
      // TODO: remove with version 11.0
      re: result.relevance,
      relevance: result.relevance
    };
    if (result.secondBest) {
      element.secondBest = {
        language: result.secondBest.language,
        relevance: result.secondBest.relevance
      };
    }

    fire("after:highlightElement", { el: element, result, text });
  }

  /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */
  function configure(userOptions) {
    options = inherit(options, userOptions);
  }

  // TODO: remove v12, deprecated
  const initHighlighting = () => {
    highlightAll();
    deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
  };

  // TODO: remove v12, deprecated
  function initHighlightingOnLoad() {
    highlightAll();
    deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
  }

  let wantsHighlight = false;

  /**
   * auto-highlights all pre>code elements on the page
   */
  function highlightAll() {
    // if we are called too early in the loading process
    if (document.readyState === "loading") {
      wantsHighlight = true;
      return;
    }

    const blocks = document.querySelectorAll(options.cssSelector);
    blocks.forEach(highlightElement);
  }

  function boot() {
    // if a highlight was requested before DOM was loaded, do now
    if (wantsHighlight) highlightAll();
  }

  // make sure we are in the browser environment
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('DOMContentLoaded', boot, false);
  }

  /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */
  function registerLanguage(languageName, languageDefinition) {
    let lang = null;
    try {
      lang = languageDefinition(hljs);
    } catch (error$1) {
      error("Language definition for '{}' could not be registered.".replace("{}", languageName));
      // hard or soft error
      if (!SAFE_MODE) { throw error$1; } else { error(error$1); }
      // languages that have serious errors are replaced with essentially a
      // "plaintext" stand-in so that the code blocks will still get normal
      // css classes applied to them - and one bad language won't break the
      // entire highlighter
      lang = PLAINTEXT_LANGUAGE;
    }
    // give it a temporary name if it doesn't have one in the meta-data
    if (!lang.name) lang.name = languageName;
    languages[languageName] = lang;
    lang.rawDefinition = languageDefinition.bind(null, hljs);

    if (lang.aliases) {
      registerAliases(lang.aliases, { languageName });
    }
  }

  /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */
  function unregisterLanguage(languageName) {
    delete languages[languageName];
    for (const alias of Object.keys(aliases)) {
      if (aliases[alias] === languageName) {
        delete aliases[alias];
      }
    }
  }

  /**
   * @returns {string[]} List of language internal names
   */
  function listLanguages() {
    return Object.keys(languages);
  }

  /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */
  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */
  function registerAliases(aliasList, { languageName }) {
    if (typeof aliasList === 'string') {
      aliasList = [aliasList];
    }
    aliasList.forEach(alias => { aliases[alias.toLowerCase()] = languageName; });
  }

  /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */
  function autoDetection(name) {
    const lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */
  function upgradePluginAPI(plugin) {
    // TODO: remove with v12
    if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
      plugin["before:highlightElement"] = (data) => {
        plugin["before:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
    if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
      plugin["after:highlightElement"] = (data) => {
        plugin["after:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
  }

  /**
   * @param {HLJSPlugin} plugin
   */
  function addPlugin(plugin) {
    upgradePluginAPI(plugin);
    plugins.push(plugin);
  }

  /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */
  function fire(event, args) {
    const cb = event;
    plugins.forEach(function(plugin) {
      if (plugin[cb]) {
        plugin[cb](args);
      }
    });
  }

  /**
   * DEPRECATED
   * @param {HighlightedHTMLElement} el
   */
  function deprecateHighlightBlock(el) {
    deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
    deprecated("10.7.0", "Please use highlightElement now.");

    return highlightElement(el);
  }

  /* Interface definition */
  Object.assign(hljs, {
    highlight,
    highlightAuto,
    highlightAll,
    highlightElement,
    // TODO: Remove with v12 API
    highlightBlock: deprecateHighlightBlock,
    configure,
    initHighlighting,
    initHighlightingOnLoad,
    registerLanguage,
    unregisterLanguage,
    listLanguages,
    getLanguage,
    registerAliases,
    autoDetection,
    inherit,
    addPlugin
  });

  hljs.debugMode = function() { SAFE_MODE = false; };
  hljs.safeMode = function() { SAFE_MODE = true; };
  hljs.versionString = version;

  hljs.regex = {
    concat: concat,
    lookahead: lookahead,
    either: either,
    optional: optional,
    anyNumberOfTimes: anyNumberOfTimes
  };

  for (const key in MODES) {
    // @ts-ignore
    if (typeof MODES[key] === "object") {
      // @ts-ignore
      deepFreeze$1(MODES[key]);
    }
  }

  // merge all the modes/regexes into our main object
  Object.assign(hljs, MODES);

  return hljs;
};

// export an "instance" of the highlighter
var highlight = HLJS({});

var core = highlight;
highlight.HighlightJS = highlight;
highlight.default = highlight;

var HighlightJS = core;

/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: http://www.json.org
Category: common, protocols, web
*/

function json(hljs) {
  const ATTRIBUTE = {
    className: 'attr',
    begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
    relevance: 1.01
  };
  const PUNCTUATION = {
    match: /[{}[\],:]/,
    className: "punctuation",
    relevance: 0
  };
  // normally we would rely on `keywords` for this but using a mode here allows us
  // to use the very tight `illegal: \S` rule later to flag any other character
  // as illegal indicating that despite looking like JSON we do not truly have
  // JSON and thus improve false-positively greatly since JSON will try and claim
  // all sorts of JSON looking stuff
  const LITERALS = { beginKeywords: [
    "true",
    "false",
    "null"
  ].join(" ") };

  return {
    name: 'JSON',
    contains: [
      ATTRIBUTE,
      PUNCTUATION,
      hljs.QUOTE_STRING_MODE,
      LITERALS,
      hljs.C_NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ],
    illegal: '\\S'
  };
}

var _excluded$5 = ["className", "readOnly", "value", "placeholder", "loading"];
if (HighlightJS && json) HighlightJS.registerLanguage("json", json);

var JSONInput = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JSONInput, _React$Component);

  var _super = _createSuper$4(JSONInput);

  function JSONInput(props) {
    var _this;

    _classCallCheck$2(this, JSONInput);

    _this = _super.call(this, props);
    _this.highlightEnabled = !!HighlightJS;
    _this.textarea = /*#__PURE__*/React__default.createRef();
    _this.pre = /*#__PURE__*/React__default.createRef();
    _this.state = {
      focused: false
    };
    return _this;
  }

  _createClass$2(JSONInput, [{
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      this.props.onChange && this.props.onChange(createFakeChangeEvent(value));
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var node = e.target,
          cursorStart = node.selectionStart,
          cursorEnd = node.selectionEnd;

      if (e.key == "Enter") {
        e.preventDefault();
        var string = e.target.value.slice(0, cursorStart),
            lines = string.split("\n"),
            lastLine = lines[lines.length - 1],
            indentation = lastLine.match(/^\s*/m)[0],
            insert = "\n".concat(indentation);
        string += insert;
        string += e.target.value.slice(cursorEnd, e.target.value.length);
        e.target.value = string;
        e.target.selectionStart = cursorStart + insert.length;
        e.target.selectionEnd = e.target.selectionStart;
        this.handleChange(e);
        return false;
      } else if (e.key == "Tab") {
        e.preventDefault();

        var _string = e.target.value.slice(0, cursorStart),
            _insert = "  ";

        _string += _insert;
        _string += e.target.value.slice(cursorEnd, e.target.value.length);
        e.target.value = _string;
        e.target.selectionStart = cursorStart + _insert.length;
        e.target.selectionEnd = e.target.selectionStart;
        this.handleChange(e);
        return false;
      } else if (e.key == "\"") {
        var _string2 = e.target.value.slice(0, cursorStart),
            _lines = _string2.split("\n"),
            _lastLine = _lines[_lines.length - 1],
            lastLineEmpty = !_lastLine.match(/\w/),
            nextLine = e.target.value.slice(cursorEnd, e.target.value.length).split("\n")[1],
            nextLineHasProperty = !!nextLine.match(/"/);

        if (!lastLineEmpty) return;
        e.preventDefault();

        var _insert2 = "\"\": null".concat(nextLineHasProperty ? "," : "");

        _string2 += _insert2;
        _string2 += e.target.value.slice(cursorEnd, e.target.value.length);
        e.target.value = _string2;
        e.target.selectionStart = cursorStart + 1;
        e.target.selectionEnd = e.target.selectionStart;
        this.handleChange(e);
        return false;
      }

      return true;
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      if (this.pre && this.pre.current) {
        this.pre.current.scrollTop = e.target.scrollTop;
        this.pre.current.scrollLeft = e.target.scrollLeft;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var valid = false,
          _this$props = this.props,
          className = _this$props.className,
          readOnly = _this$props.readOnly,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          loading = _this$props.loading,
          props = _objectWithoutProperties(_this$props, _excluded$5),
          placeholderShown = !value || value.length == 0;

      try {
        JSON.parse(value);
        valid = true;
      } catch (e) {// pass
      }

      if (typeof value !== "string") return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "json-input " + "".concat(className ? className : "", " ") + "".concat(!valid ? "invalid " : "") + "".concat(this.state.focused ? "focus " : "") + "".concat(props.disabled ? "disabled " : "") + "".concat(loading ? "loading " : "") + "".concat(placeholderShown ? "placeholder-shown " : "") + "".concat(this.highlightEnabled ? "highlight-enabled" : "")
      }, loading && /*#__PURE__*/React__default.createElement("div", {
        className: "loading-overlay"
      }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), /*#__PURE__*/React__default.createElement("pre", {
        ref: this.pre
      }, /*#__PURE__*/React__default.createElement("code", {
        ref: function ref(node) {
          if (node && _this2.highlightEnabled && value && value.length > 0) {
            node.innerHTML = HighlightJS.highlight(value, {
              language: "json"
            }).value;
          }
        }
      }, placeholderShown ? placeholder : value)), /*#__PURE__*/React__default.createElement("textarea", _extends$U({}, props, {
        readOnly: readOnly,
        spellCheck: false,
        ref: this.textarea,
        onChange: this.handleChange.bind(this),
        onKeyDown: this.handleKeyDown.bind(this),
        onScroll: this.handleScroll.bind(this),
        value: value,
        onFocus: function onFocus() {
          return _this2.setState({
            focused: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focused: false
          });
        }
      })));
    }
  }]);

  return JSONInput;
}(React__default.Component);

JSONInput.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};
var JSONInput$1 = JSONInput;

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "modal-body ".concat(className ? className : "")
  }, children);
};

ModalBody.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
var ModalBody$1 = ModalBody;

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$closeButtonProps = _ref.closeButtonProps,
      closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "modal-header ".concat(className ? className : "")
  }, /*#__PURE__*/React__default.createElement("h2", null, children), /*#__PURE__*/React__default.createElement(Button$1, _extends$U({}, closeButtonProps, {
    className: "close-modal ".concat(closeButtonProps.className || "")
  }), /*#__PURE__*/React__default.createElement(ForwardRef$P, null)));
};

ModalHeader.propTypes = {
  className: PropTypes.string,
  closeButtonProps: PropTypes.object,
  children: PropTypes.any
};
var ModalHeader$1 = ModalHeader;

var ModalActions = function ModalActions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "modal-actions"
  }, children);
};

ModalActions.propTypes = {
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;
    React__default.Children.forEach(prop, function (child) {
      if (child.type !== Button$1 && child.type !== PatientButton$1) error = new Error("".concat(componentName, " children should be of type Button"));
    });
    return error;
  }
};
var ModalActions$1 = ModalActions;

var ModalValidationMessage = function ModalValidationMessage(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "modal-validation-message"
  }, children);
};

ModalValidationMessage.propTypes = {
  children: PropTypes.string.isRequired
};
var ModalValidationMessage$1 = ModalValidationMessage;

var KeyboardShortcut = function KeyboardShortcut(props) {
  return /*#__PURE__*/React__default.createElement(QuickAction$1, props);
};

KeyboardShortcut.propTypes = {
  shortcut: PropTypes.string.isRequired
};
var KeyboardShortcut$1 = KeyboardShortcut;

var _excluded$4 = ["children", "closeShortcutLabel", "i18n"];
var tabbable = "a[href], area[href], input:not([disabled]):not([type=\"hidden\"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

var validateModalChildren = function validateModalChildren(props, propName, componentName) {
  var prop = props[propName],
      error = null,
      hasHeader = false;
  React__default.Children.forEach(prop, function (child) {
    if (!child) return;
    if (child.type == ModalHeader$1) hasHeader = true;
    if (![ModalHeader$1, ModalBody$1, ModalActions$1, ModalValidationMessage$1].includes(child.type)) error = new Error("".concat(componentName, " children should be of type ModalHeader, ModalBody, ModalActions, ModalValidationMessage"));
  });
  if (!hasHeader) return new Error("".concat(componentName, " must have ModalHeader child."));
  return error;
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      modalWrapperClassName = _ref.modalWrapperClassName,
      children = _ref.children,
      close = _ref.close;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "modal-wrapper ".concat(modalWrapperClassName ? modalWrapperClassName : "")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "modal-backdrop",
    onClick: close
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "modal ".concat(className ? className : "")
  }, children));
};

Modal.propTypes = {
  className: PropTypes.string,
  modalWrapperClassName: PropTypes.string,
  children: validateModalChildren,
  close: PropTypes.func,
  handleKeyDown: PropTypes.func
};

var ModalProxy = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ModalProxy, _React$Component);

  var _super = _createSuper$4(ModalProxy);

  function ModalProxy(props) {
    var _this;

    _classCallCheck$2(this, ModalProxy);

    _this = _super.call(this, props);
    _this.tabData = [];
    _this.appRoot = document.getElementById("app") || document.getElementById("root");
    _this.modalRoot = document.getElementById("modal-root");

    if (!_this.modalRoot) {
      _this.modalRoot = document.createElement("div");
      _this.modalRoot.id = "modal-root";
      document.body.appendChild(_this.modalRoot);
    }

    return _this;
  }

  _createClass$2(ModalProxy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.appRoot) {
        var tabbableNodes = this.appRoot.querySelectorAll(tabbable);
        this.tabData = Array.from(tabbableNodes).map(function (node) {
          var tabIndex = node.getAttribute("tabindex") || null;
          node.setAttribute("tabindex", -1);
          return {
            node: node,
            tabIndex: tabIndex
          };
        });
        this.appRoot.querySelectorAll(".theme-provider").forEach(function (node) {
          node.style.overflow = "hidden";
        });
      }

      var body = this.modalRoot.querySelector(".modal-body");

      if (body) {
        var firstTabbableInBody = body.querySelector(tabbable);

        if (firstTabbableInBody) {
          firstTabbableInBody.focus();
          return;
        }
      } // this is not the ideal case because the "close" button will almost always be the first tabble node in the modal


      var firstTabbable = this.modalRoot.querySelector(tabbable);

      if (firstTabbable) {
        firstTabbable.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.tabData.forEach(function (_ref2) {
        var node = _ref2.node,
            tabIndex = _ref2.tabIndex;

        if (tabIndex == null) {
          node.removeAttribute("tabindex");
        } else {
          node.setAttribute("tabindex", tabIndex);
        }
      });

      if (this.appRoot) {
        this.appRoot.querySelectorAll(".theme-provider").forEach(function (node) {
          node.style.overflow = "auto";
        });
      }
    }
  }, {
    key: "handleModalClose",
    value: function handleModalClose() {
      var closeBtn = this.modalRoot.querySelector(".modal-header .close-modal");

      if (closeBtn) {
        closeBtn.click();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          closeShortcutLabel = _this$props.closeShortcutLabel,
          i18n = _this$props.i18n,
          props = _objectWithoutProperties(_this$props, _excluded$4);

      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
        useQuickActionsProvider: false,
        theme: this.context
      }, /*#__PURE__*/React__default.createElement(KeyboardShortcut$1, {
        shortcut: "escape",
        handler: this.handleModalClose.bind(this),
        label: closeShortcutLabel || i18n.t("actions.closeModal")
      }), /*#__PURE__*/React__default.createElement(Modal, _extends$U({}, props, {
        close: this.handleModalClose.bind(this)
      }), children)), this.modalRoot);
    }
  }]);

  return ModalProxy;
}(React__default.Component);

_defineProperty$3(ModalProxy, "contextType", ThemeContext);

ModalProxy.propTypes = {
  closeShortcutLabel: PropTypes.string,
  className: PropTypes.string,
  modalWrapperClassName: PropTypes.string,
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  }),
  children: validateModalChildren
};
var Modal$1 = withI18n$1(ModalProxy);

var TableSearch = function TableSearch(props) {
  var i18n = useI18n$1();
  var disabled = props.disabled,
      autofocus = props.autofocus,
      value = props.value,
      _onChange = props.onChange,
      popOverContents = props.popOverContents,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? i18n.t("table.searchPlaceholder") : _props$placeholder;
  var popoverAnchor = useRef();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "table-search"
  }, /*#__PURE__*/React__default.createElement(TextInput$1, {
    className: "jumbo",
    disabled: disabled,
    autoFocus: !!autofocus,
    icon: ForwardRef$d,
    placeholder: placeholder,
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return _onChange && _onChange(e.target.value);
    }
  }), popOverContents && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
    className: "filter-anchor",
    ref: popoverAnchor
  }, /*#__PURE__*/React__default.createElement(ForwardRef$D, null)), /*#__PURE__*/React__default.createElement(PopOver$1, {
    position: "bottom-left",
    className: "table-search--filter-popover",
    wrapperClassName: "table-search--filter-popover-wrapper",
    anchor: popoverAnchor
  }, popOverContents)));
};

TableSearch.propTypes = {
  disabled: PropTypes.bool,
  autofocus: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  popOverContents: PropTypes.any,
  placeholder: PropTypes.string
};
var TableSearch$1 = TableSearch;

var PAGE_SIZES = [25, 50, 100, 200];
var keyValueRegexp = /([^\s]+):([^"\s]+|"[^"]*")/;
var parseSearchString = function parseSearchString(search) {
  var searchKeys = {};
  var segments = search.split(" ");

  for (var i = 0; i < segments.length; i += 1) {
    var segment = segments[i];

    if (keyValueRegexp.test(segment)) {
      segments[i] = null;

      var _segment$match = segment.match(keyValueRegexp),
          _segment$match2 = _slicedToArray$1(_segment$match, 3),
          key = _segment$match2[1],
          value = _segment$match2[2];

      value = value.replace(/"/g, "");
      searchKeys[key] = value.toLowerCase();
    }
  }

  search = segments.filter(function (s) {
    return !!s;
  }).join(" ").toLowerCase();
  return [search, searchKeys];
};

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgArrowLeft = function SvgArrowLeft(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-left",
    ref: ref
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React$1.createElement("path", {
    d: "M19 12H5M12 19l-7-7 7-7"
  })));
};

var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgArrowLeft);

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-right",
    ref: ref
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React$1.createElement("path", {
    d: "M5 12h14M12 5l7 7-7 7"
  })));
};

var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgArrowRight);

var TablePagination = function TablePagination(_ref) {
  var disabled = _ref.disabled,
      page = _ref.page,
      setPage = _ref.setPage,
      maxPage = _ref.maxPage,
      records = _ref.records,
      pageSize = _ref.pageSize,
      setPageSize = _ref.setPageSize,
      _ref$pageSizes = _ref.pageSizes,
      pageSizes = _ref$pageSizes === void 0 ? PAGE_SIZES : _ref$pageSizes;
  var i18n = useI18n$1();
  var start = (page - 1) * pageSize,
      end = start + pageSize;
  if (records > 0) start += 1;
  if (end > records) end = records;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "table-pagination"
  }, setPageSize ? /*#__PURE__*/React__default.createElement("div", {
    className: "page-size"
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    disabled: disabled,
    className: "inline",
    value: pageSize,
    onChange: function onChange(e) {
      return setPageSize(e.target.value);
    }
  }, pageSizes.map(function (pageSizeOption) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: pageSizeOption,
      value: pageSizeOption
    }, pageSizeOption);
  })), /*#__PURE__*/React__default.createElement("span", null, i18n.t("table.perPage"), ".")) : /*#__PURE__*/React__default.createElement("div", {
    className: "page-number"
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("table.pageNofTotal", {
    n: page,
    total: maxPage
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "page-select"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: page == 1 || disabled,
    className: "prev ".concat(!(page == 1 || disabled) ? "primary" : ""),
    onClick: function onClick() {
      return setPage(page - 1);
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$8, null)), /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: page == maxPage || disabled,
    className: "next ".concat(!(page == maxPage || disabled) ? "primary" : ""),
    onClick: function onClick() {
      return setPage(page + 1);
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$7, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "page-span"
  }, i18n.t("table.pageSpan", {
    start: start,
    end: end,
    total: records
  })));
};

TablePagination.propTypes = {
  disabled: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
  maxPage: PropTypes.number,
  records: PropTypes.number,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageSizes: PropTypes.arrayOf(PropTypes.number)
};
var TablePagination$1 = TablePagination;

var SelectManyTable = function SelectManyTable(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      _onChange = props.onChange,
      disabled = props.disabled,
      data = props.data,
      _props$columns = props.columns,
      columnsFromProps = _props$columns === void 0 ? [] : _props$columns,
      _props$getIdentifier = props.getIdentifier,
      getIdentifier = _props$getIdentifier === void 0 ? function (n) {
    return n._.id;
  } : _props$getIdentifier,
      defaultSort = props.defaultSort,
      loading = props.loading,
      pageSize = props.pageSize,
      setPageSize = props.setPageSize,
      _props$pageSizes = props.pageSizes,
      pageSizes = _props$pageSizes === void 0 ? PAGE_SIZES : _props$pageSizes,
      searchPlaceholder = props.searchPlaceholder,
      emptyDataText = props.emptyDataText,
      popOverContents = props.popOverContents;

  if (!columnsFromProps || columnsFromProps.length == 0) {
    console.log("Must provide columns to SelectManyTable");
    return null;
  }

  var columns = [{
    key: "value",
    label: "",
    display: function display(o) {
      return /*#__PURE__*/React__default.createElement(CheckboxInput$1, {
        value: value.includes(getIdentifier(o)),
        onChange: function onChange(e) {
          var newSelected = value.filter(function (s) {
            return s !== getIdentifier(o);
          });

          if (e.target.checked) {
            _onChange(createFakeChangeEvent(newSelected.concat(getIdentifier(o))));
          } else {
            _onChange(createFakeChangeEvent(newSelected));
          }
        }
      });
    },
    sort: function sort(o) {
      return value.includes(getIdentifier(o)) ? "z" : "A";
    },
    search: function search(o) {
      return value.includes(getIdentifier(o)) ? "yes" : "no";
    }
  }].concat(_toConsumableArray(columnsFromProps));

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray$1(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = useState("+".concat(columnsFromProps[0].key)),
      _useState6 = _slicedToArray$1(_useState5, 2),
      sort = _useState6[0],
      setSort = _useState6[1];

  var sortDirection = sort[0];
  var sortKey = sort.slice(1, sort.length);
  useEffect(function () {
    if (defaultSort) {
      setSort(defaultSort);
    }
  }, [defaultSort]);
  var tableData = (data || []).map(function (datum) {
    return columns.reduce(function (c, _ref) {
      var key = _ref.key,
          display = _ref.display,
          sort = _ref.sort,
          search = _ref.search;
      return _objectSpread2(_objectSpread2({}, c), {}, _defineProperty$3({}, key, {
        __display: display(datum),
        __sort: (sort || display)(datum),
        __search: (search || display)(datum)
      }));
    }, {
      __original: datum,
      __id: getIdentifier(datum)
    });
  });

  var _parseSearchString = parseSearchString(search),
      _parseSearchString2 = _slicedToArray$1(_parseSearchString, 2),
      trimmedSearch = _parseSearchString2[0],
      searchKeys = _parseSearchString2[1];

  tableData = tableData.filter(function (datum) {
    for (var key in searchKeys) {
      if (key in datum && !datum[key].__search.toLowerCase().includes(searchKeys[key])) {
        return false;
      }
    }

    return Object.values(datum).map(function (d) {
      return d.__search;
    }).join("|").toLowerCase().includes(trimmedSearch.toLowerCase());
  });
  tableData = tableData.sort(function (datumA, datumB) {
    var _a = datumA[sortKey].__sort,
        _b = datumB[sortKey].__sort;

    if (sortDirection == "+") {
      if (_a > _b) return 1;
      if (_a < _b) return -1;
      return 0;
    } else if (sortDirection == "-") {
      if (_a < _b) return 1;
      if (_a > _b) return -1;
      return 0;
    } else {
      return 0;
    }
  });
  var startingIndex = (page - 1) * pageSize,
      endingIndex = startingIndex + pageSize,
      maxPage = Math.ceil(tableData.length / pageSize) || 1,
      totalRecords = tableData.length;
  tableData = tableData.slice(startingIndex, endingIndex);
  var loading_rows = [];

  if (loading) {
    for (var row = 1; row <= pageSize; row += 1) {
      loading_rows.push(row);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "select-many-table ".concat(disabled ? "disabled" : "")
  }, /*#__PURE__*/React__default.createElement(TableSearch$1, {
    disabled: disabled,
    placeholder: searchPlaceholder,
    value: search,
    onChange: function onChange(v) {
      setSearch(v);
      if (page > 1) setPage(1);
    },
    popOverContents: popOverContents
  }), /*#__PURE__*/React__default.createElement(SortableTable$1, {
    emptyDataText: emptyDataText,
    tableData: tableData,
    columns: columns,
    sort: sort,
    setSort: setSort,
    loading: loading,
    loadingRows: loading_rows
  }), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    disabled: disabled,
    page: page,
    pageSize: pageSize,
    pageSizes: pageSizes,
    setPageSize: setPageSize,
    setPage: setPage,
    maxPage: maxPage,
    records: totalRecords
  }));
};

SelectManyTable.propTypes = {
  value: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    display: PropTypes.func,
    sort: PropTypes.func
  })),
  getIdentifier: PropTypes.func,
  onRowClick: PropTypes.func,
  defaultSort: PropTypes.string,
  loading: PropTypes.bool,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageSizes: PropTypes.arrayOf(PropTypes.number),
  popOverContents: PropTypes.any,
  searchPlaceholder: PropTypes.string,
  emptyDataText: PropTypes.string
};
var SelectManyTable$1 = SelectManyTable;

var _excluded$3 = ["icon", "className", "loading", "disabled", "options", "value", "display", "getIdentifier", "getPath", "onChange", "selectionTableProps", "modalProps"];
var SelectManyInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.icon,
      className = props.className,
      loading = props.loading,
      disabled = props.disabled,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      values = props.value,
      _props$display = props.display,
      display = _props$display === void 0 ? function (o) {
    return o;
  } : _props$display,
      _props$getIdentifier = props.getIdentifier,
      getIdentifier = _props$getIdentifier === void 0 ? function (o) {
    return o;
  } : _props$getIdentifier,
      getPath = props.getPath,
      onChange = props.onChange,
      _props$selectionTable = props.selectionTableProps,
      selectionTableProps = _props$selectionTable === void 0 ? {} : _props$selectionTable,
      _props$modalProps = props.modalProps,
      modalProps = _props$modalProps === void 0 ? {} : _props$modalProps,
      inputProps = _objectWithoutProperties(props, _excluded$3);

  var _useState = useState(inputProps.id || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      newValue = _useState6[0],
      setNewValue = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      modalOpen = _useState8[0],
      setModalOpen = _useState8[1];

  var valueRefs = useRef([]);
  useEffect(function () {
    valueRefs.current = valueRefs.current.slice(0, values.length);
  }, [values]);
  var input = useRef(ref);
  var dirty = values.length > 0;
  var buttonProps = {},
      columns = [];

  if (disabled || loading || modalOpen) {
    inputProps.disabled = true;
    buttonProps.disabled = true;
  }

  if (display) {
    columns.push({
      key: "search",
      label: "Option",
      display: display,
      search: display,
      sort: display
    });
  }

  var remainingOptions = (options || []).filter(function (o) {
    return !values.includes(getIdentifier(o));
  });
  var autocompleteOption = remainingOptions.find(function (o) {
    if (display && newValue.length > 0) {
      var displayResult = display(o);

      if (typeof displayResult == "string" && displayResult.toLowerCase().startsWith(newValue.toLowerCase())) {
        return true;
      }
    }

    return false;
  });
  var tabAutoCompleteValue = null;

  if (autocompleteOption) {
    var displayResult = display(autocompleteOption);
    tabAutoCompleteValue = "".concat(newValue).concat(displayResult.slice(newValue.length, displayResult.length));
  }

  var newValueValid = false;

  if (remainingOptions && remainingOptions.length > 0) {
    if (display && remainingOptions.find(function (o) {
      return display(o).toLowerCase() == newValue.toLowerCase();
    })) newValueValid = true;
  } else {
    newValueValid = true;
    autocompleteOption = newValue;
  }

  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "select-many-input" + (focused ? " focus" : "") + (loading ? " loading" : "") + (dirty ? " dirty" : "") + (disabled ? " disabled" : "") + (values && values.length > 0 ? " dirty" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), Icon && /*#__PURE__*/React__default.createElement(Icon, null), values.map(function (value, index) {
    var correspondingOption = options.find(function (option) {
      if (getIdentifier) return getIdentifier(option) == value;
      return false;
    });
    var TextComponent = "span",
        props = {};

    if (getPath && correspondingOption && !disabled && !loading) {
      TextComponent = "a";
      props.href = getPath(correspondingOption);
      props.target = "_blank";
    }

    return /*#__PURE__*/React__default.createElement("div", {
      key: correspondingOption ? getIdentifier(correspondingOption) : index,
      className: "value-pill"
    }, /*#__PURE__*/React__default.createElement(TextComponent, props, /*#__PURE__*/React__default.createElement("span", null, correspondingOption ? display(correspondingOption) : value)), /*#__PURE__*/React__default.createElement(Button$1, {
      ref: function ref(el) {
        return valueRefs.current[index] = el;
      },
      disabled: disabled || loading,
      onKeyDown: function onKeyDown(e) {
        if (e.key == "Backspace") {
          e.preventDefault();
          e.target.click();
          if (input && input.current) input.current.focus();
          return false;
        } else if (e.key == "ArrowLeft") {
          if (valueRefs && valueRefs.current) {
            var el = valueRefs.current[index - 1];
            if (el) el.focus();
          }
        } else if (e.key == "ArrowRight") {
          if (valueRefs && valueRefs.current) {
            var _el = valueRefs.current[index + 1];

            if (_el) {
              _el.focus();
            } else {
              if (input && input.current) input.current.focus();
            }
          }
        }
      },
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();

        var newValue = _toConsumableArray(values);

        newValue.splice(index, 1);
        onChange(createFakeChangeEvent(newValue));
        return false;
      }
    }, /*#__PURE__*/React__default.createElement(ForwardRef$P, {
      width: "18",
      height: "18"
    })));
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(TextInput$1, _extends$U({}, inputProps, {
    icon: ForwardRef$d,
    id: id,
    ref: input,
    value: newValue,
    onChange: function onChange(e) {
      return setNewValue(e.target.value);
    },
    disabled: disabled || loading,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onEnter: newValueValid ? function () {
      var newValues = [].concat(_toConsumableArray(values), [getIdentifier(autocompleteOption)]);
      setNewValue("");
      onChange(createFakeChangeEvent(newValues));
    } : null,
    onKeyDown: function onKeyDown(e) {
      if (!newValue && e.key == "Backspace" || e.key == "ArrowLeft" && e.target.selectionStart == 0) {
        if (valueRefs && valueRefs.current) {
          var el = valueRefs.current[valueRefs.current.length - 1];
          if (el) el.focus();
        }
      }
    },
    tabAutoCompleteValue: tabAutoCompleteValue
  })), options && options.length > 0 && /*#__PURE__*/React__default.createElement(Button$1, _extends$U({}, buttonProps, {
    onClick: function onClick() {
      return setModalOpen(true);
    }
  }), /*#__PURE__*/React__default.createElement(ForwardRef$A, null))), modalOpen && /*#__PURE__*/React__default.createElement(Modal$1, _extends$U({
    className: "select-many-input-modal" + (modalProps.className ? " ".concat(modalProps.className) : "")
  }, modalProps), /*#__PURE__*/React__default.createElement(ModalHeader$1, {
    closeButtonProps: {
      onClick: function onClick() {
        return setModalOpen(false);
      }
    }
  }), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(SelectManyTable$1, _extends$U({}, selectionTableProps, {
    value: values,
    onChange: onChange,
    disabled: disabled,
    loading: loading,
    data: options,
    onRowClick: function onRowClick(option) {
      return onChange(createFakeChangeEvent(values.concat(getIdentifier(option))));
    },
    getIdentifier: getIdentifier,
    columns: columns
  })))));
});
SelectManyInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  display: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.any).isRequired,
  getIdentifier: PropTypes.func,
  getPath: PropTypes.func,
  onChange: PropTypes.func,
  selectionTableProps: PropTypes.object,
  modalProps: PropTypes.object,
  placeholder: PropTypes.string
};
var SelectManyInput$1 = SelectManyInput;

var PointPillValue = function PointPillValue(_ref) {
  var point_id = _ref.point_id,
      remove = _ref.remove;

  var _useChariotFind = useChariotFind("Equipment", {
    params: {
      'points.id': point_id
    }
  }),
      _useChariotFind2 = _slicedToArray$1(_useChariotFind, 3),
      equipment = _useChariotFind2[0],
      loading = _useChariotFind2[2];

  return /*#__PURE__*/React__default.createElement("div", {
    className: "point-pill-value ".concat(loading ? "loading" : "")
  }, /*#__PURE__*/React__default.createElement("div", null, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "point-name"
  }, /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
    type: "Point",
    id: point_id
  }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "site-name"
  }, equipment && /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
    type: "Site",
    id: equipment._.site_id
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "spacer"
  }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
    className: "equipment-name"
  }, equipment && /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
    type: "Equipment",
    id: equipment._.id
  })))), remove && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: remove
  }, /*#__PURE__*/React__default.createElement(ForwardRef$P, null)));
};

PointPillValue.propTypes = {
  point_id: PropTypes.string.isRequired,
  remove: PropTypes.func
};
var PointPillValue$1 = PointPillValue;

var EquipmentTreeSegment = function EquipmentTreeSegment(_ref) {
  var chariot = _ref.chariot,
      equipment = _ref.equipment,
      selectedPointIds = _ref.selectedPointIds,
      selectPointIds = _ref.selectPointIds,
      onPointToggle = _ref.onPointToggle;
  var i18n = useI18n$1();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      points = _useState4[0],
      setPoints = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      pointsLoaded = _useState6[0],
      setPointsLoaded = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      pointsLoadFailed = _useState8[0],
      setPointsLoadFailed = _useState8[1];

  useEffect(function () {
    var mounted = true;

    if (expanded && !pointsLoaded) {
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _points;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return chariot.Point.list({
                  params: {
                    equipment_id: equipment._.id
                  }
                });

              case 3:
                _points = _context.sent;

                if (mounted) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                setPoints(_points);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setPointsLoadFailed(true);

              case 12:
                setPointsLoaded(true);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }))();
    }

    return function () {
      return mounted = false;
    };
  }, [expanded]);
  var allPointsSelected = points.every(function (_ref3) {
    var _ = _ref3._;
    return selectedPointIds.includes(_.id);
  }),
      recommendedPointsSelected = points.filter(function (_ref4) {
    var _ = _ref4._;
    return _.trend;
  }).every(function (_ref5) {
    var _ = _ref5._;
    return selectedPointIds.includes(_.id);
  });

  var selectAll = function selectAll() {
    return selectPointIds(points.map(function (_ref6) {
      var _ = _ref6._;
      return _.id;
    }));
  };

  var selectRecommended = function selectRecommended() {
    return selectPointIds(points.filter(function (_ref7) {
      var _ = _ref7._;
      return _.trend;
    }).map(function (_ref8) {
      var _ = _ref8._;
      return _.id;
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-tree-segment" + (expanded ? " expanded" : "")
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$D, null), /*#__PURE__*/React__default.createElement("span", null, equipment && equipment.getDisplayName())), expanded && /*#__PURE__*/React__default.createElement("div", {
    className: "point-tree-wrapper"
  }, !pointsLoaded && /*#__PURE__*/React__default.createElement("div", {
    className: "point-tree-segment loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.loading"))), pointsLoaded && pointsLoadFailed && /*#__PURE__*/React__default.createElement("div", {
    className: "point-tree-segment error"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$P, {
    width: "2rem",
    height: "2rem"
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("point.errorLoading"))), pointsLoaded && !pointsLoadFailed && points.length == 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "point-tree-segment empty"
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("point.noneFoundForEquipment"))), pointsLoaded && !pointsLoadFailed && points.length > 0 && /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: recommendedPointsSelected,
    onClick: selectRecommended
  }, i18n.t("point.selectRecommended")), pointsLoaded && !pointsLoadFailed && points.length > 0 && /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: allPointsSelected,
    onClick: selectAll
  }, i18n.t("point.selectAll")), pointsLoaded && points.map(function (point) {
    return /*#__PURE__*/React__default.createElement(InputWrapper$1, {
      key: point._.id,
      className: "point-tree-segment",
      label: point.getDisplayName()
    }, /*#__PURE__*/React__default.createElement(CheckboxInput$1, {
      value: selectedPointIds.includes(point._.id),
      onChange: function onChange() {
        return onPointToggle(point._.id);
      }
    }));
  })));
};

EquipmentTreeSegment.propTypes = {
  chariot: PropTypes.instanceOf(Chariot),
  equipment: PropTypes.instanceOf(Equipment$2),
  selectedPointIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectPointIds: PropTypes.func.isRequired,
  onPointToggle: PropTypes.func.isRequired
};
var EquipmentTreeSegment$1 = withChariot$1(EquipmentTreeSegment);

var SiteTreeSegment = function SiteTreeSegment(_ref) {
  var chariot = _ref.chariot,
      site = _ref.site,
      selectedPointIds = _ref.selectedPointIds,
      selectPointIds = _ref.selectPointIds,
      onPointToggle = _ref.onPointToggle;
  var i18n = useI18n$1();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      equipments = _useState4[0],
      setEquipments = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      equipmentLoaded = _useState6[0],
      setEquipmentLoaded = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      equipmentLoadFailed = _useState8[0],
      setEquipmentLoadFailed = _useState8[1];

  useEffect(function () {
    var mounted = true;

    if (expanded && !equipmentLoaded) {
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var equipment;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return chariot.Equipment.list({
                  params: {
                    site_id: site._.id
                  }
                });

              case 3:
                equipment = _context.sent;

                if (mounted) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                setEquipments(equipment);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setEquipmentLoadFailed(true);

              case 12:
                setEquipmentLoaded(true);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }))();
    }

    return function () {
      return mounted = false;
    };
  }, [expanded]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "site-tree-segment" + (expanded ? " expanded" : "")
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$D, null), /*#__PURE__*/React__default.createElement("span", null, site.getDisplayName()), /*#__PURE__*/React__default.createElement("small", null, site.getDisplayAddress())), expanded && /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-tree-wrapper"
  }, !equipmentLoaded && /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-tree-segment loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("global.loading"))), equipmentLoaded && equipmentLoadFailed && /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-tree-segment error"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$P, {
    width: "2rem",
    height: "2rem"
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.errorLoading"))), equipmentLoaded && !equipmentLoadFailed && equipments.length == 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "equipment-tree-segment empty"
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("equipment.noneFoundForSite"))), equipmentLoaded && !equipmentLoadFailed && equipments.map(function (equipment) {
    return /*#__PURE__*/React__default.createElement(EquipmentTreeSegment$1, {
      key: equipment._.id,
      equipment: equipment,
      selectedPointIds: selectedPointIds,
      selectPointIds: selectPointIds,
      onPointToggle: onPointToggle
    });
  })));
};

SiteTreeSegment.propTypes = {
  chariot: PropTypes.instanceOf(Chariot),
  site: PropTypes.instanceOf(Site),
  selectedPointIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectPointIds: PropTypes.func.isRequired,
  onPointToggle: PropTypes.func.isRequired
};
var SiteTreeSegment$1 = withChariot$1(SiteTreeSegment);

var SelectManyPointsTreeInput = function SelectManyPointsTreeInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  var i18n = useI18n$1();

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      siteFilter = _useState2[0],
      setSiteFilter = _useState2[1];

  var _useChariotList = useChariotList("Site"),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      sites = _useChariotList2[0],
      loading = _useChariotList2[2];

  return /*#__PURE__*/React__default.createElement("div", {
    className: "select-many-points-tree-input" + (loading ? " loading" : "")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "table-search"
  }, /*#__PURE__*/React__default.createElement(TextInput$1, {
    className: "jumbo",
    icon: ForwardRef$d,
    value: siteFilter,
    onChange: function onChange(e) {
      return setSiteFilter(e.target.value);
    },
    placeholder: i18n.t("site.filterSites")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "tree-wrapper"
  }, loading && /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null), !loading && sites.filter(function (site) {
    var nameMatches = site.getDisplayName().toLowerCase().includes(siteFilter.toLowerCase());
    var addressMatches = site.getDisplayAddress().toLowerCase().includes(siteFilter.toLowerCase());
    return nameMatches || addressMatches;
  }).map(function (site) {
    return /*#__PURE__*/React__default.createElement(SiteTreeSegment$1, {
      key: site._.id,
      selectedPointIds: value,
      selectPointIds: function selectPointIds(point_ids) {
        var newValue = _toConsumableArray(value);

        newValue = newValue.filter(function (point_id) {
          return !point_ids.includes(point_id);
        });
        newValue = newValue.concat(point_ids);
        onChange(createFakeChangeEvent(newValue));
      },
      onPointToggle: function onPointToggle(point_id) {
        var newValue = _toConsumableArray(value);

        newValue = newValue.filter(function (pId) {
          return pId !== point_id;
        });

        if (!value.includes(point_id)) {
          newValue.push(point_id);
        }

        onChange(createFakeChangeEvent(newValue));
      },
      site: site
    });
  })));
};

SelectManyPointsTreeInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};
var SelectManyPointsTreeInput$1 = SelectManyPointsTreeInput;

var _excluded$2 = ["icon", "className", "loading", "disabled", "value", "onChange", "modalProps"];

var SelectManyPointsInput = function SelectManyPointsInput(props) {
  var Icon = props.icon,
      className = props.className,
      loading = props.loading,
      disabled = props.disabled,
      values = props.value,
      onChange = props.onChange,
      _props$modalProps = props.modalProps,
      modalProps = _props$modalProps === void 0 ? {} : _props$modalProps,
      inputProps = _objectWithoutProperties(props, _excluded$2);

  var _useState = useState(inputProps.id || generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      modalOpen = _useState4[0],
      setModalOpen = _useState4[1];

  var valueRefs = useRef([]);
  useEffect(function () {
    valueRefs.current = valueRefs.current.slice(0, values.length);
  }, [values]);
  var dirty = values.length > 0;
  var buttonProps = {};

  if (disabled || loading || modalOpen) {
    inputProps.disabled = true;
    buttonProps.disabled = true;
  }

  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "select-many-points-input" + (loading ? " loading" : "") + (dirty ? " dirty" : "") + (disabled ? " disabled" : "") + (values && values.length > 0 ? " dirty" : "") + (className ? " ".concat(className) : "")
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "loading-overlay"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null)), Icon && /*#__PURE__*/React__default.createElement(Icon, null), values.map(function (point_id, index) {
    return /*#__PURE__*/React__default.createElement(PointPillValue$1, {
      key: index,
      point_id: point_id,
      remove: function remove() {
        var newValue = _toConsumableArray(values);

        newValue.splice(index, 1);
        onChange(createFakeChangeEvent(newValue));
      }
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(Button$1, _extends$U({}, buttonProps, {
    onClick: function onClick() {
      return setModalOpen(true);
    }
  }), /*#__PURE__*/React__default.createElement(ForwardRef$A, null))), modalOpen && /*#__PURE__*/React__default.createElement(Modal$1, _extends$U({
    className: "select-many-points-input-modal" + (modalProps.className ? " ".concat(modalProps.className) : "")
  }, modalProps), /*#__PURE__*/React__default.createElement(ModalHeader$1, {
    closeButtonProps: {
      onClick: function onClick() {
        return setModalOpen(false);
      }
    }
  }), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(SelectManyPointsTreeInput$1, {
    value: values,
    onChange: onChange
  }))));
};

SelectManyPointsInput.propTypes = {
  icon: PropTypes.elementType,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func,
  modalProps: PropTypes.object,
  placeholder: PropTypes.string
};
var SelectManyPointsInput$1 = SelectManyPointsInput;

var TODAY = "TODAY";
var PAST_DAY = "PAST_DAY";
var WEEK_AGO_TODAY = "WEEK_AGO_TODAY";
var MONTH_AGO_TODAY = "MONTH_AGO_TODAY";
var YEAR_AGO_TODAY = "YEAR_AGO_TODAY";
var PAST_WEEK = "PAST_WEEK";
var LAST_WEEK = "LAST_WEEK";
var WEEK_TO_DATE = "WEEK_TO_DATE";
var LAST_WEEK_TO_DATE = "LAST_WEEK_TO_DATE";
var PAST_MONTH = "PAST_MONTH";
var LAST_MONTH = "LAST_MONTH";
var MONTH_TO_DATE = "MONTH_TO_DATE";
var LAST_MONTH_TO_DATE = "LAST_MONTH_TO_DATE";
var PAST_YEAR = "PAST_YEAR";
var LAST_YEAR = "LAST_YEAR";
var YEAR_TO_DATE = "YEAR_TO_DATE";
var LAST_YEAR_TO_DATE = "LAST_YEAR_TO_DATE";
var CUSTOM_RANGE = "CUSTOM_RANGE";
var getRangeFromPresetId = function getRangeFromPresetId(presetId) {
  switch (presetId) {
    case TODAY:
      return {
        start: moment().startOf("day").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case PAST_DAY:
      return {
        start: moment().startOf("minute").subtract(1, "day").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case WEEK_AGO_TODAY:
      return {
        start: moment().startOf("day").subtract(7, "days").toDate(),
        end: moment().startOf("minute").subtract(7, "days").toDate()
      };

    case MONTH_AGO_TODAY:
      return {
        start: moment().startOf("day").subtract(1, "month").toDate(),
        end: moment().startOf("minute").subtract(1, "month").toDate()
      };

    case YEAR_AGO_TODAY:
      return {
        start: moment().startOf("day").subtract(1, "year").toDate(),
        end: moment().startOf("minute").subtract(1, "year").toDate()
      };

    case PAST_WEEK:
      return {
        start: moment().startOf("minute").subtract(7, "days").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_WEEK:
      return {
        start: moment().startOf("week").subtract(7, "days").toDate(),
        end: moment().startOf("minute").endOf("week").subtract(7, "days").toDate()
      };

    case WEEK_TO_DATE:
      return {
        start: moment().startOf("week").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_WEEK_TO_DATE:
      return {
        start: moment().startOf("week").subtract(7, "days").toDate(),
        end: moment().startOf("minute").subtract(7, "days").toDate()
      };

    case PAST_MONTH:
      return {
        start: moment().startOf("minute").subtract(1, "month").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_MONTH:
      return {
        start: moment().startOf("month").subtract(1, "month").toDate(),
        end: moment().startOf("minute").subtract(1, "month").endOf("month").toDate()
      };

    case MONTH_TO_DATE:
      return {
        start: moment().startOf("month").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_MONTH_TO_DATE:
      return {
        start: moment().startOf("month").subtract(1, "month").toDate(),
        end: moment().startOf("minute").subtract(1, "month").toDate()
      };

    case PAST_YEAR:
      return {
        start: moment().startOf("minute").subtract(1, "year").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_YEAR:
      return {
        start: moment().startOf("year").subtract(1, "year").toDate(),
        end: moment().endOf("year").subtract(1, "year").endOf("year").toDate()
      };

    case YEAR_TO_DATE:
      return {
        start: moment().startOf("year").toDate(),
        end: moment().startOf("minute").toDate()
      };

    case LAST_YEAR_TO_DATE:
      return {
        start: moment().startOf("year").subtract(1, "year").toDate(),
        end: moment().startOf("minute").subtract(1, "year").toDate()
      };
  }

  return null;
};
var RANGE_PRESETS = [{
  label: i18n.t("charts.rangeToday"),
  value: TODAY
}, {
  label: i18n.t("charts.rangePastDay"),
  value: PAST_DAY
}, {
  label: i18n.t("charts.rangeWeekAgoToday"),
  value: WEEK_AGO_TODAY
}, {
  label: i18n.t("charts.rangeMonthAgoToday"),
  value: MONTH_AGO_TODAY
}, {
  label: i18n.t("charts.rangeYearAgoToday"),
  value: YEAR_AGO_TODAY
}, {
  label: i18n.t("charts.rangePastWeek"),
  value: PAST_WEEK
}, {
  label: i18n.t("charts.rangeLastWeek"),
  value: LAST_WEEK
}, {
  label: i18n.t("charts.rangeWeekToDate"),
  value: WEEK_TO_DATE
}, {
  label: i18n.t("charts.rangeLastWeekToDate"),
  value: LAST_WEEK_TO_DATE
}, {
  label: i18n.t("charts.rangePastMonth"),
  value: PAST_MONTH
}, {
  label: i18n.t("charts.rangeLastMonth"),
  value: LAST_MONTH
}, {
  label: i18n.t("charts.rangeMonthToDate"),
  value: MONTH_TO_DATE
}, {
  label: i18n.t("charts.rangeLastMonthToDate"),
  value: LAST_MONTH_TO_DATE
}, {
  label: i18n.t("charts.rangePastYear"),
  value: PAST_YEAR
}, {
  label: i18n.t("charts.rangeLastYear"),
  value: LAST_YEAR
}, {
  label: i18n.t("charts.rangeYearToDate"),
  value: YEAR_TO_DATE
}, {
  label: i18n.t("charts.rangeLastYearToDate"),
  value: LAST_YEAR_TO_DATE
}, {
  label: i18n.t("charts.rangeCustom"),
  value: CUSTOM_RANGE
}];
var RANGE_PRESET_IDS = [TODAY, PAST_DAY, WEEK_AGO_TODAY, MONTH_AGO_TODAY, YEAR_AGO_TODAY, PAST_WEEK, LAST_WEEK, WEEK_TO_DATE, LAST_WEEK_TO_DATE, PAST_MONTH, LAST_MONTH, MONTH_TO_DATE, LAST_MONTH_TO_DATE, PAST_YEAR, LAST_YEAR, YEAR_TO_DATE, LAST_YEAR_TO_DATE, CUSTOM_RANGE];
var getCompatibleRangePresets = function getCompatibleRangePresets(rangeMs) {
  if (!rangeMs) return RANGE_PRESETS;
  return RANGE_PRESETS.filter(function (_ref) {
    var rangePresetId = _ref.value;
    if (rangePresetId == CUSTOM_RANGE) return true;

    var _getRangeFromPresetId = getRangeFromPresetId(rangePresetId),
        rangeStart = _getRangeFromPresetId.start,
        rangeEnd = _getRangeFromPresetId.end;

    var rangeRange = +rangeEnd - +rangeStart;
    return rangeRange == rangeMs;
  });
};
var getResolutionOptionsFromPresetId = function getResolutionOptionsFromPresetId(rangePresetId) {
  switch (rangePresetId) {
    case TODAY:
    case PAST_DAY:
    case WEEK_AGO_TODAY:
    case MONTH_AGO_TODAY:
    case YEAR_AGO_TODAY:
      return SUB_DAY_RESOLUTIONS;

    case PAST_WEEK:
    case LAST_WEEK:
    case WEEK_TO_DATE:
    case LAST_WEEK_TO_DATE:
      return [].concat(_toConsumableArray(SUB_DAY_RESOLUTIONS), _toConsumableArray(SUB_WEEK_RESOLUTIONS));

    case PAST_MONTH:
    case LAST_MONTH:
    case MONTH_TO_DATE:
    case LAST_MONTH_TO_DATE:
      return [].concat(_toConsumableArray(SUB_WEEK_RESOLUTIONS), _toConsumableArray(SUB_MONTH_RESOLUTIONS));

    case PAST_YEAR:
    case LAST_YEAR:
    case YEAR_TO_DATE:
    case LAST_YEAR_TO_DATE:
      return [].concat(_toConsumableArray(SUB_WEEK_RESOLUTIONS), _toConsumableArray(SUB_MONTH_RESOLUTIONS), _toConsumableArray(SUB_YEAR_RESOLUTIONS));

    default:
      return RESOLUTIONS;
  }
};

var filterOptionsResults = function filterOptionsResults(resolution, results) {
  return results.filter(function (_ref2) {
    var label = _ref2.label;
    var count = parseInt(label);
    var unit = label.includes("H") ? 3600000 : label.includes("D") ? 86400000 : label.includes("Mo") ? 2592000000 : 0;
    return count * unit >= RESOLUTION_MS_MAP[resolution];
  });
};

var getBarCountOptionsFromPresetId = function getBarCountOptionsFromPresetId(rangePresetId, resolution) {
  switch (rangePresetId) {
    case PAST_DAY:
      return filterOptionsResults(resolution, [{
        label: "1H",
        value: 24
      }, {
        label: "2H",
        value: 12
      }, {
        label: "6H",
        value: 4
      }]);

    case PAST_WEEK:
    case LAST_WEEK:
      return filterOptionsResults(resolution, [{
        label: "12H",
        value: 14
      }, {
        label: "1D",
        value: 7
      }]);

    case PAST_MONTH:
    case LAST_MONTH:
      return filterOptionsResults(resolution, [{
        label: "1D",
        value: 30
      }, {
        label: "5D",
        value: 6
      }]);

    case PAST_YEAR:
    case LAST_YEAR:
      return filterOptionsResults(resolution, [{
        label: "15D",
        value: 24
      }, {
        label: "1M",
        value: 12
      }]);

    default:
      return [];
  }
};
var getTileCountOptionsFromPresetId = function getTileCountOptionsFromPresetId(rangePresetId, resolution) {
  switch (rangePresetId) {
    case PAST_DAY:
      return filterOptionsResults(resolution, [{
        label: "15M",
        value: 96
      }, {
        label: "30M",
        value: 48
      }, {
        label: "1H",
        value: 24
      }, {
        label: "2H",
        value: 12
      }, {
        label: "6H",
        value: 4
      }]);

    case PAST_WEEK:
    case LAST_WEEK:
      return filterOptionsResults(resolution, [{
        label: "1H",
        value: 168
      }, {
        label: "2H",
        value: 84
      }, {
        label: "6H",
        value: 28
      }, {
        label: "12H",
        value: 14
      }, {
        label: "1D",
        value: 7
      }]);

    case PAST_MONTH:
    case LAST_MONTH:
      return filterOptionsResults(resolution, [{
        label: "6H",
        value: 120
      }, {
        label: "12H",
        value: 60
      }, {
        label: "1D",
        value: 30
      }, {
        label: "5D",
        value: 6
      }]);

    case PAST_YEAR:
    case LAST_YEAR:
      return filterOptionsResults(resolution, [{
        label: "1D",
        value: 365
      }, {
        label: "15D",
        value: 24
      }, {
        label: "1Mo",
        value: 12
      }]);

    default:
      return [];
  }
};

var dataSourceConfigPropType = {
  color: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["weather", "point"]).isRequired,
  dashed: PropTypes.bool,
  start_date: PropTypes.instanceOf(Date),
  range_preset: PropTypes.oneOf(RANGE_PRESET_IDS),
  yAxis: PropTypes.bool,
  xAxis: PropTypes.bool,
  tooltips: PropTypes.bool,
  weather_key: PropTypes.oneOf(["temperature", "humidity"]),
  site_id: PropTypes.string,
  point_id: PropTypes.string,
  resolution: PropTypes.oneOf(RESOLUTIONS),
  point_chart_type: PropTypes.oneOf(["line", "gradientPolygon", "bar", "heatmap"]),
  point_value_condition: PropTypes.shape({
    type: PropTypes.oneOf(["equal_to", "more_than", "less_than"]),
    compare: PropTypes.any
  }),
  value_lower_bound: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value_upper_bound: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value_lower_bound_color: PropTypes.string
};
var ChartConfigPropType = {
  start_date: PropTypes.instanceOf(Date),
  end_date: PropTypes.instanceOf(Date),
  range_preset: PropTypes.oneOf(RANGE_PRESET_IDS),
  resolution: PropTypes.oneOf(RESOLUTIONS),
  stack_bars: PropTypes.bool,
  bar_count: PropTypes.number,
  tile_count: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape(dataSourceConfigPropType))
};

var _excluded$1 = ["type", "color", "dashed", "start_date", "range_preset", "tooltips", "xAxis", "yAxis", "site_id", "point_id"];

var ChartBuilder = function ChartBuilder(props) {
  var i18n = useI18n$1();
  var useCanvas = props.useCanvas,
      range_preset = props.range_preset,
      start_date_from_props = props.start_date,
      end_date_from_props = props.end_date,
      defaultResolution = props.resolution,
      stack_bars = props.stack_bars,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      _props$bar_count = props.bar_count,
      bar_count = _props$bar_count === void 0 ? 12 : _props$bar_count,
      _props$tile_count = props.tile_count,
      tile_count = _props$tile_count === void 0 ? 12 : _props$tile_count,
      edit_path = props.edit_path;
  var start_date = start_date_from_props,
      end_date = end_date_from_props;

  try {
    if (range_preset && range_preset !== CUSTOM_RANGE) {
      var range = getRangeFromPresetId(range_preset);
      if (!range) throw new Error(i18n.t("charts.chartInvalidBecauseReason", {
        reason: i18n.t("charts.invalidRangeValue")
      }));
      start_date = range.start;
      end_date = range.end;
    }

    if (!start_date || start_date == "Invalid Date") {
      throw new Error(i18n.t("charts.chartInvalidBecauseReason", {
        reason: i18n.t("charts.startDateInvalidReason")
      }));
    }

    if (!end_date || end_date == "Invalid Date") {
      throw new Error(i18n.t("charts.chartInvalidBecauseReason", {
        reason: i18n.t("charts.endDateInvalidReason")
      }));
    }

    if (+start_date >= +end_date) {
      throw new Error(i18n.t("charts.chartInvalidBecauseReason", {
        reason: i18n.t("charts.startDateTooLateReason")
      }));
    }

    if (+end_date > +start_date + 86400000 * 730) {
      throw new Error(i18n.t("charts.chartInvalidBecauseReason", {
        reason: i18n.t("charts.endDateTooLateReason")
      }));
    }

    if (data.length > 0 && data.every(function (_ref) {
      var point_id = _ref.point_id,
          site_id = _ref.site_id;
      return !point_id && !site_id;
    })) {
      if (data[0].type == "weather") {
        throw new Error(i18n.t("charts.selectSiteToShowData"));
      } else if (data[0].type == "point") {
        throw new Error(i18n.t("charts.selectPointToShowData"));
      }
    }
  } catch (e) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "chart-builder error"
    }, edit_path ? /*#__PURE__*/React__default.createElement(Link, {
      className: "edit-link",
      to: edit_path
    }, /*#__PURE__*/React__default.createElement(AppError$1, null, /*#__PURE__*/React__default.createElement("span", null, e.message), /*#__PURE__*/React__default.createElement("small", null, i18n.t("charts.editChart")))) : /*#__PURE__*/React__default.createElement(AppError$1, null, e.message));
  }

  var barConfig = {};
  if (bar_count) barConfig.count = bar_count;
  if (stack_bars) barConfig.stacked = true;
  var heatMapConfig = {};
  if (tile_count) heatMapConfig.count = tile_count;
  if (data.length == 0) return /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder empty"
  }, edit_path ? /*#__PURE__*/React__default.createElement(Link, {
    className: "edit-link",
    to: edit_path
  }, /*#__PURE__*/React__default.createElement(AppWarning$1, null, /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.addDataToRenderChart")), /*#__PURE__*/React__default.createElement("small", null, i18n.t("charts.editChart")))) : /*#__PURE__*/React__default.createElement(AppWarning$1, null, i18n.t("charts.addDataToRenderChart")));
  return /*#__PURE__*/React__default.createElement(Chart$1, {
    key: useCanvas ? JSON.stringify(data) : undefined,
    className: "chart-builder",
    barConfig: barConfig,
    heatMapConfig: heatMapConfig,
    useCanvas: useCanvas
  }, data.map(function (_ref2, datumIndex) {
    var type = _ref2.type,
        color = _ref2.color,
        dashed = _ref2.dashed,
        datum_start_date = _ref2.start_date,
        datum_range_preset = _ref2.range_preset,
        tooltips = _ref2.tooltips,
        xAxis = _ref2.xAxis,
        yAxis = _ref2.yAxis,
        site_id = _ref2.site_id,
        point_id = _ref2.point_id,
        datum = _objectWithoutProperties(_ref2, _excluded$1);

    if (!point_id && !site_id) return null;
    datum_start_date = datum_start_date || start_date;
    var datum_end_date = new Date(+datum_start_date + (+end_date - +start_date));

    if (datum_range_preset && datum_range_preset !== CUSTOM_RANGE) {
      var _range = getRangeFromPresetId(datum_range_preset);

      if (_range) {
        datum_start_date = _range.start;
        datum_end_date = _range.end;
      }
    }

    var dateFormat = function dateFormat(date) {
      return moment(date).format("h a");
    };

    if (+end_date > +start_date + 86400000) {
      dateFormat = function dateFormat(date) {
        return moment(date).format("MM/DD h a");
      };
    }

    if (type == "weather") {
      var weather_key = datum.weather_key;
      return /*#__PURE__*/React__default.createElement(WeatherChartDataSource$1, {
        key: datumIndex,
        start: datum_start_date,
        end: datum_end_date,
        dataKey: weather_key,
        site_id: site_id
      }, xAxis && /*#__PURE__*/React__default.createElement(XAxis$1, {
        dateFormat: dateFormat,
        maxDateTicks: 8,
        gridStroke: "none"
      }), yAxis && /*#__PURE__*/React__default.createElement(YAxis$1, {
        gridStroke: "none"
      }), /*#__PURE__*/React__default.createElement(Line$1, {
        tooltips: tooltips,
        stroke: color,
        strokeDasharray: dashed ? "4 2" : null
      }));
    } else if (type == "point") {
      var _datum$resolution = datum.resolution,
          resolution = _datum$resolution === void 0 ? defaultResolution : _datum$resolution,
          point_value_condition = datum.point_value_condition,
          point_chart_type = datum.point_chart_type,
          value_lower_bound = datum.value_lower_bound,
          value_upper_bound = datum.value_upper_bound,
          value_lower_bound_color = datum.value_lower_bound_color;

      var compareValue = function compareValue(value) {
        if (!point_value_condition) return value > 0;
        var type = point_value_condition.type,
            compare = point_value_condition.compare;
        if (type == "equal_to") return "".concat(value).toLowerCase() == "".concat(compare).toLowerCase();
        if (type == "more_than") return parseFloat(value) > compare;
        if (type == "less_than") return parseFloat(value) < compare;
        return false;
      };

      return /*#__PURE__*/React__default.createElement(PointSnapshotChartDataSource$1, {
        key: datumIndex,
        start: datum_start_date,
        end: datum_end_date,
        resolution: resolution,
        point_id: point_id
      }, xAxis && /*#__PURE__*/React__default.createElement(XAxis$1, {
        dateFormat: dateFormat,
        maxDateTicks: 8,
        gridStroke: "none"
      }), yAxis && /*#__PURE__*/React__default.createElement(YAxis$1, {
        gridStroke: "none"
      }), point_chart_type == "line" ? /*#__PURE__*/React__default.createElement(Line$1, {
        key: datumIndex,
        tooltips: tooltips,
        stroke: color,
        strokeDasharray: dashed ? "4 2" : null
      }) : point_chart_type == "gradientPolygon" ? /*#__PURE__*/React__default.createElement(GradientPolygon, {
        key: datumIndex,
        tooltips: tooltips,
        gradientStart: color,
        gradientEnd: color
      }) : point_chart_type == "heatmap" ? /*#__PURE__*/React__default.createElement(HeatMap, {
        key: datumIndex,
        tooltips: tooltips,
        lowerBound: value_lower_bound,
        lowerFill: value_lower_bound_color,
        upperBound: value_upper_bound,
        upperFill: color
      }) : point_chart_type == "bar" ? /*#__PURE__*/React__default.createElement(Bar$1, {
        key: datumIndex,
        noUnfilled: true,
        tooltips: tooltips,
        filledColor: color,
        includeDatumInBar: compareValue
      }) : null);
    }
  }));
};

ChartBuilder.propTypes = _objectSpread2(_objectSpread2({}, ChartConfigPropType), {}, {
  edit_path: PropTypes.string,
  useCanvas: PropTypes.bool
});
var ChartBuilder$1 = ChartBuilder;

var _circle, _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgSettings = function SvgSettings(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-settings",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  })), _path$6 || (_path$6 = /*#__PURE__*/React$1.createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  })));
};

var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgSettings);

var _path$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgEdit2 = function SvgEdit2(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-edit-2",
    ref: ref
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React$1.createElement("path", {
    d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
  })));
};

var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgEdit2);

var SelectionTable = function SelectionTable(props) {
  var disabled = props.disabled,
      data = props.data,
      columns = props.columns,
      _props$getIdentifier = props.getIdentifier,
      getIdentifier = _props$getIdentifier === void 0 ? function (n) {
    return n._.id;
  } : _props$getIdentifier,
      onRowClick = props.onRowClick,
      defaultSort = props.defaultSort,
      loading = props.loading,
      pageSize = props.pageSize,
      setPageSize = props.setPageSize,
      _props$pageSizes = props.pageSizes,
      pageSizes = _props$pageSizes === void 0 ? PAGE_SIZES : _props$pageSizes,
      searchPlaceholder = props.searchPlaceholder,
      emptyDataText = props.emptyDataText,
      popOverContents = props.popOverContents;

  if (!columns || columns.length == 0) {
    console.log("Must provide columns to SelectionTable");
    return null;
  }

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray$1(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = useState("+".concat(columns[0].key)),
      _useState6 = _slicedToArray$1(_useState5, 2),
      sort = _useState6[0],
      setSort = _useState6[1];

  var sortDirection = sort[0];
  var sortKey = sort.slice(1, sort.length);
  useEffect(function () {
    if (defaultSort) {
      setSort(defaultSort);
    }
  }, [defaultSort]);
  var tableData = (data || []).map(function (datum) {
    return columns.reduce(function (c, _ref) {
      var key = _ref.key,
          display = _ref.display,
          sort = _ref.sort,
          search = _ref.search;
      return _objectSpread2(_objectSpread2({}, c), {}, _defineProperty$3({}, key, {
        __display: display(datum),
        __sort: (sort || display)(datum),
        __search: (search || display)(datum)
      }));
    }, {
      __original: datum,
      __id: getIdentifier(datum)
    });
  });

  var _parseSearchString = parseSearchString(search),
      _parseSearchString2 = _slicedToArray$1(_parseSearchString, 2),
      trimmedSearch = _parseSearchString2[0],
      searchKeys = _parseSearchString2[1];

  tableData = tableData.filter(function (datum) {
    for (var key in searchKeys) {
      if (key in datum && !datum[key].__search.toLowerCase().includes(searchKeys[key])) {
        return false;
      }
    }

    return Object.values(datum).map(function (d) {
      return d.__search;
    }).join("|").toLowerCase().includes(trimmedSearch.toLowerCase());
  });
  tableData = tableData.sort(function (datumA, datumB) {
    var _a = datumA[sortKey].__sort,
        _b = datumB[sortKey].__sort;

    if (sortDirection == "+") {
      if (_a > _b) return 1;
      if (_a < _b) return -1;
      return 0;
    } else if (sortDirection == "-") {
      if (_a < _b) return 1;
      if (_a > _b) return -1;
      return 0;
    } else {
      return 0;
    }
  });
  var startingIndex = (page - 1) * pageSize,
      endingIndex = startingIndex + pageSize,
      maxPage = Math.ceil(tableData.length / pageSize) || 1,
      totalRecords = tableData.length;
  tableData = tableData.slice(startingIndex, endingIndex);
  var loading_rows = [];

  if (loading) {
    for (var row = 1; row <= pageSize; row += 1) {
      loading_rows.push(row);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "selection-table ".concat(disabled ? "disabled" : "")
  }, /*#__PURE__*/React__default.createElement(TableSearch$1, {
    disabled: disabled,
    placeholder: searchPlaceholder,
    value: search,
    onChange: function onChange(v) {
      setSearch(v);
      if (page > 1) setPage(1);
    },
    popOverContents: popOverContents
  }), /*#__PURE__*/React__default.createElement(SortableTable$1, {
    emptyDataText: emptyDataText,
    tableData: tableData,
    columns: columns,
    sort: sort,
    setSort: setSort,
    rowProps: disabled ? undefined : function (row) {
      return {
        onClick: onRowClick ? onRowClick.bind(null, row.__original) : null,
        tabIndex: 0,
        onKeyPress: function onKeyPress(e) {
          return e.key == "Enter" && onRowClick ? onRowClick(row.__original) : null;
        }
      };
    },
    loading: loading,
    loadingRows: loading_rows
  }), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    disabled: disabled,
    page: page,
    pageSize: pageSize,
    pageSizes: pageSizes,
    setPageSize: setPageSize,
    setPage: setPage,
    maxPage: maxPage,
    records: totalRecords
  }));
};

SelectionTable.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    display: PropTypes.func,
    sort: PropTypes.func
  })),
  getIdentifier: PropTypes.func,
  onRowClick: PropTypes.func,
  defaultSort: PropTypes.string,
  loading: PropTypes.bool,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageSizes: PropTypes.arrayOf(PropTypes.number),
  popOverContents: PropTypes.any,
  searchPlaceholder: PropTypes.string,
  emptyDataText: PropTypes.string
};
var SelectionTable$1 = SelectionTable;

var SiteSelectorModal = function SiteSelectorModal(props) {
  var i18n = useI18n$1();
  var onSelect = props.onSelect,
      close = props.close;

  var _useChariotList = useChariotList("Site"),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      sites = _useChariotList2[0],
      error = _useChariotList2[1],
      loading = _useChariotList2[2];

  return /*#__PURE__*/React__default.createElement(Modal$1, {
    className: "point-selector-modal"
  }, /*#__PURE__*/React__default.createElement(ModalHeader$1, {
    closeButtonProps: {
      onClick: close
    }
  }, i18n.t("charts.selectResourceHeader", {
    resource: "Site"
  })), /*#__PURE__*/React__default.createElement(ModalBody$1, null, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), /*#__PURE__*/React__default.createElement(SelectionTable$1, {
    data: sites,
    columns: [{
      key: "name",
      label: i18n.t("charts.siteNameLabel"),
      display: function display(site) {
        return site.getDisplayName();
      }
    }, {
      key: "address",
      label: i18n.t("charts.siteAddressLabel"),
      display: function display(site) {
        return site.getDisplayAddress();
      }
    }],
    getIdentifier: function getIdentifier(site) {
      return site._.id;
    },
    onRowClick: onSelect,
    defaultSort: "+name",
    loading: loading,
    pageSize: 10
  })));
};

SiteSelectorModal.propTypes = {
  onSelect: PropTypes.func,
  close: PropTypes.func
};
var SiteSelectorModal$1 = SiteSelectorModal;

var SiteSelectorInput = function SiteSelectorInput(props) {
  var i18n = useI18n$1();
  var value = props.value,
      label = props.label,
      onChange = props.onChange,
      className = props.className;

  var _useChariotGet = useChariotGet("Site", value),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      site = _useChariotGet2[0],
      loading = _useChariotGet2[2];

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return setModalOpen(true);
    },
    className: "chart-data-selector-input ".concat(className ? "".concat(className) : "", " ").concat(!value ? "empty" : "")
  }, /*#__PURE__*/React__default.createElement("span", null, site ? site.getDisplayName() : loading && value ? i18n.t("global.loading") : value ? value : i18n.t("charts.siteSelectorEmpty"), value && /*#__PURE__*/React__default.createElement(ForwardRef$5, null)), label && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("small", null, label))), modalOpen && (!loading || !value) && /*#__PURE__*/React__default.createElement(SiteSelectorModal$1, {
    close: function close() {
      return setModalOpen(false);
    },
    onSelect: function onSelect(site) {
      onChange && onChange(createFakeChangeEvent(site._.id));
      setModalOpen(false);
    }
  }));
};

SiteSelectorInput.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string
};
var SiteSelectorInput$1 = SiteSelectorInput;

var PointSelectorModal = function PointSelectorModal(props) {
  var i18n = useI18n$1();
  var chariot = useChariot();
  var equipmentIdFromProps = props.equipmentId,
      siteIdFromProps = props.defaultSiteId,
      onSelect = props.onSelect,
      close = props.close;
  var SITE_COLUMNS = [{
    key: "name",
    label: i18n.t("charts.siteNameLabel"),
    display: function display(site) {
      return site.getDisplayName();
    }
  }, {
    key: "address",
    label: i18n.t("charts.siteAddressLabel"),
    display: function display(site) {
      return site.getDisplayAddress();
    }
  }];

  var SITE_ROW_CLICK = function SITE_ROW_CLICK(site) {
    setDisplayParams({
      site_id: site._.id
    });
    setDisplayResource("Equipment");
    setBackLabel(site.getDisplayName());
    setBackFn(function () {
      return function () {
        setBackFn(null);
        setBackLabel(null);
        setDisplayResource("Site");
        setDisplayParams(null);
      };
    });
  };

  var EQUIPMENT_COLUMNS = [{
    key: "name",
    label: i18n.t("charts.equipmentNameLabel"),
    display: function display(equipment) {
      return equipment.getDisplayName();
    }
  }, {
    key: "type",
    label: i18n.t("charts.equipmentTypeLabel"),
    display: function display(equipment) {
      var _equipment$type;

      return equipment === null || equipment === void 0 ? void 0 : (_equipment$type = equipment.type) === null || _equipment$type === void 0 ? void 0 : _equipment$type.name;
    }
  }];

  var EQUIPMENT_ROW_CLICK = function EQUIPMENT_ROW_CLICK(equipment) {
    setBackLabel(equipment.getDisplayName());
    setBackFn(function () {
      return function () {
        setBackFn(function () {
          return backFn;
        });
        setBackLabel(backLabel);
        setDisplayResource("Equipment");
        setDisplayParams({
          site_id: equipment._.site_id
        });
      };
    });
    setDisplayParams({
      equipment_id: equipment._.id
    });
    setDisplayResource("Point");
  };

  var POINT_COLUMNS = [{
    key: "name",
    label: i18n.t("charts.pointNameLabel"),
    display: function display(point) {
      return point.getDisplayName();
    }
  }, {
    key: "trend",
    label: i18n.t("charts.pointTrendLabel"),
    display: function display(point) {
      return point._.trend ? i18n.t("charts.pointTrendTrue") : i18n.t("charts.pointTrendFalse");
    },
    sort: function sort(point) {
      return point._.trend ? 1 : 0;
    }
  }];
  var POINT_ROW_CLICK = onSelect;
  var defaultDisplayResource = "Site",
      defaultDisplayParams = {},
      defaultTableColumns = SITE_COLUMNS,
      defaultRowClickFn = SITE_ROW_CLICK;

  if (siteIdFromProps) {
    defaultDisplayResource = "Equipment";
    defaultDisplayParams = {
      site_id: siteIdFromProps
    };
    defaultTableColumns = EQUIPMENT_COLUMNS;
    defaultRowClickFn = EQUIPMENT_ROW_CLICK;
  }

  if (equipmentIdFromProps) {
    defaultDisplayResource = "Point";
    defaultDisplayParams = {
      equipment_id: equipmentIdFromProps
    };
    defaultTableColumns = POINT_COLUMNS;
    defaultRowClickFn = POINT_ROW_CLICK;
  }

  var _useState = useState(defaultDisplayResource),
      _useState2 = _slicedToArray$1(_useState, 2),
      displayResource = _useState2[0],
      setDisplayResource = _useState2[1];

  var _useState3 = useState(defaultDisplayParams),
      _useState4 = _slicedToArray$1(_useState3, 2),
      displayParams = _useState4[0],
      setDisplayParams = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      tableLoading = _useState6[0],
      setTableLoading = _useState6[1];

  var _useState7 = useState(defaultTableColumns),
      _useState8 = _slicedToArray$1(_useState7, 2),
      tableColumns = _useState8[0],
      setTableColumns = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray$1(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var _useState11 = useState(function () {
    return defaultRowClickFn;
  }),
      _useState12 = _slicedToArray$1(_useState11, 2),
      rowClickFn = _useState12[0],
      setRowClickFn = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray$1(_useState13, 2),
      backLabel = _useState14[0],
      setBackLabel = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray$1(_useState15, 2),
      backFn = _useState16[0],
      setBackFn = _useState16[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var resource, data, newTableColumns, newBackLabel, newBackFn, newRowClickFn, site, equipment;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resource = chariot[displayResource];
              setTableLoading(true);

              if (resource) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return resource.list({
                params: _objectSpread2({}, displayParams)
              });

            case 6:
              data = _context.sent;

              if (mounted) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              newTableColumns = SITE_COLUMNS, newBackLabel = null, newBackFn = null, newRowClickFn = SITE_ROW_CLICK;

              if (!(displayResource == "Equipment")) {
                _context.next = 20;
                break;
              }

              _context.next = 13;
              return chariot.Site.get(displayParams.site_id);

            case 13:
              site = _context.sent;

              if (mounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              newTableColumns = EQUIPMENT_COLUMNS;
              newBackLabel = site.getDisplayName();

              newBackFn = function newBackFn() {
                setBackFn(null);
                setBackLabel(null);
                setDisplayResource("Site");
                setDisplayParams(null);
              };

              newRowClickFn = EQUIPMENT_ROW_CLICK;

            case 20:
              if (!(displayResource == "Point")) {
                _context.next = 31;
                break;
              }

              if (!displayParams.equipment_id) {
                _context.next = 29;
                break;
              }

              _context.next = 24;
              return chariot.Equipment.get(displayParams.equipment_id);

            case 24:
              equipment = _context.sent;

              if (mounted) {
                _context.next = 27;
                break;
              }

              return _context.abrupt("return");

            case 27:
              newBackLabel = equipment.getDisplayName();

              newBackFn = function newBackFn() {
                setBackFn(null);
                setBackLabel(null);
                setDisplayParams({
                  site_id: equipment._.site_id
                });
                setDisplayResource("Equipment");
              };

            case 29:
              newTableColumns = POINT_COLUMNS;
              newRowClickFn = POINT_ROW_CLICK;

            case 31:
              setTableColumns(newTableColumns);
              setBackLabel(newBackLabel);
              setBackFn(function () {
                return newBackFn;
              });
              setRowClickFn(function () {
                return newRowClickFn;
              });
              setTableData(data);
              setTableLoading(false);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      return mounted = false;
    };
  }, [displayResource, displayParams]);
  return /*#__PURE__*/React__default.createElement(Modal$1, {
    className: "point-selector-modal"
  }, /*#__PURE__*/React__default.createElement(ModalHeader$1, {
    closeButtonProps: {
      onClick: close
    }
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.selectResourceHeader", {
    resource: displayResource
  })), backFn && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "back-button primary",
    onClick: backFn
  }, /*#__PURE__*/React__default.createElement(ForwardRef$8, null), " ", backLabel)), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(SelectionTable$1, {
    key: displayResource,
    data: tableData,
    columns: tableLoading ? [SITE_COLUMNS[0]] : tableColumns,
    getIdentifier: function getIdentifier(d) {
      return d._.id;
    },
    onRowClick: rowClickFn,
    defaultSort: displayResource == "Point" && !tableLoading && tableColumns.some(function (_ref2) {
      var key = _ref2.key;
      return key == "trend";
    }) ? "-trend" : "+name",
    loading: tableLoading,
    pageSize: 10
  })));
};

PointSelectorModal.propTypes = {
  equipmentId: PropTypes.string,
  defaultSiteId: PropTypes.string,
  onSelect: PropTypes.func,
  close: PropTypes.func
};
var PointSelectorModal$1 = PointSelectorModal;

var PointSelectorInput = function PointSelectorInput(props) {
  var i18n = useI18n$1();
  var value = props.value,
      onChange = props.onChange,
      className = props.className,
      defaultSiteId = props.defaultSiteId;

  var _useChariotGet = useChariotGet("Point", value),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      point = _useChariotGet2[0],
      loading = _useChariotGet2[2];

  var _useChariotGet3 = useChariotGet("Site", point && point._.site_id),
      _useChariotGet4 = _slicedToArray$1(_useChariotGet3, 1),
      site = _useChariotGet4[0];

  var _useChariotGet5 = useChariotGet("Equipment", point && point._.equipment_id),
      _useChariotGet6 = _slicedToArray$1(_useChariotGet5, 1),
      equipment = _useChariotGet6[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return setModalOpen(true);
    },
    className: "chart-data-selector-input ".concat(className ? "".concat(className) : "", " ").concat(!value ? "empty" : "")
  }, /*#__PURE__*/React__default.createElement("span", null, point ? point.getDisplayName() : loading && value ? i18n.t("global.loading") : value ? value : i18n.t("charts.pointSelectorEmpty"), value && /*#__PURE__*/React__default.createElement(ForwardRef$5, null)), /*#__PURE__*/React__default.createElement("span", null, site && site._.id == point._.site_id && /*#__PURE__*/React__default.createElement("small", null, "Site: ", site.getDisplayName()), equipment && equipment._.id == point._.equipment_id && /*#__PURE__*/React__default.createElement("small", null, "Equipment: ", equipment.getDisplayName()))), modalOpen && (!loading || !value) && /*#__PURE__*/React__default.createElement(PointSelectorModal$1, {
    equipmentId: point === null || point === void 0 ? void 0 : point._.equipment_id,
    defaultSiteId: defaultSiteId,
    close: function close() {
      return setModalOpen(false);
    },
    onSelect: function onSelect(point) {
      onChange && onChange(createFakeChangeEvent(point._.id), point);
      setModalOpen(false);
    }
  }));
};

PointSelectorInput.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.string,
  defaultSiteId: PropTypes.string
};
var PointSelectorInput$1 = PointSelectorInput;

var ChartDataSourceConfigEditor = function ChartDataSourceConfigEditor(props) {
  var i18n = useI18n$1();
  var value = props.value,
      defaultStartDate = props.defaultStartDate,
      defaultSiteId = props.defaultSiteId,
      chartDateRange = props.chartDateRange,
      onChange = props.onChange,
      remove = props.remove;
  var moreButton = useRef();
  var morePopover = useRef();
  var endField = useRef();
  var splitColor = useRef();

  var _useState = useState(generateRandomString()),
      _useState2 = _slicedToArray$1(_useState, 1),
      id = _useState2[0];

  var handleChange = function handleChange(newConfig) {
    var newValue = _objectSpread2(_objectSpread2({}, value), newConfig);

    onChange(createFakeChangeEvent(newValue));
  };

  if (!value.point_value_condition) value.point_value_condition = {};

  var _useChariotGet = useChariotGet("Point", value.point_id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 1),
      point = _useChariotGet2[0];

  var compatibleRanges = getCompatibleRangePresets(chartDateRange);
  var compatibleResolutions = getResolutionOptionsFromPresetId(value.range_preset);
  var start_date = value.start_date,
      end_date;

  if (value.range_preset && value.range_preset !== CUSTOM_RANGE) {
    var presetRange = getRangeFromPresetId(value.range_preset);
    start_date = presetRange.start;
    end_date = presetRange.end;
  } else {
    end_date = new Date(+start_date + chartDateRange);
  }

  return /*#__PURE__*/React__default.createElement(Card$1, {
    className: "chart-data-source-config-editor"
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !(value.type == "point" && value.point_chart_type == "heatmap") ? /*#__PURE__*/React__default.createElement(InputWrapper$1, {
      className: "color",
      label: i18n.t("charts.colorLabel")
    }, /*#__PURE__*/React__default.createElement(ColorInput$1, {
      value: value.color,
      onChange: function onChange(e) {
        return handleChange({
          color: e.target.value
        });
      }
    })) : /*#__PURE__*/React__default.createElement("div", {
      className: "input-wrapper color"
    }, /*#__PURE__*/React__default.createElement("div", {
      ref: splitColor,
      className: "color-input",
      style: {
        borderRadius: "50%",
        background: "linear-gradient(135deg, ".concat(value.color, ", ").concat(value.color, " 50%, ").concat(value.value_lower_bound_color, " 51%, ").concat(value.value_lower_bound_color, ")")
      }
    }), /*#__PURE__*/React__default.createElement(ToolTip$1, {
      anchor: splitColor
    }, i18n.t("charts.useValueComparisonColorPicker"))), value.type == "weather" && /*#__PURE__*/React__default.createElement(SiteSelectorInput$1, {
      value: value.site_id,
      onChange: function onChange(e) {
        return handleChange({
          site_id: e.target.value
        });
      },
      label: value.weather_key == "humidity" ? i18n.t("charts.humidityDataLabel") : i18n.t("charts.tempDataLabel")
    }), value.type == "point" && /*#__PURE__*/React__default.createElement(PointSelectorInput$1, {
      defaultSiteId: defaultSiteId,
      value: value.point_id,
      onChange: function onChange(e, point) {
        var newConfig = {
          point_id: e.target.value,
          point_value_condition: value.point_value_condition
        };

        if (point) {
          var _point$_$type;

          if (["number", "temperature"].includes((_point$_$type = point._.type) === null || _point$_$type === void 0 ? void 0 : _point$_$type.toLowerCase())) {
            newConfig.point_value_condition = {
              type: "more_than",
              compare: "70"
            };
          } else if (point.getValueOptions().length > 0) {
            newConfig.point_value_condition = {
              type: "equal_to",
              compare: point.getValueOptions()[0].label
            };

            if (value.point_chart_type == "heatmap") {
              newConfig.point_chart_type = "line";
            }
          }
        }

        handleChange(newConfig);
      }
    }))
  }, value.type == "weather" && value.site_id || value.type == "point" && value.point_id ? /*#__PURE__*/React__default.createElement(Button$1, {
    ref: moreButton,
    className: "more",
    onClick: function onClick() {}
  }, /*#__PURE__*/React__default.createElement(ForwardRef$6, null)) : remove ? /*#__PURE__*/React__default.createElement(Button$1, {
    ref: moreButton,
    className: "more",
    onClick: remove
  }, /*#__PURE__*/React__default.createElement(ForwardRef$e, null)) : null, /*#__PURE__*/React__default.createElement(PopOver$1, {
    className: "data-source-settings-popover",
    anchor: moreButton,
    ref: morePopover
  }, value.type == "weather" && /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.weather_key,
    onChange: function onChange(e) {
      return handleChange({
        weather_key: e.target.value
      });
    }
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "temperature"
  }, i18n.t("charts.temp")), /*#__PURE__*/React__default.createElement("option", {
    value: "humidity"
  }, i18n.t("charts.humidity"))), value.type == "point" && /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.point_chart_type,
    onChange: function onChange(e) {
      return handleChange({
        point_chart_type: e.target.value
      });
    }
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "line"
  }, i18n.t("charts.lineChartTypeLabel")), /*#__PURE__*/React__default.createElement("option", {
    value: "gradientPolygon"
  }, i18n.t("charts.gradientPolygonChartTypeLabel")), /*#__PURE__*/React__default.createElement("option", {
    value: "bar"
  }, i18n.t("charts.barChartTypeLabel")), ["number", "temperature", "integer", "decimal"].includes(point === null || point === void 0 ? void 0 : point._.type.toLowerCase()) && /*#__PURE__*/React__default.createElement("option", {
    value: "heatmap"
  }, i18n.t("charts.heatmapChartTypeLabel"))), !(value.type == "point" && value.point_chart_type == "heatmap") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.xAxisLabel")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    className: "smol",
    value: value.xAxis || false,
    onChange: function onChange(e) {
      return handleChange({
        xAxis: e.target.checked
      });
    }
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.yAxisLabel")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    className: "smol",
    value: value.yAxis || false,
    onChange: function onChange(e) {
      return handleChange({
        yAxis: e.target.checked
      });
    }
  }))), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.useDifferentRangeLabel")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    className: "smol",
    value: !!value.range_preset,
    onChange: function onChange(e) {
      if (e.target.checked) {
        handleChange({
          range_preset: compatibleRanges[0].value,
          start_date: defaultStartDate
        });
      } else {
        handleChange({
          range_preset: null,
          rsolution: null,
          start_date: null
        });
      }
    }
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.tooltipsLabel")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    className: "smol",
    value: value.tooltips || false,
    onChange: function onChange(e) {
      return handleChange({
        tooltips: e.target.checked
      });
    }
  })), (value.point_chart_type == "line" || value.type == "weather") && /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.dashedLabel")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    className: "smol",
    value: value.dashed || false,
    onChange: function onChange(e) {
      return handleChange({
        dashed: e.target.checked
      });
    }
  })), remove && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      var _morePopover$current;

      remove();
      morePopover === null || morePopover === void 0 ? void 0 : (_morePopover$current = morePopover.current) === null || _morePopover$current === void 0 ? void 0 : _morePopover$current.handleClose();
    },
    className: "warning"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.removeLabel"))))), /*#__PURE__*/React__default.createElement(CardBody$1, null, !!value.range_preset && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.timeRange")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.range_preset,
    onChange: function onChange(e) {
      return handleChange({
        range_preset: e.target.value
      });
    }
  }, compatibleRanges.map(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.startDate")
  }, /*#__PURE__*/React__default.createElement(DateTimeInput$1, {
    disabled: value.range_preset !== CUSTOM_RANGE,
    value: start_date,
    onChange: function onChange(e) {
      return handleChange({
        start_date: e.target.value
      });
    }
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.endDate")
  }, /*#__PURE__*/React__default.createElement(DateTimeInput$1, {
    labelRef: endField,
    disabled: true,
    value: end_date
  })), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: endField
  }, i18n.t("charts.lengthMustMatchChartTooltip")), value.type == "point" && /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "resolution",
    label: i18n.t("charts.resolution")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.resolution,
    onChange: function onChange(e) {
      return handleChange({
        resolution: e.target.value
      });
    }
  }, compatibleResolutions.map(function (resolution) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: resolution,
      value: resolution
    }, resolution);
  })))), value.type == "point" && value.point_chart_type == "bar" && (point && point.getValueOptions().length > 0 ? /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.compareValueLabel")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.point_value_condition.compare,
    onChange: function onChange(e) {
      return handleChange({
        point_value_condition: {
          type: "equal_to",
          compare: e.target.value
        }
      });
    }
  }, point.getValueOptions().map(function (_ref2, index) {
    var label = _ref2.label;
    return /*#__PURE__*/React__default.createElement("option", {
      key: index,
      value: label
    }, label);
  }))) : /*#__PURE__*/React__default.createElement("label", {
    className: "input-wrapper value-comparison"
  }, /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.compareValueLabel")), /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.point_value_condition.type,
    onChange: function onChange(e) {
      return handleChange({
        point_value_condition: _objectSpread2(_objectSpread2({}, value.point_value_condition), {}, {
          type: e.target.value
        })
      });
    }
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "equal_to"
  }, i18n.t("charts.equalToCondition")), /*#__PURE__*/React__default.createElement("option", {
    value: "more_than"
  }, i18n.t("charts.moreThanCondition")), /*#__PURE__*/React__default.createElement("option", {
    value: "less_than"
  }, i18n.t("charts.lessThanCondition"))), /*#__PURE__*/React__default.createElement(TextInput$1, {
    value: value.point_value_condition.compare,
    onChange: function onChange(e) {
      return handleChange({
        point_value_condition: _objectSpread2(_objectSpread2({}, value.point_value_condition), {}, {
          compare: e.target.value
        })
      });
    }
  }))), value.type == "point" && value.point_chart_type == "heatmap" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "".concat(id, "UpperLimit"),
    className: "input-wrapper value-comparison"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ColorInput$1, {
    value: value.color,
    onChange: function onChange(e) {
      return handleChange({
        color: e.target.value
      });
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.upperValueLimitLabel"))), /*#__PURE__*/React__default.createElement(TextInput$1, {
    id: "".concat(id, "UpperLimit"),
    value: value.value_upper_bound,
    onChange: function onChange(e) {
      return handleChange({
        value_upper_bound: e.target.value
      });
    }
  })), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "".concat(id, "LowerLimit"),
    className: "input-wrapper value-comparison"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ColorInput$1, {
    value: value.value_lower_bound_color,
    onChange: function onChange(e) {
      return handleChange({
        value_lower_bound_color: e.target.value
      });
    }
  }), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.lowerValueLimitLabel"))), /*#__PURE__*/React__default.createElement(TextInput$1, {
    id: "".concat(id, "LowerLimit"),
    value: value.value_lower_bound,
    onChange: function onChange(e) {
      return handleChange({
        value_lower_bound: e.target.value
      });
    }
  })))));
};

ChartDataSourceConfigEditor.propTypes = {
  value: PropTypes.shape(dataSourceConfigPropType),
  defaultStartDate: PropTypes.instanceOf(Date),
  defaultSiteId: PropTypes.string,
  chartDateRange: PropTypes.number,
  onChange: PropTypes.func,
  remove: PropTypes.func
};
var ChartDataSourceConfigEditor$1 = ChartDataSourceConfigEditor;

var colorPool = ["#4F53E6", "#48696F", "#6FA09D", "#CEB908", "#BCCFA1", "#94BB5E", "#888BE1", "#DA835A"];
var DEFAULT_POINT_SOURCE_CONFIG = {
  color: "",
  type: "point",
  dashed: false,
  point_id: "",
  point_chart_type: "line",
  tooltips: true,
  point_value_condition: {
    type: "equal_to",
    compare: "On"
  },
  value_lower_bound: 64,
  value_upper_bound: 80,
  value_lower_bound_color: "#4040dc"
};
var DEFAULT_WEATHER_SOURCE_CONFIG = {
  color: "",
  type: "weather",
  dashed: false,
  tooltips: true,
  weather_key: "temperature",
  site_id: ""
};
var getNewPointConfig = function getNewPointConfig() {
  var takenColors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isFirst = arguments.length > 1 ? arguments[1] : undefined;

  var config = _objectSpread2({}, DEFAULT_POINT_SOURCE_CONFIG);

  var availableColors = colorPool.filter(function (color) {
    return !takenColors.includes(color);
  });

  if (availableColors.length == 0) {
    config.color = "#000000";
  } else {
    config.color = availableColors[0];
  }

  if (isFirst) {
    config.xAxis = true;
    config.yAxis = true;
  }

  return config;
};
var getNewWeatherConfig = function getNewWeatherConfig() {
  var takenColors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isFirst = arguments.length > 1 ? arguments[1] : undefined;

  var config = _objectSpread2({}, DEFAULT_WEATHER_SOURCE_CONFIG);

  var availableColors = colorPool.filter(function (color) {
    return !takenColors.includes(color);
  });

  if (availableColors.length == 0) {
    config.color = "#000000";
  } else {
    config.color = availableColors[0];
  }

  if (isFirst) {
    config.tooltips = true;
    config.xAxis = true;
    config.yAxis = true;
  }

  return config;
};

var ChartConfigEditor = function ChartConfigEditor(props) {
  var i18n = useI18n$1();
  var chariot = useChariot();
  var value = props.value,
      onChange = props.onChange;
  var data = value.data || [];

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      defaultSiteId = _useState2[0],
      setDefaultSiteId = _useState2[1];

  useEffect(function () {
    var mounted = true;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var siteIds, _iterator, _step, datum, point, freq, _i, _siteIds, siteId, sorted;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              siteIds = [];
              _iterator = _createForOfIteratorHelper(data);
              _context.prev = 2;

              _iterator.s();

            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 17;
                break;
              }

              datum = _step.value;

              if (!(datum.type == "weather" && datum.site_id)) {
                _context.next = 10;
                break;
              }

              siteIds.push(datum.site_id);
              _context.next = 15;
              break;

            case 10:
              if (!(datum.type == "point" && datum.point_id)) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return chariot.Point.get(datum.point_id);

            case 13:
              point = _context.sent;
              siteIds.push(point._.site_id);

            case 15:
              _context.next = 4;
              break;

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](2);

              _iterator.e(_context.t0);

            case 22:
              _context.prev = 22;

              _iterator.f();

              return _context.finish(22);

            case 25:
              freq = {};

              for (_i = 0, _siteIds = siteIds; _i < _siteIds.length; _i++) {
                siteId = _siteIds[_i];
                if (!freq[siteId]) freq[siteId] = 0;
                freq[siteId] += 1;
              }

              sorted = Object.keys(freq).sort(function (siteIdA, siteIdB) {
                return freq[siteIdB] - freq[siteIdA];
              });

              if (sorted[0] && mounted) {
                setDefaultSiteId(sorted[0]);
              }

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 19, 22, 25]]);
    }))();

    return function () {
      return mounted = false;
    };
  }, [value]);

  var handleChange = function handleChange(newConfig) {
    var newValue = _objectSpread2(_objectSpread2({}, value), newConfig);

    if (!newValue.bar_count) {
      newValue.bar_count = 12;
    }

    if (!newValue.tile_count) {
      newValue.tile_count = 12;
    }

    if (newValue.range_preset) {
      var _resolutionOptions = getResolutionOptionsFromPresetId(newValue.range_preset);

      if (_resolutionOptions.length > 0 && !_resolutionOptions.some(function (resolution) {
        return resolution == newValue.resolution;
      })) {
        newValue.resolution = _resolutionOptions[0];
      }

      var _barCountOptions = getBarCountOptionsFromPresetId(newValue.range_preset, newValue.resolution);

      if (_barCountOptions.length > 0 && !_barCountOptions.some(function (_ref2) {
        var value = _ref2.value;
        return value == newValue.bar_count;
      })) {
        newValue.bar_count = _barCountOptions[0].value;
      }

      var _tileCountOptions = getTileCountOptionsFromPresetId(newValue.range_preset, newValue.resolution);

      if (_tileCountOptions.length > 0 && !_tileCountOptions.some(function (_ref3) {
        var value = _ref3.value;
        return value == newValue.tile_count;
      })) {
        newValue.tile_count = _tileCountOptions[0].value;
      }
    }

    var start_date = newValue.start_date,
        end_date = newValue.end_date,
        range_preset = newValue.range_preset;

    if (range_preset !== CUSTOM_RANGE) {
      var presetRange = getRangeFromPresetId(range_preset);
      start_date = presetRange.start;
      end_date = presetRange.end;
    }

    var compatibleRanges = getCompatibleRangePresets(+end_date - +start_date);
    newValue.data = (newValue.data || []).map(function (datum) {
      if (datum.range_preset && !compatibleRanges.some(function (_ref4) {
        var value = _ref4.value;
        return datum.range_preset == value;
      })) {
        datum.range_preset = compatibleRanges[0].value;
      }

      var resolutionOptions = getResolutionOptionsFromPresetId(datum.range_preset);

      if ((datum.range_preset || datum.start_date) && !resolutionOptions.some(function (resolution) {
        return datum.resolution == resolution;
      })) {
        datum.resolution = newValue.resolution;
      }

      if (datum.type == "point" && datum.point_chart_type == "heatmap") {
        datum.xAxis = false;
        datum.yAxis = false;
      }

      return datum;
    });
    onChange(createFakeChangeEvent(newValue));
  };

  var start_date = value.start_date,
      end_date = value.end_date,
      range_preset = value.range_preset;

  if (range_preset !== CUSTOM_RANGE) {
    var presetRange = getRangeFromPresetId(range_preset);
    start_date = presetRange.start;
    end_date = presetRange.end;
  }

  useEffect(function () {
    handleChange({});
  }, []);
  var barCountOptions = getBarCountOptionsFromPresetId(range_preset, value.resolution);
  var tileCountOptions = getTileCountOptionsFromPresetId(range_preset, value.resolution);
  var resolutionOptions = getResolutionOptionsFromPresetId(range_preset);
  var atLeastOnePointData = data.some(function (_ref5) {
    var type = _ref5.type;
    return type == "point";
  });
  var atLeastOneBarChart = data.some(function (_ref6) {
    var type = _ref6.type,
        point_chart_type = _ref6.point_chart_type;
    return type == "point" && point_chart_type == "bar";
  });
  var atLeastTwoBarCharts = data.filter(function (_ref7) {
    var type = _ref7.type,
        point_chart_type = _ref7.point_chart_type;
    return type == "point" && point_chart_type == "bar";
  }).length > 1;
  var atLeastOneHeatMap = data.some(function (_ref8) {
    var type = _ref8.type,
        point_chart_type = _ref8.point_chart_type;
    return type == "point" && point_chart_type == "heatmap";
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "chart-config-editor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "chart-settings"
  }, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.timeRange")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: range_preset,
    onChange: function onChange(e) {
      return handleChange({
        range_preset: e.target.value
      });
    }
  }, RANGE_PRESETS.map(function (_ref9) {
    var value = _ref9.value,
        label = _ref9.label;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "date-range-wrapper ".concat(range_preset !== CUSTOM_RANGE ? "disabled" : "")
  }, /*#__PURE__*/React__default.createElement("p", null, range_preset == CUSTOM_RANGE ? i18n.t("charts.startEndDesc") : i18n.t("charts.controlledRange")), /*#__PURE__*/React__default.createElement("div", {
    className: "input-row"
  }, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.startDate")
  }, /*#__PURE__*/React__default.createElement(DateTimeInput$1, {
    disabled: range_preset !== CUSTOM_RANGE,
    value: start_date,
    onChange: function onChange(e) {
      return handleChange({
        start_date: e.target.value
      });
    }
  })), /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.endDate")
  }, /*#__PURE__*/React__default.createElement(DateTimeInput$1, {
    disabled: range_preset !== CUSTOM_RANGE,
    value: end_date,
    onChange: function onChange(e) {
      return handleChange({
        end_date: e.target.value
      });
    }
  })))), atLeastOnePointData && /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "resolution",
    label: i18n.t("charts.resolution")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.resolution,
    onChange: function onChange(e) {
      return handleChange({
        resolution: e.target.value
      });
    }
  }, resolutionOptions.map(function (resolution) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: resolution,
      value: resolution
    }, resolution);
  }))), atLeastOneBarChart && (barCountOptions.length > 0 ? /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.barSize")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.bar_count,
    onChange: function onChange(e) {
      return handleChange({
        bar_count: parseInt(e.target.value)
      });
    }
  }, barCountOptions.map(function (_ref10) {
    var label = _ref10.label,
        value = _ref10.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))) : /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.numberOfBars")
  }, /*#__PURE__*/React__default.createElement(StepInput$1, {
    min: 0,
    value: value.bar_count,
    onChange: function onChange(e) {
      return handleChange({
        bar_count: e.target.value
      });
    }
  }))), atLeastTwoBarCharts && /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    className: "wraps-toggle",
    label: i18n.t("charts.stackBars")
  }, /*#__PURE__*/React__default.createElement(ToggleInput$1, {
    value: value.stack_bars,
    onChange: function onChange(e) {
      return handleChange({
        stack_bars: e.target.checked
      });
    }
  })), atLeastOneHeatMap && (tileCountOptions.length > 0 ? /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.tileSize")
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: value.tile_count,
    onChange: function onChange(e) {
      return handleChange({
        tile_count: parseInt(e.target.value)
      });
    }
  }, tileCountOptions.map(function (_ref11) {
    var label = _ref11.label,
        value = _ref11.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))) : /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: i18n.t("charts.numberOfTiles")
  }, /*#__PURE__*/React__default.createElement(StepInput$1, {
    min: 0,
    value: value.tile_count,
    onChange: function onChange(e) {
      return handleChange({
        tile_count: e.target.value
      });
    }
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "chart-data"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "add-data-sources"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      var newData = data.slice(0);
      newData.push(getNewPointConfig(newData.map(function (_ref12) {
        var color = _ref12.color;
        return color;
      }), newData.length == 0));
      handleChange({
        data: newData
      });
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.point"))), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      var newData = data.slice(0);
      var newConfig = getNewWeatherConfig(newData.map(function (_ref13) {
        var color = _ref13.color;
        return color;
      }), newData.length == 0);
      newConfig.site_id = defaultSiteId;
      newData.push(newConfig);
      handleChange({
        data: newData
      });
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("charts.weather")))), data.length == 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "empty"
  }, i18n.t("charts.addDataSource")), data.slice(0).reverse().map(function (datum, reverseIndex) {
    var index = data.length - 1 - reverseIndex;

    var onChange = function onChange(e) {
      var newData = data.slice(0);
      newData[index] = e.target.value;
      handleChange({
        data: newData
      });
    };

    var remove = function remove() {
      var newData = data.slice(0);
      newData.splice(index, 1);
      handleChange({
        data: newData
      });
    };

    return /*#__PURE__*/React__default.createElement(ChartDataSourceConfigEditor$1, {
      key: index,
      value: datum,
      defaultStartDate: start_date,
      defaultSiteId: defaultSiteId,
      chartDateRange: +end_date - +start_date,
      onChange: onChange,
      remove: remove
    });
  })));
};

ChartConfigEditor.propTypes = {
  value: PropTypes.shape(ChartConfigPropType),
  onChange: PropTypes.func
};
var ChartConfigEditor$1 = ChartConfigEditor;

var ChartBuilderLegend = function ChartBuilderLegend(props) {
  var i18n = useI18n$1();
  var _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "chart-builder-legend"
  }, data.filter(function (_ref) {
    var site_id = _ref.site_id,
        point_id = _ref.point_id;
    return site_id || point_id;
  }).map(function (datum, index) {
    var color = datum.color,
        type = datum.type,
        dashed = datum.dashed,
        point_chart_type = datum.point_chart_type,
        point_id = datum.point_id,
        site_id = datum.site_id,
        weather_key = datum.weather_key,
        _datum$point_value_co = datum.point_value_condition,
        point_value_condition = _datum$point_value_co === void 0 ? {} : _datum$point_value_co,
        value_lower_bound = datum.value_lower_bound,
        value_upper_bound = datum.value_upper_bound,
        value_lower_bound_color = datum.value_lower_bound_color;
    var style = "line";

    if (point_chart_type == "bar" || point_chart_type == "heatmap" || point_chart_type == "gradientPolygon") {
      style = "swatch";
    }

    if (type == "weather") {
      style = "line";
    }

    var value_compare_type = point_value_condition.type,
        point_value_compare_value = point_value_condition.compare;
    return /*#__PURE__*/React__default.createElement("span", {
      key: index
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "".concat(style, " ").concat(dashed ? "dashed" : ""),
      style: point_chart_type == "heatmap" ? {
        background: "linear-gradient(135deg, ".concat(color, ", ").concat(color, " 50%, ").concat(value_lower_bound_color, " 51%, ").concat(value_lower_bound_color, ")")
      } : style == "swatch" ? {
        backgroundColor: color
      } : {
        borderColor: color
      }
    }), type == "point" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
      type: "Point",
      id: point_id
    }), type == "point" && value_compare_type && point_chart_type == "bar" ? value_compare_type == "more_than" ? " (".concat(i18n.t("charts.moreThanCondition"), " ").concat(point_value_compare_value, ")") : value_compare_type == "less_than" ? " (".concat(i18n.t("charts.lessThanCondition"), " ").concat(point_value_compare_value, ")") : " (".concat(point_value_compare_value, ")") : null, type == "point" && point_chart_type == "heatmap" && " (".concat(value_lower_bound, "-").concat(value_upper_bound, ")")) : type == "weather" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChariotResourceLabel$1, {
      type: "Site",
      id: site_id
    }), " ", "(", weather_key == "humidity" ? i18n.t("charts.humidity") : i18n.t("charts.temp"), ")") : null);
  }));
};

ChartBuilderLegend.propTypes = ChartConfigPropType;
var ChartBuilderLegend$1 = ChartBuilderLegend;

var ChartBuilderHeader = function ChartBuilderHeader(props) {
  var absolute = props.absolute,
      range_preset = props.range_preset,
      start_date = props.start_date,
      end_date = props.end_date;
  var showDate = false;

  if (range_preset && range_preset !== CUSTOM_RANGE) {
    var range = getRangeFromPresetId(range_preset);

    if (range) {
      start_date = range.start;
      end_date = range.end;

      if (!absolute) {
        var _RANGE_PRESETS$find = RANGE_PRESETS.find(function (_ref) {
          var value = _ref.value;
          return value == range_preset;
        }),
            label = _RANGE_PRESETS$find.label;

        return /*#__PURE__*/React__default.createElement("span", null, label);
      }
    }
  }

  if (moment(start_date).format("l") !== moment(end_date).format("l")) showDate = true;
  return /*#__PURE__*/React__default.createElement("span", null, moment(start_date).format("lll"), " - ", showDate ? moment(end_date).format("lll") : moment(end_date).format("LT"));
};

ChartBuilderHeader.propTypes = _objectSpread2({
  absolute: PropTypes.bool
}, ChartConfigPropType);
var ChartBuilderHeader$1 = ChartBuilderHeader;

var PointValueCardInput = function PointValueCardInput(_ref) {
  var point_id = _ref.point_id,
      value = _ref.value,
      onChange = _ref.onChange,
      actions = _ref.actions;
  var i18n = useI18n$1();

  var _useChariotGet = useChariotGet("Point", point_id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 3),
      point = _useChariotGet2[0],
      error = _useChariotGet2[1],
      loading = _useChariotGet2[2];

  var _useChariotGet3 = useChariotGet("Equipment", point && point._.equipment_id),
      _useChariotGet4 = _slicedToArray$1(_useChariotGet3, 1),
      equipment = _useChariotGet4[0];

  if (loading) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      className: "point-value-card-input",
      loading: true
    });
  }

  if (error) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      className: "point-value-card-input"
    }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
      label: i18n.t("global.loading"),
      actions: actions
    }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(AppError$1, null, error.message)));
  }

  return /*#__PURE__*/React__default.createElement(Card$1, {
    className: "point-value-card-input"
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: equipment ? equipment.getDisplayName() : i18n.t("global.loading"),
    actions: actions
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    label: point.getDisplayName()
  }, /*#__PURE__*/React__default.createElement(PointValueInput, {
    getDefaultValue: true,
    point: point,
    value: value,
    onChange: onChange
  }))));
};

PointValueCardInput.propTypes = {
  point_id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  }))
};
var PointValueCardInput$1 = PointValueCardInput;

var AddPointsToPresetModal = function AddPointsToPresetModal(_ref) {
  var _selectedEquipment$po;

  var site_id = _ref.site_id,
      close = _ref.close,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect;
  var i18n = useI18n$1();

  var _useChariotList = useChariotList("Equipment", {
    params: {
      site_id: site_id
    }
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      equipment = _useChariotList2[0],
      error = _useChariotList2[1],
      loading = _useChariotList2[2];

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      selectedEquipmentId = _useState2[0],
      setSelectedEquipmentId = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      selectedPointIds = _useState4[0],
      setSelectedPointIds = _useState4[1];

  var selectedEquipment = equipment === null || equipment === void 0 ? void 0 : equipment.find(function (_ref2) {
    var _ = _ref2._;
    return _.id == selectedEquipmentId;
  });
  return /*#__PURE__*/React__default.createElement(Modal$1, {
    className: "add-points-to-preset-modal"
  }, /*#__PURE__*/React__default.createElement(ModalHeader$1, {
    closeButtonProps: {
      onClick: close
    }
  }, selectedEquipment ? i18n.t("schedules.selectPoints") : i18n.t("schedules.selectEquipment"), selectedEquipment && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "back-button primary",
    onClick: function onClick() {
      return setSelectedEquipmentId("");
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$8, null), /*#__PURE__*/React__default.createElement("span", null, selectedEquipment.getDisplayName()))), /*#__PURE__*/React__default.createElement(ModalBody$1, null, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), selectedEquipment ? /*#__PURE__*/React__default.createElement(SortableTable$1, {
    className: "point-table",
    rowProps: function rowProps(row) {
      return {
        onClick: function onClick() {
          var point = row.__original;
          var newSelectedPointIds = selectedPointIds.slice(0);

          if (newSelectedPointIds.includes(point._.id)) {
            newSelectedPointIds = newSelectedPointIds.filter(function (id) {
              return id !== point._.id;
            });
          } else {
            newSelectedPointIds.push(point._.id);
          }

          setSelectedPointIds(newSelectedPointIds);
        }
      };
    },
    data: (selectedEquipment === null || selectedEquipment === void 0 ? void 0 : (_selectedEquipment$po = selectedEquipment.points) === null || _selectedEquipment$po === void 0 ? void 0 : _selectedEquipment$po.filter(function (_ref3) {
      var settable = _ref3._.settable;
      return settable;
    })) || [],
    defaultSort: "+name",
    columns: [{
      key: "selected",
      label: "",
      display: function display(point) {
        return /*#__PURE__*/React__default.createElement(CheckboxInput$1, {
          className: "smol",
          disabled: disabled.includes(point._.id),
          value: disabled.includes(point._.id) || selectedPointIds.includes(point._.id),
          onChange: function onChange(e) {
            var newSelectedPointIds = selectedPointIds.slice(0).filter(function (id) {
              return id !== point._.id;
            });

            if (e.target.checked) {
              newSelectedPointIds.push(point._.id);
            }

            setSelectedPointIds(newSelectedPointIds);
          }
        });
      },
      sort: function sort(point) {
        return selectedPointIds.includes(point._.id) || disabled.includes(point._.id) ? 1 : 0;
      }
    }, {
      key: "name",
      label: i18n.t("schedules.pointNameLabel"),
      display: function display(point) {
        return point.getDisplayName();
      }
    }]
  }) : /*#__PURE__*/React__default.createElement(SelectionTable$1, {
    loading: loading,
    data: equipment === null || equipment === void 0 ? void 0 : equipment.filter(function (_ref4) {
      var points = _ref4.points;
      return points.some(function (_ref5) {
        var settable = _ref5._.settable;
        return settable;
      });
    }),
    defaultSort: "+name",
    pageSize: 10,
    onRowClick: function onRowClick(e) {
      return setSelectedEquipmentId(e._.id);
    },
    columns: [{
      key: "name",
      label: i18n.t("schedules.equipmentNameLabel"),
      display: function display(equipment) {
        return equipment.getDisplayName();
      }
    }, {
      key: "type",
      label: i18n.t("schedules.equipmentTypeLabel"),
      display: function display(equipment) {
        var _equipment$type;

        return equipment === null || equipment === void 0 ? void 0 : (_equipment$type = equipment.type) === null || _equipment$type === void 0 ? void 0 : _equipment$type.name;
      }
    }]
  })), /*#__PURE__*/React__default.createElement(ModalActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: close
  }, i18n.t("global.cancel")), /*#__PURE__*/React__default.createElement(Button$1, {
    className: "primary",
    disabled: selectedPointIds.length == 0,
    onClick: function onClick() {
      onSelect && onSelect(selectedPointIds);
      close && close();
    }
  }, i18n.t("schedules.addPoints"))));
};

AddPointsToPresetModal.propTypes = {
  site_id: PropTypes.string.isRequired,
  close: PropTypes.func,
  disabled: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func
};
var AddPointsToPresetModal$1 = AddPointsToPresetModal;

var PresetEditor = function PresetEditor(_ref) {
  var preset = _ref.preset,
      onChange = _ref.onChange;
  var i18n = useI18n$1();

  var _useDimensions = useDimensions$1(),
      observe = _useDimensions.observe,
      width = _useDimensions.width;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      addPointsModalOpen = _useState2[0],
      setAddPointsModalOpen = _useState2[1];

  if (!preset) return /*#__PURE__*/React__default.createElement("div", {
    className: "preset-editor loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));

  var handleChange = function handleChange(changeObject) {
    onChange && onChange(createFakeChangeEvent(_objectSpread2(_objectSpread2({}, preset._), changeObject)));
  };

  var sizeClass = "xs";
  if (width > 500) sizeClass = "sm";
  if (width > 750) sizeClass = "md";
  if (width > 1000) sizeClass = "lg";
  return /*#__PURE__*/React__default.createElement("div", {
    ref: observe,
    className: "preset-editor ".concat(sizeClass)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "preset-editor-header"
  }, /*#__PURE__*/React__default.createElement(TextInput$1, {
    value: preset._.name,
    onChange: function onChange(e) {
      return handleChange({
        name: e.target.value
      });
    }
  }), /*#__PURE__*/React__default.createElement(ColorInput$1, {
    value: preset._.color,
    onChange: function onChange(e) {
      return handleChange({
        color: e.target.value
      });
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "preset-points"
  }, preset._.points.map(function (_ref2, index) {
    var point_id = _ref2.point_id,
        value = _ref2.value;

    var handlePointChange = function handlePointChange(newValue) {
      var points = preset._.points.slice(0);

      points[index].value = newValue;
      handleChange({
        points: points
      });
    };

    var handleRemovePoint = function handleRemovePoint() {
      var points = preset._.points.slice(0);

      points.splice(index, 1);
      handleChange({
        points: points
      });
    };

    var actions = [{
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.removePoint"))),
      onClick: handleRemovePoint,
      className: "warning"
    }];
    return /*#__PURE__*/React__default.createElement(PointValueCardInput$1, {
      key: point_id,
      point_id: point_id,
      value: value,
      actions: actions,
      onChange: function onChange(e) {
        return handlePointChange(e.target.value);
      }
    });
  }), /*#__PURE__*/React__default.createElement(Button$1, {
    className: "add-points",
    onClick: function onClick() {
      return setAddPointsModalOpen(true);
    }
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.addPoints")))), addPointsModalOpen && /*#__PURE__*/React__default.createElement(AddPointsToPresetModal$1, {
    site_id: preset._.site_id,
    close: function close() {
      return setAddPointsModalOpen(false);
    },
    disabled: preset._.points.map(function (_ref3) {
      var point_id = _ref3.point_id;
      return point_id;
    }),
    onSelect: function onSelect(point_ids) {
      return handleChange({
        points: preset._.points.slice(0).concat(point_ids.map(function (point_id) {
          return {
            point_id: point_id,
            value: null
          };
        }))
      });
    }
  }));
};

PresetEditor.propTypes = {
  preset: PropTypes.instanceOf(Preset),
  onChange: PropTypes.func
};
var PresetEditor$1 = PresetEditor;

var ScheduledEquipment = function ScheduledEquipment(props) {
  var i18n = useI18n$1();
  var schedule = props.schedule;

  var _useChariotList = useChariotList("Equipment", {
    params: {
      site_id: schedule._.siteId
    }
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 3),
      equipment = _useChariotList2[0],
      equipmentError = _useChariotList2[1],
      equipmentLoading = _useChariotList2[2];

  var _useChariotList3 = useChariotList("Preset", {
    params: {
      site_id: schedule._.siteId
    }
  }),
      _useChariotList4 = _slicedToArray$1(_useChariotList3, 3),
      presets = _useChariotList4[0],
      presetsError = _useChariotList4[1],
      presetsLoading = _useChariotList4[2];

  var presetIdsInSchedule = Object.values(schedule._.rawDays).reduce(function (presetIds, dayZones) {
    var presetsFromDay = dayZones.map(function (_ref) {
      var preset_id = _ref.preset_id;
      return preset_id;
    });
    return Array.from(new Set([].concat(_toConsumableArray(presetIds), _toConsumableArray(presetsFromDay))));
  }, []);
  var coloredPointIds = (presets === null || presets === void 0 ? void 0 : presets.filter(function (_ref2) {
    var id = _ref2._.id;
    return presetIdsInSchedule.includes(id);
  }).reduce(function (points, preset) {
    return points.concat(preset._.points.map(function (_ref3) {
      var point_id = _ref3.point_id;
      return {
        point_id: point_id,
        color: preset._.color
      };
    }));
  }, [])) || [];
  var coloredEquipments = (equipment === null || equipment === void 0 ? void 0 : equipment.filter(function (_ref4) {
    var points = _ref4.points;
    return points.find(function (_ref5) {
      var id = _ref5._.id;
      return coloredPointIds.find(function (_ref6) {
        var point_id = _ref6.point_id;
        return point_id == id;
      });
    });
  }).map(function (equipment) {
    return {
      name: equipment.getDisplayName(),
      colors: Array.from(new Set(coloredPointIds.filter(function (_ref7) {
        var point_id = _ref7.point_id;
        return equipment.points.some(function (_ref8) {
          var id = _ref8._.id;
          return id == point_id;
        });
      }).map(function (_ref9) {
        var color = _ref9.color;
        return color;
      })))
    };
  })) || [];
  var error = equipmentError || presetsError;
  var loading = equipmentLoading || presetsLoading;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    loading: loading,
    className: "scheduled-equipment"
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: i18n.t("schedules.controlledEquipmentHeader")
  }), /*#__PURE__*/React__default.createElement(CardBody$1, null, error && /*#__PURE__*/React__default.createElement(AppError$1, null, error.message), coloredEquipments.length == 0 && /*#__PURE__*/React__default.createElement("p", null, i18n.t("schedules.noControlledEquipment")), coloredEquipments.map(function (_ref10, index) {
    var name = _ref10.name,
        colors = _ref10.colors;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "equipment",
      key: index
    }, /*#__PURE__*/React__default.createElement("span", null, name), colors.map(function (color) {
      return /*#__PURE__*/React__default.createElement("svg", {
        key: color,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 10 10"
      }, /*#__PURE__*/React__default.createElement("circle", {
        cx: "5",
        cy: "5",
        r: "5",
        fill: color
      }));
    }));
  })));
};

ScheduledEquipment.propTypes = {
  schedule: PropTypes.instanceOf(Schedule).isRequired
};
var ScheduledEquipment$1 = ScheduledEquipment;

var context = /*#__PURE__*/React__default.createContext({
  width: 0,
  height: 0,
  snaps: [],
  grid: []
});
var DayPresetContext = context;

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize',
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize',
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize',
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize',
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize',
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize',
    },
};
var Resizer = /** @class */ (function (_super) {
    __extends$1(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function () {
        return (React$1.createElement("div", { className: this.props.className || '', style: __assign$1(__assign$1({ position: 'absolute', userSelect: 'none' }, styles[this.props.direction]), (this.props.replaceStyles || {})), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children));
    };
    return Resizer;
}(React$1.PureComponent));

var src = {exports: {}};

//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault;

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault;

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault;

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
};

//
// API
//

src.exports = memoize;
src.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};

var memoize$1 = src.exports;

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto',
};
var clamp = memoize$1(function (n, min, max) { return Math.max(Math.min(n, max), min); });
var snap = memoize$1(function (n, size) { return Math.round(n / size) * size; });
var hasDirection = memoize$1(function (dir, target) {
    return new RegExp(dir, 'i').test(target);
});
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var isTouchEvent = function (event) {
    return Boolean(event.touches && event.touches.length);
};
var isMouseEvent = function (event) {
    return Boolean((event.clientX || event.clientX === 0) &&
        (event.clientY || event.clientY === 0));
};
var findClosestSnap = memoize$1(function (n, snapArray, snapGap) {
    if (snapGap === void 0) { snapGap = 0; }
    var closestGapIndex = snapArray.reduce(function (prev, curr, index) { return (Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev); }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var endsWith = memoize$1(function (str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var getStringSize = memoize$1(function (n) {
    n = n.toString();
    if (n === 'auto') {
        return n;
    }
    if (endsWith(n, 'px')) {
        return n;
    }
    if (endsWith(n, '%')) {
        return n;
    }
    if (endsWith(n, 'vh')) {
        return n;
    }
    if (endsWith(n, 'vw')) {
        return n;
    }
    if (endsWith(n, 'vmax')) {
        return n;
    }
    if (endsWith(n, 'vmin')) {
        return n;
    }
    return n + "px";
});
var getPixelSize = function (size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === 'string') {
        if (endsWith(size, 'px')) {
            return Number(size.replace('px', ''));
        }
        if (endsWith(size, '%')) {
            var ratio = Number(size.replace('%', '')) / 100;
            return parentSize * ratio;
        }
        if (endsWith(size, 'vw')) {
            var ratio = Number(size.replace('vw', '')) / 100;
            return innerWidth * ratio;
        }
        if (endsWith(size, 'vh')) {
            var ratio = Number(size.replace('vh', '')) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var calculateNewMax = memoize$1(function (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight),
    };
});
var definedProps = [
    'as',
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'boundsByDirection',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap',
];
// HACK: This class is used to calculate % size.
var baseClassName = '__resizable_base__';
var Resizable = /** @class */ (function (_super) {
    __extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function () {
            if (!_this.resizable || !_this.window) {
                return null;
            }
            var parent = _this.parentNode;
            if (!parent) {
                return null;
            }
            var element = _this.window.document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0 0 100%';
            if (element.classList) {
                element.classList.add(baseClassName);
            }
            else {
                element.className += baseClassName;
            }
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function (base) {
            var parent = _this.parentNode;
            if (!parent) {
                return;
            }
            parent.removeChild(base);
        };
        _this.ref = function (c) {
            if (c) {
                _this.resizable = c;
            }
        };
        _this.state = {
            isResizing: false,
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            backgroundStyle: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: 'auto',
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
            },
            flexBasis: undefined,
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            if (!this.resizable.ownerDocument) {
                return null;
            }
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function () {
            return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function () {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') {
                    this.resizable.style.position = 'relative';
                }
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function () {
            var _this = this;
            var size = this.props.size;
            var getSize = function (key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') {
                    return 'auto';
                }
                if (_this.propsSize && _this.propsSize[key] && endsWith(_this.propsSize[key].toString(), '%')) {
                    if (endsWith(_this.state[key].toString(), '%')) {
                        return _this.state[key].toString();
                    }
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = (value / parentSize[key]) * 100;
                    return percent + "%";
                }
                return getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.width)
                : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.height)
                : getSize('height');
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function () {
        if (!this.parentNode) {
            if (!this.window) {
                return { width: 0, height: 0 };
            }
            return { width: this.window.innerWidth, height: this.window.innerHeight };
        }
        var base = this.appendBase();
        if (!base) {
            return { width: 0, height: 0 };
        }
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
            // HACK: Use relative to get parent padding size
        }
        base.style.position = 'relative';
        base.style.minWidth = '100%';
        base.style.minHeight = '100%';
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight,
        };
        if (wrapChanged) {
            this.parentNode.style.flexWrap = wrap;
        }
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function () {
        if (this.window) {
            this.window.addEventListener('mouseup', this.onMouseUp);
            this.window.addEventListener('mousemove', this.onMouseMove);
            this.window.addEventListener('mouseleave', this.onMouseUp);
            this.window.addEventListener('touchmove', this.onMouseMove, {
                capture: true,
                passive: false,
            });
            this.window.addEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function () {
        if (this.window) {
            this.window.removeEventListener('mouseup', this.onMouseUp);
            this.window.removeEventListener('mousemove', this.onMouseMove);
            this.window.removeEventListener('mouseleave', this.onMouseUp);
            this.window.removeEventListener('touchmove', this.onMouseMove, true);
            this.window.removeEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function () {
        if (!this.resizable || !this.window) {
            return;
        }
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined,
        });
    };
    Resizable.prototype.componentWillUnmount = function () {
        if (this.window) {
            this.unbindEvents();
        }
    };
    Resizable.prototype.createSizeForCssProperty = function (newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' &&
            this.state.original[kind] === newSize &&
            (typeof propsSize === 'undefined' || propsSize === 'auto')
            ? 'auto'
            : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function (maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && hasDirection('left', direction);
        var heightByDirection = boundsByDirection && hasDirection('top', direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === 'parent') {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection
                    ? this.resizableRight - this.parentLeft
                    : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection
                    ? this.resizableBottom - this.parentTop
                    : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        }
        else if (this.props.bounds === 'window') {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        }
        else if (this.props.bounds) {
            boundWidth = widthByDirection
                ? this.resizableRight - this.targetLeft
                : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection
                ? this.resizableBottom - this.targetTop
                : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) {
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        }
        if (boundHeight && Number.isFinite(boundHeight)) {
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return { maxWidth: maxWidth, maxHeight: maxHeight };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function (clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (hasDirection('right', direction)) {
            newWidth = original.width + ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('left', direction)) {
            newWidth = original.width - ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('bottom', direction)) {
            newHeight = original.height + ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        if (hasDirection('top', direction)) {
            newHeight = original.height - ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function (newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        }
        else {
            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.setBoundingClientRect = function () {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== 'string') {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left;
            this.resizableRight = right;
            this.resizableTop = top_1;
            this.resizableBottom = bottom;
        }
    };
    Resizable.prototype.onResizeStart = function (event, direction) {
        if (!this.resizable || !this.window) {
            return;
        }
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        }
        else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) {
                    return;
                }
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
                this.setState({ height: this.props.size.height });
            }
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
                this.setState({ width: this.props.size.width });
            }
        }
        // For lockAspectRatio case
        this.ratio =
            typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== 'auto') {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height,
            },
            isResizing: true,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(event.target).cursor || 'auto' }),
            direction: direction,
            flexBasis: flexBasis,
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function (event) {
        if (!this.state.isResizing || !this.resizable || !this.window) {
            return;
        }
        if (this.window.TouchEvent && isTouchEvent(event)) {
            try {
                event.preventDefault();
                event.stopPropagation();
            }
            catch (e) {
                // Ignore on fail
            }
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) {
            newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        }
        if (this.props.snap && this.props.snap.y) {
            newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        }
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, { width: boundaryMax.maxWidth, height: boundaryMax.maxHeight }, { width: minWidth, height: minHeight });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = snap(newWidth, this.props.grid[0]);
            var newGridHeight = snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height,
        };
        if (width && typeof width === 'string') {
            if (endsWith(width, '%')) {
                var percent = (newWidth / parentSize.width) * 100;
                newWidth = percent + "%";
            }
            else if (endsWith(width, 'vw')) {
                var vw = (newWidth / this.window.innerWidth) * 100;
                newWidth = vw + "vw";
            }
            else if (endsWith(width, 'vh')) {
                var vh = (newWidth / this.window.innerHeight) * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if (endsWith(height, '%')) {
                var percent = (newHeight / parentSize.height) * 100;
                newHeight = percent + "%";
            }
            else if (endsWith(height, 'vw')) {
                var vw = (newHeight / this.window.innerWidth) * 100;
                newHeight = vw + "vw";
            }
            else if (endsWith(height, 'vh')) {
                var vh = (newHeight / this.window.innerHeight) * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height'),
        };
        if (this.flexDir === 'row') {
            newState.flexBasis = newState.width;
        }
        else if (this.flexDir === 'column') {
            newState.flexBasis = newState.height;
        }
        this.setState(newState);
        if (this.props.onResize) {
            this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function (event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) {
            return;
        }
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height,
        };
        if (this.props.onResizeStop) {
            this.props.onResizeStop(event, direction, this.resizable, delta);
        }
        if (this.props.size) {
            this.setState(this.props.size);
        }
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: 'auto' }),
        });
    };
    Resizable.prototype.updateSize = function (size) {
        this.setState({ width: size.width, height: size.height });
    };
    Resizable.prototype.renderResizer = function () {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) {
            return null;
        }
        var resizers = Object.keys(enable).map(function (dir) {
            if (enable[dir] !== false) {
                return (React$1.createElement(Resizer, { key: dir, direction: dir, onResizeStart: _this.onResizeStart, replaceStyles: handleStyles && handleStyles[dir], className: handleClasses && handleClasses[dir] }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null));
            }
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return (React$1.createElement("div", { className: handleWrapperClass, style: handleWrapperStyle }, resizers));
    };
    Resizable.prototype.render = function () {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function (acc, key) {
            if (definedProps.indexOf(key) !== -1) {
                return acc;
            }
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = __assign(__assign(__assign({ position: 'relative', userSelect: this.state.isResizing ? 'none' : 'auto' }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: 'border-box', flexShrink: 0 });
        if (this.state.flexBasis) {
            style.flexBasis = this.state.flexBasis;
        }
        var Wrapper = this.props.as || 'div';
        return (React$1.createElement(Wrapper, __assign({ ref: this.ref, style: style, className: this.props.className }, extendsProps),
            this.state.isResizing && React$1.createElement("div", { style: this.state.backgroundStyle }),
            this.props.children,
            this.renderResizer()));
    };
    Resizable.defaultProps = {
        as: 'div',
        onResizeStart: function () { },
        onResize: function () { },
        onResizeStop: function () { },
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true,
        },
        style: {},
        grid: [1, 1],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0,
    };
    return Resizable;
}(React$1.PureComponent));

var cjs = {exports: {}};

var Draggable$2 = {};

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx_m () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var clsx_m$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': clsx_m
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(clsx_m$1);

var domFns = {};

var shims = {};

Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.findInArray = findInArray;
shims.isFunction = isFunction;
shims.isNum = isNum;
shims.int = int;
shims.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
)
/*: ?Error*/
{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

var getPrefix$1 = {};

Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.getPrefix = getPrefix;
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var _window$document, _window$document$docu;

  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Ensure we're running in an environment where there is actually a global
  // `window` obj
  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.

  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style) return '';
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = (getPrefix()
/*: string*/
);

getPrefix$1.default = _default;

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.addEvent = addEvent;
domFns.removeEvent = removeEvent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTranslation = getTranslation;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.removeUserSelectStyles = removeUserSelectStyles;
domFns.addClassName = addClassName;
domFns.removeClassName = removeClassName;

var _shims$2 = shims;

var _getPrefix = _interopRequireWildcard$1(getPrefix$1);

function _getRequireWildcardCache$1(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$1 = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$1(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$1(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims$2.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$2.int)(computedStyle.paddingTop);
  height -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/


// Get from offsetParent
function offsetXYFromParent(evt
/*: EventWithOffset*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty$1({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

var positionFns = {};

Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.getBoundPosition = getBoundPosition;
positionFns.snapToGrid = snapToGrid;
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.getControlPosition = getControlPosition;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;

var _shims$1 = shims;

var _domFns$1 = domFns;

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var boundNodeEl
    /*: HTMLElement*/
    = boundNode; // for Flow, can't seem to refine correctly

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node) - node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node) - node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims$1.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims$1.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims$1.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

var DraggableCore$2 = {};

var log$1 = {};

Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;

/*eslint no-console:0*/
function log() {
}

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;

var React = _interopRequireWildcard(React__default);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _reactDom = _interopRequireDefault(ReactDOM);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _log = _interopRequireDefault(log$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Simple abstraction for dragging events names.
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/

//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore$1 = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log.default)('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents')
          /*: any*/
          )
          /*: MouseTouchEvent*/
          ); // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: React.Element<any>*/
    {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

DraggableCore$2.default = DraggableCore$1;

_defineProperty(DraggableCore$1, "displayName", 'DraggableCore');

_defineProperty(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore.default;
  }
});
exports.default = void 0;

var React = _interopRequireWildcard(React__default);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _reactDom = _interopRequireDefault(ReactDOM);

var _clsx2 = _interopRequireDefault(require$$3);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _DraggableCore = _interopRequireDefault(DraggableCore$2);

var _log = _interopRequireDefault(log$1);

var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Define <Draggable>
//
var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log.default)('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log.default)('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _clsx;

      var _this$props2 = this.props;
          _this$props2.axis;
          _this$props2.bounds;
          var children = _this$props2.children,
          defaultPosition = _this$props2.defaultPosition,
          defaultClassName = _this$props2.defaultClassName,
          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
          position = _this$props2.position,
          positionOffset = _this$props2.positionOffset;
          _this$props2.scale;
          var draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2)
    /*: ?$Shape<DraggableState>*/
    {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition;

      // Set x/y if a new position is provided in props that is different than the previous.
      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports.default = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number
  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
  defaultClassName: _propTypes.default.string,
  defaultClassNameDragging: _propTypes.default.string,
  defaultClassNameDragged: _propTypes.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  positionOffset: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  scale: 1
}));
}(Draggable$2));

var _require = Draggable$2,
    Draggable = _require.default,
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore;

var Draggable$1 = cjs.exports;

var _path$4;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgResizeHandle = function SvgResizeHandle(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 14",
    ref: ref
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React$1.createElement("path", {
    opacity: 0.2,
    fill: "none",
    stroke: "#001f56",
    strokeMiterlimit: 10,
    d: "M.5 0v14M3.5 0v14M6.5 0v14"
  })));
};

var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgResizeHandle);

var sortDesc = function sortDesc(key) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
    return d;
  };
  return function (a, b) {
    if (transform(a[key], a) < transform(b[key], b)) return 1;
    if (transform(a[key], a) > transform(b[key], b)) return -1;
    return 0;
  };
};
var sortAsc = function sortAsc(key) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
    return d;
  };
  return function (a, b) {
    if (transform(a[key], a) > transform(b[key], b)) return 1;
    if (transform(a[key], a) < transform(b[key], b)) return -1;
    return 0;
  };
};

var convert24HrToInt = function convert24HrToInt(string) {
  var _string$split$map = string.split(":").map(function (s) {
    return parseInt(s);
  }),
      _string$split$map2 = _slicedToArray$1(_string$split$map, 3),
      hr = _string$split$map2[0],
      min = _string$split$map2[1],
      sec = _string$split$map2[2];

  return (hr * 60 + min) * 60 + sec;
};
var convert24HrToFriendly = function convert24HrToFriendly(string) {
  var _string$split$map3 = string.split(":").map(function (s) {
    return parseInt(s);
  }),
      _string$split$map4 = _slicedToArray$1(_string$split$map3, 2),
      hr = _string$split$map4[0],
      min = _string$split$map4[1],
      mode = "am";

  if (hr > 11 && hr < 24) mode = "pm";
  if (hr > 12) hr -= 12;
  if (hr == 0) hr += 12;
  if (min.toString().length == 1) min = "0".concat(min);
  return "".concat(hr, ":").concat(min, " ").concat(mode);
};
var min = convert24HrToInt("00:00:00");
var max = convert24HrToInt("23:59:59");
var increment = convert24HrToInt("00:15:00");
var minWidth = convert24HrToInt("00:14:59");
var convertIntTo24Hr = function convertIntTo24Hr(num) {
  var sec = num % 60,
      min = Math.floor(num / 60),
      hr = Math.floor(min / 60);
  min -= hr * 60;
  if (hr < 10) hr = "0".concat(hr);
  if (min < 10) min = "0".concat(min);
  if (sec < 10) sec = "0".concat(sec);
  return "".concat(hr, ":").concat(min, ":").concat(sec);
};
var getSnaps = function getSnaps(width) {
  var snaps = [],
      i = 0,
      trueEnd = convert24HrToInt("24:00:00");

  while (i <= trueEnd) {
    snaps.push(width * (i / trueEnd));
    i += increment;
  }

  return snaps;
};
var doCollisionsExist = function doCollisionsExist(zones, freemove) {
  return !zones.every(function (zone, index, array) {
    var before = array[index - 1],
        after = array[index + 1];

    if (!freemove && before && convert24HrToInt(before.end) >= convert24HrToInt(zone.start)) {
      return false;
    }

    if (!freemove && after && convert24HrToInt(after.start) <= convert24HrToInt(zone.end)) {
      return false;
    }

    if (!zone.start.endsWith("00:00") && !zone.start.endsWith("45:00") && !zone.start.endsWith("30:00") && !zone.start.endsWith("15:00")) {
      return false;
    }

    if (!zone.end.endsWith("59:59") && !zone.end.endsWith("44:59") && !zone.end.endsWith("29:59") && !zone.end.endsWith("14:59")) {
      return false;
    }

    if (convert24HrToInt(zone.end) - convert24HrToInt(zone.start) < minWidth || convert24HrToInt(zone.end) - convert24HrToInt(zone.start) > convert24HrToInt("23:59:59")) {
      return false;
    }

    if (convert24HrToInt(zone.end) < minWidth) {
      return false;
    }

    if (convert24HrToInt(zone.start) > convert24HrToInt("24:00:00") - minWidth) {
      return false;
    }

    return true;
  });
};
var checkForCollisions = function checkForCollisions(changingIndex, zones, freemove) {
  zones = JSON.parse(JSON.stringify(zones));

  while (doCollisionsExist(zones, freemove)) {
    for (var i = 0; i < zones.length; i += 1) {
      if (freemove && i !== changingIndex) continue;
      var changedCurStart = false,
          changedCurEnd = false,
          changedBeforeEnd = false,
          changedAfterStart = false,
          beforeCount = i,
          afterCount = zones.length - 1 - i,
          minStart = min + beforeCount * increment,
          maxEnd = max - afterCount * increment;

      if (!freemove) {
        if (convert24HrToInt(zones[i].start) < minStart) {
          zones[i].start = convertIntTo24Hr(minStart);
        }

        if (convert24HrToInt(zones[i].end) > maxEnd) {
          zones[i].end = convertIntTo24Hr(maxEnd);
        }

        if (zones[i - 1] && convert24HrToInt(zones[i - 1].end) >= convert24HrToInt(zones[i].start)) {
          if (changingIndex == i) {
            zones[i - 1].end = zones[i].start;
            changedBeforeEnd = true;
          } else {
            zones[i].start = zones[i - 1].end;
            changedCurStart = true;
          }
        }

        if (zones[i + 1] && convert24HrToInt(zones[i + 1].start) <= convert24HrToInt(zones[i].end)) {
          if (changingIndex == i) {
            zones[i + 1].start = zones[i].end;
            changedAfterStart = true;
          } else {
            zones[i].end = zones[i + 1].start;
            changedCurEnd = true;
          }
        }

        if (changedBeforeEnd) {
          var length = convert24HrToInt(zones[i - 1].end) - convert24HrToInt(zones[i - 1].start);
          if (length < minWidth) zones[i - 1].start = convertIntTo24Hr(convert24HrToInt(zones[i - 1].end) - minWidth);
        }

        if (changedAfterStart) {
          var _length = convert24HrToInt(zones[i + 1].end) - convert24HrToInt(zones[i + 1].start);

          if (_length < minWidth) zones[i + 1].end = convertIntTo24Hr(convert24HrToInt(zones[i + 1].start) + minWidth);
        }
      }

      if (!zones[i].start.endsWith("00:00") || !zones[i].start.endsWith("45:00") || !zones[i].start.endsWith("30:00") || !zones[i].start.endsWith("15:00")) {
        if (changedCurStart) {
          var temp = convert24HrToInt(zones[i].start) + Math.floor(increment / 2);
          zones[i].start = convertIntTo24Hr(temp - temp % increment);
        } else {
          zones[i].start = convertIntTo24Hr(convert24HrToInt(zones[i].start) - convert24HrToInt(zones[i].start) % increment);
        }
      }

      if (!zones[i].end.endsWith("59:59") || !zones[i].end.endsWith("44:59") || !zones[i].end.endsWith("29:59") || !zones[i].end.endsWith("14:59")) {
        var _temp = convert24HrToInt(zones[i].end) + Math.floor(increment / 2);

        zones[i].end = convertIntTo24Hr(_temp - _temp % increment - 1);
      }

      if (convert24HrToInt(zones[i].end) - convert24HrToInt(zones[i].start) < minWidth) {
        if (changedCurStart) {
          zones[i].end = convertIntTo24Hr(convert24HrToInt(zones[i].start) + minWidth);
        } else if (changedCurEnd) {
          zones[i].start = convertIntTo24Hr(convert24HrToInt(zones[i].end) - minWidth);
        }
      }
    }
  }

  return zones;
};
var days = [{
  label: "Monday",
  value: "monday"
}, {
  label: "Tuesday",
  value: "tuesday"
}, {
  label: "Wednesday",
  value: "wednesday"
}, {
  label: "Thursday",
  value: "thursday"
}, {
  label: "Friday",
  value: "friday"
}, {
  label: "Saturday",
  value: "saturday"
}, {
  label: "Sunday",
  value: "sunday"
}];
var getDaysFromKeys = function getDaysFromKeys(object) {
  return Object.keys(object).map(function (value) {
    var _ref = value.includes("/") ? value.split("/") : value.split("-"),
        _ref2 = _slicedToArray$1(_ref, 2),
        month = _ref2[0],
        day = _ref2[1];

    return {
      label: "".concat(months[parseInt(month) - 1].label.slice(0, 3), " ").concat(day),
      value: value
    };
  }).sort(sortAsc("value", function (value) {
    var _ref3 = value.includes("/") ? value.split("/") : value.split("-"),
        _ref4 = _slicedToArray$1(_ref3, 2),
        month = _ref4[0],
        day = _ref4[1];

    return parseInt(month) * 31 + parseInt(day);
  }));
};
var months = [{
  label: "January",
  value: "01"
}, {
  label: "February",
  value: "02"
}, {
  label: "March",
  value: "03"
}, {
  label: "April",
  value: "04"
}, {
  label: "May",
  value: "05"
}, {
  label: "June",
  value: "06"
}, {
  label: "July",
  value: "07"
}, {
  label: "August",
  value: "08"
}, {
  label: "September",
  value: "09"
}, {
  label: "October",
  value: "10"
}, {
  label: "November",
  value: "11"
}, {
  label: "December",
  value: "12"
}];
var getDatesFromMonth = function getDatesFromMonth(month) {
  var monthIndex = parseInt(month) - 1;
  var daysInMonth = 31;

  if (monthIndex == 1) {
    // february
    daysInMonth = 29;
  } else if (monthIndex % 2) {
    daysInMonth = 30;
  }

  var dates = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    var date = i < 10 ? "0".concat(i) : i;
    dates.push({
      label: date,
      value: date
    });
  }

  return dates;
};

var PresetZone = function PresetZone(props) {
  var i18n = useI18n$1();
  var onChange = props.onChange,
      remove = props.remove,
      editing = props.editing,
      edit = props.edit,
      resetEdit = props.resetEdit,
      moving = props.moving,
      move = props.move,
      resetMove = props.resetMove,
      startFromProps = props.start,
      endFromProps = props.end,
      preset_id = props.preset_id,
      zonesBefore = props.zonesBefore,
      zonesAfter = props.zonesAfter,
      disabled = props.disabled;
  var leftHandle = useRef();
  var rightHandle = useRef();
  var presetZonePopover = useRef();
  var startTooltip = useRef();
  var endTooltip = useRef();

  var _useContext = useContext(DayPresetContext),
      containerWidth = _useContext.width,
      containerHeight = _useContext.height,
      snaps = _useContext.snaps,
      grid = _useContext.grid;

  var _useChariotGet = useChariotGet("Preset", preset_id),
      _useChariotGet2 = _slicedToArray$1(_useChariotGet, 1),
      preset = _useChariotGet2[0];

  var _useState = useState(),
      _useState2 = _slicedToArray$1(_useState, 2),
      editingDirection = _useState2[0],
      setEditingDirection = _useState2[1];

  var start = (convert24HrToInt(startFromProps) - min) / max;
  var end = (convert24HrToInt(endFromProps) - min) / max;
  var width = (end - start) * containerWidth;
  var left = start * containerWidth;
  var minStart = min + zonesBefore * increment;
  var maxEnd = max - zonesAfter * increment;
  useEffect(function () {
    if (editing) {
      var _startTooltip$current, _endTooltip$current, _presetZonePopover$cu;

      startTooltip === null || startTooltip === void 0 ? void 0 : (_startTooltip$current = startTooltip.current) === null || _startTooltip$current === void 0 ? void 0 : _startTooltip$current.setPosition();
      endTooltip === null || endTooltip === void 0 ? void 0 : (_endTooltip$current = endTooltip.current) === null || _endTooltip$current === void 0 ? void 0 : _endTooltip$current.setPosition();
      presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu = presetZonePopover.current) === null || _presetZonePopover$cu === void 0 ? void 0 : _presetZonePopover$cu.setPosition();
    } else {
      var _presetZonePopover$cu2;

      presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu2 = presetZonePopover.current) === null || _presetZonePopover$cu2 === void 0 ? void 0 : _presetZonePopover$cu2.handleClose();
    }
  }, [editing]);
  var enableResize = {
    top: false,
    right: false,
    bottom: false,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false
  };

  if (!disabled && editing) {
    enableResize.right = true;
    enableResize.left = true;

    if (convert24HrToInt(endFromProps) - convert24HrToInt(startFromProps) == minWidth) {
      if (convert24HrToInt(startFromProps) <= minStart) enableResize.left = false;
      if (convert24HrToInt(endFromProps) >= maxEnd) enableResize.right = false;
    }
  }

  var highlightStyles = {};
  var maxWidth = (maxEnd - minStart) / max * containerWidth;

  if (editing) {
    if (editingDirection == "left") {
      var right = containerWidth - convert24HrToInt(endFromProps) / max * containerWidth;

      var _left = zonesBefore * increment / max * containerWidth;

      maxWidth = containerWidth - right - _left;
    } else if (editingDirection == "right") {
      var _right = zonesAfter * increment / max * containerWidth;

      var _left2 = convert24HrToInt(startFromProps) / max * containerWidth;

      maxWidth = containerWidth - _right - _left2;
    }
  }

  var handleResize = function handleResize(event, direction, ref, d) {
    var _presetZonePopover$cu3, _startTooltip$current2, _endTooltip$current2;

    if (convert24HrToInt(startFromProps) == 0 && ref == "left" && d.width > 0) return;
    var width = ((convert24HrToInt(endFromProps) - min) / max - (convert24HrToInt(startFromProps) - min) / max) * containerWidth;
    var diff = (ref.offsetWidth - width) / containerWidth * max;
    var start = startFromProps;
    var end = endFromProps;

    if (direction == "left") {
      start = Math.floor(convert24HrToInt(startFromProps) - diff);
      start = increment * Math.round(start / increment);
      start = convertIntTo24Hr(start);
    } else {
      end = Math.floor(convert24HrToInt(endFromProps) + diff);
      end = increment * Math.round(end / increment);
      end = convertIntTo24Hr(end);
    }

    onChange && onChange(createFakeChangeEvent({
      start: start,
      end: end,
      preset_id: preset_id
    }));
    presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu3 = presetZonePopover.current) === null || _presetZonePopover$cu3 === void 0 ? void 0 : _presetZonePopover$cu3.setPosition();
    startTooltip === null || startTooltip === void 0 ? void 0 : (_startTooltip$current2 = startTooltip.current) === null || _startTooltip$current2 === void 0 ? void 0 : _startTooltip$current2.setPosition();
    endTooltip === null || endTooltip === void 0 ? void 0 : (_endTooltip$current2 = endTooltip.current) === null || _endTooltip$current2 === void 0 ? void 0 : _endTooltip$current2.setPosition();
  };

  var handleMove = function handleMove(moveLifecycleEvent, event, _ref) {
    var _presetZonePopover$cu5, _startTooltip$current4, _endTooltip$current4;

    var deltaX = _ref.deltaX;
    var freemove = false,
        resort = false;
    if (event.target.closest(".move-bottom")) freemove = true;
    if (!freemove && moveLifecycleEvent == "start" && !event.target.classList.contains("preset-zone")) return false;

    if (moveLifecycleEvent == "start" && freemove) {
      move();
    } else if (moveLifecycleEvent == "stop") {
      freemove = false;
      resort = true;
      resetMove();
    }

    var start = convert24HrToInt(startFromProps) + Math.round(deltaX / grid[0]) * increment;
    var end = start + (convert24HrToInt(endFromProps) - convert24HrToInt(startFromProps));

    if (start < min || end > max) {
      var _presetZonePopover$cu4, _startTooltip$current3, _endTooltip$current3;

      var changeEvent = createFakeChangeEvent({
        start: startFromProps,
        end: endFromProps,
        preset_id: preset_id
      });
      changeEvent.RESORT = true;
      onChange(changeEvent);
      resetMove();
      resetEdit();
      presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu4 = presetZonePopover.current) === null || _presetZonePopover$cu4 === void 0 ? void 0 : _presetZonePopover$cu4.setPosition();
      startTooltip === null || startTooltip === void 0 ? void 0 : (_startTooltip$current3 = startTooltip.current) === null || _startTooltip$current3 === void 0 ? void 0 : _startTooltip$current3.setPosition();
      endTooltip === null || endTooltip === void 0 ? void 0 : (_endTooltip$current3 = endTooltip.current) === null || _endTooltip$current3 === void 0 ? void 0 : _endTooltip$current3.setPosition();
      return false;
    } else {
      start = convertIntTo24Hr(start);
      end = convertIntTo24Hr(end);

      var _changeEvent = createFakeChangeEvent({
        start: start,
        end: end,
        preset_id: preset_id
      });

      _changeEvent.FREEMOVE = freemove || moving;
      _changeEvent.RESORT = resort;
      onChange(_changeEvent);
    }

    presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu5 = presetZonePopover.current) === null || _presetZonePopover$cu5 === void 0 ? void 0 : _presetZonePopover$cu5.setPosition();
    startTooltip === null || startTooltip === void 0 ? void 0 : (_startTooltip$current4 = startTooltip.current) === null || _startTooltip$current4 === void 0 ? void 0 : _startTooltip$current4.setPosition();
    endTooltip === null || endTooltip === void 0 ? void 0 : (_endTooltip$current4 = endTooltip.current) === null || _endTooltip$current4 === void 0 ? void 0 : _endTooltip$current4.setPosition();
  };

  var minWidth$1 = minWidth / max * containerWidth;
  var bounds = {
    left: zonesBefore * minWidth$1,
    right: containerWidth - zonesAfter * minWidth$1
  };

  if (moving) {
    bounds.left = 0;
    bounds.right = containerWidth;
  }

  return /*#__PURE__*/React__default.createElement(Draggable$1, {
    disabled: disabled,
    allowAnyClick: false,
    axis: "x",
    grid: grid,
    bounds: bounds,
    onStart: handleMove.bind(null, "start"),
    onDrag: handleMove.bind(null, null),
    onStop: handleMove.bind(null, "stop"),
    position: {
      x: left
    }
  }, /*#__PURE__*/React__default.createElement(Resizable, {
    onClick: function onClick(event) {
      if (disabled) return;
      presetZonePopover === null || presetZonePopover === void 0 ? void 0 : presetZonePopover.current.rebindAnchor({
        current: event.target.closest(".preset-zone")
      }, null, true);

      if (editing) {
        var _presetZonePopover$cu6;

        resetEdit();
        resetMove();
        presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu6 = presetZonePopover.current) === null || _presetZonePopover$cu6 === void 0 ? void 0 : _presetZonePopover$cu6.handleClose();
      } else {
        var _presetZonePopover$cu7;

        edit();
        presetZonePopover === null || presetZonePopover === void 0 ? void 0 : (_presetZonePopover$cu7 = presetZonePopover.current) === null || _presetZonePopover$cu7 === void 0 ? void 0 : _presetZonePopover$cu7.setPosition();
      }
    },
    className: "preset-zone ".concat(disabled ? "disabled" : "", " ").concat(moving ? "moving" : ""),
    size: {
      width: width,
      height: containerHeight
    },
    minWidth: minWidth$1,
    maxWidth: maxWidth,
    snap: {
      x: snaps
    },
    style: _objectSpread2({
      left: left,
      backgroundColor: (preset === null || preset === void 0 ? void 0 : preset._.color) || "#333",
      position: "absolute"
    }, highlightStyles),
    enable: enableResize,
    onResizeStart: function onResizeStart(event, direction) {
      if (!editing) {
        edit();
        setEditingDirection(direction);
      }
    },
    onResize: handleResize,
    onResizeStop: editing ? null : resetEdit,
    handleComponent: {
      left: /*#__PURE__*/React__default.createElement("span", {
        ref: leftHandle,
        className: "resize-left ".concat(editing ? "highlight" : "")
      }, /*#__PURE__*/React__default.createElement(ForwardRef$4, null)),
      right: /*#__PURE__*/React__default.createElement("span", {
        ref: rightHandle,
        className: "resize-right ".concat(editing ? "highlight" : "")
      }, /*#__PURE__*/React__default.createElement(ForwardRef$4, null))
    }
  }, /*#__PURE__*/React__default.createElement(PopOver$1, {
    className: "preset-zone-popover",
    ref: presetZonePopover,
    position: "top"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "5",
    fill: (preset === null || preset === void 0 ? void 0 : preset._.color) || "#333"
  })), /*#__PURE__*/React__default.createElement("strong", null, (preset === null || preset === void 0 ? void 0 : preset._.name) || i18n.t("schedules.unknownPreset"))), /*#__PURE__*/React__default.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    component: Link,
    to: "/sites/".concat(preset === null || preset === void 0 ? void 0 : preset._.site_id, "/presets/").concat(preset === null || preset === void 0 ? void 0 : preset._.id)
  }, /*#__PURE__*/React__default.createElement(ForwardRef$5, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.editPreset"))), remove && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "warning",
    onClick: remove
  }, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.removePreset"))))), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    ref: startTooltip,
    style: {
      animation: "none"
    },
    show: editing,
    anchor: leftHandle,
    position: "bottom"
  }, convert24HrToFriendly(startFromProps)), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    ref: endTooltip,
    style: {
      animation: "none"
    },
    show: editing,
    anchor: rightHandle,
    position: "bottom"
  }, convert24HrToFriendly(convertIntTo24Hr(convert24HrToInt(endFromProps) + 1))), editing && /*#__PURE__*/React__default.createElement("span", {
    className: "move-bottom"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$4, null))));
};

PresetZone.propTypes = {
  onChange: PropTypes.func,
  remove: PropTypes.func,
  editing: PropTypes.bool,
  edit: PropTypes.func,
  resetEdit: PropTypes.func,
  moving: PropTypes.bool,
  move: PropTypes.func,
  resetMove: PropTypes.func,
  start: PropTypes.string,
  end: PropTypes.string,
  preset_id: PropTypes.string,
  zonesBefore: PropTypes.number,
  zonesAfter: PropTypes.number,
  disabled: PropTypes.bool
};
var PresetZone$1 = PresetZone;

var ticks = [];

for (var i = 0; i < 25; i += 1) {
  ticks.push( /*#__PURE__*/React__default.createElement("div", {
    key: i,
    className: "tick",
    style: {
      left: "".concat(i / 24 * 100, "%")
    }
  }, i % 2 == 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "label"
  }, i == 0 ? 12 : i < 13 ? i : i - 12, i > 11 && i !== 24 ? "pm" : "am") : /*#__PURE__*/React__default.createElement("div", {
    className: "label"
  }, "\xA0"), /*#__PURE__*/React__default.createElement("i", {
    className: "gridline"
  })));
}

var ScheduleDayEditor = function ScheduleDayEditor(props) {
  var _useDimensions = useDimensions$1(),
      observeCard = _useDimensions.observe,
      cardWidth = _useDimensions.width;

  var _useDimensions2 = useDimensions$1(),
      observe = _useDimensions2.observe,
      width = _useDimensions2.width,
      height = _useDimensions2.height;

  var label = props.label,
      linked = props.linked,
      value = props.value,
      actions = props.actions,
      site_id = props.site_id,
      _onChange = props.onChange;

  var _useChariotList = useChariotList("Preset", {
    params: {
      site_id: site_id
    }
  }),
      _useChariotList2 = _slicedToArray$1(_useChariotList, 1),
      presets = _useChariotList2[0];

  var _useState = useState(-1),
      _useState2 = _slicedToArray$1(_useState, 2),
      editingZoneIndex = _useState2[0],
      setEditingZoneIndex = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray$1(_useState3, 2),
      movingZoneIndex = _useState4[0],
      setMovingZoneIndex = _useState4[1];

  var actionsButton = useRef();
  var presetsButton = useRef();
  var snaps = getSnaps(width);
  var grid = [snaps[1]];
  var contextValue = {
    width: width,
    height: height,
    snaps: snaps,
    grid: grid
  };
  var sizeClass = "lg";
  if (cardWidth < 700) sizeClass = "sm";
  return /*#__PURE__*/React__default.createElement(Card$1, {
    ref: observeCard,
    className: "schedule-day-editor ".concat(linked ? "linked" : "", " ").concat(sizeClass)
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    label: label
  }), /*#__PURE__*/React__default.createElement(CardBody$1, {
    ref: observe
  }, /*#__PURE__*/React__default.createElement(DayPresetContext.Provider, {
    value: contextValue
  }, ticks, /*#__PURE__*/React__default.createElement("div", {
    className: "preset-zones"
  }, value && value.map(function (_ref, index) {
    var start = _ref.start,
        end = _ref.end,
        preset_id = _ref.preset_id;
    return /*#__PURE__*/React__default.createElement(PresetZone$1, {
      key: index,
      onChange: function onChange(e) {
        var newValue = value.slice(0),
            changedIndex = index;
        newValue[index] = e.target.value;

        if (e.RESORT) {
          newValue[index] = _objectSpread2(_objectSpread2({}, newValue[index]), {}, {
            JUST_CHANGED: true
          });
          newValue = newValue.sort(sortAsc("start", function (s, _ref2) {
            var JUST_CHANGED = _ref2.JUST_CHANGED;
            return convert24HrToInt(s) + (JUST_CHANGED ? -1 : 0);
          }));
          var newIndex = newValue.findIndex(function (z) {
            return z.JUST_CHANGED;
          });
          delete newValue[newIndex].JUST_CHANGED;
          changedIndex = index;
        }

        _onChange && _onChange(createFakeChangeEvent(checkForCollisions(changedIndex, newValue, e.FREEMOVE)));
      },
      disabled: linked,
      editing: index == editingZoneIndex,
      edit: function edit() {
        return setEditingZoneIndex(index);
      },
      resetEdit: function resetEdit() {
        return setEditingZoneIndex(-1);
      },
      moving: index == movingZoneIndex,
      move: function move() {
        return setMovingZoneIndex(index);
      },
      resetMove: function resetMove() {
        return setMovingZoneIndex(-1);
      },
      remove: function remove() {
        var newValue = value.slice(0);
        newValue.splice(index, 1);
        _onChange && _onChange(createFakeChangeEvent(newValue));
      },
      start: start,
      end: end,
      preset_id: preset_id,
      zonesBefore: index,
      zonesAfter: value.length - 1 - index
    });
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "card-actions"
  }, !linked && (presets && presets.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
    ref: presetsButton,
    disabled: !presets || presets.length == 0
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null)), /*#__PURE__*/React__default.createElement(PopOverMenu$1, {
    anchor: presetsButton,
    items: presets.map(function (preset) {
      return {
        label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 10 10"
        }, /*#__PURE__*/React__default.createElement("circle", {
          cx: "5",
          cy: "5",
          r: "5",
          fill: preset._.color
        })), /*#__PURE__*/React__default.createElement("span", null, preset._.name)),
        onClick: function onClick() {
          var newValue = value.slice(0);
          var length = convert24HrToInt("02:00:00");

          var _value$slice$sort = value.slice(0).sort(sortDesc("end", function (d) {
            return convert24HrToInt(d);
          })),
              _value$slice$sort2 = _slicedToArray$1(_value$slice$sort, 1),
              last = _value$slice$sort2[0];

          if (!last) {
            last = {
              end: "00:00:-1"
            };
          } else if (last && convert24HrToInt(last.end) > max - length) {
            last = {
              end: convertIntTo24Hr(max - length)
            };
          }

          newValue.push({
            start: convertIntTo24Hr(convert24HrToInt(last.end) + 1),
            end: convertIntTo24Hr(convert24HrToInt(last.end) + length),
            preset_id: preset._.id
          });
          _onChange && _onChange(createFakeChangeEvent(checkForCollisions(newValue.length, newValue)));
        }
      };
    })
  })) : /*#__PURE__*/React__default.createElement(Button$1, {
    component: Link,
    to: "/"
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null))), actions && actions.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
    ref: actionsButton
  }, /*#__PURE__*/React__default.createElement(ForwardRef$O, null)), /*#__PURE__*/React__default.createElement(PopOverMenu$1, {
    anchor: actionsButton,
    items: actions
  }))));
};

ScheduleDayEditor.propTypes = {
  label: PropTypes.string,
  linked: PropTypes.bool,
  site_id: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    preset_id: PropTypes.string
  })),
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func
  })),
  onChange: PropTypes.func
};
var ScheduleDayEditor$1 = ScheduleDayEditor;

var _rect, _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgCopy = function SvgCopy(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-copy",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React$1.createElement("rect", {
    x: 9,
    y: 9,
    width: 13,
    height: 13,
    rx: 2,
    ry: 2
  })), _path$3 || (_path$3 = /*#__PURE__*/React$1.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  })));
};

var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgCopy);

var _path$2, _path2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgLink = function SvgLink(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-link",
    ref: ref
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React$1.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  })), _path2 || (_path2 = /*#__PURE__*/React$1.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  })));
};

var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgLink);

var ScheduleEditor = function ScheduleEditor(_ref) {
  var schedule = _ref.schedule,
      onChange = _ref.onChange;
  var i18n = useI18n$1();

  var _useState = useState(months[0].value),
      _useState2 = _slicedToArray$1(_useState, 2),
      newMonth = _useState2[0],
      setNewMonth = _useState2[1];

  var _useState3 = useState("01"),
      _useState4 = _slicedToArray$1(_useState3, 2),
      newDate = _useState4[0],
      setNewDate = _useState4[1];

  if (!schedule) return /*#__PURE__*/React__default.createElement("div", {
    className: "schedule-editor loading"
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null));

  if (!schedule._.linkedDays) {
    schedule._.linkedDays = {};
  }

  var handleChange = function handleChange(changeObject) {
    onChange && onChange(createFakeChangeEvent(_objectSpread2(_objectSpread2({}, schedule._), changeObject)));
  };

  var handleAddDay = function handleAddDay() {
    var newRawDays = _objectSpread2({}, schedule._.rawDays);

    newRawDays["".concat(newMonth, "/").concat(newDate)] = [];
    handleChange({
      rawDays: newRawDays
    });
    setNewMonth(months[0].value);
    setNewDate("01");
  };

  var days$1 = schedule._.type == "DoW" ? days : getDaysFromKeys(schedule._.rawDays);
  var allDays = schedule._.type == "DoW" ? days : getDaysFromKeys(_objectSpread2(_objectSpread2({}, schedule._.rawDays), schedule._.linkedDays));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "schedule-editor"
  }, days$1.filter(function (_ref2) {
    var value = _ref2.value;
    return schedule._.rawDays[value];
  }).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    var linkableDays = allDays.filter(function (_ref4) {
      var compareValue = _ref4.value;
      return value !== compareValue && !Object.values(schedule._.linkedDays).includes(compareValue) && schedule._.linkedDays[compareValue] !== value;
    });
    var copyableDays = allDays.filter(function (_ref5) {
      var compareValue = _ref5.value;
      return value !== compareValue;
    });
    var actions = [{
      disabled: linkableDays.length == 0,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$2, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.linkDayTo", {
        day: label
      }))),
      items: linkableDays.map(function (_ref6) {
        var label = _ref6.label,
            linkValue = _ref6.value;
        return {
          label: label,
          onClick: function onClick() {
            var newRawDays = _objectSpread2({}, schedule._.rawDays);

            var newLinkedDays = _objectSpread2({}, schedule._.linkedDays);

            newLinkedDays[linkValue] = value;
            delete newRawDays[linkValue];
            handleChange({
              rawDays: newRawDays,
              linkedDays: newLinkedDays
            });
          }
        };
      })
    }, {
      disabled: copyableDays.length == 0,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$3, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.copyDay", {
        day: label
      }))),
      items: copyableDays.map(function (_ref7) {
        var label = _ref7.label,
            copyValue = _ref7.value;
        return {
          label: label,
          onClick: function onClick() {
            var newRawDays = _objectSpread2({}, schedule._.rawDays);

            var newLinkedDays = _objectSpread2({}, schedule._.linkedDays);

            newRawDays[copyValue] = newRawDays[value];
            delete newLinkedDays[copyValue];
            handleChange({
              rawDays: newRawDays,
              linkedDays: newLinkedDays
            });
          }
        };
      })
    }];

    if (schedule._.type == "annual") {
      actions.push({
        label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.removeDay", {
          day: label
        }))),
        className: "warning",
        onClick: function onClick() {
          var newRawDays = _objectSpread2({}, schedule._.rawDays);

          var newLinkedDays = _objectSpread2({}, schedule._.linkedDays);

          delete newRawDays[value];
          var linkedDays = Object.keys(newLinkedDays).filter(function (day) {
            return newLinkedDays[day] == value;
          });

          var _iterator = _createForOfIteratorHelper(linkedDays),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var linkedDay = _step.value;
              delete newLinkedDays[linkedDay];
              newRawDays[linkedDay] = [];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          handleChange({
            rawDays: newRawDays,
            linkedDays: newLinkedDays
          });
        }
      });
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: value
    }, /*#__PURE__*/React__default.createElement(ScheduleDayEditor$1, {
      label: label,
      value: schedule._.rawDays[value],
      site_id: schedule._.siteId,
      onChange: function onChange(e) {
        var newRawDays = _objectSpread2({}, schedule._.rawDays);

        newRawDays[value] = e.target.value;
        handleChange({
          rawDays: newRawDays
        });
      },
      actions: actions
    }), allDays.filter(function (_ref8) {
      var linkedValue = _ref8.value;
      return schedule._.linkedDays[linkedValue] == value;
    }).map(function (_ref9) {
      var linkedDayLabel = _ref9.label,
          linkedDay = _ref9.value;
      var actions = [{
        onClick: function onClick() {
          var newRawDays = _objectSpread2({}, schedule._.rawDays);

          var newLinkedDays = _objectSpread2({}, schedule._.linkedDays);

          delete newLinkedDays[linkedDay];
          newRawDays[linkedDay] = [];
          handleChange({
            rawDays: newRawDays,
            linkedDays: newLinkedDays
          });
        },
        label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$P, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.unlinkDay", {
          day: linkedDayLabel,
          linkedToDay: label
        })))
      }];

      if (schedule._.type == "annual") {
        actions.push({
          label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ForwardRef$e, null), /*#__PURE__*/React__default.createElement("span", null, i18n.t("schedules.removeDay", {
            day: label
          }))),
          className: "warning",
          onClick: function onClick() {
            var newLinkedDays = _objectSpread2({}, schedule._.linkedDays);

            delete newLinkedDays[linkedDay];
            handleChange({
              linkedDays: newLinkedDays
            });
          }
        });
      }

      return /*#__PURE__*/React__default.createElement(ScheduleDayEditor$1, {
        linked: true,
        key: linkedDay,
        label: linkedDayLabel,
        day: linkedDay,
        value: schedule._.rawDays[value],
        site_id: schedule._.siteId,
        actions: actions
      });
    }));
  }), schedule._.type == "annual" && /*#__PURE__*/React__default.createElement("div", {
    className: "new-date"
  }, /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: newMonth,
    onChange: function onChange(e) {
      setNewMonth(e.target.value);
      var newDateOptions = getDatesFromMonth(e.target.value);

      if (!newDateOptions.some(function (_ref10) {
        var value = _ref10.value;
        return value == newDate;
      })) {
        setNewDate(newDateOptions[newDateOptions.length - 1].value);
      }
    }
  }, months.map(function (_ref11) {
    var label = _ref11.label,
        value = _ref11.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/React__default.createElement(SelectInput$1, {
    value: newDate,
    onChange: function onChange(e) {
      return setNewDate(e.target.value);
    }
  }, getDatesFromMonth(newMonth).map(function (_ref12) {
    var label = _ref12.label,
        value = _ref12.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: schedule._.rawDays["".concat(newMonth, "/").concat(newDate)] || schedule._.linkedDays["".concat(newMonth, "/").concat(newDate)],
    onClick: handleAddDay
  }, /*#__PURE__*/React__default.createElement(ForwardRef$A, null), /*#__PURE__*/React__default.createElement("span", null, "Add Day"))));
};

ScheduleEditor.propTypes = {
  schedule: PropTypes.instanceOf(Schedule),
  onChange: PropTypes.func
};
var ScheduleEditor$1 = ScheduleEditor;

var DataTable = function DataTable(_ref) {
  var _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows;
  var i18n = useI18n$1();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "data-table"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "table-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "table"
  }, (!rows || rows.length == 0) && /*#__PURE__*/React__default.createElement("div", {
    className: "empty-data"
  }, /*#__PURE__*/React__default.createElement("em", null, i18n.t("table.noData"))), /*#__PURE__*/React__default.createElement("div", {
    className: "tbody"
  }, rows.map(function (_ref2, index) {
    var label = _ref2.label,
        value = _ref2.value;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "tr"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "td"
    }, label), /*#__PURE__*/React__default.createElement("div", {
      className: "td"
    }, value));
  })))));
};

DataTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    value: PropTypes.any
  }))
};
var DataTable$1 = DataTable;

var parseParams = function parseParams() {
  var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (queryParams.indexOf("?") !== 0) return {};
  return queryParams.split("?")[1].split("&").reduce(function (a, q) {
    a[q.split("=")[0]] = decodeURIComponent(q.split("=")[1]);
    return a;
  }, {});
};
var stringifyParams = function stringifyParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Object.keys(params).length == 0) return "";
  var query = "?".concat(Object.keys(params).filter(function (o) {
    return params[o] !== undefined && params[o] !== null;
  }).map(function (o) {
    return "".concat(o, "=").concat(encodeURIComponent(params[o]));
  }).join("&"));
  if (query.length < 2) return "";
  return query;
};
var getQueryParam = function getQueryParam(key) {
  var params = parseParams(window.location.search);
  if (key in params) return params[key];
  return null;
};
var updateQueryParamString = function updateQueryParamString(obj) {
  var params = parseParams(window.location.search);
  params = _objectSpread2(_objectSpread2({}, params), obj);
  window.history.replaceState(null, document.title, "".concat(window.location.pathname).concat(stringifyParams(params)));
};

var NavigationTable = function NavigationTable(props) {
  var data = props.data,
      columns = props.columns,
      getPath = props.getPath,
      pageSize = props.pageSize,
      setPageSize = props.setPageSize,
      _props$pageSizes = props.pageSizes,
      pageSizes = _props$pageSizes === void 0 ? PAGE_SIZES : _props$pageSizes,
      _props$getIdentifier = props.getIdentifier,
      getIdentifier = _props$getIdentifier === void 0 ? function (n) {
    return n._.id;
  } : _props$getIdentifier,
      defaultSort = props.defaultSort,
      autofocus = props.autofocus,
      loading = props.loading,
      popOverContents = props.popOverContents,
      searchPlaceholder = props.searchPlaceholder,
      _props$searchQueryPar = props.searchQueryParam,
      searchQueryParam = _props$searchQueryPar === void 0 ? "nts" : _props$searchQueryPar,
      _props$pageQueryParam = props.pageQueryParam,
      pageQueryParam = _props$pageQueryParam === void 0 ? "ntp" : _props$pageQueryParam;

  if (!columns || columns.length == 0) {
    console.log("Must provide columns to NavigationTable");
    return null;
  }

  var defaultSearch = getQueryParam(searchQueryParam) || "";

  var _useState = useState(defaultSearch),
      _useState2 = _slicedToArray$1(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var defaultPage = parseInt(getQueryParam(pageQueryParam)) || 1;

  var _useState3 = useState(defaultPage),
      _useState4 = _slicedToArray$1(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = useState(defaultSort || "+".concat(columns[0].key)),
      _useState6 = _slicedToArray$1(_useState5, 2),
      sort = _useState6[0],
      setSort = _useState6[1];

  var sortDirection = sort[0];
  var sortKey = sort.slice(1, sort.length);
  useEffect(function () {
    if (defaultSort) {
      setSort(defaultSort);
    }
  }, [defaultSort]);
  useEffect(function () {
    updateQueryParamString(_defineProperty$3({}, searchQueryParam, search && search.length > 0 ? search : null));
  }, ["".concat(search)]);
  useEffect(function () {
    updateQueryParamString(_defineProperty$3({}, pageQueryParam, page > 1 ? page : null));
  }, ["".concat(page)]);
  var tableData = (data || []).map(function (datum) {
    return columns.reduce(function (c, _ref) {
      var key = _ref.key,
          display = _ref.display,
          sort = _ref.sort,
          search = _ref.search;
      return _objectSpread2(_objectSpread2({}, c), {}, _defineProperty$3({}, key, {
        __display: display(datum),
        __sort: (sort || display)(datum),
        __search: (search || display)(datum)
      }));
    }, {
      __id: getIdentifier(datum),
      __path: getPath(datum)
    });
  });

  var _parseSearchString = parseSearchString(search),
      _parseSearchString2 = _slicedToArray$1(_parseSearchString, 2),
      trimmedSearch = _parseSearchString2[0],
      searchKeys = _parseSearchString2[1];

  tableData = tableData.filter(function (datum) {
    for (var key in searchKeys) {
      if (key in datum && !datum[key].__search.toLowerCase().includes(searchKeys[key])) {
        return false;
      }
    }

    return Object.values(datum).map(function (d) {
      return d.__search;
    }).join("|").toLowerCase().includes(trimmedSearch.toLowerCase());
  });
  tableData = tableData.sort(function (datumA, datumB) {
    var _a = datumA[sortKey].__sort,
        _b = datumB[sortKey].__sort;

    if (sortDirection == "+") {
      if (_a > _b) return 1;
      if (_a < _b) return -1;
      return 0;
    } else if (sortDirection == "-") {
      if (_a < _b) return 1;
      if (_a > _b) return -1;
      return 0;
    } else {
      return 0;
    }
  });
  var startingIndex = (page - 1) * pageSize,
      endingIndex = startingIndex + pageSize,
      maxPage = Math.ceil(tableData.length / pageSize) || 1,
      totalRecords = tableData.length;
  tableData = tableData.slice(startingIndex, endingIndex);
  var loading_rows = [];

  if (loading) {
    for (var row = 1; row <= pageSize; row += 1) {
      loading_rows.push(row);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "navigation-table"
  }, /*#__PURE__*/React__default.createElement(TableSearch$1, {
    placeholder: searchPlaceholder,
    autofocus: !!autofocus,
    value: search,
    onChange: function onChange(v) {
      setSearch(v);
      if (page > 1) setPage(1);
    },
    popOverContents: popOverContents
  }), /*#__PURE__*/React__default.createElement(SortableTable$1, {
    tableData: tableData,
    columns: columns,
    sort: sort,
    setSort: setSort,
    rowComponent: NavLink,
    rowProps: function rowProps(row) {
      return {
        to: row.__path,
        activeClassName: "active"
      };
    },
    loading: loading,
    loadingRows: loading_rows
  }), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    page: page,
    pageSize: pageSize,
    pageSizes: pageSizes,
    setPageSize: setPageSize,
    setPage: setPage,
    maxPage: maxPage,
    records: totalRecords
  }));
};

NavigationTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    display: PropTypes.func,
    sort: PropTypes.func
  })),
  getPath: PropTypes.func,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageSizes: PropTypes.arrayOf(PropTypes.number),
  getIdentifier: PropTypes.func,
  defaultSort: PropTypes.string,
  autofocus: PropTypes.bool,
  loading: PropTypes.bool,
  popOverContents: PropTypes.any,
  searchPlaceholder: PropTypes.string,
  searchQueryParam: PropTypes.string,
  pageQueryParam: PropTypes.string
};
var NavigationTable$1 = NavigationTable;

var CopyableText = function CopyableText(_ref) {
  var children = _ref.children;
  var i18n = useI18n$1();
  var node = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  var copy = function copy() {
    var _window$navigator, _window$navigator$cli, _node$current;

    (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$cli = _window$navigator.clipboard) === null || _window$navigator$cli === void 0 ? void 0 : _window$navigator$cli.writeText((_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.innerText);
    setCopied(true);
  };

  useEffect(function () {
    var mounted = true;
    var resetTimeout = setTimeout(function () {
      if (!mounted) return;
      setCopied(false);
    }, 1000);
    return function () {
      mounted = false;
      clearTimeout(resetTimeout);
    };
  }, [copied]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    ref: node,
    onClick: copy,
    className: "copyable-text"
  }, children), /*#__PURE__*/React__default.createElement(ToolTip$1, {
    anchor: node,
    delay: 0,
    position: "bottom"
  }, copied ? i18n.t("global.copied") : i18n.t("global.clickToCopy")));
};

CopyableText.propTypes = {
  children: PropTypes.any
};
var CopyableText$1 = CopyableText;

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-up",
    ref: ref
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React$1.createElement("path", {
    d: "M12 19V5M5 12l7-7 7 7"
  })));
};

var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgArrowUp);

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowDown = function SvgArrowDown(props, ref) {
  return /*#__PURE__*/React$1.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-down",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React$1.createElement("path", {
    d: "M12 5v14M19 12l-7 7-7-7"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);

var KeyboardKey = function KeyboardKey(_ref) {
  var kkey = _ref.kkey;

  switch (kkey) {
    case "arrowup":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key icon"
      }, /*#__PURE__*/React__default.createElement(ForwardRef$1, null));

    case "arrowright":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key icon"
      }, /*#__PURE__*/React__default.createElement(ForwardRef$7, null));

    case "arrowdown":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key icon"
      }, /*#__PURE__*/React__default.createElement(ForwardRef, null));

    case "arrowleft":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key icon"
      }, /*#__PURE__*/React__default.createElement(ForwardRef$8, null));

    case "escape":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key"
      }, "esc");

    case "bracketleft":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key"
      }, "[");

    case "bracketright":
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key"
      }, "]");

    default:
      return /*#__PURE__*/React__default.createElement("span", {
        className: "key"
      }, kkey);
  }
};

KeyboardKey.propTypes = {
  kkey: PropTypes.oneOf(VALID_KEYS)
};
var KeyboardKey$1 = KeyboardKey;

var UUID_REGEXP = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;

var QuickAccessModal = /*#__PURE__*/function (_React$Component) {
  _inherits$2(QuickAccessModal, _React$Component);

  var _super = _createSuper$4(QuickAccessModal);

  function QuickAccessModal(props) {
    var _this;

    _classCallCheck$2(this, QuickAccessModal);

    _this = _super.call(this, props);
    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass$2(QuickAccessModal, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        inputValue: "",
        valueProcessing: false,
        valueOptions: [],
        previewLoading: false,
        previewContent: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.chariot) this.props.chariot.Site.list(); // cache list of sites to search
    }
  }, {
    key: "getShortcutOptions",
    value: function getShortcutOptions() {
      var _this2 = this;

      var i18n = this.props.i18n;
      var actions = this.context.actions;

      if (actions && actions.length > 0) {
        return actions.map(function (s) {
          var context = s.context,
              description = s.description,
              label = s.label,
              shortcut = s.shortcut,
              onClick = s.trigger;
          var loadPreview;

          if (description || shortcut) {
            loadPreview = _this2.loadShortcutPreview.bind(_this2, s);
          }

          return {
            type: context == "global" ? i18n.t("actions.globalActionsHeader") : i18n.t("actions.pageActionsHeader"),
            label: label,
            description: description,
            shortcut: shortcut,
            onClick: onClick,
            loadPreview: loadPreview
          };
        });
      } else {
        return [];
      }
    }
  }, {
    key: "checkForResourceSafely",
    value: function () {
      var _checkForResourceSafely = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resourceType, resourceId) {
        var chariot;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                chariot = this.props.chariot;
                _context.next = 4;
                return chariot[resourceType].get(resourceId);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", null);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function checkForResourceSafely(_x, _x2) {
        return _checkForResourceSafely.apply(this, arguments);
      }

      return checkForResourceSafely;
    }()
  }, {
    key: "getSiteSuggestions",
    value: function () {
      var _getSiteSuggestions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
        var _this3 = this;

        var chariot, sites, matchingSites;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                chariot = this.props.chariot;
                _context2.next = 4;
                return chariot.Site.list();

              case 4:
                sites = _context2.sent;
                matchingSites = sites.filter(function (s) {
                  return s.getDisplayName().toLowerCase().includes(search.toLowerCase()) || s.getDisplayAddress().toLowerCase().includes(search.toLowerCase()) || s._.name.toLowerCase().includes(search.toLowerCase());
                });
                return _context2.abrupt("return", matchingSites.map(function (s) {
                  return {
                    type: "Sites",
                    label: s.getDisplayName(),
                    description: s.getDisplayAddress(),
                    destination: "/sites/".concat(s._.id),
                    loadPreview: _this3.loadSitePreview.bind(_this3, s._.id)
                  };
                }).slice(0, 3));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);
                return _context2.abrupt("return", []);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function getSiteSuggestions(_x3) {
        return _getSiteSuggestions.apply(this, arguments);
      }

      return getSiteSuggestions;
    }()
  }, {
    key: "processInputValue",
    value: function () {
      var _processInputValue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var value,
            valueOptions,
            matchingShortcutOptions,
            _yield$Promise$all,
            _yield$Promise$all2,
            equipment,
            floorplan,
            point,
            preset,
            rule,
            schedule,
            site,
            user,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                value = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : this.state.inputValue;
                valueOptions = [];
                matchingShortcutOptions = this.getShortcutOptions().filter(function (_ref) {
                  var label = _ref.label;
                  return label.toLowerCase().includes(value.toLowerCase());
                });

                if (matchingShortcutOptions.length > 0) {
                  valueOptions = valueOptions.concat(matchingShortcutOptions);
                  this.setState({
                    valueOptions: valueOptions
                  });
                }

                if (!UUID_REGEXP.test(value)) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 7;
                return Promise.all([this.checkForResourceSafely("Equipment", value), this.checkForResourceSafely("Floorplan", value), this.checkForResourceSafely("Point", value), this.checkForResourceSafely("Preset", value), this.checkForResourceSafely("Rule", value), this.checkForResourceSafely("Schedule", value), this.checkForResourceSafely("Site", value), this.checkForResourceSafely("User", value)]);

              case 7:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = _slicedToArray$1(_yield$Promise$all, 8);
                equipment = _yield$Promise$all2[0];
                floorplan = _yield$Promise$all2[1];
                point = _yield$Promise$all2[2];
                preset = _yield$Promise$all2[3];
                rule = _yield$Promise$all2[4];
                schedule = _yield$Promise$all2[5];
                site = _yield$Promise$all2[6];
                user = _yield$Promise$all2[7];
                if (equipment) valueOptions.push({
                  type: "Equipment",
                  label: "".concat(equipment.getDisplayName()),
                  destination: "/sites/".concat(equipment._.site_id, "?intent=equipment:").concat(point._.equipment_id)
                });
                if (floorplan) valueOptions.push({
                  type: "Floorplans",
                  label: "".concat(floorplan._.name),
                  destination: "/sites/".concat(floorplan._.site_id, "?intent=floorplan:").concat(point._.floorplan_id)
                });
                if (point) valueOptions.push({
                  type: "Points",
                  label: "".concat(point.getDisplayName()),
                  destination: "/sites/".concat(point._.site_id, "?intent=equipment:").concat(point._.equipment_id, ",point:").concat(point._.id)
                });
                if (preset) valueOptions.push({
                  type: "Presets",
                  label: "".concat(preset._.name),
                  destination: "/sites/".concat(preset._.site_id, "?intent=preset:").concat(preset._.id)
                });
                if (rule) valueOptions.push({
                  type: "Rules",
                  label: "".concat(rule._.name),
                  destination: "/rules/".concat(rule._.id)
                });
                if (schedule) valueOptions.push({
                  type: "Schedules",
                  label: "".concat(schedule._.name),
                  destination: "/sites/".concat(schedule._.site_id, "?intent=schedule:").concat(schedule._.id)
                });
                if (user) valueOptions.push({
                  type: "Users",
                  label: "".concat(user._.name),
                  destination: "/users/".concat(user._.id)
                });
                if (site) valueOptions.push({
                  type: "Sites",
                  label: "".concat(site.getDisplayName()),
                  destination: "/sites/".concat(site._.id),
                  loadPreview: this.loadSitePreview.bind(this, site._.id)
                });

              case 25:
                _context3.t0 = valueOptions;
                _context3.next = 28;
                return this.getSiteSuggestions(value);

              case 28:
                _context3.t1 = _context3.sent;
                valueOptions = _context3.t0.concat.call(_context3.t0, _context3.t1);

                if (value === this.state.inputValue) {
                  this.setState({
                    valueOptions: valueOptions,
                    valueProcessing: false
                  });
                }

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function processInputValue() {
        return _processInputValue.apply(this, arguments);
      }

      return processInputValue;
    }()
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(inputValue) {
      this.setState({
        inputValue: inputValue
      });
      this.processInputValue(inputValue).catch(function (e) {
        console.error(e);
      });
    }
  }, {
    key: "groupValueOptionsByType",
    value: function groupValueOptionsByType() {
      var valueOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.valueOptions;
      var i18n = this.props.i18n;
      var valueOptionTypeMap = valueOptions.reduce(function (map, option) {
        var type = option.type;
        if (!map.has(type)) map.set(type, []);
        map.set(type, [].concat(_toConsumableArray(map.get(type)), [option]));
        return map;
      }, new Map());
      return Array.from(valueOptionTypeMap.keys()).map(function (key) {
        return [key, valueOptionTypeMap.get(key).sort(function (a, b) {
          if (a.label < b.label) return -1;
          if (b.label < a.label) return 1;
          return 0;
        })];
      }).sort(function (a) {
        if (a[0] == i18n.t("actions.pageActionsHeader")) return -1;
        return 0;
      });
    }
  }, {
    key: "loadPreview",
    value: function loadPreview(loadFn) {
      var _this4 = this;

      if (loadFn) {
        this.setState({
          previewLoading: true
        }, function () {
          loadFn().then(function (previewContent) {
            _this4.setState({
              previewContent: previewContent,
              previewLoading: false
            });
          });
        });
      } else {
        this.setState({
          previewContent: null,
          previewLoading: false
        });
      }
    }
  }, {
    key: "loadSitePreview",
    value: function () {
      var _loadSitePreview = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(siteId) {
        var _this5 = this;

        var chariot, site;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                chariot = this.props.chariot;
                _context4.next = 3;
                return chariot.Site.get(siteId);

              case 3:
                site = _context4.sent;
                return _context4.abrupt("return", function () {
                  return /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-wrapper"
                  }, /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-header"
                  }, /*#__PURE__*/React__default.createElement("h3", null, site.getDisplayName())), /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-meta"
                  }, /*#__PURE__*/React__default.createElement("span", null, site.getDisplayAddress())), /*#__PURE__*/React__default.createElement(Button$1, {
                    className: "preview-action",
                    component: Link,
                    to: "/sites/".concat(site._.id),
                    onClick: _this5.props.close
                  }, /*#__PURE__*/React__default.createElement("span", null, "Go to Site"), /*#__PURE__*/React__default.createElement(ForwardRef$7, null)));
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadSitePreview(_x4) {
        return _loadSitePreview.apply(this, arguments);
      }

      return loadSitePreview;
    }()
  }, {
    key: "loadShortcutPreview",
    value: function () {
      var _loadShortcutPreview = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(s) {
        var _this6 = this;

        var description, label, shortcut;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                description = s.description, label = s.label, shortcut = s.shortcut;
                return _context5.abrupt("return", function () {
                  return /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-wrapper"
                  }, /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-header"
                  }, /*#__PURE__*/React__default.createElement("h3", null, label)), /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-meta"
                  }, /*#__PURE__*/React__default.createElement("span", null, description)), shortcut && /*#__PURE__*/React__default.createElement("div", {
                    className: "preview-action"
                  }, _this6.renderShortcut(shortcut)));
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function loadShortcutPreview(_x5) {
        return _loadShortcutPreview.apply(this, arguments);
      }

      return loadShortcutPreview;
    }()
  }, {
    key: "renderShortcut",
    value: function renderShortcut(shortcut) {
      var keys = shortcut.split("+");
      var macUser = navigator.userAgent.indexOf("Mac OS X") != -1 || navigator.userAgent.indexOf("macOS") != -1;
      var ctrlText = macUser ? "cmd" : "ctrl";
      var altText = macUser ? "opt" : "alt";

      if (keys.includes("alt")) {
        keys = keys.filter(function (k) {
          return k !== "alt";
        });
        keys.unshift(altText);
      }

      if (keys.includes("shift")) {
        keys = keys.filter(function (k) {
          return k !== "shift";
        });
        keys.unshift("shift");
      }

      if (keys.includes("ctrl")) {
        keys = keys.filter(function (k) {
          return k !== "ctrl";
        });
        keys.unshift(ctrlText);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "keyboard-shortcut"
      }, keys.map(function (key) {
        return /*#__PURE__*/React__default.createElement(KeyboardKey$1, {
          key: key,
          kkey: key.startsWith("key") ? key.slice(3, key.length) : key
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$state = this.state,
          inputValue = _this$state.inputValue,
          valueOptions = _this$state.valueOptions,
          trueIndexFocused = _this$state.trueIndexFocused,
          previewLoading = _this$state.previewLoading,
          Content = _this$state.previewContent;
      var i18n = this.props.i18n;
      var renderedOptions = inputValue ? valueOptions : this.getShortcutOptions();
      var groupedOptions = this.groupValueOptionsByType(renderedOptions);
      this.optionsNodes = new Map();
      var trueIndexCursor = 0;
      var firstOption = groupedOptions.length > 0 ? groupedOptions[0][1][0] : null;
      return /*#__PURE__*/React__default.createElement(Modal$1, {
        className: "quick-access",
        modalWrapperClassName: "quick-access-wrapper",
        closeShortcutLabel: i18n.t("actions.closeQuickAccess")
      }, /*#__PURE__*/React__default.createElement(ModalHeader$1, {
        closeButtonProps: {
          onClick: this.props.close
        }
      }), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(TextInput$1, {
        ref: function ref(n) {
          return _this7.input = n;
        },
        icon: ForwardRef$d,
        value: inputValue,
        onChange: function onChange(e) {
          return _this7.handleInputValueChange(e.target.value);
        },
        returnAutoCompleteValue: firstOption ? firstOption.label : null,
        onKeyDown: function onKeyDown(e) {
          if (e.key == "ArrowDown") {
            e.preventDefault();

            if (_this7.optionsNodes && _this7.optionsNodes.get(0)) {
              _this7.optionsNodes.get(0).focus();
            }
          }
        },
        onEnter: function onEnter() {
          if (_this7.optionsNodes && _this7.optionsNodes.get(0)) {
            _this7.optionsNodes.get(0).click();
          }
        }
      }), groupedOptions.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "results"
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(node) {
          return _this7.resultsContainer = node;
        },
        className: "results-container"
      }, groupedOptions.map(function (_ref2, index) {
        var _ref3 = _slicedToArray$1(_ref2, 2),
            label = _ref3[0],
            options = _ref3[1];

        return /*#__PURE__*/React__default.createElement("div", {
          key: index,
          className: "result-group"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "result-group-label"
        }, /*#__PURE__*/React__default.createElement("span", null, label)), /*#__PURE__*/React__default.createElement("div", {
          className: "result-group-items"
        }, options.map(function (_ref4, index) {
          var label = _ref4.label,
              description = _ref4.description,
              shortcut = _ref4.shortcut,
              destination = _ref4.destination,
              onClick = _ref4.onClick,
              loadPreview = _ref4.loadPreview;
          var trueIndex = trueIndexCursor++;
          var props = {
            onClick: _this7.props.close
          };
          var Component = "button";

          if (destination) {
            Component = Link;
            props.to = destination;
          }

          if (onClick) {
            props.onClick = function (event) {
              onClick(event);

              _this7.props.close();
            };
          }

          return /*#__PURE__*/React__default.createElement(Component, _extends$U({}, props, {
            key: index,
            className: trueIndex == trueIndexFocused ? "focus" : null,
            ref: function ref(node) {
              return _this7.optionsNodes.set(trueIndex, node);
            },
            onFocus: function onFocus() {
              _this7.setState({
                trueIndexFocused: trueIndex
              }, function () {
                _this7.loadPreview(loadPreview);
              });
            },
            onBlur: function onBlur() {
              _this7.setState({
                trueIndexFocused: undefined,
                previewContent: null,
                previewLoading: false
              });
            },
            onKeyDown: function onKeyDown(e) {
              if (e.key == "ArrowDown") {
                e.preventDefault();
                if (_this7.optionsNodes.get(trueIndex + 1)) _this7.optionsNodes.get(trueIndex + 1).focus();
              } else if (e.key == "ArrowUp") {
                e.preventDefault();

                if (_this7.optionsNodes.get(trueIndex - 1)) {
                  _this7.optionsNodes.get(trueIndex - 1).focus();
                } else {
                  if (_this7.resultsContainer) _this7.resultsContainer.scrollTop = 0;

                  _this7.input.focus();
                }
              }
            }
          }), /*#__PURE__*/React__default.createElement("span", {
            className: "label"
          }, label), /*#__PURE__*/React__default.createElement("span", {
            className: "description"
          }, description), shortcut && _this7.renderShortcut(shortcut));
        })));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "result-preview" + (previewLoading ? " loading" : "") + (Content || previewLoading ? " visible" : "")
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "result-preview-inner"
      }, previewLoading ? /*#__PURE__*/React__default.createElement(LoadingSpinner$1, null) : Content ? /*#__PURE__*/React__default.createElement(Content, null) : null)))));
    }
  }]);

  return QuickAccessModal;
}(React__default.Component);

QuickAccessModal.contextType = QuickActionsContext;
QuickAccessModal.propTypes = {
  close: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  }),
  chariot: PropTypes.instanceOf(Chariot)
};
var QuickAccessModal$1 = withChariot$1(withI18n$1(QuickAccessModal));

var QuickAccess = /*#__PURE__*/function (_React$Component) {
  _inherits$2(QuickAccess, _React$Component);

  var _super = _createSuper$4(QuickAccess);

  function QuickAccess(props) {
    var _this;

    _classCallCheck$2(this, QuickAccess);

    _this = _super.call(this, props);
    _this.state = {
      open: props.defaultOpen || false
    };
    return _this;
  }

  _createClass$2(QuickAccess, [{
    key: "toggleOpen",
    value: function toggleOpen() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var i18n = this.props.i18n;
      var open = this.state.open;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(KeyboardShortcut$1, {
        context: "global",
        label: i18n.t("actions.quickAccess"),
        description: i18n.t("actions.quickAccessDesc"),
        shortcut: "ctrl+k",
        handler: this.toggleOpen.bind(this)
      }), open && /*#__PURE__*/React__default.createElement(QuickAccessModal$1, {
        close: this.close.bind(this)
      }));
    }
  }]);

  return QuickAccess;
}(React__default.Component);

QuickAccess.propTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  }),
  defaultOpen: PropTypes.bool
};
var QuickAccess$1 = withI18n$1(QuickAccess);

// pass data to the Tabs component. This should not be used directly.

var Tab = function Tab() {
  return null;
};

Tab.propTypes = {
  label: PropTypes.string,
  contents: PropTypes.any
};
var Tab$1 = Tab;

var _excluded = ["children", "tabs", "className"];

var Tabs = function Tabs(props) {
  var i18n = useI18n$1();

  var children = props.children,
      tabsFromProps = props.tabs,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(0),
      _useState2 = _slicedToArray$1(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var tabs = tabsFromProps;

  if (!tabs || tabs.length == 0) {
    tabs = React__default.Children.map(children, function (child) {
      return {
        label: child.props.label,
        contents: child.props.children
      };
    });
  }

  if (tabs.length == 0) return null;
  var activeTab = tabs[activeIndex];
  if (!activeTab) return null;
  var contents = activeTab.contents;
  return /*#__PURE__*/React__default.createElement("div", _extends$U({
    className: "tabs ".concat(className ? className : "")
  }, otherProps), /*#__PURE__*/React__default.createElement("div", {
    className: "tabs-navigation"
  }, tabs.map(function (_ref, index) {
    var label = _ref.label;
    var quickActionProps = {};

    if (index == activeIndex - 1) {
      quickActionProps.quickActionShortcut = "shift+alt+[";
      quickActionProps.quickActionLabel = i18n.t("actions.goToPrevTab");
      quickActionProps.quickActionDescription = i18n.t("actions.goToPrevTabDesc");
    } else if (index == activeIndex + 1) {
      quickActionProps.quickActionShortcut = "shift+alt+]";
      quickActionProps.quickActionLabel = i18n.t("actions.goToNextTab");
      quickActionProps.quickActionDescription = i18n.t("actions.goToNextTabDesc");
    } else if (index == 0 && activeIndex == tabs.length - 1) {
      quickActionProps.quickActionShortcut = "shift+alt+]";
      quickActionProps.quickActionLabel = i18n.t("actions.goToFirstTab");
      quickActionProps.quickActionDescription = i18n.t("actions.goToFirstTabDesc");
    } else if (index == tabs.length - 1 && activeIndex == 0) {
      quickActionProps.quickActionShortcut = "shift+alt+[";
      quickActionProps.quickActionLabel = i18n.t("actions.goToLastTab");
      quickActionProps.quickActionDescription = i18n.t("actions.goToLastTabDesc");
    }

    return /*#__PURE__*/React__default.createElement(Button$1, _extends$U({
      key: index,
      disabled: index == activeIndex,
      onClick: function onClick() {
        return setActiveIndex(index);
      }
    }, quickActionProps), label);
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "tabs-content"
  }, contents));
};

Tabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    contents: PropTypes.any
  })),
  children: function children(props, propName, componentName) {
    var prop = props[propName],
        error = null;

    if (props["tabs"] && props["tabs"].length > 0 && React__default.Children.count(prop) > 0) {
      return new Error("Cannot provide both children and tabs prop to Tabs component.");
    }

    React__default.Children.forEach(prop, function (child) {
      if (child.type !== Tab$1) {
        error = new Error("".concat(componentName, " children should be of type Tab"));
      }
    });
    return error;
  }
};
var Tabs$1 = Tabs;

var ProgressBar = function ProgressBar(props) {
  var value = props.value,
      _props$showValue = props.showValue,
      showValue = _props$showValue === void 0 ? true : _props$showValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "progress-indicator",
    style: {
      width: "".concat(value, "%")
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "progress-percent"
  }, showValue && /*#__PURE__*/React__default.createElement("span", null, value.toFixed(0), "%")));
};

var ProgressBar$1 = ProgressBar;

export { AppError$1 as AppError, AppInfo$1 as AppInfo, AppMessage$1 as AppMessage, AppNotification$1 as AppNotification, AppNotificationsContext, AppNotificationsProvider$1 as AppNotificationsProvider, AppWarning$1 as AppWarning, Bar$1 as Bar, Button$1 as Button, ButtonGroup$1 as ButtonGroup, Card$1 as Card, CardBody$1 as CardBody, CardHeader$1 as CardHeader, ChariotResourceLabel$1 as ChariotResourceLabel, Chart$1 as Chart, ChartBuilder$1 as ChartBuilder, ChartBuilderHeader$1 as ChartBuilderHeader, ChartBuilderLegend$1 as ChartBuilderLegend, ChartConfigEditor$1 as ChartConfigEditor, ChartDataSourceContext, CheckboxInput$1 as CheckboxInput, ColorInput$1 as ColorInput, CopyableText$1 as CopyableText, DataTable$1 as DataTable, DateTimeInput$1 as DateTimeInput, Equipment$1 as Equipment, EquipmentDashboard$1 as EquipmentDashboard, EquipmentHourlyActivity$1 as EquipmentHourlyActivity, EquipmentNameLabelFromExternalId$1 as EquipmentNameLabelFromExternalId, EquipmentOfflineIndicator, FileInput$1 as FileInput, FileThumbnail$1 as FileThumbnail, Floorplan$1 as Floorplan, FloorplanAddFeaturePanel$1 as FloorplanAddFeaturePanel, FloorplanEquipmentDetails$1 as FloorplanEquipmentDetails, FloorplanEquipmentIcon$1 as FloorplanEquipmentIcon, FloorplanMap$1 as FloorplanMap, FloorplanMapFeature$1 as FloorplanMapFeature, FloorplanMapTools$1 as FloorplanMapTools, GappedLine, GradientPolygon, GroupedPointValueDisplay$1 as GroupedPointValueDisplay, HeatMap, IPAddressInput$1 as IPAddressInput, InputWrapper$1 as InputWrapper, JSONInput$1 as JSONInput, KeyboardKey$1 as KeyboardKey, KeyboardShortcut$1 as KeyboardShortcut, Line$1 as Line, LoadingSpinner$1 as LoadingSpinner, LoadingString$1 as LoadingString, Modal$1 as Modal, ModalActions$1 as ModalActions, ModalBody$1 as ModalBody, ModalHeader$1 as ModalHeader, ModalValidationMessage$1 as ModalValidationMessage, NavigationTable$1 as NavigationTable, PatientButton$1 as PatientButton, PieGraph$1 as PieGraph, PointActivityAtValueChartDataSource$1 as PointActivityAtValueChartDataSource, PointCard$1 as PointCard, PointControl$1 as PointControl, PointSnapshotChartDataSource$1 as PointSnapshotChartDataSource, PointTrend$1 as PointTrend, PointValueDisplay$1 as PointValueDisplay, PointValueInput, PopOver$1 as PopOver, PopOverMenu$1 as PopOverMenu, PresetEditor$1 as PresetEditor, ProgressBar$1 as ProgressBar, QuickAccess$1 as QuickAccess, QuickAction$1 as QuickAction, QuickActionsContext, QuickActionsProvider$1 as QuickActionsProvider, RuleEvent$1 as RuleEvent, RuleEventList$1 as RuleEventList, ScheduleEditor$1 as ScheduleEditor, ScheduledEquipment$1 as ScheduledEquipment, SelectInput$1 as SelectInput, SelectManyInput$1 as SelectManyInput, SelectManyPointsInput$1 as SelectManyPointsInput, SelectManyPointsTreeInput$1 as SelectManyPointsTreeInput, SelectManyTable$1 as SelectManyTable, SelectionTable$1 as SelectionTable, SiteClock$1 as SiteClock, SiteControls$1 as SiteControls, SiteEventList$1 as SiteEventList, SiteStar$1 as SiteStar, SiteStatusEvent$1 as SiteStatusEvent, SortableTable$1 as SortableTable, StackedBar$1 as StackedBar, StackedBarChart$1 as StackedBarChart, StepInput$1 as StepInput, Tab$1 as Tab, TablePagination$1 as TablePagination, TableSearch$1 as TableSearch, Tabs$1 as Tabs, TextInput$1 as TextInput, ThemeContext, ThemeLanguage$1 as ThemeLanguage, ThemeProvider$1 as ThemeProvider, ToggleInput$1 as ToggleInput, ToolTip$1 as ToolTip, WeatherChartDataSource$1 as WeatherChartDataSource, XAxis$1 as XAxis, YAxis$1 as YAxis, useAppNotification$1 as useAppNotification, useDefaultResolution$1 as useDefaultResolution, useEquipmentStatus$1 as useEquipmentStatus, useI18n$1 as useI18n, withChariot$1 as withChariot, withChariotLogin$1 as withChariotLogin, withChariotProvider$1 as withChariotProvider, withI18n$1 as withI18n };
//# sourceMappingURL=index.js.map
